import { reactive as Ba, defineComponent as X, openBlock as v, createElementBlock as b, normalizeClass as z, normalizeStyle as fe, toDisplayString as F, createElementVNode as y, resolveComponent as ye, createVNode as H, Transition as ft, withCtx as Z, createBlock as le, createCommentVNode as W, renderSlot as J, ref as q, computed as j, mergeProps as ht, withModifiers as ne, Fragment as he, renderList as Se, withDirectives as Ne, vModelText as Nn, createTextVNode as Ke, vShow as Dn, withKeys as on, vModelCheckbox as Xi, nextTick as $t, vModelDynamic as yu, Teleport as Yn, mergeDefaults as xu, useSlots as Vu, onBeforeMount as vn, onMounted as zn, onBeforeUnmount as qn, watch as an, createSlots as Pu, unref as Lu, vModelSelect as Ru, vModelRadio as Fu, shallowRef as Wu, resolveDynamicComponent as Zi, toHandlers as Hu, onUnmounted as o0 } from "vue";
const st = Ba({
  language: "en",
  components: {
    inputs: {},
    content: {},
    modalsAndWindows: {},
    spinnersOrLoaders: {}
  }
}), gt = (t) => {
  if (!t)
    return console.warn("getText obj parameter is undefined or otherwise falsy"), "";
  let i = t[st.language];
  return i || (console.warn("Translation missing for lang: " + st.language), console.warn(t)), i;
}, a0 = X({
  props: {
    icon: {
      type: String,
      required: !0
    },
    size: {
      type: Number,
      default: 100
    },
    theme: {
      type: String,
      required: !1
    }
  },
  computed: {
    iconClass() {
      let t = ["bi-" + this.icon];
      return this.theme && t.push(`text-${this.theme}`), t;
    }
  }
}), ge = (t, i) => {
  const r = t.__vccOpts || t;
  for (const [l, a] of i)
    r[l] = a;
  return r;
};
function s0(t, i, r, l, a, u) {
  return v(), b("i", {
    class: z(t.iconClass),
    style: fe({ fontSize: t.size + "%" })
  }, null, 6);
}
const He = /* @__PURE__ */ ge(a0, [["render", s0]]), wu = {
  company: "#6D7174",
  job: "#8962D9",
  startup: "#5DC4E1",
  businessidea: "#3a91ad",
  activity: "#2089FA",
  topical: "#33B56A",
  user: "#33B56A",
  contact: "#EE9A2D",
  request: "#E8B828",
  project: "#2FA9AD",
  messaging: "#EE354F",
  servicearea: "#89BF41",
  survey: "#326BA2",
  integration: "#BF4A99",
  customership: "#F9AD81",
  customershipaction: "#a3d39c",
  application: "#DDA059"
}, Ca = Object.keys(wu).reduce((t, i) => (t[`hakotheme-${i}`] = wu[i], t), {}), bu = {
  primary: "#007bff",
  secondary: "#6c757d",
  success: "#28a745",
  danger: "#dc3545",
  warning: "#ffc107",
  info: "#17a2b8",
  light: "#f8f9fa",
  dark: "#343a40"
};
var Uu = /* @__PURE__ */ ((t) => (t.Company = "company", t.Job = "job", t.Startup = "startup", t.BusinessIdea = "businessidea", t.Activity = "activity", t.Topical = "topical", t.User = "user", t.Contact = "contact", t.Request = "request", t.Project = "project", t.Messaging = "messaging", t.ServiceArea = "servicearea", t.Survey = "survey", t.Integration = "integration", t.Customership = "customership", t.CustomershipAction = "customershipaction", t.Application = "application", t))(Uu || {});
const xa = [];
for (const t of Object.values(Uu))
  xa.push(t);
const or = {};
xa.forEach((t) => {
  const i = "hakotheme-" + t;
  or[t] = {
    name: t,
    color: Ca[i],
    colorDark: Ca[i + "-dark"],
    colorLight: Ca[i + "-light"]
  };
});
let Nu = [], ar = {};
Object.keys(bu).forEach((t) => {
  let i = "bs-theme-color-", r = t.replace(i, ""), l = bu[t];
  Nu.push(r), ar[r] = {
    name: r,
    color: l
  };
});
[...xa, ...Nu];
let l0 = { ...or, ...ar };
const u0 = X({
  props: {
    avatarData: {
      type: String,
      required: !0
    },
    role: {
      type: String,
      default: ""
    },
    size: {
      type: Number,
      default: 2
    }
  },
  computed: {
    bgColor() {
      let t = or[this.role] || ar[this.role];
      return t ? t.color : "gray";
    },
    isAvatarText() {
      let t = this.avatarData;
      return t || (t = ""), !t.includes("http://") && !t.includes("https://");
    },
    avatarText() {
      const t = this.avatarData;
      let i = "", r;
      return t && t.length <= 2 ? r = t.split("") : t && (r = t.split(" ")), r && (i = r[0][0], r[1] && (i += r[1][0])), i;
    },
    myFontSize() {
      return this.size / 2 * 100 + "%";
    }
  }
}), c0 = ["src"];
function d0(t, i, r, l, a, u) {
  return v(), b("div", {
    class: "hakosalo-rounded-avatar",
    style: fe({ backgroundColor: t.bgColor, width: t.size + "rem", height: t.size + "rem" })
  }, [
    t.isAvatarText ? (v(), b("span", {
      key: 0,
      style: fe({ fontSize: t.myFontSize })
    }, F(t.avatarText), 5)) : (v(), b("img", {
      key: 1,
      src: t.avatarData,
      alt: "Avatar",
      style: fe({ borderColor: t.bgColor })
    }, null, 12, c0))
  ], 4);
}
const Zr = /* @__PURE__ */ ge(u0, [["render", d0]]), f0 = X({
  props: {
    theme: {
      type: String,
      default: "primary"
    },
    size: {
      type: Number,
      default: 4
    },
    sm: {
      type: Boolean,
      default: !1
    },
    lg: {
      type: Boolean,
      default: !1
    },
    inline: {
      type: Boolean,
      default: !1
    },
    center: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      mySize: this.size
    };
  },
  watch: {
    size() {
      this.mySize = this.size;
    }
  },
  beforeMount() {
    this.sm ? this.mySize = 1 : this.lg && (this.mySize = 8);
  },
  computed: {
    themeClass() {
      return ["text-" + this.theme];
    },
    containerStyling() {
      let t = {};
      return this.inline && (t.display = "inline-block"), this.center && (t["text-align"] = "center"), t;
    },
    styling() {
      let t = {
        width: `${this.mySize}rem`,
        height: `${this.mySize}rem`
      };
      const i = 0.25, r = 2;
      let l = this.mySize / r * i;
      return l < 0.2 && (l = 0.2), t["border-width"] = l + "em", t;
    }
  }
}), h0 = /* @__PURE__ */ y("span", { class: "visually-hidden" }, "Loading...", -1), p0 = [
  h0
];
function v0(t, i, r, l, a, u) {
  return v(), b("div", {
    class: "bs-spinner-container",
    style: fe(t.containerStyling)
  }, [
    y("div", {
      class: z(["spinner-border", t.themeClass]),
      style: fe(t.styling),
      role: "status"
    }, p0, 6)
  ], 4);
}
const Gn = /* @__PURE__ */ ge(f0, [["render", v0]]), m0 = X({
  components: {
    Spinner: Gn
  },
  props: {
    type: {
      type: String,
      default: "button"
    },
    /**
    * Button theme color (primary, danger, job, startuc etc...)
    */
    theme: {
      type: String,
      default: "primary"
    },
    /**
    * Small button
    */
    sm: {
      type: Boolean,
      default: !1
    },
    /**
    * Large button
    */
    lg: {
      type: Boolean,
      default: !1
    },
    /**
    * Button will be a block element and 100% width.
    */
    isBlock: {
      type: Boolean,
      default: !1
    },
    /**
    * Show an integrated spinner when true
    */
    isLoading: {
      type: Boolean,
      default: !1
    },
    /**
    * Button doesn't have a min-width. Good if the button is just an icon.
    */
    isNarrow: {
      type: Boolean,
      default: !1
    },
    /**
    * Do not use capitalized letters
    */
    uncapitalize: {
      type: Boolean,
      default: !1
    },
    /**
    * Disables button
    */
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    classList() {
      let t = ["btn", "hako-btn"];
      return t.push(`btn-${this.theme}`), this.sm ? t.push("btn-sm") : this.lg && t.push("btn-lg"), this.isLoading && t.push("is-loading"), this.isNarrow && t.push("is-narrow"), this.uncapitalize && t.push("uncapitalize"), t;
    }
  }
}), g0 = ["type", "disabled"];
function y0(t, i, r, l, a, u) {
  const s = ye("Spinner");
  return v(), b("button", {
    type: t.type,
    class: z(t.classList),
    style: fe({
      display: t.isBlock ? "block" : "inline-block",
      width: t.isBlock ? "100%" : "auto"
    }),
    disabled: t.isLoading || t.disabled
  }, [
    H(ft, null, {
      default: Z(() => [
        t.isLoading ? (v(), le(s, {
          key: 0,
          class: "pe-2",
          theme: "light",
          inline: "",
          size: t.lg ? 1.25 : t.sm ? 0.8 : 1
        }, null, 8, ["size"])) : W("", !0)
      ]),
      _: 1
    }),
    J(t.$slots, "default")
  ], 14, g0);
}
const At = /* @__PURE__ */ ge(m0, [["render", y0]]), w0 = /* @__PURE__ */ X({
  __name: "BsIconButton",
  props: {
    icon: {
      type: String,
      required: !0
    },
    size: {
      type: Number,
      default: 1.5
    },
    theme: {
      type: String,
      default: "primary"
    },
    inactiveTheme: {
      type: String,
      default: "dark"
    }
  },
  setup(t) {
    const i = t, r = q(!1), l = j(() => {
      let h = [];
      return r.value && h.push("fg-" + i.theme), h;
    }), a = j(() => {
      const h = {}, g = i.size.toString().replace(",", ".") + "em";
      return h.width = g, h.height = g, h;
    }), u = j(() => {
      const h = i.size / 1.5;
      return Math.floor(h * 100);
    }), s = j(() => r.value ? i.theme : i.inactiveTheme);
    return (h, g) => (v(), b("button", {
      class: z(["hakolib-bs-icon-button", l.value]),
      style: fe(a.value),
      onMouseenter: g[0] || (g[0] = (T) => r.value = !0),
      onMouseleave: g[1] || (g[1] = (T) => r.value = !1)
    }, [
      H(He, {
        icon: t.icon,
        size: u.value,
        theme: s.value
      }, null, 8, ["icon", "size", "theme"])
    ], 38));
  }
}), b0 = {
  key: 0,
  class: "spinner-container"
}, Ji = /* @__PURE__ */ X({
  __name: "ButtonIconOnly",
  props: {
    theme: {
      type: String,
      default: "primary"
    },
    icon: {
      type: String,
      required: !0
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    isLoading: {
      type: Boolean,
      default: !1
    },
    rounded: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    return (i, r) => (v(), le(At, {
      class: z(["hakobtn-icon-only", { rounded: t.rounded }]),
      theme: t.theme,
      disabled: t.disabled || t.isLoading
    }, {
      default: Z(() => [
        t.isLoading ? (v(), b("div", b0, [
          H(Gn, {
            size: 1,
            theme: "light"
          })
        ])) : W("", !0),
        H(He, {
          icon: t.icon,
          class: z({ "is-loading": t.isLoading })
        }, null, 8, ["icon", "class"])
      ]),
      _: 1
    }, 8, ["class", "theme", "disabled"]));
  }
}), k0 = /* @__PURE__ */ X({
  __name: "ButtonIconOnlyAdd",
  setup(t) {
    return (i, r) => (v(), le(Ji, ht(i.$attrs, {
      icon: "plus-square",
      theme: "success"
    }), null, 16));
  }
}), C0 = /* @__PURE__ */ X({
  __name: "ButtonIconOnlyRemove",
  setup(t) {
    return (i, r) => (v(), le(Ji, ht(i.$attrs, {
      icon: "trash",
      theme: "danger"
    }), null, 16));
  }
}), $0 = /* @__PURE__ */ X({
  __name: "ButtonIconOnlyEdit",
  setup(t) {
    return (i, r) => (v(), le(Ji, ht(i.$attrs, {
      icon: "pencil-square",
      theme: "primary"
    }), null, 16));
  }
});
function An(t) {
  "@babel/helpers - typeof";
  return An = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(i) {
    return typeof i;
  } : function(i) {
    return i && typeof Symbol == "function" && i.constructor === Symbol && i !== Symbol.prototype ? "symbol" : typeof i;
  }, An(t);
}
function _t(t) {
  if (t === null || t === !0 || t === !1)
    return NaN;
  var i = Number(t);
  return isNaN(i) ? i : i < 0 ? Math.ceil(i) : Math.floor(i);
}
function qe(t, i) {
  if (i.length < t)
    throw new TypeError(t + " argument" + (t > 1 ? "s" : "") + " required, but only " + i.length + " present");
}
function lt(t) {
  qe(1, arguments);
  var i = Object.prototype.toString.call(t);
  return t instanceof Date || An(t) === "object" && i === "[object Date]" ? new Date(t.getTime()) : typeof t == "number" || i === "[object Number]" ? new Date(t) : ((typeof t == "string" || i === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function $a(t, i) {
  qe(2, arguments);
  var r = lt(t), l = _t(i);
  return isNaN(l) ? /* @__PURE__ */ new Date(NaN) : (l && r.setDate(r.getDate() + l), r);
}
function _0(t, i) {
  qe(2, arguments);
  var r = lt(t).getTime(), l = _t(i);
  return new Date(r + l);
}
var T0 = {};
function sr() {
  return T0;
}
function S0(t, i) {
  var r, l, a, u, s, h, g, T;
  qe(1, arguments);
  var k = sr(), S = _t((r = (l = (a = (u = i == null ? void 0 : i.weekStartsOn) !== null && u !== void 0 ? u : i == null || (s = i.locale) === null || s === void 0 || (h = s.options) === null || h === void 0 ? void 0 : h.weekStartsOn) !== null && a !== void 0 ? a : k.weekStartsOn) !== null && l !== void 0 ? l : (g = k.locale) === null || g === void 0 || (T = g.options) === null || T === void 0 ? void 0 : T.weekStartsOn) !== null && r !== void 0 ? r : 0);
  if (!(S >= 0 && S <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var E = lt(t), O = E.getDay(), C = (O < S ? 7 : 0) + O - S;
  return E.setDate(E.getDate() - C), E.setHours(0, 0, 0, 0), E;
}
function zi(t) {
  return qe(1, arguments), S0(t, {
    weekStartsOn: 1
  });
}
function O0(t) {
  qe(1, arguments);
  var i = lt(t), r = i.getFullYear(), l = /* @__PURE__ */ new Date(0);
  l.setFullYear(r + 1, 0, 4), l.setHours(0, 0, 0, 0);
  var a = zi(l), u = /* @__PURE__ */ new Date(0);
  u.setFullYear(r, 0, 4), u.setHours(0, 0, 0, 0);
  var s = zi(u);
  return i.getTime() >= a.getTime() ? r + 1 : i.getTime() >= s.getTime() ? r : r - 1;
}
function M0(t) {
  qe(1, arguments);
  var i = O0(t), r = /* @__PURE__ */ new Date(0);
  r.setFullYear(i, 0, 4), r.setHours(0, 0, 0, 0);
  var l = zi(r);
  return l;
}
function zu(t) {
  var i = new Date(Date.UTC(t.getFullYear(), t.getMonth(), t.getDate(), t.getHours(), t.getMinutes(), t.getSeconds(), t.getMilliseconds()));
  return i.setUTCFullYear(t.getFullYear()), t.getTime() - i.getTime();
}
var A0 = 6e4, D0 = 36e5, I0 = 1e3;
function E0(t) {
  return qe(1, arguments), t instanceof Date || An(t) === "object" && Object.prototype.toString.call(t) === "[object Date]";
}
function qu(t) {
  if (qe(1, arguments), !E0(t) && typeof t != "number")
    return !1;
  var i = lt(t);
  return !isNaN(Number(i));
}
function Yu(t, i) {
  qe(2, arguments);
  var r = _t(i);
  return _0(t, -r);
}
var B0 = 864e5;
function x0(t) {
  qe(1, arguments);
  var i = lt(t), r = i.getTime();
  i.setUTCMonth(0, 1), i.setUTCHours(0, 0, 0, 0);
  var l = i.getTime(), a = r - l;
  return Math.floor(a / B0) + 1;
}
function Tr(t) {
  qe(1, arguments);
  var i = 1, r = lt(t), l = r.getUTCDay(), a = (l < i ? 7 : 0) + l - i;
  return r.setUTCDate(r.getUTCDate() - a), r.setUTCHours(0, 0, 0, 0), r;
}
function Gu(t) {
  qe(1, arguments);
  var i = lt(t), r = i.getUTCFullYear(), l = /* @__PURE__ */ new Date(0);
  l.setUTCFullYear(r + 1, 0, 4), l.setUTCHours(0, 0, 0, 0);
  var a = Tr(l), u = /* @__PURE__ */ new Date(0);
  u.setUTCFullYear(r, 0, 4), u.setUTCHours(0, 0, 0, 0);
  var s = Tr(u);
  return i.getTime() >= a.getTime() ? r + 1 : i.getTime() >= s.getTime() ? r : r - 1;
}
function V0(t) {
  qe(1, arguments);
  var i = Gu(t), r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(i, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var l = Tr(r);
  return l;
}
var P0 = 6048e5;
function Ku(t) {
  qe(1, arguments);
  var i = lt(t), r = Tr(i).getTime() - V0(i).getTime();
  return Math.round(r / P0) + 1;
}
function ir(t, i) {
  var r, l, a, u, s, h, g, T;
  qe(1, arguments);
  var k = sr(), S = _t((r = (l = (a = (u = i == null ? void 0 : i.weekStartsOn) !== null && u !== void 0 ? u : i == null || (s = i.locale) === null || s === void 0 || (h = s.options) === null || h === void 0 ? void 0 : h.weekStartsOn) !== null && a !== void 0 ? a : k.weekStartsOn) !== null && l !== void 0 ? l : (g = k.locale) === null || g === void 0 || (T = g.options) === null || T === void 0 ? void 0 : T.weekStartsOn) !== null && r !== void 0 ? r : 0);
  if (!(S >= 0 && S <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var E = lt(t), O = E.getUTCDay(), C = (O < S ? 7 : 0) + O - S;
  return E.setUTCDate(E.getUTCDate() - C), E.setUTCHours(0, 0, 0, 0), E;
}
function Va(t, i) {
  var r, l, a, u, s, h, g, T;
  qe(1, arguments);
  var k = lt(t), S = k.getUTCFullYear(), E = sr(), O = _t((r = (l = (a = (u = i == null ? void 0 : i.firstWeekContainsDate) !== null && u !== void 0 ? u : i == null || (s = i.locale) === null || s === void 0 || (h = s.options) === null || h === void 0 ? void 0 : h.firstWeekContainsDate) !== null && a !== void 0 ? a : E.firstWeekContainsDate) !== null && l !== void 0 ? l : (g = E.locale) === null || g === void 0 || (T = g.options) === null || T === void 0 ? void 0 : T.firstWeekContainsDate) !== null && r !== void 0 ? r : 1);
  if (!(O >= 1 && O <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var C = /* @__PURE__ */ new Date(0);
  C.setUTCFullYear(S + 1, 0, O), C.setUTCHours(0, 0, 0, 0);
  var I = ir(C, i), M = /* @__PURE__ */ new Date(0);
  M.setUTCFullYear(S, 0, O), M.setUTCHours(0, 0, 0, 0);
  var R = ir(M, i);
  return k.getTime() >= I.getTime() ? S + 1 : k.getTime() >= R.getTime() ? S : S - 1;
}
function L0(t, i) {
  var r, l, a, u, s, h, g, T;
  qe(1, arguments);
  var k = sr(), S = _t((r = (l = (a = (u = i == null ? void 0 : i.firstWeekContainsDate) !== null && u !== void 0 ? u : i == null || (s = i.locale) === null || s === void 0 || (h = s.options) === null || h === void 0 ? void 0 : h.firstWeekContainsDate) !== null && a !== void 0 ? a : k.firstWeekContainsDate) !== null && l !== void 0 ? l : (g = k.locale) === null || g === void 0 || (T = g.options) === null || T === void 0 ? void 0 : T.firstWeekContainsDate) !== null && r !== void 0 ? r : 1), E = Va(t, i), O = /* @__PURE__ */ new Date(0);
  O.setUTCFullYear(E, 0, S), O.setUTCHours(0, 0, 0, 0);
  var C = ir(O, i);
  return C;
}
var R0 = 6048e5;
function Qu(t, i) {
  qe(1, arguments);
  var r = lt(t), l = ir(r, i).getTime() - L0(r, i).getTime();
  return Math.round(l / R0) + 1;
}
function We(t, i) {
  for (var r = t < 0 ? "-" : "", l = Math.abs(t).toString(); l.length < i; )
    l = "0" + l;
  return r + l;
}
var F0 = {
  // Year
  y: function(i, r) {
    var l = i.getUTCFullYear(), a = l > 0 ? l : 1 - l;
    return We(r === "yy" ? a % 100 : a, r.length);
  },
  // Month
  M: function(i, r) {
    var l = i.getUTCMonth();
    return r === "M" ? String(l + 1) : We(l + 1, 2);
  },
  // Day of the month
  d: function(i, r) {
    return We(i.getUTCDate(), r.length);
  },
  // AM or PM
  a: function(i, r) {
    var l = i.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (r) {
      case "a":
      case "aa":
        return l.toUpperCase();
      case "aaa":
        return l;
      case "aaaaa":
        return l[0];
      case "aaaa":
      default:
        return l === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(i, r) {
    return We(i.getUTCHours() % 12 || 12, r.length);
  },
  // Hour [0-23]
  H: function(i, r) {
    return We(i.getUTCHours(), r.length);
  },
  // Minute
  m: function(i, r) {
    return We(i.getUTCMinutes(), r.length);
  },
  // Second
  s: function(i, r) {
    return We(i.getUTCSeconds(), r.length);
  },
  // Fraction of second
  S: function(i, r) {
    var l = r.length, a = i.getUTCMilliseconds(), u = Math.floor(a * Math.pow(10, l - 3));
    return We(u, r.length);
  }
};
const Wn = F0;
var $r = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, W0 = {
  // Era
  G: function(i, r, l) {
    var a = i.getUTCFullYear() > 0 ? 1 : 0;
    switch (r) {
      case "G":
      case "GG":
      case "GGG":
        return l.era(a, {
          width: "abbreviated"
        });
      case "GGGGG":
        return l.era(a, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return l.era(a, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(i, r, l) {
    if (r === "yo") {
      var a = i.getUTCFullYear(), u = a > 0 ? a : 1 - a;
      return l.ordinalNumber(u, {
        unit: "year"
      });
    }
    return Wn.y(i, r);
  },
  // Local week-numbering year
  Y: function(i, r, l, a) {
    var u = Va(i, a), s = u > 0 ? u : 1 - u;
    if (r === "YY") {
      var h = s % 100;
      return We(h, 2);
    }
    return r === "Yo" ? l.ordinalNumber(s, {
      unit: "year"
    }) : We(s, r.length);
  },
  // ISO week-numbering year
  R: function(i, r) {
    var l = Gu(i);
    return We(l, r.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(i, r) {
    var l = i.getUTCFullYear();
    return We(l, r.length);
  },
  // Quarter
  Q: function(i, r, l) {
    var a = Math.ceil((i.getUTCMonth() + 1) / 3);
    switch (r) {
      case "Q":
        return String(a);
      case "QQ":
        return We(a, 2);
      case "Qo":
        return l.ordinalNumber(a, {
          unit: "quarter"
        });
      case "QQQ":
        return l.quarter(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return l.quarter(a, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return l.quarter(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(i, r, l) {
    var a = Math.ceil((i.getUTCMonth() + 1) / 3);
    switch (r) {
      case "q":
        return String(a);
      case "qq":
        return We(a, 2);
      case "qo":
        return l.ordinalNumber(a, {
          unit: "quarter"
        });
      case "qqq":
        return l.quarter(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return l.quarter(a, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return l.quarter(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(i, r, l) {
    var a = i.getUTCMonth();
    switch (r) {
      case "M":
      case "MM":
        return Wn.M(i, r);
      case "Mo":
        return l.ordinalNumber(a + 1, {
          unit: "month"
        });
      case "MMM":
        return l.month(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return l.month(a, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return l.month(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(i, r, l) {
    var a = i.getUTCMonth();
    switch (r) {
      case "L":
        return String(a + 1);
      case "LL":
        return We(a + 1, 2);
      case "Lo":
        return l.ordinalNumber(a + 1, {
          unit: "month"
        });
      case "LLL":
        return l.month(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return l.month(a, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return l.month(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(i, r, l, a) {
    var u = Qu(i, a);
    return r === "wo" ? l.ordinalNumber(u, {
      unit: "week"
    }) : We(u, r.length);
  },
  // ISO week of year
  I: function(i, r, l) {
    var a = Ku(i);
    return r === "Io" ? l.ordinalNumber(a, {
      unit: "week"
    }) : We(a, r.length);
  },
  // Day of the month
  d: function(i, r, l) {
    return r === "do" ? l.ordinalNumber(i.getUTCDate(), {
      unit: "date"
    }) : Wn.d(i, r);
  },
  // Day of year
  D: function(i, r, l) {
    var a = x0(i);
    return r === "Do" ? l.ordinalNumber(a, {
      unit: "dayOfYear"
    }) : We(a, r.length);
  },
  // Day of week
  E: function(i, r, l) {
    var a = i.getUTCDay();
    switch (r) {
      case "E":
      case "EE":
      case "EEE":
        return l.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return l.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return l.day(a, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return l.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(i, r, l, a) {
    var u = i.getUTCDay(), s = (u - a.weekStartsOn + 8) % 7 || 7;
    switch (r) {
      case "e":
        return String(s);
      case "ee":
        return We(s, 2);
      case "eo":
        return l.ordinalNumber(s, {
          unit: "day"
        });
      case "eee":
        return l.day(u, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return l.day(u, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return l.day(u, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return l.day(u, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(i, r, l, a) {
    var u = i.getUTCDay(), s = (u - a.weekStartsOn + 8) % 7 || 7;
    switch (r) {
      case "c":
        return String(s);
      case "cc":
        return We(s, r.length);
      case "co":
        return l.ordinalNumber(s, {
          unit: "day"
        });
      case "ccc":
        return l.day(u, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return l.day(u, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return l.day(u, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return l.day(u, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(i, r, l) {
    var a = i.getUTCDay(), u = a === 0 ? 7 : a;
    switch (r) {
      case "i":
        return String(u);
      case "ii":
        return We(u, r.length);
      case "io":
        return l.ordinalNumber(u, {
          unit: "day"
        });
      case "iii":
        return l.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return l.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return l.day(a, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return l.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(i, r, l) {
    var a = i.getUTCHours(), u = a / 12 >= 1 ? "pm" : "am";
    switch (r) {
      case "a":
      case "aa":
        return l.dayPeriod(u, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return l.dayPeriod(u, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return l.dayPeriod(u, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return l.dayPeriod(u, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(i, r, l) {
    var a = i.getUTCHours(), u;
    switch (a === 12 ? u = $r.noon : a === 0 ? u = $r.midnight : u = a / 12 >= 1 ? "pm" : "am", r) {
      case "b":
      case "bb":
        return l.dayPeriod(u, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return l.dayPeriod(u, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return l.dayPeriod(u, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return l.dayPeriod(u, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(i, r, l) {
    var a = i.getUTCHours(), u;
    switch (a >= 17 ? u = $r.evening : a >= 12 ? u = $r.afternoon : a >= 4 ? u = $r.morning : u = $r.night, r) {
      case "B":
      case "BB":
      case "BBB":
        return l.dayPeriod(u, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return l.dayPeriod(u, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return l.dayPeriod(u, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(i, r, l) {
    if (r === "ho") {
      var a = i.getUTCHours() % 12;
      return a === 0 && (a = 12), l.ordinalNumber(a, {
        unit: "hour"
      });
    }
    return Wn.h(i, r);
  },
  // Hour [0-23]
  H: function(i, r, l) {
    return r === "Ho" ? l.ordinalNumber(i.getUTCHours(), {
      unit: "hour"
    }) : Wn.H(i, r);
  },
  // Hour [0-11]
  K: function(i, r, l) {
    var a = i.getUTCHours() % 12;
    return r === "Ko" ? l.ordinalNumber(a, {
      unit: "hour"
    }) : We(a, r.length);
  },
  // Hour [1-24]
  k: function(i, r, l) {
    var a = i.getUTCHours();
    return a === 0 && (a = 24), r === "ko" ? l.ordinalNumber(a, {
      unit: "hour"
    }) : We(a, r.length);
  },
  // Minute
  m: function(i, r, l) {
    return r === "mo" ? l.ordinalNumber(i.getUTCMinutes(), {
      unit: "minute"
    }) : Wn.m(i, r);
  },
  // Second
  s: function(i, r, l) {
    return r === "so" ? l.ordinalNumber(i.getUTCSeconds(), {
      unit: "second"
    }) : Wn.s(i, r);
  },
  // Fraction of second
  S: function(i, r) {
    return Wn.S(i, r);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(i, r, l, a) {
    var u = a._originalDate || i, s = u.getTimezoneOffset();
    if (s === 0)
      return "Z";
    switch (r) {
      case "X":
        return Cu(s);
      case "XXXX":
      case "XX":
        return rr(s);
      case "XXXXX":
      case "XXX":
      default:
        return rr(s, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(i, r, l, a) {
    var u = a._originalDate || i, s = u.getTimezoneOffset();
    switch (r) {
      case "x":
        return Cu(s);
      case "xxxx":
      case "xx":
        return rr(s);
      case "xxxxx":
      case "xxx":
      default:
        return rr(s, ":");
    }
  },
  // Timezone (GMT)
  O: function(i, r, l, a) {
    var u = a._originalDate || i, s = u.getTimezoneOffset();
    switch (r) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + ku(s, ":");
      case "OOOO":
      default:
        return "GMT" + rr(s, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(i, r, l, a) {
    var u = a._originalDate || i, s = u.getTimezoneOffset();
    switch (r) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + ku(s, ":");
      case "zzzz":
      default:
        return "GMT" + rr(s, ":");
    }
  },
  // Seconds timestamp
  t: function(i, r, l, a) {
    var u = a._originalDate || i, s = Math.floor(u.getTime() / 1e3);
    return We(s, r.length);
  },
  // Milliseconds timestamp
  T: function(i, r, l, a) {
    var u = a._originalDate || i, s = u.getTime();
    return We(s, r.length);
  }
};
function ku(t, i) {
  var r = t > 0 ? "-" : "+", l = Math.abs(t), a = Math.floor(l / 60), u = l % 60;
  if (u === 0)
    return r + String(a);
  var s = i || "";
  return r + String(a) + s + We(u, 2);
}
function Cu(t, i) {
  if (t % 60 === 0) {
    var r = t > 0 ? "-" : "+";
    return r + We(Math.abs(t) / 60, 2);
  }
  return rr(t, i);
}
function rr(t, i) {
  var r = i || "", l = t > 0 ? "-" : "+", a = Math.abs(t), u = We(Math.floor(a / 60), 2), s = We(a % 60, 2);
  return l + u + r + s;
}
const H0 = W0;
var $u = function(i, r) {
  switch (i) {
    case "P":
      return r.date({
        width: "short"
      });
    case "PP":
      return r.date({
        width: "medium"
      });
    case "PPP":
      return r.date({
        width: "long"
      });
    case "PPPP":
    default:
      return r.date({
        width: "full"
      });
  }
}, Xu = function(i, r) {
  switch (i) {
    case "p":
      return r.time({
        width: "short"
      });
    case "pp":
      return r.time({
        width: "medium"
      });
    case "ppp":
      return r.time({
        width: "long"
      });
    case "pppp":
    default:
      return r.time({
        width: "full"
      });
  }
}, U0 = function(i, r) {
  var l = i.match(/(P+)(p+)?/) || [], a = l[1], u = l[2];
  if (!u)
    return $u(i, r);
  var s;
  switch (a) {
    case "P":
      s = r.dateTime({
        width: "short"
      });
      break;
    case "PP":
      s = r.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      s = r.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      s = r.dateTime({
        width: "full"
      });
      break;
  }
  return s.replace("{{date}}", $u(a, r)).replace("{{time}}", Xu(u, r));
}, N0 = {
  p: Xu,
  P: U0
};
const Oa = N0;
var z0 = ["D", "DD"], q0 = ["YY", "YYYY"];
function Zu(t) {
  return z0.indexOf(t) !== -1;
}
function Ju(t) {
  return q0.indexOf(t) !== -1;
}
function qi(t, i, r) {
  if (t === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(i, "`) for formatting years to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(i, "`) for formatting years to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(i, "`) for formatting days of the month to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(i, "`) for formatting days of the month to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var Y0 = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, G0 = function(i, r, l) {
  var a, u = Y0[i];
  return typeof u == "string" ? a = u : r === 1 ? a = u.one : a = u.other.replace("{{count}}", r.toString()), l != null && l.addSuffix ? l.comparison && l.comparison > 0 ? "in " + a : a + " ago" : a;
};
const K0 = G0;
function _a(t) {
  return function() {
    var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = i.width ? String(i.width) : t.defaultWidth, l = t.formats[r] || t.formats[t.defaultWidth];
    return l;
  };
}
var Q0 = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, X0 = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Z0 = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, J0 = {
  date: _a({
    formats: Q0,
    defaultWidth: "full"
  }),
  time: _a({
    formats: X0,
    defaultWidth: "full"
  }),
  dateTime: _a({
    formats: Z0,
    defaultWidth: "full"
  })
};
const j0 = J0;
var ey = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, ty = function(i, r, l, a) {
  return ey[i];
};
const ny = ty;
function Yr(t) {
  return function(i, r) {
    var l = r != null && r.context ? String(r.context) : "standalone", a;
    if (l === "formatting" && t.formattingValues) {
      var u = t.defaultFormattingWidth || t.defaultWidth, s = r != null && r.width ? String(r.width) : u;
      a = t.formattingValues[s] || t.formattingValues[u];
    } else {
      var h = t.defaultWidth, g = r != null && r.width ? String(r.width) : t.defaultWidth;
      a = t.values[g] || t.values[h];
    }
    var T = t.argumentCallback ? t.argumentCallback(i) : i;
    return a[T];
  };
}
var ry = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, iy = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, oy = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, ay = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, sy = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, ly = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, uy = function(i, r) {
  var l = Number(i), a = l % 100;
  if (a > 20 || a < 10)
    switch (a % 10) {
      case 1:
        return l + "st";
      case 2:
        return l + "nd";
      case 3:
        return l + "rd";
    }
  return l + "th";
}, cy = {
  ordinalNumber: uy,
  era: Yr({
    values: ry,
    defaultWidth: "wide"
  }),
  quarter: Yr({
    values: iy,
    defaultWidth: "wide",
    argumentCallback: function(i) {
      return i - 1;
    }
  }),
  month: Yr({
    values: oy,
    defaultWidth: "wide"
  }),
  day: Yr({
    values: ay,
    defaultWidth: "wide"
  }),
  dayPeriod: Yr({
    values: sy,
    defaultWidth: "wide",
    formattingValues: ly,
    defaultFormattingWidth: "wide"
  })
};
const dy = cy;
function Gr(t) {
  return function(i) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, l = r.width, a = l && t.matchPatterns[l] || t.matchPatterns[t.defaultMatchWidth], u = i.match(a);
    if (!u)
      return null;
    var s = u[0], h = l && t.parsePatterns[l] || t.parsePatterns[t.defaultParseWidth], g = Array.isArray(h) ? hy(h, function(S) {
      return S.test(s);
    }) : fy(h, function(S) {
      return S.test(s);
    }), T;
    T = t.valueCallback ? t.valueCallback(g) : g, T = r.valueCallback ? r.valueCallback(T) : T;
    var k = i.slice(s.length);
    return {
      value: T,
      rest: k
    };
  };
}
function fy(t, i) {
  for (var r in t)
    if (t.hasOwnProperty(r) && i(t[r]))
      return r;
}
function hy(t, i) {
  for (var r = 0; r < t.length; r++)
    if (i(t[r]))
      return r;
}
function py(t) {
  return function(i) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, l = i.match(t.matchPattern);
    if (!l)
      return null;
    var a = l[0], u = i.match(t.parsePattern);
    if (!u)
      return null;
    var s = t.valueCallback ? t.valueCallback(u[0]) : u[0];
    s = r.valueCallback ? r.valueCallback(s) : s;
    var h = i.slice(a.length);
    return {
      value: s,
      rest: h
    };
  };
}
var vy = /^(\d+)(th|st|nd|rd)?/i, my = /\d+/i, gy = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, yy = {
  any: [/^b/i, /^(a|c)/i]
}, wy = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, by = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, ky = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Cy = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, $y = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, _y = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Ty = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Sy = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Oy = {
  ordinalNumber: py({
    matchPattern: vy,
    parsePattern: my,
    valueCallback: function(i) {
      return parseInt(i, 10);
    }
  }),
  era: Gr({
    matchPatterns: gy,
    defaultMatchWidth: "wide",
    parsePatterns: yy,
    defaultParseWidth: "any"
  }),
  quarter: Gr({
    matchPatterns: wy,
    defaultMatchWidth: "wide",
    parsePatterns: by,
    defaultParseWidth: "any",
    valueCallback: function(i) {
      return i + 1;
    }
  }),
  month: Gr({
    matchPatterns: ky,
    defaultMatchWidth: "wide",
    parsePatterns: Cy,
    defaultParseWidth: "any"
  }),
  day: Gr({
    matchPatterns: $y,
    defaultMatchWidth: "wide",
    parsePatterns: _y,
    defaultParseWidth: "any"
  }),
  dayPeriod: Gr({
    matchPatterns: Ty,
    defaultMatchWidth: "any",
    parsePatterns: Sy,
    defaultParseWidth: "any"
  })
};
const My = Oy;
var Ay = {
  code: "en-US",
  formatDistance: K0,
  formatLong: j0,
  formatRelative: ny,
  localize: dy,
  match: My,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const ju = Ay;
var Dy = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Iy = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Ey = /^'([^]*?)'?$/, By = /''/g, xy = /[a-zA-Z]/;
function Ta(t, i, r) {
  var l, a, u, s, h, g, T, k, S, E, O, C, I, M, R, ee, U, de;
  qe(2, arguments);
  var ue = String(i), Ie = sr(), Ae = (l = (a = r == null ? void 0 : r.locale) !== null && a !== void 0 ? a : Ie.locale) !== null && l !== void 0 ? l : ju, Ze = _t((u = (s = (h = (g = r == null ? void 0 : r.firstWeekContainsDate) !== null && g !== void 0 ? g : r == null || (T = r.locale) === null || T === void 0 || (k = T.options) === null || k === void 0 ? void 0 : k.firstWeekContainsDate) !== null && h !== void 0 ? h : Ie.firstWeekContainsDate) !== null && s !== void 0 ? s : (S = Ie.locale) === null || S === void 0 || (E = S.options) === null || E === void 0 ? void 0 : E.firstWeekContainsDate) !== null && u !== void 0 ? u : 1);
  if (!(Ze >= 1 && Ze <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var pt = _t((O = (C = (I = (M = r == null ? void 0 : r.weekStartsOn) !== null && M !== void 0 ? M : r == null || (R = r.locale) === null || R === void 0 || (ee = R.options) === null || ee === void 0 ? void 0 : ee.weekStartsOn) !== null && I !== void 0 ? I : Ie.weekStartsOn) !== null && C !== void 0 ? C : (U = Ie.locale) === null || U === void 0 || (de = U.options) === null || de === void 0 ? void 0 : de.weekStartsOn) !== null && O !== void 0 ? O : 0);
  if (!(pt >= 0 && pt <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!Ae.localize)
    throw new RangeError("locale must contain localize property");
  if (!Ae.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var re = lt(t);
  if (!qu(re))
    throw new RangeError("Invalid time value");
  var xe = zu(re), Le = Yu(re, xe), be = {
    firstWeekContainsDate: Ze,
    weekStartsOn: pt,
    locale: Ae,
    _originalDate: re
  }, Tt = ue.match(Iy).map(function(De) {
    var Je = De[0];
    if (Je === "p" || Je === "P") {
      var ke = Oa[Je];
      return ke(De, Ae.formatLong);
    }
    return De;
  }).join("").match(Dy).map(function(De) {
    if (De === "''")
      return "'";
    var Je = De[0];
    if (Je === "'")
      return Vy(De);
    var ke = H0[Je];
    if (ke)
      return !(r != null && r.useAdditionalWeekYearTokens) && Ju(De) && qi(De, i, String(t)), !(r != null && r.useAdditionalDayOfYearTokens) && Zu(De) && qi(De, i, String(t)), ke(Le, De, Ae.localize, be);
    if (Je.match(xy))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + Je + "`");
    return De;
  }).join("");
  return Tt;
}
function Vy(t) {
  var i = t.match(Ey);
  return i ? i[1].replace(By, "'") : t;
}
function Py(t, i) {
  if (t == null)
    throw new TypeError("assign requires that input parameter not be null or undefined");
  for (var r in i)
    Object.prototype.hasOwnProperty.call(i, r) && (t[r] = i[r]);
  return t;
}
var Ly = 6048e5;
function Ry(t) {
  qe(1, arguments);
  var i = lt(t), r = zi(i).getTime() - M0(i).getTime();
  return Math.round(r / Ly) + 1;
}
function _u(t, i) {
  (i == null || i > t.length) && (i = t.length);
  for (var r = 0, l = new Array(i); r < i; r++)
    l[r] = t[r];
  return l;
}
function Fy(t, i) {
  if (t) {
    if (typeof t == "string")
      return _u(t, i);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set")
      return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return _u(t, i);
  }
}
function Tu(t, i) {
  var r = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (!r) {
    if (Array.isArray(t) || (r = Fy(t)) || i && t && typeof t.length == "number") {
      r && (t = r);
      var l = 0, a = function() {
      };
      return {
        s: a,
        n: function() {
          return l >= t.length ? {
            done: !0
          } : {
            done: !1,
            value: t[l++]
          };
        },
        e: function(T) {
          throw T;
        },
        f: a
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var u = !0, s = !1, h;
  return {
    s: function() {
      r = r.call(t);
    },
    n: function() {
      var T = r.next();
      return u = T.done, T;
    },
    e: function(T) {
      s = !0, h = T;
    },
    f: function() {
      try {
        !u && r.return != null && r.return();
      } finally {
        if (s)
          throw h;
      }
    }
  };
}
function Q(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function Ma(t, i) {
  return Ma = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(l, a) {
    return l.__proto__ = a, l;
  }, Ma(t, i);
}
function Ee(t, i) {
  if (typeof i != "function" && i !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(i && i.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), i && Ma(t, i);
}
function Yi(t) {
  return Yi = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Yi(t);
}
function Wy() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Hy(t, i) {
  if (i && (An(i) === "object" || typeof i == "function"))
    return i;
  if (i !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Q(t);
}
function Be(t) {
  var i = Wy();
  return function() {
    var l = Yi(t), a;
    if (i) {
      var u = Yi(this).constructor;
      a = Reflect.construct(l, arguments, u);
    } else
      a = l.apply(this, arguments);
    return Hy(this, a);
  };
}
function Oe(t, i) {
  if (!(t instanceof i))
    throw new TypeError("Cannot call a class as a function");
}
function Uy(t, i) {
  if (An(t) != "object" || !t)
    return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var l = r.call(t, i || "default");
    if (An(l) != "object")
      return l;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (i === "string" ? String : Number)(t);
}
function ec(t) {
  var i = Uy(t, "string");
  return An(i) == "symbol" ? i : String(i);
}
function Su(t, i) {
  for (var r = 0; r < i.length; r++) {
    var l = i[r];
    l.enumerable = l.enumerable || !1, l.configurable = !0, "value" in l && (l.writable = !0), Object.defineProperty(t, ec(l.key), l);
  }
}
function Me(t, i, r) {
  return i && Su(t.prototype, i), r && Su(t, r), Object.defineProperty(t, "prototype", {
    writable: !1
  }), t;
}
function Y(t, i, r) {
  return i = ec(i), i in t ? Object.defineProperty(t, i, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[i] = r, t;
}
var Ny = 10, tc = /* @__PURE__ */ function() {
  function t() {
    Oe(this, t), Y(this, "priority", void 0), Y(this, "subPriority", 0);
  }
  return Me(t, [{
    key: "validate",
    value: function(r, l) {
      return !0;
    }
  }]), t;
}(), zy = /* @__PURE__ */ function(t) {
  Ee(r, t);
  var i = Be(r);
  function r(l, a, u, s, h) {
    var g;
    return Oe(this, r), g = i.call(this), g.value = l, g.validateValue = a, g.setValue = u, g.priority = s, h && (g.subPriority = h), g;
  }
  return Me(r, [{
    key: "validate",
    value: function(a, u) {
      return this.validateValue(a, this.value, u);
    }
  }, {
    key: "set",
    value: function(a, u, s) {
      return this.setValue(a, u, this.value, s);
    }
  }]), r;
}(tc), qy = /* @__PURE__ */ function(t) {
  Ee(r, t);
  var i = Be(r);
  function r() {
    var l;
    Oe(this, r);
    for (var a = arguments.length, u = new Array(a), s = 0; s < a; s++)
      u[s] = arguments[s];
    return l = i.call.apply(i, [this].concat(u)), Y(Q(l), "priority", Ny), Y(Q(l), "subPriority", -1), l;
  }
  return Me(r, [{
    key: "set",
    value: function(a, u) {
      if (u.timestampIsSet)
        return a;
      var s = /* @__PURE__ */ new Date(0);
      return s.setFullYear(a.getUTCFullYear(), a.getUTCMonth(), a.getUTCDate()), s.setHours(a.getUTCHours(), a.getUTCMinutes(), a.getUTCSeconds(), a.getUTCMilliseconds()), s;
    }
  }]), r;
}(tc), Pe = /* @__PURE__ */ function() {
  function t() {
    Oe(this, t), Y(this, "incompatibleTokens", void 0), Y(this, "priority", void 0), Y(this, "subPriority", void 0);
  }
  return Me(t, [{
    key: "run",
    value: function(r, l, a, u) {
      var s = this.parse(r, l, a, u);
      return s ? {
        setter: new zy(s.value, this.validate, this.set, this.priority, this.subPriority),
        rest: s.rest
      } : null;
    }
  }, {
    key: "validate",
    value: function(r, l, a) {
      return !0;
    }
  }]), t;
}(), Yy = /* @__PURE__ */ function(t) {
  Ee(r, t);
  var i = Be(r);
  function r() {
    var l;
    Oe(this, r);
    for (var a = arguments.length, u = new Array(a), s = 0; s < a; s++)
      u[s] = arguments[s];
    return l = i.call.apply(i, [this].concat(u)), Y(Q(l), "priority", 140), Y(Q(l), "incompatibleTokens", ["R", "u", "t", "T"]), l;
  }
  return Me(r, [{
    key: "parse",
    value: function(a, u, s) {
      switch (u) {
        case "G":
        case "GG":
        case "GGG":
          return s.era(a, {
            width: "abbreviated"
          }) || s.era(a, {
            width: "narrow"
          });
        case "GGGGG":
          return s.era(a, {
            width: "narrow"
          });
        case "GGGG":
        default:
          return s.era(a, {
            width: "wide"
          }) || s.era(a, {
            width: "abbreviated"
          }) || s.era(a, {
            width: "narrow"
          });
      }
    }
  }, {
    key: "set",
    value: function(a, u, s) {
      return u.era = s, a.setUTCFullYear(s, 0, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), r;
}(Pe), ot = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, hn = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function at(t, i) {
  return t && {
    value: i(t.value),
    rest: t.rest
  };
}
function Xe(t, i) {
  var r = i.match(t);
  return r ? {
    value: parseInt(r[0], 10),
    rest: i.slice(r[0].length)
  } : null;
}
function pn(t, i) {
  var r = i.match(t);
  if (!r)
    return null;
  if (r[0] === "Z")
    return {
      value: 0,
      rest: i.slice(1)
    };
  var l = r[1] === "+" ? 1 : -1, a = r[2] ? parseInt(r[2], 10) : 0, u = r[3] ? parseInt(r[3], 10) : 0, s = r[5] ? parseInt(r[5], 10) : 0;
  return {
    value: l * (a * D0 + u * A0 + s * I0),
    rest: i.slice(r[0].length)
  };
}
function nc(t) {
  return Xe(ot.anyDigitsSigned, t);
}
function et(t, i) {
  switch (t) {
    case 1:
      return Xe(ot.singleDigit, i);
    case 2:
      return Xe(ot.twoDigits, i);
    case 3:
      return Xe(ot.threeDigits, i);
    case 4:
      return Xe(ot.fourDigits, i);
    default:
      return Xe(new RegExp("^\\d{1," + t + "}"), i);
  }
}
function Gi(t, i) {
  switch (t) {
    case 1:
      return Xe(ot.singleDigitSigned, i);
    case 2:
      return Xe(ot.twoDigitsSigned, i);
    case 3:
      return Xe(ot.threeDigitsSigned, i);
    case 4:
      return Xe(ot.fourDigitsSigned, i);
    default:
      return Xe(new RegExp("^-?\\d{1," + t + "}"), i);
  }
}
function Pa(t) {
  switch (t) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function rc(t, i) {
  var r = i > 0, l = r ? i : 1 - i, a;
  if (l <= 50)
    a = t || 100;
  else {
    var u = l + 50, s = Math.floor(u / 100) * 100, h = t >= u % 100;
    a = t + s - (h ? 100 : 0);
  }
  return r ? a : 1 - a;
}
function ic(t) {
  return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
}
var Gy = /* @__PURE__ */ function(t) {
  Ee(r, t);
  var i = Be(r);
  function r() {
    var l;
    Oe(this, r);
    for (var a = arguments.length, u = new Array(a), s = 0; s < a; s++)
      u[s] = arguments[s];
    return l = i.call.apply(i, [this].concat(u)), Y(Q(l), "priority", 130), Y(Q(l), "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]), l;
  }
  return Me(r, [{
    key: "parse",
    value: function(a, u, s) {
      var h = function(T) {
        return {
          year: T,
          isTwoDigitYear: u === "yy"
        };
      };
      switch (u) {
        case "y":
          return at(et(4, a), h);
        case "yo":
          return at(s.ordinalNumber(a, {
            unit: "year"
          }), h);
        default:
          return at(et(u.length, a), h);
      }
    }
  }, {
    key: "validate",
    value: function(a, u) {
      return u.isTwoDigitYear || u.year > 0;
    }
  }, {
    key: "set",
    value: function(a, u, s) {
      var h = a.getUTCFullYear();
      if (s.isTwoDigitYear) {
        var g = rc(s.year, h);
        return a.setUTCFullYear(g, 0, 1), a.setUTCHours(0, 0, 0, 0), a;
      }
      var T = !("era" in u) || u.era === 1 ? s.year : 1 - s.year;
      return a.setUTCFullYear(T, 0, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), r;
}(Pe), Ky = /* @__PURE__ */ function(t) {
  Ee(r, t);
  var i = Be(r);
  function r() {
    var l;
    Oe(this, r);
    for (var a = arguments.length, u = new Array(a), s = 0; s < a; s++)
      u[s] = arguments[s];
    return l = i.call.apply(i, [this].concat(u)), Y(Q(l), "priority", 130), Y(Q(l), "incompatibleTokens", ["y", "R", "u", "Q", "q", "M", "L", "I", "d", "D", "i", "t", "T"]), l;
  }
  return Me(r, [{
    key: "parse",
    value: function(a, u, s) {
      var h = function(T) {
        return {
          year: T,
          isTwoDigitYear: u === "YY"
        };
      };
      switch (u) {
        case "Y":
          return at(et(4, a), h);
        case "Yo":
          return at(s.ordinalNumber(a, {
            unit: "year"
          }), h);
        default:
          return at(et(u.length, a), h);
      }
    }
  }, {
    key: "validate",
    value: function(a, u) {
      return u.isTwoDigitYear || u.year > 0;
    }
  }, {
    key: "set",
    value: function(a, u, s, h) {
      var g = Va(a, h);
      if (s.isTwoDigitYear) {
        var T = rc(s.year, g);
        return a.setUTCFullYear(T, 0, h.firstWeekContainsDate), a.setUTCHours(0, 0, 0, 0), ir(a, h);
      }
      var k = !("era" in u) || u.era === 1 ? s.year : 1 - s.year;
      return a.setUTCFullYear(k, 0, h.firstWeekContainsDate), a.setUTCHours(0, 0, 0, 0), ir(a, h);
    }
  }]), r;
}(Pe), Qy = /* @__PURE__ */ function(t) {
  Ee(r, t);
  var i = Be(r);
  function r() {
    var l;
    Oe(this, r);
    for (var a = arguments.length, u = new Array(a), s = 0; s < a; s++)
      u[s] = arguments[s];
    return l = i.call.apply(i, [this].concat(u)), Y(Q(l), "priority", 130), Y(Q(l), "incompatibleTokens", ["G", "y", "Y", "u", "Q", "q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), l;
  }
  return Me(r, [{
    key: "parse",
    value: function(a, u) {
      return Gi(u === "R" ? 4 : u.length, a);
    }
  }, {
    key: "set",
    value: function(a, u, s) {
      var h = /* @__PURE__ */ new Date(0);
      return h.setUTCFullYear(s, 0, 4), h.setUTCHours(0, 0, 0, 0), Tr(h);
    }
  }]), r;
}(Pe), Xy = /* @__PURE__ */ function(t) {
  Ee(r, t);
  var i = Be(r);
  function r() {
    var l;
    Oe(this, r);
    for (var a = arguments.length, u = new Array(a), s = 0; s < a; s++)
      u[s] = arguments[s];
    return l = i.call.apply(i, [this].concat(u)), Y(Q(l), "priority", 130), Y(Q(l), "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]), l;
  }
  return Me(r, [{
    key: "parse",
    value: function(a, u) {
      return Gi(u === "u" ? 4 : u.length, a);
    }
  }, {
    key: "set",
    value: function(a, u, s) {
      return a.setUTCFullYear(s, 0, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), r;
}(Pe), Zy = /* @__PURE__ */ function(t) {
  Ee(r, t);
  var i = Be(r);
  function r() {
    var l;
    Oe(this, r);
    for (var a = arguments.length, u = new Array(a), s = 0; s < a; s++)
      u[s] = arguments[s];
    return l = i.call.apply(i, [this].concat(u)), Y(Q(l), "priority", 120), Y(Q(l), "incompatibleTokens", ["Y", "R", "q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), l;
  }
  return Me(r, [{
    key: "parse",
    value: function(a, u, s) {
      switch (u) {
        case "Q":
        case "QQ":
          return et(u.length, a);
        case "Qo":
          return s.ordinalNumber(a, {
            unit: "quarter"
          });
        case "QQQ":
          return s.quarter(a, {
            width: "abbreviated",
            context: "formatting"
          }) || s.quarter(a, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQQ":
          return s.quarter(a, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQ":
        default:
          return s.quarter(a, {
            width: "wide",
            context: "formatting"
          }) || s.quarter(a, {
            width: "abbreviated",
            context: "formatting"
          }) || s.quarter(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(a, u) {
      return u >= 1 && u <= 4;
    }
  }, {
    key: "set",
    value: function(a, u, s) {
      return a.setUTCMonth((s - 1) * 3, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), r;
}(Pe), Jy = /* @__PURE__ */ function(t) {
  Ee(r, t);
  var i = Be(r);
  function r() {
    var l;
    Oe(this, r);
    for (var a = arguments.length, u = new Array(a), s = 0; s < a; s++)
      u[s] = arguments[s];
    return l = i.call.apply(i, [this].concat(u)), Y(Q(l), "priority", 120), Y(Q(l), "incompatibleTokens", ["Y", "R", "Q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), l;
  }
  return Me(r, [{
    key: "parse",
    value: function(a, u, s) {
      switch (u) {
        case "q":
        case "qq":
          return et(u.length, a);
        case "qo":
          return s.ordinalNumber(a, {
            unit: "quarter"
          });
        case "qqq":
          return s.quarter(a, {
            width: "abbreviated",
            context: "standalone"
          }) || s.quarter(a, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqqq":
          return s.quarter(a, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqq":
        default:
          return s.quarter(a, {
            width: "wide",
            context: "standalone"
          }) || s.quarter(a, {
            width: "abbreviated",
            context: "standalone"
          }) || s.quarter(a, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(a, u) {
      return u >= 1 && u <= 4;
    }
  }, {
    key: "set",
    value: function(a, u, s) {
      return a.setUTCMonth((s - 1) * 3, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), r;
}(Pe), jy = /* @__PURE__ */ function(t) {
  Ee(r, t);
  var i = Be(r);
  function r() {
    var l;
    Oe(this, r);
    for (var a = arguments.length, u = new Array(a), s = 0; s < a; s++)
      u[s] = arguments[s];
    return l = i.call.apply(i, [this].concat(u)), Y(Q(l), "incompatibleTokens", ["Y", "R", "q", "Q", "L", "w", "I", "D", "i", "e", "c", "t", "T"]), Y(Q(l), "priority", 110), l;
  }
  return Me(r, [{
    key: "parse",
    value: function(a, u, s) {
      var h = function(T) {
        return T - 1;
      };
      switch (u) {
        case "M":
          return at(Xe(ot.month, a), h);
        case "MM":
          return at(et(2, a), h);
        case "Mo":
          return at(s.ordinalNumber(a, {
            unit: "month"
          }), h);
        case "MMM":
          return s.month(a, {
            width: "abbreviated",
            context: "formatting"
          }) || s.month(a, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMMM":
          return s.month(a, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMM":
        default:
          return s.month(a, {
            width: "wide",
            context: "formatting"
          }) || s.month(a, {
            width: "abbreviated",
            context: "formatting"
          }) || s.month(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(a, u) {
      return u >= 0 && u <= 11;
    }
  }, {
    key: "set",
    value: function(a, u, s) {
      return a.setUTCMonth(s, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), r;
}(Pe), ew = /* @__PURE__ */ function(t) {
  Ee(r, t);
  var i = Be(r);
  function r() {
    var l;
    Oe(this, r);
    for (var a = arguments.length, u = new Array(a), s = 0; s < a; s++)
      u[s] = arguments[s];
    return l = i.call.apply(i, [this].concat(u)), Y(Q(l), "priority", 110), Y(Q(l), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "w", "I", "D", "i", "e", "c", "t", "T"]), l;
  }
  return Me(r, [{
    key: "parse",
    value: function(a, u, s) {
      var h = function(T) {
        return T - 1;
      };
      switch (u) {
        case "L":
          return at(Xe(ot.month, a), h);
        case "LL":
          return at(et(2, a), h);
        case "Lo":
          return at(s.ordinalNumber(a, {
            unit: "month"
          }), h);
        case "LLL":
          return s.month(a, {
            width: "abbreviated",
            context: "standalone"
          }) || s.month(a, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLLL":
          return s.month(a, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLL":
        default:
          return s.month(a, {
            width: "wide",
            context: "standalone"
          }) || s.month(a, {
            width: "abbreviated",
            context: "standalone"
          }) || s.month(a, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(a, u) {
      return u >= 0 && u <= 11;
    }
  }, {
    key: "set",
    value: function(a, u, s) {
      return a.setUTCMonth(s, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), r;
}(Pe);
function tw(t, i, r) {
  qe(2, arguments);
  var l = lt(t), a = _t(i), u = Qu(l, r) - a;
  return l.setUTCDate(l.getUTCDate() - u * 7), l;
}
var nw = /* @__PURE__ */ function(t) {
  Ee(r, t);
  var i = Be(r);
  function r() {
    var l;
    Oe(this, r);
    for (var a = arguments.length, u = new Array(a), s = 0; s < a; s++)
      u[s] = arguments[s];
    return l = i.call.apply(i, [this].concat(u)), Y(Q(l), "priority", 100), Y(Q(l), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "i", "t", "T"]), l;
  }
  return Me(r, [{
    key: "parse",
    value: function(a, u, s) {
      switch (u) {
        case "w":
          return Xe(ot.week, a);
        case "wo":
          return s.ordinalNumber(a, {
            unit: "week"
          });
        default:
          return et(u.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, u) {
      return u >= 1 && u <= 53;
    }
  }, {
    key: "set",
    value: function(a, u, s, h) {
      return ir(tw(a, s, h), h);
    }
  }]), r;
}(Pe);
function rw(t, i) {
  qe(2, arguments);
  var r = lt(t), l = _t(i), a = Ku(r) - l;
  return r.setUTCDate(r.getUTCDate() - a * 7), r;
}
var iw = /* @__PURE__ */ function(t) {
  Ee(r, t);
  var i = Be(r);
  function r() {
    var l;
    Oe(this, r);
    for (var a = arguments.length, u = new Array(a), s = 0; s < a; s++)
      u[s] = arguments[s];
    return l = i.call.apply(i, [this].concat(u)), Y(Q(l), "priority", 100), Y(Q(l), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), l;
  }
  return Me(r, [{
    key: "parse",
    value: function(a, u, s) {
      switch (u) {
        case "I":
          return Xe(ot.week, a);
        case "Io":
          return s.ordinalNumber(a, {
            unit: "week"
          });
        default:
          return et(u.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, u) {
      return u >= 1 && u <= 53;
    }
  }, {
    key: "set",
    value: function(a, u, s) {
      return Tr(rw(a, s));
    }
  }]), r;
}(Pe), ow = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], aw = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], sw = /* @__PURE__ */ function(t) {
  Ee(r, t);
  var i = Be(r);
  function r() {
    var l;
    Oe(this, r);
    for (var a = arguments.length, u = new Array(a), s = 0; s < a; s++)
      u[s] = arguments[s];
    return l = i.call.apply(i, [this].concat(u)), Y(Q(l), "priority", 90), Y(Q(l), "subPriority", 1), Y(Q(l), "incompatibleTokens", ["Y", "R", "q", "Q", "w", "I", "D", "i", "e", "c", "t", "T"]), l;
  }
  return Me(r, [{
    key: "parse",
    value: function(a, u, s) {
      switch (u) {
        case "d":
          return Xe(ot.date, a);
        case "do":
          return s.ordinalNumber(a, {
            unit: "date"
          });
        default:
          return et(u.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, u) {
      var s = a.getUTCFullYear(), h = ic(s), g = a.getUTCMonth();
      return h ? u >= 1 && u <= aw[g] : u >= 1 && u <= ow[g];
    }
  }, {
    key: "set",
    value: function(a, u, s) {
      return a.setUTCDate(s), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), r;
}(Pe), lw = /* @__PURE__ */ function(t) {
  Ee(r, t);
  var i = Be(r);
  function r() {
    var l;
    Oe(this, r);
    for (var a = arguments.length, u = new Array(a), s = 0; s < a; s++)
      u[s] = arguments[s];
    return l = i.call.apply(i, [this].concat(u)), Y(Q(l), "priority", 90), Y(Q(l), "subpriority", 1), Y(Q(l), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "L", "w", "I", "d", "E", "i", "e", "c", "t", "T"]), l;
  }
  return Me(r, [{
    key: "parse",
    value: function(a, u, s) {
      switch (u) {
        case "D":
        case "DD":
          return Xe(ot.dayOfYear, a);
        case "Do":
          return s.ordinalNumber(a, {
            unit: "date"
          });
        default:
          return et(u.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, u) {
      var s = a.getUTCFullYear(), h = ic(s);
      return h ? u >= 1 && u <= 366 : u >= 1 && u <= 365;
    }
  }, {
    key: "set",
    value: function(a, u, s) {
      return a.setUTCMonth(0, s), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), r;
}(Pe);
function La(t, i, r) {
  var l, a, u, s, h, g, T, k;
  qe(2, arguments);
  var S = sr(), E = _t((l = (a = (u = (s = r == null ? void 0 : r.weekStartsOn) !== null && s !== void 0 ? s : r == null || (h = r.locale) === null || h === void 0 || (g = h.options) === null || g === void 0 ? void 0 : g.weekStartsOn) !== null && u !== void 0 ? u : S.weekStartsOn) !== null && a !== void 0 ? a : (T = S.locale) === null || T === void 0 || (k = T.options) === null || k === void 0 ? void 0 : k.weekStartsOn) !== null && l !== void 0 ? l : 0);
  if (!(E >= 0 && E <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var O = lt(t), C = _t(i), I = O.getUTCDay(), M = C % 7, R = (M + 7) % 7, ee = (R < E ? 7 : 0) + C - I;
  return O.setUTCDate(O.getUTCDate() + ee), O;
}
var uw = /* @__PURE__ */ function(t) {
  Ee(r, t);
  var i = Be(r);
  function r() {
    var l;
    Oe(this, r);
    for (var a = arguments.length, u = new Array(a), s = 0; s < a; s++)
      u[s] = arguments[s];
    return l = i.call.apply(i, [this].concat(u)), Y(Q(l), "priority", 90), Y(Q(l), "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]), l;
  }
  return Me(r, [{
    key: "parse",
    value: function(a, u, s) {
      switch (u) {
        case "E":
        case "EE":
        case "EEE":
          return s.day(a, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(a, {
            width: "short",
            context: "formatting"
          }) || s.day(a, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEE":
          return s.day(a, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEEE":
          return s.day(a, {
            width: "short",
            context: "formatting"
          }) || s.day(a, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEE":
        default:
          return s.day(a, {
            width: "wide",
            context: "formatting"
          }) || s.day(a, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(a, {
            width: "short",
            context: "formatting"
          }) || s.day(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(a, u) {
      return u >= 0 && u <= 6;
    }
  }, {
    key: "set",
    value: function(a, u, s, h) {
      return a = La(a, s, h), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), r;
}(Pe), cw = /* @__PURE__ */ function(t) {
  Ee(r, t);
  var i = Be(r);
  function r() {
    var l;
    Oe(this, r);
    for (var a = arguments.length, u = new Array(a), s = 0; s < a; s++)
      u[s] = arguments[s];
    return l = i.call.apply(i, [this].concat(u)), Y(Q(l), "priority", 90), Y(Q(l), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "c", "t", "T"]), l;
  }
  return Me(r, [{
    key: "parse",
    value: function(a, u, s, h) {
      var g = function(k) {
        var S = Math.floor((k - 1) / 7) * 7;
        return (k + h.weekStartsOn + 6) % 7 + S;
      };
      switch (u) {
        case "e":
        case "ee":
          return at(et(u.length, a), g);
        case "eo":
          return at(s.ordinalNumber(a, {
            unit: "day"
          }), g);
        case "eee":
          return s.day(a, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(a, {
            width: "short",
            context: "formatting"
          }) || s.day(a, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeee":
          return s.day(a, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeeee":
          return s.day(a, {
            width: "short",
            context: "formatting"
          }) || s.day(a, {
            width: "narrow",
            context: "formatting"
          });
        case "eeee":
        default:
          return s.day(a, {
            width: "wide",
            context: "formatting"
          }) || s.day(a, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(a, {
            width: "short",
            context: "formatting"
          }) || s.day(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(a, u) {
      return u >= 0 && u <= 6;
    }
  }, {
    key: "set",
    value: function(a, u, s, h) {
      return a = La(a, s, h), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), r;
}(Pe), dw = /* @__PURE__ */ function(t) {
  Ee(r, t);
  var i = Be(r);
  function r() {
    var l;
    Oe(this, r);
    for (var a = arguments.length, u = new Array(a), s = 0; s < a; s++)
      u[s] = arguments[s];
    return l = i.call.apply(i, [this].concat(u)), Y(Q(l), "priority", 90), Y(Q(l), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "e", "t", "T"]), l;
  }
  return Me(r, [{
    key: "parse",
    value: function(a, u, s, h) {
      var g = function(k) {
        var S = Math.floor((k - 1) / 7) * 7;
        return (k + h.weekStartsOn + 6) % 7 + S;
      };
      switch (u) {
        case "c":
        case "cc":
          return at(et(u.length, a), g);
        case "co":
          return at(s.ordinalNumber(a, {
            unit: "day"
          }), g);
        case "ccc":
          return s.day(a, {
            width: "abbreviated",
            context: "standalone"
          }) || s.day(a, {
            width: "short",
            context: "standalone"
          }) || s.day(a, {
            width: "narrow",
            context: "standalone"
          });
        case "ccccc":
          return s.day(a, {
            width: "narrow",
            context: "standalone"
          });
        case "cccccc":
          return s.day(a, {
            width: "short",
            context: "standalone"
          }) || s.day(a, {
            width: "narrow",
            context: "standalone"
          });
        case "cccc":
        default:
          return s.day(a, {
            width: "wide",
            context: "standalone"
          }) || s.day(a, {
            width: "abbreviated",
            context: "standalone"
          }) || s.day(a, {
            width: "short",
            context: "standalone"
          }) || s.day(a, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(a, u) {
      return u >= 0 && u <= 6;
    }
  }, {
    key: "set",
    value: function(a, u, s, h) {
      return a = La(a, s, h), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), r;
}(Pe);
function fw(t, i) {
  qe(2, arguments);
  var r = _t(i);
  r % 7 === 0 && (r = r - 7);
  var l = 1, a = lt(t), u = a.getUTCDay(), s = r % 7, h = (s + 7) % 7, g = (h < l ? 7 : 0) + r - u;
  return a.setUTCDate(a.getUTCDate() + g), a;
}
var hw = /* @__PURE__ */ function(t) {
  Ee(r, t);
  var i = Be(r);
  function r() {
    var l;
    Oe(this, r);
    for (var a = arguments.length, u = new Array(a), s = 0; s < a; s++)
      u[s] = arguments[s];
    return l = i.call.apply(i, [this].concat(u)), Y(Q(l), "priority", 90), Y(Q(l), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "E", "e", "c", "t", "T"]), l;
  }
  return Me(r, [{
    key: "parse",
    value: function(a, u, s) {
      var h = function(T) {
        return T === 0 ? 7 : T;
      };
      switch (u) {
        case "i":
        case "ii":
          return et(u.length, a);
        case "io":
          return s.ordinalNumber(a, {
            unit: "day"
          });
        case "iii":
          return at(s.day(a, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(a, {
            width: "short",
            context: "formatting"
          }) || s.day(a, {
            width: "narrow",
            context: "formatting"
          }), h);
        case "iiiii":
          return at(s.day(a, {
            width: "narrow",
            context: "formatting"
          }), h);
        case "iiiiii":
          return at(s.day(a, {
            width: "short",
            context: "formatting"
          }) || s.day(a, {
            width: "narrow",
            context: "formatting"
          }), h);
        case "iiii":
        default:
          return at(s.day(a, {
            width: "wide",
            context: "formatting"
          }) || s.day(a, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(a, {
            width: "short",
            context: "formatting"
          }) || s.day(a, {
            width: "narrow",
            context: "formatting"
          }), h);
      }
    }
  }, {
    key: "validate",
    value: function(a, u) {
      return u >= 1 && u <= 7;
    }
  }, {
    key: "set",
    value: function(a, u, s) {
      return a = fw(a, s), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), r;
}(Pe), pw = /* @__PURE__ */ function(t) {
  Ee(r, t);
  var i = Be(r);
  function r() {
    var l;
    Oe(this, r);
    for (var a = arguments.length, u = new Array(a), s = 0; s < a; s++)
      u[s] = arguments[s];
    return l = i.call.apply(i, [this].concat(u)), Y(Q(l), "priority", 80), Y(Q(l), "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]), l;
  }
  return Me(r, [{
    key: "parse",
    value: function(a, u, s) {
      switch (u) {
        case "a":
        case "aa":
        case "aaa":
          return s.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          }) || s.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaaa":
          return s.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return s.dayPeriod(a, {
            width: "wide",
            context: "formatting"
          }) || s.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          }) || s.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(a, u, s) {
      return a.setUTCHours(Pa(s), 0, 0, 0), a;
    }
  }]), r;
}(Pe), vw = /* @__PURE__ */ function(t) {
  Ee(r, t);
  var i = Be(r);
  function r() {
    var l;
    Oe(this, r);
    for (var a = arguments.length, u = new Array(a), s = 0; s < a; s++)
      u[s] = arguments[s];
    return l = i.call.apply(i, [this].concat(u)), Y(Q(l), "priority", 80), Y(Q(l), "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]), l;
  }
  return Me(r, [{
    key: "parse",
    value: function(a, u, s) {
      switch (u) {
        case "b":
        case "bb":
        case "bbb":
          return s.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          }) || s.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbbb":
          return s.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return s.dayPeriod(a, {
            width: "wide",
            context: "formatting"
          }) || s.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          }) || s.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(a, u, s) {
      return a.setUTCHours(Pa(s), 0, 0, 0), a;
    }
  }]), r;
}(Pe), mw = /* @__PURE__ */ function(t) {
  Ee(r, t);
  var i = Be(r);
  function r() {
    var l;
    Oe(this, r);
    for (var a = arguments.length, u = new Array(a), s = 0; s < a; s++)
      u[s] = arguments[s];
    return l = i.call.apply(i, [this].concat(u)), Y(Q(l), "priority", 80), Y(Q(l), "incompatibleTokens", ["a", "b", "t", "T"]), l;
  }
  return Me(r, [{
    key: "parse",
    value: function(a, u, s) {
      switch (u) {
        case "B":
        case "BB":
        case "BBB":
          return s.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          }) || s.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBBB":
          return s.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return s.dayPeriod(a, {
            width: "wide",
            context: "formatting"
          }) || s.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          }) || s.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(a, u, s) {
      return a.setUTCHours(Pa(s), 0, 0, 0), a;
    }
  }]), r;
}(Pe), gw = /* @__PURE__ */ function(t) {
  Ee(r, t);
  var i = Be(r);
  function r() {
    var l;
    Oe(this, r);
    for (var a = arguments.length, u = new Array(a), s = 0; s < a; s++)
      u[s] = arguments[s];
    return l = i.call.apply(i, [this].concat(u)), Y(Q(l), "priority", 70), Y(Q(l), "incompatibleTokens", ["H", "K", "k", "t", "T"]), l;
  }
  return Me(r, [{
    key: "parse",
    value: function(a, u, s) {
      switch (u) {
        case "h":
          return Xe(ot.hour12h, a);
        case "ho":
          return s.ordinalNumber(a, {
            unit: "hour"
          });
        default:
          return et(u.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, u) {
      return u >= 1 && u <= 12;
    }
  }, {
    key: "set",
    value: function(a, u, s) {
      var h = a.getUTCHours() >= 12;
      return h && s < 12 ? a.setUTCHours(s + 12, 0, 0, 0) : !h && s === 12 ? a.setUTCHours(0, 0, 0, 0) : a.setUTCHours(s, 0, 0, 0), a;
    }
  }]), r;
}(Pe), yw = /* @__PURE__ */ function(t) {
  Ee(r, t);
  var i = Be(r);
  function r() {
    var l;
    Oe(this, r);
    for (var a = arguments.length, u = new Array(a), s = 0; s < a; s++)
      u[s] = arguments[s];
    return l = i.call.apply(i, [this].concat(u)), Y(Q(l), "priority", 70), Y(Q(l), "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]), l;
  }
  return Me(r, [{
    key: "parse",
    value: function(a, u, s) {
      switch (u) {
        case "H":
          return Xe(ot.hour23h, a);
        case "Ho":
          return s.ordinalNumber(a, {
            unit: "hour"
          });
        default:
          return et(u.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, u) {
      return u >= 0 && u <= 23;
    }
  }, {
    key: "set",
    value: function(a, u, s) {
      return a.setUTCHours(s, 0, 0, 0), a;
    }
  }]), r;
}(Pe), ww = /* @__PURE__ */ function(t) {
  Ee(r, t);
  var i = Be(r);
  function r() {
    var l;
    Oe(this, r);
    for (var a = arguments.length, u = new Array(a), s = 0; s < a; s++)
      u[s] = arguments[s];
    return l = i.call.apply(i, [this].concat(u)), Y(Q(l), "priority", 70), Y(Q(l), "incompatibleTokens", ["h", "H", "k", "t", "T"]), l;
  }
  return Me(r, [{
    key: "parse",
    value: function(a, u, s) {
      switch (u) {
        case "K":
          return Xe(ot.hour11h, a);
        case "Ko":
          return s.ordinalNumber(a, {
            unit: "hour"
          });
        default:
          return et(u.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, u) {
      return u >= 0 && u <= 11;
    }
  }, {
    key: "set",
    value: function(a, u, s) {
      var h = a.getUTCHours() >= 12;
      return h && s < 12 ? a.setUTCHours(s + 12, 0, 0, 0) : a.setUTCHours(s, 0, 0, 0), a;
    }
  }]), r;
}(Pe), bw = /* @__PURE__ */ function(t) {
  Ee(r, t);
  var i = Be(r);
  function r() {
    var l;
    Oe(this, r);
    for (var a = arguments.length, u = new Array(a), s = 0; s < a; s++)
      u[s] = arguments[s];
    return l = i.call.apply(i, [this].concat(u)), Y(Q(l), "priority", 70), Y(Q(l), "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]), l;
  }
  return Me(r, [{
    key: "parse",
    value: function(a, u, s) {
      switch (u) {
        case "k":
          return Xe(ot.hour24h, a);
        case "ko":
          return s.ordinalNumber(a, {
            unit: "hour"
          });
        default:
          return et(u.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, u) {
      return u >= 1 && u <= 24;
    }
  }, {
    key: "set",
    value: function(a, u, s) {
      var h = s <= 24 ? s % 24 : s;
      return a.setUTCHours(h, 0, 0, 0), a;
    }
  }]), r;
}(Pe), kw = /* @__PURE__ */ function(t) {
  Ee(r, t);
  var i = Be(r);
  function r() {
    var l;
    Oe(this, r);
    for (var a = arguments.length, u = new Array(a), s = 0; s < a; s++)
      u[s] = arguments[s];
    return l = i.call.apply(i, [this].concat(u)), Y(Q(l), "priority", 60), Y(Q(l), "incompatibleTokens", ["t", "T"]), l;
  }
  return Me(r, [{
    key: "parse",
    value: function(a, u, s) {
      switch (u) {
        case "m":
          return Xe(ot.minute, a);
        case "mo":
          return s.ordinalNumber(a, {
            unit: "minute"
          });
        default:
          return et(u.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, u) {
      return u >= 0 && u <= 59;
    }
  }, {
    key: "set",
    value: function(a, u, s) {
      return a.setUTCMinutes(s, 0, 0), a;
    }
  }]), r;
}(Pe), Cw = /* @__PURE__ */ function(t) {
  Ee(r, t);
  var i = Be(r);
  function r() {
    var l;
    Oe(this, r);
    for (var a = arguments.length, u = new Array(a), s = 0; s < a; s++)
      u[s] = arguments[s];
    return l = i.call.apply(i, [this].concat(u)), Y(Q(l), "priority", 50), Y(Q(l), "incompatibleTokens", ["t", "T"]), l;
  }
  return Me(r, [{
    key: "parse",
    value: function(a, u, s) {
      switch (u) {
        case "s":
          return Xe(ot.second, a);
        case "so":
          return s.ordinalNumber(a, {
            unit: "second"
          });
        default:
          return et(u.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, u) {
      return u >= 0 && u <= 59;
    }
  }, {
    key: "set",
    value: function(a, u, s) {
      return a.setUTCSeconds(s, 0), a;
    }
  }]), r;
}(Pe), $w = /* @__PURE__ */ function(t) {
  Ee(r, t);
  var i = Be(r);
  function r() {
    var l;
    Oe(this, r);
    for (var a = arguments.length, u = new Array(a), s = 0; s < a; s++)
      u[s] = arguments[s];
    return l = i.call.apply(i, [this].concat(u)), Y(Q(l), "priority", 30), Y(Q(l), "incompatibleTokens", ["t", "T"]), l;
  }
  return Me(r, [{
    key: "parse",
    value: function(a, u) {
      var s = function(g) {
        return Math.floor(g * Math.pow(10, -u.length + 3));
      };
      return at(et(u.length, a), s);
    }
  }, {
    key: "set",
    value: function(a, u, s) {
      return a.setUTCMilliseconds(s), a;
    }
  }]), r;
}(Pe), _w = /* @__PURE__ */ function(t) {
  Ee(r, t);
  var i = Be(r);
  function r() {
    var l;
    Oe(this, r);
    for (var a = arguments.length, u = new Array(a), s = 0; s < a; s++)
      u[s] = arguments[s];
    return l = i.call.apply(i, [this].concat(u)), Y(Q(l), "priority", 10), Y(Q(l), "incompatibleTokens", ["t", "T", "x"]), l;
  }
  return Me(r, [{
    key: "parse",
    value: function(a, u) {
      switch (u) {
        case "X":
          return pn(hn.basicOptionalMinutes, a);
        case "XX":
          return pn(hn.basic, a);
        case "XXXX":
          return pn(hn.basicOptionalSeconds, a);
        case "XXXXX":
          return pn(hn.extendedOptionalSeconds, a);
        case "XXX":
        default:
          return pn(hn.extended, a);
      }
    }
  }, {
    key: "set",
    value: function(a, u, s) {
      return u.timestampIsSet ? a : new Date(a.getTime() - s);
    }
  }]), r;
}(Pe), Tw = /* @__PURE__ */ function(t) {
  Ee(r, t);
  var i = Be(r);
  function r() {
    var l;
    Oe(this, r);
    for (var a = arguments.length, u = new Array(a), s = 0; s < a; s++)
      u[s] = arguments[s];
    return l = i.call.apply(i, [this].concat(u)), Y(Q(l), "priority", 10), Y(Q(l), "incompatibleTokens", ["t", "T", "X"]), l;
  }
  return Me(r, [{
    key: "parse",
    value: function(a, u) {
      switch (u) {
        case "x":
          return pn(hn.basicOptionalMinutes, a);
        case "xx":
          return pn(hn.basic, a);
        case "xxxx":
          return pn(hn.basicOptionalSeconds, a);
        case "xxxxx":
          return pn(hn.extendedOptionalSeconds, a);
        case "xxx":
        default:
          return pn(hn.extended, a);
      }
    }
  }, {
    key: "set",
    value: function(a, u, s) {
      return u.timestampIsSet ? a : new Date(a.getTime() - s);
    }
  }]), r;
}(Pe), Sw = /* @__PURE__ */ function(t) {
  Ee(r, t);
  var i = Be(r);
  function r() {
    var l;
    Oe(this, r);
    for (var a = arguments.length, u = new Array(a), s = 0; s < a; s++)
      u[s] = arguments[s];
    return l = i.call.apply(i, [this].concat(u)), Y(Q(l), "priority", 40), Y(Q(l), "incompatibleTokens", "*"), l;
  }
  return Me(r, [{
    key: "parse",
    value: function(a) {
      return nc(a);
    }
  }, {
    key: "set",
    value: function(a, u, s) {
      return [new Date(s * 1e3), {
        timestampIsSet: !0
      }];
    }
  }]), r;
}(Pe), Ow = /* @__PURE__ */ function(t) {
  Ee(r, t);
  var i = Be(r);
  function r() {
    var l;
    Oe(this, r);
    for (var a = arguments.length, u = new Array(a), s = 0; s < a; s++)
      u[s] = arguments[s];
    return l = i.call.apply(i, [this].concat(u)), Y(Q(l), "priority", 20), Y(Q(l), "incompatibleTokens", "*"), l;
  }
  return Me(r, [{
    key: "parse",
    value: function(a) {
      return nc(a);
    }
  }, {
    key: "set",
    value: function(a, u, s) {
      return [new Date(s), {
        timestampIsSet: !0
      }];
    }
  }]), r;
}(Pe), Mw = {
  G: new Yy(),
  y: new Gy(),
  Y: new Ky(),
  R: new Qy(),
  u: new Xy(),
  Q: new Zy(),
  q: new Jy(),
  M: new jy(),
  L: new ew(),
  w: new nw(),
  I: new iw(),
  d: new sw(),
  D: new lw(),
  E: new uw(),
  e: new cw(),
  c: new dw(),
  i: new hw(),
  a: new pw(),
  b: new vw(),
  B: new mw(),
  h: new gw(),
  H: new yw(),
  K: new ww(),
  k: new bw(),
  m: new kw(),
  s: new Cw(),
  S: new $w(),
  X: new _w(),
  x: new Tw(),
  t: new Sw(),
  T: new Ow()
}, Aw = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Dw = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Iw = /^'([^]*?)'?$/, Ew = /''/g, Bw = /\S/, xw = /[a-zA-Z]/;
function Vw(t, i, r, l) {
  var a, u, s, h, g, T, k, S, E, O, C, I, M, R, ee, U, de, ue;
  qe(3, arguments);
  var Ie = String(t), Ae = String(i), Ze = sr(), pt = (a = (u = l == null ? void 0 : l.locale) !== null && u !== void 0 ? u : Ze.locale) !== null && a !== void 0 ? a : ju;
  if (!pt.match)
    throw new RangeError("locale must contain match property");
  var re = _t((s = (h = (g = (T = l == null ? void 0 : l.firstWeekContainsDate) !== null && T !== void 0 ? T : l == null || (k = l.locale) === null || k === void 0 || (S = k.options) === null || S === void 0 ? void 0 : S.firstWeekContainsDate) !== null && g !== void 0 ? g : Ze.firstWeekContainsDate) !== null && h !== void 0 ? h : (E = Ze.locale) === null || E === void 0 || (O = E.options) === null || O === void 0 ? void 0 : O.firstWeekContainsDate) !== null && s !== void 0 ? s : 1);
  if (!(re >= 1 && re <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var xe = _t((C = (I = (M = (R = l == null ? void 0 : l.weekStartsOn) !== null && R !== void 0 ? R : l == null || (ee = l.locale) === null || ee === void 0 || (U = ee.options) === null || U === void 0 ? void 0 : U.weekStartsOn) !== null && M !== void 0 ? M : Ze.weekStartsOn) !== null && I !== void 0 ? I : (de = Ze.locale) === null || de === void 0 || (ue = de.options) === null || ue === void 0 ? void 0 : ue.weekStartsOn) !== null && C !== void 0 ? C : 0);
  if (!(xe >= 0 && xe <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (Ae === "")
    return Ie === "" ? lt(r) : /* @__PURE__ */ new Date(NaN);
  var Le = {
    firstWeekContainsDate: re,
    weekStartsOn: xe,
    locale: pt
  }, be = [new qy()], Tt = Ae.match(Dw).map(function(Ce) {
    var _e = Ce[0];
    if (_e in Oa) {
      var vt = Oa[_e];
      return vt(Ce, pt.formatLong);
    }
    return Ce;
  }).join("").match(Aw), De = [], Je = Tu(Tt), ke;
  try {
    var yt = function() {
      var _e = ke.value;
      !(l != null && l.useAdditionalWeekYearTokens) && Ju(_e) && qi(_e, Ae, t), !(l != null && l.useAdditionalDayOfYearTokens) && Zu(_e) && qi(_e, Ae, t);
      var vt = _e[0], Nt = Mw[vt];
      if (Nt) {
        var yn = Nt.incompatibleTokens;
        if (Array.isArray(yn)) {
          var V = De.find(function(G) {
            return yn.includes(G.token) || G.token === vt;
          });
          if (V)
            throw new RangeError("The format string mustn't contain `".concat(V.fullToken, "` and `").concat(_e, "` at the same time"));
        } else if (Nt.incompatibleTokens === "*" && De.length > 0)
          throw new RangeError("The format string mustn't contain `".concat(_e, "` and any other token at the same time"));
        De.push({
          token: vt,
          fullToken: _e
        });
        var L = Nt.run(Ie, _e, pt.match, Le);
        if (!L)
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
        be.push(L.setter), Ie = L.rest;
      } else {
        if (vt.match(xw))
          throw new RangeError("Format string contains an unescaped latin alphabet character `" + vt + "`");
        if (_e === "''" ? _e = "'" : vt === "'" && (_e = Pw(_e)), Ie.indexOf(_e) === 0)
          Ie = Ie.slice(_e.length);
        else
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
      }
    };
    for (Je.s(); !(ke = Je.n()).done; ) {
      var Ht = yt();
      if (An(Ht) === "object")
        return Ht.v;
    }
  } catch (Ce) {
    Je.e(Ce);
  } finally {
    Je.f();
  }
  if (Ie.length > 0 && Bw.test(Ie))
    return /* @__PURE__ */ new Date(NaN);
  var xt = be.map(function(Ce) {
    return Ce.priority;
  }).sort(function(Ce, _e) {
    return _e - Ce;
  }).filter(function(Ce, _e, vt) {
    return vt.indexOf(Ce) === _e;
  }).map(function(Ce) {
    return be.filter(function(_e) {
      return _e.priority === Ce;
    }).sort(function(_e, vt) {
      return vt.subPriority - _e.subPriority;
    });
  }).map(function(Ce) {
    return Ce[0];
  }), ut = lt(r);
  if (isNaN(ut.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var Ut = Yu(ut, zu(ut)), sn = {}, gn = Tu(xt), Jt;
  try {
    for (gn.s(); !(Jt = gn.n()).done; ) {
      var ln = Jt.value;
      if (!ln.validate(Ut, Le))
        return /* @__PURE__ */ new Date(NaN);
      var un = ln.set(Ut, sn, Le);
      Array.isArray(un) ? (Ut = un[0], Py(sn, un[1])) : Ut = un;
    }
  } catch (Ce) {
    gn.e(Ce);
  } finally {
    gn.f();
  }
  return Ut;
}
function Pw(t) {
  return t.match(Iw)[1].replace(Ew, "'");
}
function Lw(t) {
  const i = new Date(t.getFullYear(), t.getMonth(), 1), r = $a(new Date(t.getFullYear(), t.getMonth() + 1, 1), -1), l = Ou(i);
  Ou(r);
  const a = {
    weeks: [],
    year: t.getFullYear()
  };
  for (var u = 0; u < 6; u++) {
    let h = $a(i, u * 7);
    h.setDate(h.getDate() - (h.getDay() + 6) % 7);
    const g = {
      days: [],
      number: Ry(h)
    };
    a.weeks.push(g);
    for (var s = 0; s < 7; s++) {
      let T = new Date(i);
      T = $a(T, 7 * u + s - l), g.days.push(Rw(T));
    }
  }
  return a;
}
function Rw(t) {
  return {
    date: t.getDate(),
    month: t.getMonth(),
    year: t.getFullYear()
  };
}
function Ou(t) {
  return t.getDay() === 0 ? 6 : t.getDay() - 1;
}
const Mu = [
  { normal: "tammikuu", short: "tammi" },
  { normal: "helmikuu", short: "helmi" },
  { normal: "maaliskuu", short: "maalis" },
  { normal: "huhtikuu", short: "huhti" },
  { normal: "toukokuu", short: "touko" },
  { normal: "kesäkuu", short: "kesä" },
  { normal: "heinäkuu", short: "heinä" },
  { normal: "elokuu", short: "elo" },
  { normal: "syyskuu", short: "syys" },
  { normal: "lokakuu", short: "loka" },
  { normal: "marraskuu", short: "marras" },
  { normal: "joulukuu", short: "joulu" }
], Fw = X({
  components: {
    BsIcon: He
  },
  props: {
    currentDate: {
      type: Date,
      default: () => /* @__PURE__ */ new Date()
    }
  },
  data() {
    return {
      view: "calendar",
      calendarDate: new Date(this.currentDate || /* @__PURE__ */ new Date()),
      yearViewBasis: new Date(this.currentDate || /* @__PURE__ */ new Date()).getFullYear(),
      monthTransition: "",
      monthTransitionOn: !0
    };
  },
  computed: {
    weekdayTitles() {
      return ["M", "T", "K", "T", "P", "L", "S"];
    },
    monthViewValues() {
      let t = [];
      for (let i = 0; i < 12; i++)
        t.push({
          value: i,
          text: Mu[i].short
        });
      return t;
    },
    yearViewValues() {
      const t = [], i = this.yearViewBasis - 4;
      for (let r = i; r < i + 12; r++)
        t.push(r);
      return t;
    },
    headerText() {
      return this.view == "years" ? this.yearViewValues[0] + " - " + this.yearViewValues[this.yearViewValues.length - 1] : Mu.map((t) => t.normal)[this.calendarDate.getMonth()] + " " + this.calendarDate.getFullYear();
    },
    currentCalendarMonth() {
      return Lw(this.calendarDate);
    },
    dayTransitionClasses() {
      const t = [];
      return this.monthTransition && t.push("animate-" + this.monthTransition), this.monthTransitionOn && t.push("trans-on"), t;
    }
  },
  methods: {
    onClickTitle() {
      this.view == "calendar" ? this.view = "months" : this.view == "months" ? (this.yearViewBasis = (this.currentDate || /* @__PURE__ */ new Date()).getFullYear(), this.view = "years") : this.view = "months";
    },
    onClickArrow(t) {
      let i = t == "up" ? -1 : 1;
      this.view == "calendar" ? this.moveMonth(1 * i) : this.view == "months" ? this.selectYear(this.calendarDate.getFullYear() + 1 * i) : this.yearViewBasis = this.yearViewBasis + 12 * i;
    },
    moveMonth(t) {
      const i = t > 0 ? "up" : "down", r = i == "up" ? "down" : "up";
      this.monthTransition = i, window.setTimeout(() => {
        this.monthTransitionOn = !1, this.monthTransition = r, window.setTimeout(() => {
          this.monthTransitionOn = !0, this.calendarDate = new Date(this.calendarDate.setMonth(this.calendarDate.getMonth() + t)), this.$nextTick(() => {
            this.monthTransition = "";
          });
        }, 10);
      }, 100);
    },
    selectMonth(t) {
      const i = new Date(this.calendarDate);
      i.setMonth(t), this.calendarDate = i, this.view = "calendar";
    },
    selectYear(t) {
      const i = new Date(this.calendarDate);
      i.setFullYear(t), this.calendarDate = i, this.view = "months";
    },
    emitDate(t) {
      const i = new Date(t.year, t.month, t.date, 0, 0, 0, 0);
      return this.$emit("dateClicked", i), !0;
    },
    weekdayClasses(t) {
      const i = [];
      t.month != this.calendarDate.getMonth() && i.push("diff-month"), this.currentDate != null && t.date === this.currentDate.getDate() && t.month === this.currentDate.getMonth() && t.year === this.currentDate.getFullYear() && i.push("current-date");
      const r = /* @__PURE__ */ new Date();
      return t.date === r.getDate() && t.month === r.getMonth() && t.year === r.getFullYear() && i.push("today-date"), i;
    }
  }
}), Ww = { class: "minicalendar" }, Hw = { class: "calendar-head" }, Uw = { class: "btn-container-1" }, Nw = { class: "title" }, zw = { class: "btn-container-2" }, qw = { class: "calendar-content" }, Yw = {
  key: 0,
  class: "years-view"
}, Gw = { class: "months-grid" }, Kw = ["onClick"], Qw = {
  key: 1,
  class: "months-view"
}, Xw = { class: "months-grid" }, Zw = ["onClick"], Jw = {
  key: 2,
  class: "calendar-view"
}, jw = { class: "weekday-names make-grid" }, e1 = /* @__PURE__ */ y("div", { class: "weeknumber" }, [
  /* @__PURE__ */ y("span", null, " ")
], -1), t1 = { class: "weeknumber" }, n1 = ["onClick"];
function r1(t, i, r, l, a, u) {
  const s = ye("bs-icon");
  return v(), b("div", Ww, [
    y("div", null, [
      y("div", Hw, [
        y("div", Uw, [
          y("button", {
            type: "button",
            onClick: i[0] || (i[0] = ne((h) => t.onClickArrow("up"), ["prevent"]))
          }, [
            H(s, { icon: "arrow-left" })
          ])
        ]),
        y("div", Nw, [
          y("button", {
            type: "button",
            onClick: i[1] || (i[1] = ne((...h) => t.onClickTitle && t.onClickTitle(...h), ["prevent"]))
          }, F(t.headerText), 1)
        ]),
        y("div", zw, [
          y("button", {
            type: "button",
            onClick: i[2] || (i[2] = ne((h) => t.onClickArrow("down"), ["prevent"]))
          }, [
            H(s, { icon: "arrow-right" })
          ])
        ])
      ]),
      y("div", qw, [
        t.view == "years" ? (v(), b("div", Yw, [
          y("div", Gw, [
            (v(!0), b(he, null, Se(t.yearViewValues, (h) => (v(), b("button", {
              type: "button",
              key: h,
              onClick: (g) => t.selectYear(h)
            }, F(h), 9, Kw))), 128))
          ])
        ])) : t.view == "months" ? (v(), b("div", Qw, [
          y("div", Xw, [
            (v(!0), b(he, null, Se(t.monthViewValues, (h) => (v(), b("button", {
              type: "button",
              key: h.value,
              onClick: (g) => t.selectMonth(h.value)
            }, F(h.text), 9, Zw))), 128))
          ])
        ])) : (v(), b("div", Jw, [
          y("div", jw, [
            e1,
            (v(!0), b(he, null, Se(t.weekdayTitles, (h, g) => (v(), b("div", {
              class: "weekday",
              key: g
            }, [
              y("span", null, F(h), 1)
            ]))), 128))
          ]),
          y("div", {
            class: z(["generated-calendar", t.dayTransitionClasses])
          }, [
            (v(!0), b(he, null, Se(t.currentCalendarMonth.weeks, (h) => (v(), b("div", {
              class: "week make-grid",
              key: h.number
            }, [
              y("div", t1, [
                y("span", null, F(h.number), 1)
              ]),
              (v(!0), b(he, null, Se(h.days, (g) => (v(), b("button", {
                class: z(["weekday clickable", t.weekdayClasses(g)]),
                key: g.date,
                onClick: ne((T) => t.emitDate(g), ["prevent"])
              }, [
                y("span", null, F(g.date), 1)
              ], 10, n1))), 128))
            ]))), 128))
          ], 2)
        ]))
      ])
    ])
  ]);
}
const oc = /* @__PURE__ */ ge(Fw, [["render", r1]]), Au = {
  getMatchesAndCaptureGroups(t, i) {
    i.lastIndex = 0;
    let r = [], l;
    for (; l = i.exec(t); ) {
      let a = {
        match: l[0],
        captured: []
      };
      for (let u = 1; u < l.length; u++)
        a.captured.push(l[u]);
      if (r.push(a), !i.global)
        break;
    }
    return r;
  }
};
function mn() {
  return Math.random().toString().split(".")[1] + Date.now().valueOf().toString();
}
st.components.inputs.datePicker = {
  texts: {
    placeholder: {
      en: "Write a date (dd.mm.yyyy)",
      fi: "Kirjoita päivämäärä",
      sv: "Skriv ett datum"
    }
  }
};
const i1 = X({
  components: {
    MiniCalendar: oc,
    BsIcon: He
  },
  props: {
    modelValue: {
      type: Date,
      required: !1
    },
    id: {
      type: String,
      default: () => mn()
    },
    zIndex: {
      type: Number,
      default: 9999
    },
    placeholder: {
      type: String,
      default: () => {
        var t;
        return gt((t = st.components.inputs.datePicker.texts) == null ? void 0 : t.placeholder);
      }
    },
    allowEmpty: {
      type: Boolean,
      default: !1
    },
    /**
    * Manually set validation state with true/false/null.
    */
    isInvalid: {
      type: Boolean,
      default: null
    }
  },
  data() {
    return {
      modelTextValue: "",
      isValid: !0,
      onInputTimeout: null,
      showCalendar: !1
    };
  },
  watch: {
    modelValue(t, i) {
      t != i && (t && i && t.valueOf() == i.valueOf() || this.setModelTextValue());
    }
  },
  beforeMount() {
    this.setModelTextValue();
  },
  computed: {
    isValidComputed() {
      return !this.isValid || this.isInvalid === !0 ? !1 : this.isInvalid === null ? null : !0;
    }
  },
  methods: {
    // Sets a formatted string from modelValue, to the input's value (modelTextValue)
    setModelTextValue(t = null) {
      let i = this.modelValue;
      t != null ? i = t : this.modelTextValue = "", i && (this.modelTextValue = Ta(i, "d.M.yyyy")), this.processModelTextValue();
    },
    // Fires when user writes to the input 
    onDateInput() {
      this.onInputTimeout != null && (window.clearTimeout(this.onInputTimeout), this.onInputTimeout = null), this.onInputTimeout = window.setTimeout(() => {
        this.processModelTextValue();
      }, 500);
    },
    onDateBlur() {
      this.processModelTextValue(), this.$emit("blur");
    },
    setDateFromCalendar(t) {
      this.setModelTextValue(t), this.showCalendar = !1;
    },
    // Process modelTextValue, and if it's OK then update:modelValue
    processModelTextValue() {
      let t = this.modelTextValue.trim().toLowerCase();
      if (this.allowEmpty && t == "") {
        this.setIsValid(!0), this.$emit("update:modelValue", null);
        return;
      }
      const i = /* @__PURE__ */ new Date(), r = i.getFullYear(), l = Ta(i, "MM"), a = /^(\d{1,2})\.(\d{1,2})\.*$/i, u = /^(\d{1,2})\.*$/i, h = [
        "ma",
        "ti",
        "ke",
        "to",
        "pe",
        "la",
        "su"
      ].indexOf(t.substr(0, 2));
      if (h >= 0) {
        const T = new Date(i);
        t.includes("+") ? T.setDate(T.getDate() + (t.split("+").length - 1) * 7) : t.includes("-") && T.setDate(T.getDate() - (t.split("-").length - 1) * 7);
        const k = T.getDay() === 0 ? 6 : T.getDay() - 1, S = new Date(T);
        S.setDate(S.getDate() - (k - h)), t = Ta(S, "dd.MM.yyyy");
      }
      if (a.test(t)) {
        let T = Au.getMatchesAndCaptureGroups(t, a);
        if (T.length > 0) {
          const k = T[0].captured;
          let S = k[0], E = k[1];
          t = `${S}.${E}.${r}`;
        }
      } else if (u.test(t)) {
        let T = Au.getMatchesAndCaptureGroups(t, u);
        T.length > 0 && (t = `${T[0].captured[0]}.${l}.${r}`);
      }
      if (/^\d{1,2}\.\d{1,2}\.\d{4}$/i.test(t) == !1) {
        this.setIsValid(!1);
        return;
      }
      var g = Vw(t, "dd.MM.yyyy", /* @__PURE__ */ new Date());
      this.modelValue != null && (g.setHours(this.modelValue.getHours()), g.setMinutes(this.modelValue.getMinutes()), g.setSeconds(this.modelValue.getSeconds()), g.setMilliseconds(this.modelValue.getMilliseconds())), qu(g) ? (this.setIsValid(!0), this.$emit("update:modelValue", g)) : this.setIsValid(!1);
    },
    setIsValid(t) {
      this.isValid = t, this.$emit("is-valid", t);
    }
  }
}), o1 = { class: "input-container" }, a1 = ["id", "placeholder"];
function s1(t, i, r, l, a, u) {
  const s = ye("bs-icon"), h = ye("mini-calendar");
  return v(), b("div", {
    class: z(["hakosalo-date-picker", { "is-invalid": t.isValidComputed === !1, "is-valid": t.isValidComputed === !0 }])
  }, [
    y("div", o1, [
      Ne(y("input", {
        type: "text",
        id: t.id,
        placeholder: t.placeholder,
        class: z(["form-control", { "is-invalid": t.isValidComputed === !1, "is-valid": t.isInvalid === !1 }]),
        "onUpdate:modelValue": i[0] || (i[0] = (g) => t.modelTextValue = g),
        onInput: () => {
        },
        onBlur: i[1] || (i[1] = (...g) => t.onDateBlur && t.onDateBlur(...g))
      }, null, 42, a1), [
        [Nn, t.modelTextValue]
      ]),
      y("button", {
        type: "button",
        class: "calendar-btn",
        onClick: i[2] || (i[2] = ne((g) => t.showCalendar = !t.showCalendar, ["prevent"])),
        tabindex: "-1"
      }, [
        H(s, { icon: "calendar3" })
      ])
    ]),
    H(ft, { name: "fade" }, {
      default: Z(() => [
        t.showCalendar ? (v(), b("div", {
          key: 0,
          class: "calendar-popup",
          style: fe({ "z-index": t.zIndex })
        }, [
          H(h, {
            "current-date": t.modelValue,
            onDateClicked: t.setDateFromCalendar
          }, null, 8, ["current-date", "onDateClicked"])
        ], 4)) : W("", !0)
      ]),
      _: 1
    }),
    t.showCalendar ? (v(), b("div", {
      key: 0,
      class: "calendar-popup-bg see-through-bg",
      style: fe({ "z-index": t.zIndex - 1 }),
      onClick: i[3] || (i[3] = ne((g) => t.showCalendar = !1, ["prevent"]))
    }, null, 4)) : W("", !0)
  ], 2);
}
const l1 = /* @__PURE__ */ ge(i1, [["render", s1]]), u1 = X({
  components: {
    BsIcon: He
  },
  props: {
    modelValue: {
      type: Object,
      required: !1
    },
    id: {
      type: String,
      default: () => mn()
    },
    timeDivider: {
      type: Number,
      default: 2
    },
    zIndex: {
      type: Number,
      default: 9999
    },
    /**
    * Manually set validation state with true/false/null.
    */
    isInvalid: {
      type: Boolean,
      default: null
    }
  },
  data() {
    return {
      modelTextValue: "",
      showDropdown: !1,
      inputTimeout: 0,
      isValid: !0
    };
  },
  watch: {
    modelValue() {
      this.modelValue != null ? this.modelTextValue = this.dateToTimeTextValue(this.modelValue) : this.modelTextValue = "";
    },
    showDropdown() {
      if (this.isDisabled) {
        this.showDropdown = !1;
        return;
      }
      if (this.showDropdown == !1 || this.modelValue == null)
        return;
      const t = this.modelValue;
      let i = t.getHours() - 1, r = 0;
      t.getMinutes() / 60 > 0.5 && (r = 30);
      let l = (i < 10 ? "0" + i : i).toString(), a = (r < 10 ? "0" + r : r).toString();
      const u = "id" + this.id + "-tdi-" + l + a;
      this.$nextTick(() => {
        var h;
        (h = this.$refs.timeDropdown.querySelector(`#${u}`)) == null || h.scrollIntoView(!1);
      });
    }
  },
  beforeMount() {
    this.modelValue != null && (this.modelTextValue = this.dateToTimeTextValue(this.modelValue));
  },
  computed: {
    isValidComputed() {
      return !this.isValid || this.isInvalid === !0 ? !1 : this.isInvalid === null ? null : !0;
    },
    isDisabled() {
      return this.modelValue == null;
    },
    dropdownItems() {
      const t = [];
      for (let i = 0; i < 24; i++) {
        let r = this.timeDivider, l = 60 / r;
        for (let a = 0; a < r; a++) {
          let u = l * a, s = (i < 10 ? "0" + i : i) + ":" + (u < 10 ? "0" + u : u);
          t.push(s);
        }
      }
      return t;
    }
  },
  methods: {
    dateToTimeTextValue(t) {
      let i = t.getHours() < 10 ? "0" + t.getHours() : t.getHours(), r = t.getMinutes() < 10 ? "0" + t.getMinutes() : t.getMinutes();
      return i + ":" + r;
    },
    // Parse time from string 'HH:MM'
    selectTime(t) {
      if (this.modelValue == null)
        return;
      let i = t.split(":"), r = new Date(this.modelValue);
      r.setHours(parseInt(i[0])), r.setMinutes(parseInt(i[1])), this.$emit("update:modelValue", r), this.showDropdown = !1;
    },
    onTimeInput(t) {
      let i = [".", ":", "Backspace", "ArrowLeft", "ArrowRight", "Tab"];
      for (let r = 0; r < 10; r++)
        i.push(r.toString());
      if (!i.includes(t.key))
        return t.preventDefault(), !1;
    },
    onTimeBlur() {
      this.validate(), this.$emit("blur");
    },
    validate() {
      let t = this.modelTextValue.substr(0, 5);
      if (t.indexOf(":") < 0 && (t = t.substr(0, 4), /^\d{4}$/.test(t) ? t = t.substring(0, 2) + ":" + t.substring(2, 4) : /^\d{1,2}$/.test(t) && (t = t + ":00")), /^\d{1,2}:\d{1,2}/.test(t)) {
        let i = t.split(":").map((l) => parseInt(l)), r = !i.some((l) => l < 0);
        if (i[0] > 23 && (r = !1), i[1] > 59 && (r = !1), r) {
          this.isValid = !0, this.selectTime(t);
          return;
        }
      }
      this.isValid = !1;
    }
  }
}), c1 = { class: "input-container" }, d1 = ["id", "disabled"], f1 = { class: "items" }, h1 = ["id", "onClick"];
function p1(t, i, r, l, a, u) {
  const s = ye("bs-icon");
  return v(), b("div", {
    class: z(["hakosalo-time-picker", { "is-invalid": t.isValidComputed === !1, "is-valid": t.isValidComputed === !0 }])
  }, [
    y("div", c1, [
      Ne(y("input", {
        type: "text",
        class: z(["form-control", { "is-invalid": t.isValidComputed === !1, "is-valid": t.isValidComputed === !0 }]),
        "onUpdate:modelValue": i[0] || (i[0] = (h) => t.modelTextValue = h),
        id: t.id,
        onBlur: i[1] || (i[1] = ne((...h) => t.onTimeBlur && t.onTimeBlur(...h), ["prevent"])),
        onKeydown: i[2] || (i[2] = (...h) => t.onTimeInput && t.onTimeInput(...h)),
        disabled: t.isDisabled
      }, null, 42, d1), [
        [Nn, t.modelTextValue]
      ]),
      y("button", {
        type: "button",
        class: "dropdown-btn",
        onClick: i[3] || (i[3] = ne((h) => t.showDropdown = !0, ["prevent"])),
        tabindex: "-1"
      }, [
        H(s, { icon: "chevron-down" })
      ])
    ]),
    t.showDropdown ? (v(), b("div", {
      key: 0,
      class: "time-dropdown-bg see-through-bg",
      style: fe({ "z-index": t.zIndex - 1 }),
      onClick: i[4] || (i[4] = ne((h) => t.showDropdown = !1, ["prevent"]))
    }, null, 4)) : W("", !0),
    H(ft, { name: "menu" }, {
      default: Z(() => [
        t.showDropdown ? (v(), b("div", {
          key: 0,
          class: "time-dropdown",
          ref: "timeDropdown",
          style: fe({ "z-index": t.zIndex })
        }, [
          y("div", f1, [
            (v(!0), b(he, null, Se(t.dropdownItems, (h) => (v(), b("div", {
              key: h,
              id: "id" + t.id + "-tdi-" + h.replace(":", ""),
              onClick: ne((g) => t.selectTime(h), ["prevent"])
            }, [
              y("span", null, F(h), 1)
            ], 8, h1))), 128))
          ])
        ], 4)) : W("", !0)
      ]),
      _: 1
    })
  ], 2);
}
const v1 = /* @__PURE__ */ ge(u1, [["render", p1]]), m1 = X({
  props: {
    modelValue: {
      type: [Boolean, null, Array]
    },
    id: {
      type: String,
      default: () => Date.now().toString(36) + Math.random().toString(36).substr(2)
    },
    theme: {
      type: String,
      default: "primary"
    },
    inline: {
      type: Boolean,
      default: !1
    },
    value: {
      type: [Number, String, null]
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  beforeMount() {
    (this.modelValue === null || this.modelValue === void 0) && this.$emit("update:modelValue", !1);
  },
  computed: {
    myClasses() {
      const t = [];
      return t.push("theme-" + this.theme), this.inline && t.push("d-inline-block"), t;
    },
    cSimpleSwitch() {
      return typeof this.$props.modelValue == "boolean" ? !0 : !Array.isArray(this.$props.modelValue);
    },
    cModelHasValue() {
      return Array.isArray(this.$props.modelValue) && this.$props.value !== void 0 && this.$props.value !== null ? this.$props.modelValue.includes(this.$props.value) : !1;
    }
  },
  methods: {
    updateArrayModelValue() {
      if (!Array.isArray(this.$props.modelValue) || this.$props.value === null || this.$props.value === void 0)
        return;
      let t = [...this.$props.modelValue];
      this.cModelHasValue ? t = t.filter((i) => i !== this.$props.value) : t.push(this.$props.value), this.$emit("update:modelValue", t);
    }
  }
}), g1 = ["disabled", "id", "checked"], y1 = ["for"], w1 = ["disabled", "id", "checked"], b1 = ["for"];
function k1(t, i, r, l, a, u) {
  return t.cSimpleSwitch ? (v(), b("div", {
    key: 0,
    class: z(["form-check form-switch", t.myClasses])
  }, [
    y("input", {
      class: "form-check-input",
      type: "checkbox",
      role: "switch",
      disabled: t.disabled,
      id: t.id,
      checked: t.modelValue || !1,
      onChange: i[0] || (i[0] = (s) => t.$emit("update:modelValue", !t.modelValue))
    }, null, 40, g1),
    y("label", {
      class: "form-check-label",
      for: t.id
    }, [
      J(t.$slots, "default")
    ], 8, y1)
  ], 2)) : (v(), b("div", {
    key: 1,
    class: z(["form-check form-switch", t.myClasses])
  }, [
    y("input", {
      class: "form-check-input",
      type: "checkbox",
      role: "switch",
      disabled: t.disabled,
      id: t.id,
      checked: t.cModelHasValue,
      onChange: i[1] || (i[1] = (s) => t.updateArrayModelValue())
    }, null, 40, w1),
    y("label", {
      class: "form-check-label",
      for: t.id
    }, [
      J(t.$slots, "default")
    ], 8, b1)
  ], 2));
}
const C1 = /* @__PURE__ */ ge(m1, [["render", k1]]);
st.components.inputs.labelControl = {
  texts: {
    required: {
      fi: "Pakollinen",
      en: "Required",
      sv: "Obligatorisk"
    }
  }
};
const $1 = X({
  props: {
    colSize: {
      type: Number,
      default: 3
    },
    block: {
      type: Boolean,
      default: !1
    },
    label: {
      type: String,
      default: ""
    },
    for: {
      type: String,
      required: !0
    },
    marginBottom: {
      type: Number,
      default: 3
    },
    required: {
      type: Boolean,
      default: !1
    },
    /**
     * Can be used to correctly align elements that don't have any margin-top on them.
     * Note that <span> elements are corrected automatically.
     */
    alignContent: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    myFor() {
      return this.for;
    },
    rootClasses() {
      let t = ["mb-" + this.marginBottom];
      return this.block && t.push("is-block"), t;
    },
    myColSize() {
      return this.block ? 12 : this.colSize;
    }
    // requiredText() {
    // 	return getText(config.components.inputs.labelControl.texts?.required);
    // }
  },
  methods: {
    intMax12(t) {
      return t > 12 ? 12 : t;
    }
  }
}), _1 = ["for"], T1 = {
  key: 0,
  class: "required text-muted"
}, S1 = { class: "col-sm slot-content" };
function O1(t, i, r, l, a, u) {
  return v(), b("div", {
    class: z(["row hakosalo-label-control", t.rootClasses])
  }, [
    y("label", {
      for: t.myFor,
      class: z(["col-form-label", ["col-sm-" + t.intMax12(t.myColSize), "col-md-" + t.intMax12(t.myColSize + 1)]])
    }, [
      Ke(F(t.label) + " ", 1),
      J(t.$slots, "label"),
      t.required ? (v(), b("span", T1, " * ")) : W("", !0),
      J(t.$slots, "infoball")
    ], 10, _1),
    y("div", S1, [
      y("div", {
        class: z({ "form-control-plaintext": t.alignContent })
      }, [
        J(t.$slots, "default")
      ], 2)
    ])
  ], 2);
}
const M1 = /* @__PURE__ */ ge($1, [["render", O1]]), A1 = X({
  name: "SelectedOptionSingle",
  components: {
    Avatar: Zr,
    BsIcon: He
  },
  props: {
    option: {
      type: Object,
      required: !0
    },
    useAvatar: {
      type: Boolean,
      default: !0
    },
    avatarSize: {
      type: Number,
      default: 2
    },
    useBadges: {
      type: Boolean,
      default: !1
    },
    disallowRemove: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    getAvatarData() {
      return this.option.avatar ? this.option.avatar : this.option.text;
    }
  },
  methods: {
    removeOption() {
      this.$emit("remove");
    }
  }
}), D1 = { class: "d-flex align-items-center" }, I1 = {
  key: 0,
  class: "avatar-container"
}, E1 = ["title"], B1 = { class: "actions-container" };
function x1(t, i, r, l, a, u) {
  const s = ye("avatar"), h = ye("bs-icon");
  return v(), b("div", {
    class: z(["hakosalo-selected-option", { blocks: !t.useBadges, badges: t.useBadges }])
  }, [
    y("div", D1, [
      t.useAvatar ? (v(), b("div", I1, [
        H(s, {
          "avatar-data": t.getAvatarData,
          role: t.option.theme,
          size: t.avatarSize
        }, null, 8, ["avatar-data", "role", "size"])
      ])) : W("", !0),
      y("div", {
        class: "text-container flex-fill",
        title: t.option.text
      }, F(t.option.text), 9, E1),
      y("div", B1, [
        Ne(y("button", {
          type: "button",
          onClick: i[0] || (i[0] = ne((g) => t.removeOption(), ["prevent", "stop"]))
        }, [
          H(h, { icon: "x" })
        ], 512), [
          [Dn, !t.disallowRemove]
        ])
      ])
    ])
  ], 2);
}
const ac = /* @__PURE__ */ ge(A1, [["render", x1]]), Ra = {
  save: "Tallenna",
  cancel: "Peruuta",
  selectAll: "Valitse kaikki",
  unselectAll: "Poista valinnat",
  search: "Haku",
  noResults: "Ei hakutuloksia",
  yes: "Kyllä",
  no: "Ei"
};
var Kr = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function V1(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var Ki = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
Ki.exports;
(function(t, i) {
  (function() {
    var r, l = "4.17.21", a = 200, u = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", s = "Expected a function", h = "Invalid `variable` option passed into `_.template`", g = "__lodash_hash_undefined__", T = 500, k = "__lodash_placeholder__", S = 1, E = 2, O = 4, C = 1, I = 2, M = 1, R = 2, ee = 4, U = 8, de = 16, ue = 32, Ie = 64, Ae = 128, Ze = 256, pt = 512, re = 30, xe = "...", Le = 800, be = 16, Tt = 1, De = 2, Je = 3, ke = 1 / 0, yt = 9007199254740991, Ht = 17976931348623157e292, xt = NaN, ut = 4294967295, Ut = ut - 1, sn = ut >>> 1, gn = [
      ["ary", Ae],
      ["bind", M],
      ["bindKey", R],
      ["curry", U],
      ["curryRight", de],
      ["flip", pt],
      ["partial", ue],
      ["partialRight", Ie],
      ["rearg", Ze]
    ], Jt = "[object Arguments]", ln = "[object Array]", un = "[object AsyncFunction]", Ce = "[object Boolean]", _e = "[object Date]", vt = "[object DOMException]", Nt = "[object Error]", yn = "[object Function]", V = "[object GeneratorFunction]", L = "[object Map]", G = "[object Number]", tt = "[object Null]", nt = "[object Object]", wn = "[object Promise]", Ua = "[object Proxy]", Or = "[object RegExp]", jt = "[object Set]", Mr = "[object String]", Jr = "[object Symbol]", $c = "[object Undefined]", Ar = "[object WeakMap]", _c = "[object WeakSet]", Dr = "[object ArrayBuffer]", lr = "[object DataView]", eo = "[object Float32Array]", to = "[object Float64Array]", no = "[object Int8Array]", ro = "[object Int16Array]", io = "[object Int32Array]", oo = "[object Uint8Array]", ao = "[object Uint8ClampedArray]", so = "[object Uint16Array]", lo = "[object Uint32Array]", Tc = /\b__p \+= '';/g, Sc = /\b(__p \+=) '' \+/g, Oc = /(__e\(.*?\)|\b__t\)) \+\n'';/g, Na = /&(?:amp|lt|gt|quot|#39);/g, za = /[&<>"']/g, Mc = RegExp(Na.source), Ac = RegExp(za.source), Dc = /<%-([\s\S]+?)%>/g, Ic = /<%([\s\S]+?)%>/g, qa = /<%=([\s\S]+?)%>/g, Ec = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Bc = /^\w*$/, xc = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, uo = /[\\^$.*+?()[\]{}|]/g, Vc = RegExp(uo.source), co = /^\s+/, Pc = /\s/, Lc = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, Rc = /\{\n\/\* \[wrapped with (.+)\] \*/, Fc = /,? & /, Wc = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, Hc = /[()=,{}\[\]\/\s]/, Uc = /\\(\\)?/g, Nc = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, Ya = /\w*$/, zc = /^[-+]0x[0-9a-f]+$/i, qc = /^0b[01]+$/i, Yc = /^\[object .+?Constructor\]$/, Gc = /^0o[0-7]+$/i, Kc = /^(?:0|[1-9]\d*)$/, Qc = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, jr = /($^)/, Xc = /['\n\r\u2028\u2029\\]/g, ei = "\\ud800-\\udfff", Zc = "\\u0300-\\u036f", Jc = "\\ufe20-\\ufe2f", jc = "\\u20d0-\\u20ff", Ga = Zc + Jc + jc, Ka = "\\u2700-\\u27bf", Qa = "a-z\\xdf-\\xf6\\xf8-\\xff", ed = "\\xac\\xb1\\xd7\\xf7", td = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", nd = "\\u2000-\\u206f", rd = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Xa = "A-Z\\xc0-\\xd6\\xd8-\\xde", Za = "\\ufe0e\\ufe0f", Ja = ed + td + nd + rd, fo = "['’]", id = "[" + ei + "]", ja = "[" + Ja + "]", ti = "[" + Ga + "]", es = "\\d+", od = "[" + Ka + "]", ts = "[" + Qa + "]", ns = "[^" + ei + Ja + es + Ka + Qa + Xa + "]", ho = "\\ud83c[\\udffb-\\udfff]", ad = "(?:" + ti + "|" + ho + ")", rs = "[^" + ei + "]", po = "(?:\\ud83c[\\udde6-\\uddff]){2}", vo = "[\\ud800-\\udbff][\\udc00-\\udfff]", ur = "[" + Xa + "]", is = "\\u200d", os = "(?:" + ts + "|" + ns + ")", sd = "(?:" + ur + "|" + ns + ")", as = "(?:" + fo + "(?:d|ll|m|re|s|t|ve))?", ss = "(?:" + fo + "(?:D|LL|M|RE|S|T|VE))?", ls = ad + "?", us = "[" + Za + "]?", ld = "(?:" + is + "(?:" + [rs, po, vo].join("|") + ")" + us + ls + ")*", ud = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", cd = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", cs = us + ls + ld, dd = "(?:" + [od, po, vo].join("|") + ")" + cs, fd = "(?:" + [rs + ti + "?", ti, po, vo, id].join("|") + ")", hd = RegExp(fo, "g"), pd = RegExp(ti, "g"), mo = RegExp(ho + "(?=" + ho + ")|" + fd + cs, "g"), vd = RegExp([
      ur + "?" + ts + "+" + as + "(?=" + [ja, ur, "$"].join("|") + ")",
      sd + "+" + ss + "(?=" + [ja, ur + os, "$"].join("|") + ")",
      ur + "?" + os + "+" + as,
      ur + "+" + ss,
      cd,
      ud,
      es,
      dd
    ].join("|"), "g"), md = RegExp("[" + is + ei + Ga + Za + "]"), gd = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, yd = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], wd = -1, Ye = {};
    Ye[eo] = Ye[to] = Ye[no] = Ye[ro] = Ye[io] = Ye[oo] = Ye[ao] = Ye[so] = Ye[lo] = !0, Ye[Jt] = Ye[ln] = Ye[Dr] = Ye[Ce] = Ye[lr] = Ye[_e] = Ye[Nt] = Ye[yn] = Ye[L] = Ye[G] = Ye[nt] = Ye[Or] = Ye[jt] = Ye[Mr] = Ye[Ar] = !1;
    var ze = {};
    ze[Jt] = ze[ln] = ze[Dr] = ze[lr] = ze[Ce] = ze[_e] = ze[eo] = ze[to] = ze[no] = ze[ro] = ze[io] = ze[L] = ze[G] = ze[nt] = ze[Or] = ze[jt] = ze[Mr] = ze[Jr] = ze[oo] = ze[ao] = ze[so] = ze[lo] = !0, ze[Nt] = ze[yn] = ze[Ar] = !1;
    var bd = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, kd = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, Cd = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, $d = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, _d = parseFloat, Td = parseInt, ds = typeof Kr == "object" && Kr && Kr.Object === Object && Kr, Sd = typeof self == "object" && self && self.Object === Object && self, wt = ds || Sd || Function("return this")(), go = i && !i.nodeType && i, Kn = go && !0 && t && !t.nodeType && t, fs = Kn && Kn.exports === go, yo = fs && ds.process, zt = function() {
      try {
        var $ = Kn && Kn.require && Kn.require("util").types;
        return $ || yo && yo.binding && yo.binding("util");
      } catch {
      }
    }(), hs = zt && zt.isArrayBuffer, ps = zt && zt.isDate, vs = zt && zt.isMap, ms = zt && zt.isRegExp, gs = zt && zt.isSet, ys = zt && zt.isTypedArray;
    function Vt($, D, A) {
      switch (A.length) {
        case 0:
          return $.call(D);
        case 1:
          return $.call(D, A[0]);
        case 2:
          return $.call(D, A[0], A[1]);
        case 3:
          return $.call(D, A[0], A[1], A[2]);
      }
      return $.apply(D, A);
    }
    function Od($, D, A, K) {
      for (var se = -1, Ve = $ == null ? 0 : $.length; ++se < Ve; ) {
        var ct = $[se];
        D(K, ct, A(ct), $);
      }
      return K;
    }
    function qt($, D) {
      for (var A = -1, K = $ == null ? 0 : $.length; ++A < K && D($[A], A, $) !== !1; )
        ;
      return $;
    }
    function Md($, D) {
      for (var A = $ == null ? 0 : $.length; A-- && D($[A], A, $) !== !1; )
        ;
      return $;
    }
    function ws($, D) {
      for (var A = -1, K = $ == null ? 0 : $.length; ++A < K; )
        if (!D($[A], A, $))
          return !1;
      return !0;
    }
    function In($, D) {
      for (var A = -1, K = $ == null ? 0 : $.length, se = 0, Ve = []; ++A < K; ) {
        var ct = $[A];
        D(ct, A, $) && (Ve[se++] = ct);
      }
      return Ve;
    }
    function ni($, D) {
      var A = $ == null ? 0 : $.length;
      return !!A && cr($, D, 0) > -1;
    }
    function wo($, D, A) {
      for (var K = -1, se = $ == null ? 0 : $.length; ++K < se; )
        if (A(D, $[K]))
          return !0;
      return !1;
    }
    function Ge($, D) {
      for (var A = -1, K = $ == null ? 0 : $.length, se = Array(K); ++A < K; )
        se[A] = D($[A], A, $);
      return se;
    }
    function En($, D) {
      for (var A = -1, K = D.length, se = $.length; ++A < K; )
        $[se + A] = D[A];
      return $;
    }
    function bo($, D, A, K) {
      var se = -1, Ve = $ == null ? 0 : $.length;
      for (K && Ve && (A = $[++se]); ++se < Ve; )
        A = D(A, $[se], se, $);
      return A;
    }
    function Ad($, D, A, K) {
      var se = $ == null ? 0 : $.length;
      for (K && se && (A = $[--se]); se--; )
        A = D(A, $[se], se, $);
      return A;
    }
    function ko($, D) {
      for (var A = -1, K = $ == null ? 0 : $.length; ++A < K; )
        if (D($[A], A, $))
          return !0;
      return !1;
    }
    var Dd = Co("length");
    function Id($) {
      return $.split("");
    }
    function Ed($) {
      return $.match(Wc) || [];
    }
    function bs($, D, A) {
      var K;
      return A($, function(se, Ve, ct) {
        if (D(se, Ve, ct))
          return K = Ve, !1;
      }), K;
    }
    function ri($, D, A, K) {
      for (var se = $.length, Ve = A + (K ? 1 : -1); K ? Ve-- : ++Ve < se; )
        if (D($[Ve], Ve, $))
          return Ve;
      return -1;
    }
    function cr($, D, A) {
      return D === D ? zd($, D, A) : ri($, ks, A);
    }
    function Bd($, D, A, K) {
      for (var se = A - 1, Ve = $.length; ++se < Ve; )
        if (K($[se], D))
          return se;
      return -1;
    }
    function ks($) {
      return $ !== $;
    }
    function Cs($, D) {
      var A = $ == null ? 0 : $.length;
      return A ? _o($, D) / A : xt;
    }
    function Co($) {
      return function(D) {
        return D == null ? r : D[$];
      };
    }
    function $o($) {
      return function(D) {
        return $ == null ? r : $[D];
      };
    }
    function $s($, D, A, K, se) {
      return se($, function(Ve, ct, Ue) {
        A = K ? (K = !1, Ve) : D(A, Ve, ct, Ue);
      }), A;
    }
    function xd($, D) {
      var A = $.length;
      for ($.sort(D); A--; )
        $[A] = $[A].value;
      return $;
    }
    function _o($, D) {
      for (var A, K = -1, se = $.length; ++K < se; ) {
        var Ve = D($[K]);
        Ve !== r && (A = A === r ? Ve : A + Ve);
      }
      return A;
    }
    function To($, D) {
      for (var A = -1, K = Array($); ++A < $; )
        K[A] = D(A);
      return K;
    }
    function Vd($, D) {
      return Ge(D, function(A) {
        return [A, $[A]];
      });
    }
    function _s($) {
      return $ && $.slice(0, Ms($) + 1).replace(co, "");
    }
    function Pt($) {
      return function(D) {
        return $(D);
      };
    }
    function So($, D) {
      return Ge(D, function(A) {
        return $[A];
      });
    }
    function Ir($, D) {
      return $.has(D);
    }
    function Ts($, D) {
      for (var A = -1, K = $.length; ++A < K && cr(D, $[A], 0) > -1; )
        ;
      return A;
    }
    function Ss($, D) {
      for (var A = $.length; A-- && cr(D, $[A], 0) > -1; )
        ;
      return A;
    }
    function Pd($, D) {
      for (var A = $.length, K = 0; A--; )
        $[A] === D && ++K;
      return K;
    }
    var Ld = $o(bd), Rd = $o(kd);
    function Fd($) {
      return "\\" + $d[$];
    }
    function Wd($, D) {
      return $ == null ? r : $[D];
    }
    function dr($) {
      return md.test($);
    }
    function Hd($) {
      return gd.test($);
    }
    function Ud($) {
      for (var D, A = []; !(D = $.next()).done; )
        A.push(D.value);
      return A;
    }
    function Oo($) {
      var D = -1, A = Array($.size);
      return $.forEach(function(K, se) {
        A[++D] = [se, K];
      }), A;
    }
    function Os($, D) {
      return function(A) {
        return $(D(A));
      };
    }
    function Bn($, D) {
      for (var A = -1, K = $.length, se = 0, Ve = []; ++A < K; ) {
        var ct = $[A];
        (ct === D || ct === k) && ($[A] = k, Ve[se++] = A);
      }
      return Ve;
    }
    function ii($) {
      var D = -1, A = Array($.size);
      return $.forEach(function(K) {
        A[++D] = K;
      }), A;
    }
    function Nd($) {
      var D = -1, A = Array($.size);
      return $.forEach(function(K) {
        A[++D] = [K, K];
      }), A;
    }
    function zd($, D, A) {
      for (var K = A - 1, se = $.length; ++K < se; )
        if ($[K] === D)
          return K;
      return -1;
    }
    function qd($, D, A) {
      for (var K = A + 1; K--; )
        if ($[K] === D)
          return K;
      return K;
    }
    function fr($) {
      return dr($) ? Gd($) : Dd($);
    }
    function en($) {
      return dr($) ? Kd($) : Id($);
    }
    function Ms($) {
      for (var D = $.length; D-- && Pc.test($.charAt(D)); )
        ;
      return D;
    }
    var Yd = $o(Cd);
    function Gd($) {
      for (var D = mo.lastIndex = 0; mo.test($); )
        ++D;
      return D;
    }
    function Kd($) {
      return $.match(mo) || [];
    }
    function Qd($) {
      return $.match(vd) || [];
    }
    var Xd = function $(D) {
      D = D == null ? wt : hr.defaults(wt.Object(), D, hr.pick(wt, yd));
      var A = D.Array, K = D.Date, se = D.Error, Ve = D.Function, ct = D.Math, Ue = D.Object, Mo = D.RegExp, Zd = D.String, Yt = D.TypeError, oi = A.prototype, Jd = Ve.prototype, pr = Ue.prototype, ai = D["__core-js_shared__"], si = Jd.toString, Fe = pr.hasOwnProperty, jd = 0, As = function() {
        var e = /[^.]+$/.exec(ai && ai.keys && ai.keys.IE_PROTO || "");
        return e ? "Symbol(src)_1." + e : "";
      }(), li = pr.toString, ef = si.call(Ue), tf = wt._, nf = Mo(
        "^" + si.call(Fe).replace(uo, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), ui = fs ? D.Buffer : r, xn = D.Symbol, ci = D.Uint8Array, Ds = ui ? ui.allocUnsafe : r, di = Os(Ue.getPrototypeOf, Ue), Is = Ue.create, Es = pr.propertyIsEnumerable, fi = oi.splice, Bs = xn ? xn.isConcatSpreadable : r, Er = xn ? xn.iterator : r, Qn = xn ? xn.toStringTag : r, hi = function() {
        try {
          var e = er(Ue, "defineProperty");
          return e({}, "", {}), e;
        } catch {
        }
      }(), rf = D.clearTimeout !== wt.clearTimeout && D.clearTimeout, of = K && K.now !== wt.Date.now && K.now, af = D.setTimeout !== wt.setTimeout && D.setTimeout, pi = ct.ceil, vi = ct.floor, Ao = Ue.getOwnPropertySymbols, sf = ui ? ui.isBuffer : r, xs = D.isFinite, lf = oi.join, uf = Os(Ue.keys, Ue), dt = ct.max, kt = ct.min, cf = K.now, df = D.parseInt, Vs = ct.random, ff = oi.reverse, Do = er(D, "DataView"), Br = er(D, "Map"), Io = er(D, "Promise"), vr = er(D, "Set"), xr = er(D, "WeakMap"), Vr = er(Ue, "create"), mi = xr && new xr(), mr = {}, hf = tr(Do), pf = tr(Br), vf = tr(Io), mf = tr(vr), gf = tr(xr), gi = xn ? xn.prototype : r, Pr = gi ? gi.valueOf : r, Ps = gi ? gi.toString : r;
      function f(e) {
        if (je(e) && !ce(e) && !(e instanceof $e)) {
          if (e instanceof Gt)
            return e;
          if (Fe.call(e, "__wrapped__"))
            return Ll(e);
        }
        return new Gt(e);
      }
      var gr = /* @__PURE__ */ function() {
        function e() {
        }
        return function(n) {
          if (!Qe(n))
            return {};
          if (Is)
            return Is(n);
          e.prototype = n;
          var o = new e();
          return e.prototype = r, o;
        };
      }();
      function yi() {
      }
      function Gt(e, n) {
        this.__wrapped__ = e, this.__actions__ = [], this.__chain__ = !!n, this.__index__ = 0, this.__values__ = r;
      }
      f.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: Dc,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: Ic,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: qa,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: f
        }
      }, f.prototype = yi.prototype, f.prototype.constructor = f, Gt.prototype = gr(yi.prototype), Gt.prototype.constructor = Gt;
      function $e(e) {
        this.__wrapped__ = e, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = ut, this.__views__ = [];
      }
      function yf() {
        var e = new $e(this.__wrapped__);
        return e.__actions__ = Dt(this.__actions__), e.__dir__ = this.__dir__, e.__filtered__ = this.__filtered__, e.__iteratees__ = Dt(this.__iteratees__), e.__takeCount__ = this.__takeCount__, e.__views__ = Dt(this.__views__), e;
      }
      function wf() {
        if (this.__filtered__) {
          var e = new $e(this);
          e.__dir__ = -1, e.__filtered__ = !0;
        } else
          e = this.clone(), e.__dir__ *= -1;
        return e;
      }
      function bf() {
        var e = this.__wrapped__.value(), n = this.__dir__, o = ce(e), c = n < 0, d = o ? e.length : 0, p = Eh(0, d, this.__views__), m = p.start, w = p.end, _ = w - m, B = c ? w : m - 1, x = this.__iteratees__, P = x.length, N = 0, te = kt(_, this.__takeCount__);
        if (!o || !c && d == _ && te == _)
          return al(e, this.__actions__);
        var oe = [];
        e:
          for (; _-- && N < te; ) {
            B += n;
            for (var ve = -1, ae = e[B]; ++ve < P; ) {
              var we = x[ve], Te = we.iteratee, Ft = we.type, Mt = Te(ae);
              if (Ft == De)
                ae = Mt;
              else if (!Mt) {
                if (Ft == Tt)
                  continue e;
                break e;
              }
            }
            oe[N++] = ae;
          }
        return oe;
      }
      $e.prototype = gr(yi.prototype), $e.prototype.constructor = $e;
      function Xn(e) {
        var n = -1, o = e == null ? 0 : e.length;
        for (this.clear(); ++n < o; ) {
          var c = e[n];
          this.set(c[0], c[1]);
        }
      }
      function kf() {
        this.__data__ = Vr ? Vr(null) : {}, this.size = 0;
      }
      function Cf(e) {
        var n = this.has(e) && delete this.__data__[e];
        return this.size -= n ? 1 : 0, n;
      }
      function $f(e) {
        var n = this.__data__;
        if (Vr) {
          var o = n[e];
          return o === g ? r : o;
        }
        return Fe.call(n, e) ? n[e] : r;
      }
      function _f(e) {
        var n = this.__data__;
        return Vr ? n[e] !== r : Fe.call(n, e);
      }
      function Tf(e, n) {
        var o = this.__data__;
        return this.size += this.has(e) ? 0 : 1, o[e] = Vr && n === r ? g : n, this;
      }
      Xn.prototype.clear = kf, Xn.prototype.delete = Cf, Xn.prototype.get = $f, Xn.prototype.has = _f, Xn.prototype.set = Tf;
      function bn(e) {
        var n = -1, o = e == null ? 0 : e.length;
        for (this.clear(); ++n < o; ) {
          var c = e[n];
          this.set(c[0], c[1]);
        }
      }
      function Sf() {
        this.__data__ = [], this.size = 0;
      }
      function Of(e) {
        var n = this.__data__, o = wi(n, e);
        if (o < 0)
          return !1;
        var c = n.length - 1;
        return o == c ? n.pop() : fi.call(n, o, 1), --this.size, !0;
      }
      function Mf(e) {
        var n = this.__data__, o = wi(n, e);
        return o < 0 ? r : n[o][1];
      }
      function Af(e) {
        return wi(this.__data__, e) > -1;
      }
      function Df(e, n) {
        var o = this.__data__, c = wi(o, e);
        return c < 0 ? (++this.size, o.push([e, n])) : o[c][1] = n, this;
      }
      bn.prototype.clear = Sf, bn.prototype.delete = Of, bn.prototype.get = Mf, bn.prototype.has = Af, bn.prototype.set = Df;
      function kn(e) {
        var n = -1, o = e == null ? 0 : e.length;
        for (this.clear(); ++n < o; ) {
          var c = e[n];
          this.set(c[0], c[1]);
        }
      }
      function If() {
        this.size = 0, this.__data__ = {
          hash: new Xn(),
          map: new (Br || bn)(),
          string: new Xn()
        };
      }
      function Ef(e) {
        var n = Ii(this, e).delete(e);
        return this.size -= n ? 1 : 0, n;
      }
      function Bf(e) {
        return Ii(this, e).get(e);
      }
      function xf(e) {
        return Ii(this, e).has(e);
      }
      function Vf(e, n) {
        var o = Ii(this, e), c = o.size;
        return o.set(e, n), this.size += o.size == c ? 0 : 1, this;
      }
      kn.prototype.clear = If, kn.prototype.delete = Ef, kn.prototype.get = Bf, kn.prototype.has = xf, kn.prototype.set = Vf;
      function Zn(e) {
        var n = -1, o = e == null ? 0 : e.length;
        for (this.__data__ = new kn(); ++n < o; )
          this.add(e[n]);
      }
      function Pf(e) {
        return this.__data__.set(e, g), this;
      }
      function Lf(e) {
        return this.__data__.has(e);
      }
      Zn.prototype.add = Zn.prototype.push = Pf, Zn.prototype.has = Lf;
      function tn(e) {
        var n = this.__data__ = new bn(e);
        this.size = n.size;
      }
      function Rf() {
        this.__data__ = new bn(), this.size = 0;
      }
      function Ff(e) {
        var n = this.__data__, o = n.delete(e);
        return this.size = n.size, o;
      }
      function Wf(e) {
        return this.__data__.get(e);
      }
      function Hf(e) {
        return this.__data__.has(e);
      }
      function Uf(e, n) {
        var o = this.__data__;
        if (o instanceof bn) {
          var c = o.__data__;
          if (!Br || c.length < a - 1)
            return c.push([e, n]), this.size = ++o.size, this;
          o = this.__data__ = new kn(c);
        }
        return o.set(e, n), this.size = o.size, this;
      }
      tn.prototype.clear = Rf, tn.prototype.delete = Ff, tn.prototype.get = Wf, tn.prototype.has = Hf, tn.prototype.set = Uf;
      function Ls(e, n) {
        var o = ce(e), c = !o && nr(e), d = !o && !c && Fn(e), p = !o && !c && !d && kr(e), m = o || c || d || p, w = m ? To(e.length, Zd) : [], _ = w.length;
        for (var B in e)
          (n || Fe.call(e, B)) && !(m && // Safari 9 has enumerable `arguments.length` in strict mode.
          (B == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          d && (B == "offset" || B == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          p && (B == "buffer" || B == "byteLength" || B == "byteOffset") || // Skip index properties.
          Tn(B, _))) && w.push(B);
        return w;
      }
      function Rs(e) {
        var n = e.length;
        return n ? e[Uo(0, n - 1)] : r;
      }
      function Nf(e, n) {
        return Ei(Dt(e), Jn(n, 0, e.length));
      }
      function zf(e) {
        return Ei(Dt(e));
      }
      function Eo(e, n, o) {
        (o !== r && !nn(e[n], o) || o === r && !(n in e)) && Cn(e, n, o);
      }
      function Lr(e, n, o) {
        var c = e[n];
        (!(Fe.call(e, n) && nn(c, o)) || o === r && !(n in e)) && Cn(e, n, o);
      }
      function wi(e, n) {
        for (var o = e.length; o--; )
          if (nn(e[o][0], n))
            return o;
        return -1;
      }
      function qf(e, n, o, c) {
        return Vn(e, function(d, p, m) {
          n(c, d, o(d), m);
        }), c;
      }
      function Fs(e, n) {
        return e && dn(n, mt(n), e);
      }
      function Yf(e, n) {
        return e && dn(n, Et(n), e);
      }
      function Cn(e, n, o) {
        n == "__proto__" && hi ? hi(e, n, {
          configurable: !0,
          enumerable: !0,
          value: o,
          writable: !0
        }) : e[n] = o;
      }
      function Bo(e, n) {
        for (var o = -1, c = n.length, d = A(c), p = e == null; ++o < c; )
          d[o] = p ? r : ha(e, n[o]);
        return d;
      }
      function Jn(e, n, o) {
        return e === e && (o !== r && (e = e <= o ? e : o), n !== r && (e = e >= n ? e : n)), e;
      }
      function Kt(e, n, o, c, d, p) {
        var m, w = n & S, _ = n & E, B = n & O;
        if (o && (m = d ? o(e, c, d, p) : o(e)), m !== r)
          return m;
        if (!Qe(e))
          return e;
        var x = ce(e);
        if (x) {
          if (m = xh(e), !w)
            return Dt(e, m);
        } else {
          var P = Ct(e), N = P == yn || P == V;
          if (Fn(e))
            return ul(e, w);
          if (P == nt || P == Jt || N && !d) {
            if (m = _ || N ? {} : Ml(e), !w)
              return _ ? $h(e, Yf(m, e)) : Ch(e, Fs(m, e));
          } else {
            if (!ze[P])
              return d ? e : {};
            m = Vh(e, P, w);
          }
        }
        p || (p = new tn());
        var te = p.get(e);
        if (te)
          return te;
        p.set(e, m), ru(e) ? e.forEach(function(ae) {
          m.add(Kt(ae, n, o, ae, e, p));
        }) : tu(e) && e.forEach(function(ae, we) {
          m.set(we, Kt(ae, n, o, we, e, p));
        });
        var oe = B ? _ ? jo : Jo : _ ? Et : mt, ve = x ? r : oe(e);
        return qt(ve || e, function(ae, we) {
          ve && (we = ae, ae = e[we]), Lr(m, we, Kt(ae, n, o, we, e, p));
        }), m;
      }
      function Gf(e) {
        var n = mt(e);
        return function(o) {
          return Ws(o, e, n);
        };
      }
      function Ws(e, n, o) {
        var c = o.length;
        if (e == null)
          return !c;
        for (e = Ue(e); c--; ) {
          var d = o[c], p = n[d], m = e[d];
          if (m === r && !(d in e) || !p(m))
            return !1;
        }
        return !0;
      }
      function Hs(e, n, o) {
        if (typeof e != "function")
          throw new Yt(s);
        return zr(function() {
          e.apply(r, o);
        }, n);
      }
      function Rr(e, n, o, c) {
        var d = -1, p = ni, m = !0, w = e.length, _ = [], B = n.length;
        if (!w)
          return _;
        o && (n = Ge(n, Pt(o))), c ? (p = wo, m = !1) : n.length >= a && (p = Ir, m = !1, n = new Zn(n));
        e:
          for (; ++d < w; ) {
            var x = e[d], P = o == null ? x : o(x);
            if (x = c || x !== 0 ? x : 0, m && P === P) {
              for (var N = B; N--; )
                if (n[N] === P)
                  continue e;
              _.push(x);
            } else
              p(n, P, c) || _.push(x);
          }
        return _;
      }
      var Vn = pl(cn), Us = pl(Vo, !0);
      function Kf(e, n) {
        var o = !0;
        return Vn(e, function(c, d, p) {
          return o = !!n(c, d, p), o;
        }), o;
      }
      function bi(e, n, o) {
        for (var c = -1, d = e.length; ++c < d; ) {
          var p = e[c], m = n(p);
          if (m != null && (w === r ? m === m && !Rt(m) : o(m, w)))
            var w = m, _ = p;
        }
        return _;
      }
      function Qf(e, n, o, c) {
        var d = e.length;
        for (o = pe(o), o < 0 && (o = -o > d ? 0 : d + o), c = c === r || c > d ? d : pe(c), c < 0 && (c += d), c = o > c ? 0 : ou(c); o < c; )
          e[o++] = n;
        return e;
      }
      function Ns(e, n) {
        var o = [];
        return Vn(e, function(c, d, p) {
          n(c, d, p) && o.push(c);
        }), o;
      }
      function bt(e, n, o, c, d) {
        var p = -1, m = e.length;
        for (o || (o = Lh), d || (d = []); ++p < m; ) {
          var w = e[p];
          n > 0 && o(w) ? n > 1 ? bt(w, n - 1, o, c, d) : En(d, w) : c || (d[d.length] = w);
        }
        return d;
      }
      var xo = vl(), zs = vl(!0);
      function cn(e, n) {
        return e && xo(e, n, mt);
      }
      function Vo(e, n) {
        return e && zs(e, n, mt);
      }
      function ki(e, n) {
        return In(n, function(o) {
          return Sn(e[o]);
        });
      }
      function jn(e, n) {
        n = Ln(n, e);
        for (var o = 0, c = n.length; e != null && o < c; )
          e = e[fn(n[o++])];
        return o && o == c ? e : r;
      }
      function qs(e, n, o) {
        var c = n(e);
        return ce(e) ? c : En(c, o(e));
      }
      function St(e) {
        return e == null ? e === r ? $c : tt : Qn && Qn in Ue(e) ? Ih(e) : zh(e);
      }
      function Po(e, n) {
        return e > n;
      }
      function Xf(e, n) {
        return e != null && Fe.call(e, n);
      }
      function Zf(e, n) {
        return e != null && n in Ue(e);
      }
      function Jf(e, n, o) {
        return e >= kt(n, o) && e < dt(n, o);
      }
      function Lo(e, n, o) {
        for (var c = o ? wo : ni, d = e[0].length, p = e.length, m = p, w = A(p), _ = 1 / 0, B = []; m--; ) {
          var x = e[m];
          m && n && (x = Ge(x, Pt(n))), _ = kt(x.length, _), w[m] = !o && (n || d >= 120 && x.length >= 120) ? new Zn(m && x) : r;
        }
        x = e[0];
        var P = -1, N = w[0];
        e:
          for (; ++P < d && B.length < _; ) {
            var te = x[P], oe = n ? n(te) : te;
            if (te = o || te !== 0 ? te : 0, !(N ? Ir(N, oe) : c(B, oe, o))) {
              for (m = p; --m; ) {
                var ve = w[m];
                if (!(ve ? Ir(ve, oe) : c(e[m], oe, o)))
                  continue e;
              }
              N && N.push(oe), B.push(te);
            }
          }
        return B;
      }
      function jf(e, n, o, c) {
        return cn(e, function(d, p, m) {
          n(c, o(d), p, m);
        }), c;
      }
      function Fr(e, n, o) {
        n = Ln(n, e), e = El(e, n);
        var c = e == null ? e : e[fn(Xt(n))];
        return c == null ? r : Vt(c, e, o);
      }
      function Ys(e) {
        return je(e) && St(e) == Jt;
      }
      function eh(e) {
        return je(e) && St(e) == Dr;
      }
      function th(e) {
        return je(e) && St(e) == _e;
      }
      function Wr(e, n, o, c, d) {
        return e === n ? !0 : e == null || n == null || !je(e) && !je(n) ? e !== e && n !== n : nh(e, n, o, c, Wr, d);
      }
      function nh(e, n, o, c, d, p) {
        var m = ce(e), w = ce(n), _ = m ? ln : Ct(e), B = w ? ln : Ct(n);
        _ = _ == Jt ? nt : _, B = B == Jt ? nt : B;
        var x = _ == nt, P = B == nt, N = _ == B;
        if (N && Fn(e)) {
          if (!Fn(n))
            return !1;
          m = !0, x = !1;
        }
        if (N && !x)
          return p || (p = new tn()), m || kr(e) ? Tl(e, n, o, c, d, p) : Ah(e, n, _, o, c, d, p);
        if (!(o & C)) {
          var te = x && Fe.call(e, "__wrapped__"), oe = P && Fe.call(n, "__wrapped__");
          if (te || oe) {
            var ve = te ? e.value() : e, ae = oe ? n.value() : n;
            return p || (p = new tn()), d(ve, ae, o, c, p);
          }
        }
        return N ? (p || (p = new tn()), Dh(e, n, o, c, d, p)) : !1;
      }
      function rh(e) {
        return je(e) && Ct(e) == L;
      }
      function Ro(e, n, o, c) {
        var d = o.length, p = d, m = !c;
        if (e == null)
          return !p;
        for (e = Ue(e); d--; ) {
          var w = o[d];
          if (m && w[2] ? w[1] !== e[w[0]] : !(w[0] in e))
            return !1;
        }
        for (; ++d < p; ) {
          w = o[d];
          var _ = w[0], B = e[_], x = w[1];
          if (m && w[2]) {
            if (B === r && !(_ in e))
              return !1;
          } else {
            var P = new tn();
            if (c)
              var N = c(B, x, _, e, n, P);
            if (!(N === r ? Wr(x, B, C | I, c, P) : N))
              return !1;
          }
        }
        return !0;
      }
      function Gs(e) {
        if (!Qe(e) || Fh(e))
          return !1;
        var n = Sn(e) ? nf : Yc;
        return n.test(tr(e));
      }
      function ih(e) {
        return je(e) && St(e) == Or;
      }
      function oh(e) {
        return je(e) && Ct(e) == jt;
      }
      function ah(e) {
        return je(e) && Ri(e.length) && !!Ye[St(e)];
      }
      function Ks(e) {
        return typeof e == "function" ? e : e == null ? Bt : typeof e == "object" ? ce(e) ? Zs(e[0], e[1]) : Xs(e) : mu(e);
      }
      function Fo(e) {
        if (!Nr(e))
          return uf(e);
        var n = [];
        for (var o in Ue(e))
          Fe.call(e, o) && o != "constructor" && n.push(o);
        return n;
      }
      function sh(e) {
        if (!Qe(e))
          return Nh(e);
        var n = Nr(e), o = [];
        for (var c in e)
          c == "constructor" && (n || !Fe.call(e, c)) || o.push(c);
        return o;
      }
      function Wo(e, n) {
        return e < n;
      }
      function Qs(e, n) {
        var o = -1, c = It(e) ? A(e.length) : [];
        return Vn(e, function(d, p, m) {
          c[++o] = n(d, p, m);
        }), c;
      }
      function Xs(e) {
        var n = ta(e);
        return n.length == 1 && n[0][2] ? Dl(n[0][0], n[0][1]) : function(o) {
          return o === e || Ro(o, e, n);
        };
      }
      function Zs(e, n) {
        return ra(e) && Al(n) ? Dl(fn(e), n) : function(o) {
          var c = ha(o, e);
          return c === r && c === n ? pa(o, e) : Wr(n, c, C | I);
        };
      }
      function Ci(e, n, o, c, d) {
        e !== n && xo(n, function(p, m) {
          if (d || (d = new tn()), Qe(p))
            lh(e, n, m, o, Ci, c, d);
          else {
            var w = c ? c(oa(e, m), p, m + "", e, n, d) : r;
            w === r && (w = p), Eo(e, m, w);
          }
        }, Et);
      }
      function lh(e, n, o, c, d, p, m) {
        var w = oa(e, o), _ = oa(n, o), B = m.get(_);
        if (B) {
          Eo(e, o, B);
          return;
        }
        var x = p ? p(w, _, o + "", e, n, m) : r, P = x === r;
        if (P) {
          var N = ce(_), te = !N && Fn(_), oe = !N && !te && kr(_);
          x = _, N || te || oe ? ce(w) ? x = w : rt(w) ? x = Dt(w) : te ? (P = !1, x = ul(_, !0)) : oe ? (P = !1, x = cl(_, !0)) : x = [] : qr(_) || nr(_) ? (x = w, nr(w) ? x = au(w) : (!Qe(w) || Sn(w)) && (x = Ml(_))) : P = !1;
        }
        P && (m.set(_, x), d(x, _, c, p, m), m.delete(_)), Eo(e, o, x);
      }
      function Js(e, n) {
        var o = e.length;
        if (o)
          return n += n < 0 ? o : 0, Tn(n, o) ? e[n] : r;
      }
      function js(e, n, o) {
        n.length ? n = Ge(n, function(p) {
          return ce(p) ? function(m) {
            return jn(m, p.length === 1 ? p[0] : p);
          } : p;
        }) : n = [Bt];
        var c = -1;
        n = Ge(n, Pt(ie()));
        var d = Qs(e, function(p, m, w) {
          var _ = Ge(n, function(B) {
            return B(p);
          });
          return { criteria: _, index: ++c, value: p };
        });
        return xd(d, function(p, m) {
          return kh(p, m, o);
        });
      }
      function uh(e, n) {
        return el(e, n, function(o, c) {
          return pa(e, c);
        });
      }
      function el(e, n, o) {
        for (var c = -1, d = n.length, p = {}; ++c < d; ) {
          var m = n[c], w = jn(e, m);
          o(w, m) && Hr(p, Ln(m, e), w);
        }
        return p;
      }
      function ch(e) {
        return function(n) {
          return jn(n, e);
        };
      }
      function Ho(e, n, o, c) {
        var d = c ? Bd : cr, p = -1, m = n.length, w = e;
        for (e === n && (n = Dt(n)), o && (w = Ge(e, Pt(o))); ++p < m; )
          for (var _ = 0, B = n[p], x = o ? o(B) : B; (_ = d(w, x, _, c)) > -1; )
            w !== e && fi.call(w, _, 1), fi.call(e, _, 1);
        return e;
      }
      function tl(e, n) {
        for (var o = e ? n.length : 0, c = o - 1; o--; ) {
          var d = n[o];
          if (o == c || d !== p) {
            var p = d;
            Tn(d) ? fi.call(e, d, 1) : qo(e, d);
          }
        }
        return e;
      }
      function Uo(e, n) {
        return e + vi(Vs() * (n - e + 1));
      }
      function dh(e, n, o, c) {
        for (var d = -1, p = dt(pi((n - e) / (o || 1)), 0), m = A(p); p--; )
          m[c ? p : ++d] = e, e += o;
        return m;
      }
      function No(e, n) {
        var o = "";
        if (!e || n < 1 || n > yt)
          return o;
        do
          n % 2 && (o += e), n = vi(n / 2), n && (e += e);
        while (n);
        return o;
      }
      function me(e, n) {
        return aa(Il(e, n, Bt), e + "");
      }
      function fh(e) {
        return Rs(Cr(e));
      }
      function hh(e, n) {
        var o = Cr(e);
        return Ei(o, Jn(n, 0, o.length));
      }
      function Hr(e, n, o, c) {
        if (!Qe(e))
          return e;
        n = Ln(n, e);
        for (var d = -1, p = n.length, m = p - 1, w = e; w != null && ++d < p; ) {
          var _ = fn(n[d]), B = o;
          if (_ === "__proto__" || _ === "constructor" || _ === "prototype")
            return e;
          if (d != m) {
            var x = w[_];
            B = c ? c(x, _, w) : r, B === r && (B = Qe(x) ? x : Tn(n[d + 1]) ? [] : {});
          }
          Lr(w, _, B), w = w[_];
        }
        return e;
      }
      var nl = mi ? function(e, n) {
        return mi.set(e, n), e;
      } : Bt, ph = hi ? function(e, n) {
        return hi(e, "toString", {
          configurable: !0,
          enumerable: !1,
          value: ma(n),
          writable: !0
        });
      } : Bt;
      function vh(e) {
        return Ei(Cr(e));
      }
      function Qt(e, n, o) {
        var c = -1, d = e.length;
        n < 0 && (n = -n > d ? 0 : d + n), o = o > d ? d : o, o < 0 && (o += d), d = n > o ? 0 : o - n >>> 0, n >>>= 0;
        for (var p = A(d); ++c < d; )
          p[c] = e[c + n];
        return p;
      }
      function mh(e, n) {
        var o;
        return Vn(e, function(c, d, p) {
          return o = n(c, d, p), !o;
        }), !!o;
      }
      function $i(e, n, o) {
        var c = 0, d = e == null ? c : e.length;
        if (typeof n == "number" && n === n && d <= sn) {
          for (; c < d; ) {
            var p = c + d >>> 1, m = e[p];
            m !== null && !Rt(m) && (o ? m <= n : m < n) ? c = p + 1 : d = p;
          }
          return d;
        }
        return zo(e, n, Bt, o);
      }
      function zo(e, n, o, c) {
        var d = 0, p = e == null ? 0 : e.length;
        if (p === 0)
          return 0;
        n = o(n);
        for (var m = n !== n, w = n === null, _ = Rt(n), B = n === r; d < p; ) {
          var x = vi((d + p) / 2), P = o(e[x]), N = P !== r, te = P === null, oe = P === P, ve = Rt(P);
          if (m)
            var ae = c || oe;
          else
            B ? ae = oe && (c || N) : w ? ae = oe && N && (c || !te) : _ ? ae = oe && N && !te && (c || !ve) : te || ve ? ae = !1 : ae = c ? P <= n : P < n;
          ae ? d = x + 1 : p = x;
        }
        return kt(p, Ut);
      }
      function rl(e, n) {
        for (var o = -1, c = e.length, d = 0, p = []; ++o < c; ) {
          var m = e[o], w = n ? n(m) : m;
          if (!o || !nn(w, _)) {
            var _ = w;
            p[d++] = m === 0 ? 0 : m;
          }
        }
        return p;
      }
      function il(e) {
        return typeof e == "number" ? e : Rt(e) ? xt : +e;
      }
      function Lt(e) {
        if (typeof e == "string")
          return e;
        if (ce(e))
          return Ge(e, Lt) + "";
        if (Rt(e))
          return Ps ? Ps.call(e) : "";
        var n = e + "";
        return n == "0" && 1 / e == -ke ? "-0" : n;
      }
      function Pn(e, n, o) {
        var c = -1, d = ni, p = e.length, m = !0, w = [], _ = w;
        if (o)
          m = !1, d = wo;
        else if (p >= a) {
          var B = n ? null : Oh(e);
          if (B)
            return ii(B);
          m = !1, d = Ir, _ = new Zn();
        } else
          _ = n ? [] : w;
        e:
          for (; ++c < p; ) {
            var x = e[c], P = n ? n(x) : x;
            if (x = o || x !== 0 ? x : 0, m && P === P) {
              for (var N = _.length; N--; )
                if (_[N] === P)
                  continue e;
              n && _.push(P), w.push(x);
            } else
              d(_, P, o) || (_ !== w && _.push(P), w.push(x));
          }
        return w;
      }
      function qo(e, n) {
        return n = Ln(n, e), e = El(e, n), e == null || delete e[fn(Xt(n))];
      }
      function ol(e, n, o, c) {
        return Hr(e, n, o(jn(e, n)), c);
      }
      function _i(e, n, o, c) {
        for (var d = e.length, p = c ? d : -1; (c ? p-- : ++p < d) && n(e[p], p, e); )
          ;
        return o ? Qt(e, c ? 0 : p, c ? p + 1 : d) : Qt(e, c ? p + 1 : 0, c ? d : p);
      }
      function al(e, n) {
        var o = e;
        return o instanceof $e && (o = o.value()), bo(n, function(c, d) {
          return d.func.apply(d.thisArg, En([c], d.args));
        }, o);
      }
      function Yo(e, n, o) {
        var c = e.length;
        if (c < 2)
          return c ? Pn(e[0]) : [];
        for (var d = -1, p = A(c); ++d < c; )
          for (var m = e[d], w = -1; ++w < c; )
            w != d && (p[d] = Rr(p[d] || m, e[w], n, o));
        return Pn(bt(p, 1), n, o);
      }
      function sl(e, n, o) {
        for (var c = -1, d = e.length, p = n.length, m = {}; ++c < d; ) {
          var w = c < p ? n[c] : r;
          o(m, e[c], w);
        }
        return m;
      }
      function Go(e) {
        return rt(e) ? e : [];
      }
      function Ko(e) {
        return typeof e == "function" ? e : Bt;
      }
      function Ln(e, n) {
        return ce(e) ? e : ra(e, n) ? [e] : Pl(Re(e));
      }
      var gh = me;
      function Rn(e, n, o) {
        var c = e.length;
        return o = o === r ? c : o, !n && o >= c ? e : Qt(e, n, o);
      }
      var ll = rf || function(e) {
        return wt.clearTimeout(e);
      };
      function ul(e, n) {
        if (n)
          return e.slice();
        var o = e.length, c = Ds ? Ds(o) : new e.constructor(o);
        return e.copy(c), c;
      }
      function Qo(e) {
        var n = new e.constructor(e.byteLength);
        return new ci(n).set(new ci(e)), n;
      }
      function yh(e, n) {
        var o = n ? Qo(e.buffer) : e.buffer;
        return new e.constructor(o, e.byteOffset, e.byteLength);
      }
      function wh(e) {
        var n = new e.constructor(e.source, Ya.exec(e));
        return n.lastIndex = e.lastIndex, n;
      }
      function bh(e) {
        return Pr ? Ue(Pr.call(e)) : {};
      }
      function cl(e, n) {
        var o = n ? Qo(e.buffer) : e.buffer;
        return new e.constructor(o, e.byteOffset, e.length);
      }
      function dl(e, n) {
        if (e !== n) {
          var o = e !== r, c = e === null, d = e === e, p = Rt(e), m = n !== r, w = n === null, _ = n === n, B = Rt(n);
          if (!w && !B && !p && e > n || p && m && _ && !w && !B || c && m && _ || !o && _ || !d)
            return 1;
          if (!c && !p && !B && e < n || B && o && d && !c && !p || w && o && d || !m && d || !_)
            return -1;
        }
        return 0;
      }
      function kh(e, n, o) {
        for (var c = -1, d = e.criteria, p = n.criteria, m = d.length, w = o.length; ++c < m; ) {
          var _ = dl(d[c], p[c]);
          if (_) {
            if (c >= w)
              return _;
            var B = o[c];
            return _ * (B == "desc" ? -1 : 1);
          }
        }
        return e.index - n.index;
      }
      function fl(e, n, o, c) {
        for (var d = -1, p = e.length, m = o.length, w = -1, _ = n.length, B = dt(p - m, 0), x = A(_ + B), P = !c; ++w < _; )
          x[w] = n[w];
        for (; ++d < m; )
          (P || d < p) && (x[o[d]] = e[d]);
        for (; B--; )
          x[w++] = e[d++];
        return x;
      }
      function hl(e, n, o, c) {
        for (var d = -1, p = e.length, m = -1, w = o.length, _ = -1, B = n.length, x = dt(p - w, 0), P = A(x + B), N = !c; ++d < x; )
          P[d] = e[d];
        for (var te = d; ++_ < B; )
          P[te + _] = n[_];
        for (; ++m < w; )
          (N || d < p) && (P[te + o[m]] = e[d++]);
        return P;
      }
      function Dt(e, n) {
        var o = -1, c = e.length;
        for (n || (n = A(c)); ++o < c; )
          n[o] = e[o];
        return n;
      }
      function dn(e, n, o, c) {
        var d = !o;
        o || (o = {});
        for (var p = -1, m = n.length; ++p < m; ) {
          var w = n[p], _ = c ? c(o[w], e[w], w, o, e) : r;
          _ === r && (_ = e[w]), d ? Cn(o, w, _) : Lr(o, w, _);
        }
        return o;
      }
      function Ch(e, n) {
        return dn(e, na(e), n);
      }
      function $h(e, n) {
        return dn(e, Sl(e), n);
      }
      function Ti(e, n) {
        return function(o, c) {
          var d = ce(o) ? Od : qf, p = n ? n() : {};
          return d(o, e, ie(c, 2), p);
        };
      }
      function yr(e) {
        return me(function(n, o) {
          var c = -1, d = o.length, p = d > 1 ? o[d - 1] : r, m = d > 2 ? o[2] : r;
          for (p = e.length > 3 && typeof p == "function" ? (d--, p) : r, m && Ot(o[0], o[1], m) && (p = d < 3 ? r : p, d = 1), n = Ue(n); ++c < d; ) {
            var w = o[c];
            w && e(n, w, c, p);
          }
          return n;
        });
      }
      function pl(e, n) {
        return function(o, c) {
          if (o == null)
            return o;
          if (!It(o))
            return e(o, c);
          for (var d = o.length, p = n ? d : -1, m = Ue(o); (n ? p-- : ++p < d) && c(m[p], p, m) !== !1; )
            ;
          return o;
        };
      }
      function vl(e) {
        return function(n, o, c) {
          for (var d = -1, p = Ue(n), m = c(n), w = m.length; w--; ) {
            var _ = m[e ? w : ++d];
            if (o(p[_], _, p) === !1)
              break;
          }
          return n;
        };
      }
      function _h(e, n, o) {
        var c = n & M, d = Ur(e);
        function p() {
          var m = this && this !== wt && this instanceof p ? d : e;
          return m.apply(c ? o : this, arguments);
        }
        return p;
      }
      function ml(e) {
        return function(n) {
          n = Re(n);
          var o = dr(n) ? en(n) : r, c = o ? o[0] : n.charAt(0), d = o ? Rn(o, 1).join("") : n.slice(1);
          return c[e]() + d;
        };
      }
      function wr(e) {
        return function(n) {
          return bo(pu(hu(n).replace(hd, "")), e, "");
        };
      }
      function Ur(e) {
        return function() {
          var n = arguments;
          switch (n.length) {
            case 0:
              return new e();
            case 1:
              return new e(n[0]);
            case 2:
              return new e(n[0], n[1]);
            case 3:
              return new e(n[0], n[1], n[2]);
            case 4:
              return new e(n[0], n[1], n[2], n[3]);
            case 5:
              return new e(n[0], n[1], n[2], n[3], n[4]);
            case 6:
              return new e(n[0], n[1], n[2], n[3], n[4], n[5]);
            case 7:
              return new e(n[0], n[1], n[2], n[3], n[4], n[5], n[6]);
          }
          var o = gr(e.prototype), c = e.apply(o, n);
          return Qe(c) ? c : o;
        };
      }
      function Th(e, n, o) {
        var c = Ur(e);
        function d() {
          for (var p = arguments.length, m = A(p), w = p, _ = br(d); w--; )
            m[w] = arguments[w];
          var B = p < 3 && m[0] !== _ && m[p - 1] !== _ ? [] : Bn(m, _);
          if (p -= B.length, p < o)
            return kl(
              e,
              n,
              Si,
              d.placeholder,
              r,
              m,
              B,
              r,
              r,
              o - p
            );
          var x = this && this !== wt && this instanceof d ? c : e;
          return Vt(x, this, m);
        }
        return d;
      }
      function gl(e) {
        return function(n, o, c) {
          var d = Ue(n);
          if (!It(n)) {
            var p = ie(o, 3);
            n = mt(n), o = function(w) {
              return p(d[w], w, d);
            };
          }
          var m = e(n, o, c);
          return m > -1 ? d[p ? n[m] : m] : r;
        };
      }
      function yl(e) {
        return _n(function(n) {
          var o = n.length, c = o, d = Gt.prototype.thru;
          for (e && n.reverse(); c--; ) {
            var p = n[c];
            if (typeof p != "function")
              throw new Yt(s);
            if (d && !m && Di(p) == "wrapper")
              var m = new Gt([], !0);
          }
          for (c = m ? c : o; ++c < o; ) {
            p = n[c];
            var w = Di(p), _ = w == "wrapper" ? ea(p) : r;
            _ && ia(_[0]) && _[1] == (Ae | U | ue | Ze) && !_[4].length && _[9] == 1 ? m = m[Di(_[0])].apply(m, _[3]) : m = p.length == 1 && ia(p) ? m[w]() : m.thru(p);
          }
          return function() {
            var B = arguments, x = B[0];
            if (m && B.length == 1 && ce(x))
              return m.plant(x).value();
            for (var P = 0, N = o ? n[P].apply(this, B) : x; ++P < o; )
              N = n[P].call(this, N);
            return N;
          };
        });
      }
      function Si(e, n, o, c, d, p, m, w, _, B) {
        var x = n & Ae, P = n & M, N = n & R, te = n & (U | de), oe = n & pt, ve = N ? r : Ur(e);
        function ae() {
          for (var we = arguments.length, Te = A(we), Ft = we; Ft--; )
            Te[Ft] = arguments[Ft];
          if (te)
            var Mt = br(ae), Wt = Pd(Te, Mt);
          if (c && (Te = fl(Te, c, d, te)), p && (Te = hl(Te, p, m, te)), we -= Wt, te && we < B) {
            var it = Bn(Te, Mt);
            return kl(
              e,
              n,
              Si,
              ae.placeholder,
              o,
              Te,
              it,
              w,
              _,
              B - we
            );
          }
          var rn = P ? o : this, Mn = N ? rn[e] : e;
          return we = Te.length, w ? Te = qh(Te, w) : oe && we > 1 && Te.reverse(), x && _ < we && (Te.length = _), this && this !== wt && this instanceof ae && (Mn = ve || Ur(Mn)), Mn.apply(rn, Te);
        }
        return ae;
      }
      function wl(e, n) {
        return function(o, c) {
          return jf(o, e, n(c), {});
        };
      }
      function Oi(e, n) {
        return function(o, c) {
          var d;
          if (o === r && c === r)
            return n;
          if (o !== r && (d = o), c !== r) {
            if (d === r)
              return c;
            typeof o == "string" || typeof c == "string" ? (o = Lt(o), c = Lt(c)) : (o = il(o), c = il(c)), d = e(o, c);
          }
          return d;
        };
      }
      function Xo(e) {
        return _n(function(n) {
          return n = Ge(n, Pt(ie())), me(function(o) {
            var c = this;
            return e(n, function(d) {
              return Vt(d, c, o);
            });
          });
        });
      }
      function Mi(e, n) {
        n = n === r ? " " : Lt(n);
        var o = n.length;
        if (o < 2)
          return o ? No(n, e) : n;
        var c = No(n, pi(e / fr(n)));
        return dr(n) ? Rn(en(c), 0, e).join("") : c.slice(0, e);
      }
      function Sh(e, n, o, c) {
        var d = n & M, p = Ur(e);
        function m() {
          for (var w = -1, _ = arguments.length, B = -1, x = c.length, P = A(x + _), N = this && this !== wt && this instanceof m ? p : e; ++B < x; )
            P[B] = c[B];
          for (; _--; )
            P[B++] = arguments[++w];
          return Vt(N, d ? o : this, P);
        }
        return m;
      }
      function bl(e) {
        return function(n, o, c) {
          return c && typeof c != "number" && Ot(n, o, c) && (o = c = r), n = On(n), o === r ? (o = n, n = 0) : o = On(o), c = c === r ? n < o ? 1 : -1 : On(c), dh(n, o, c, e);
        };
      }
      function Ai(e) {
        return function(n, o) {
          return typeof n == "string" && typeof o == "string" || (n = Zt(n), o = Zt(o)), e(n, o);
        };
      }
      function kl(e, n, o, c, d, p, m, w, _, B) {
        var x = n & U, P = x ? m : r, N = x ? r : m, te = x ? p : r, oe = x ? r : p;
        n |= x ? ue : Ie, n &= ~(x ? Ie : ue), n & ee || (n &= ~(M | R));
        var ve = [
          e,
          n,
          d,
          te,
          P,
          oe,
          N,
          w,
          _,
          B
        ], ae = o.apply(r, ve);
        return ia(e) && Bl(ae, ve), ae.placeholder = c, xl(ae, e, n);
      }
      function Zo(e) {
        var n = ct[e];
        return function(o, c) {
          if (o = Zt(o), c = c == null ? 0 : kt(pe(c), 292), c && xs(o)) {
            var d = (Re(o) + "e").split("e"), p = n(d[0] + "e" + (+d[1] + c));
            return d = (Re(p) + "e").split("e"), +(d[0] + "e" + (+d[1] - c));
          }
          return n(o);
        };
      }
      var Oh = vr && 1 / ii(new vr([, -0]))[1] == ke ? function(e) {
        return new vr(e);
      } : wa;
      function Cl(e) {
        return function(n) {
          var o = Ct(n);
          return o == L ? Oo(n) : o == jt ? Nd(n) : Vd(n, e(n));
        };
      }
      function $n(e, n, o, c, d, p, m, w) {
        var _ = n & R;
        if (!_ && typeof e != "function")
          throw new Yt(s);
        var B = c ? c.length : 0;
        if (B || (n &= ~(ue | Ie), c = d = r), m = m === r ? m : dt(pe(m), 0), w = w === r ? w : pe(w), B -= d ? d.length : 0, n & Ie) {
          var x = c, P = d;
          c = d = r;
        }
        var N = _ ? r : ea(e), te = [
          e,
          n,
          o,
          c,
          d,
          x,
          P,
          p,
          m,
          w
        ];
        if (N && Uh(te, N), e = te[0], n = te[1], o = te[2], c = te[3], d = te[4], w = te[9] = te[9] === r ? _ ? 0 : e.length : dt(te[9] - B, 0), !w && n & (U | de) && (n &= ~(U | de)), !n || n == M)
          var oe = _h(e, n, o);
        else
          n == U || n == de ? oe = Th(e, n, w) : (n == ue || n == (M | ue)) && !d.length ? oe = Sh(e, n, o, c) : oe = Si.apply(r, te);
        var ve = N ? nl : Bl;
        return xl(ve(oe, te), e, n);
      }
      function $l(e, n, o, c) {
        return e === r || nn(e, pr[o]) && !Fe.call(c, o) ? n : e;
      }
      function _l(e, n, o, c, d, p) {
        return Qe(e) && Qe(n) && (p.set(n, e), Ci(e, n, r, _l, p), p.delete(n)), e;
      }
      function Mh(e) {
        return qr(e) ? r : e;
      }
      function Tl(e, n, o, c, d, p) {
        var m = o & C, w = e.length, _ = n.length;
        if (w != _ && !(m && _ > w))
          return !1;
        var B = p.get(e), x = p.get(n);
        if (B && x)
          return B == n && x == e;
        var P = -1, N = !0, te = o & I ? new Zn() : r;
        for (p.set(e, n), p.set(n, e); ++P < w; ) {
          var oe = e[P], ve = n[P];
          if (c)
            var ae = m ? c(ve, oe, P, n, e, p) : c(oe, ve, P, e, n, p);
          if (ae !== r) {
            if (ae)
              continue;
            N = !1;
            break;
          }
          if (te) {
            if (!ko(n, function(we, Te) {
              if (!Ir(te, Te) && (oe === we || d(oe, we, o, c, p)))
                return te.push(Te);
            })) {
              N = !1;
              break;
            }
          } else if (!(oe === ve || d(oe, ve, o, c, p))) {
            N = !1;
            break;
          }
        }
        return p.delete(e), p.delete(n), N;
      }
      function Ah(e, n, o, c, d, p, m) {
        switch (o) {
          case lr:
            if (e.byteLength != n.byteLength || e.byteOffset != n.byteOffset)
              return !1;
            e = e.buffer, n = n.buffer;
          case Dr:
            return !(e.byteLength != n.byteLength || !p(new ci(e), new ci(n)));
          case Ce:
          case _e:
          case G:
            return nn(+e, +n);
          case Nt:
            return e.name == n.name && e.message == n.message;
          case Or:
          case Mr:
            return e == n + "";
          case L:
            var w = Oo;
          case jt:
            var _ = c & C;
            if (w || (w = ii), e.size != n.size && !_)
              return !1;
            var B = m.get(e);
            if (B)
              return B == n;
            c |= I, m.set(e, n);
            var x = Tl(w(e), w(n), c, d, p, m);
            return m.delete(e), x;
          case Jr:
            if (Pr)
              return Pr.call(e) == Pr.call(n);
        }
        return !1;
      }
      function Dh(e, n, o, c, d, p) {
        var m = o & C, w = Jo(e), _ = w.length, B = Jo(n), x = B.length;
        if (_ != x && !m)
          return !1;
        for (var P = _; P--; ) {
          var N = w[P];
          if (!(m ? N in n : Fe.call(n, N)))
            return !1;
        }
        var te = p.get(e), oe = p.get(n);
        if (te && oe)
          return te == n && oe == e;
        var ve = !0;
        p.set(e, n), p.set(n, e);
        for (var ae = m; ++P < _; ) {
          N = w[P];
          var we = e[N], Te = n[N];
          if (c)
            var Ft = m ? c(Te, we, N, n, e, p) : c(we, Te, N, e, n, p);
          if (!(Ft === r ? we === Te || d(we, Te, o, c, p) : Ft)) {
            ve = !1;
            break;
          }
          ae || (ae = N == "constructor");
        }
        if (ve && !ae) {
          var Mt = e.constructor, Wt = n.constructor;
          Mt != Wt && "constructor" in e && "constructor" in n && !(typeof Mt == "function" && Mt instanceof Mt && typeof Wt == "function" && Wt instanceof Wt) && (ve = !1);
        }
        return p.delete(e), p.delete(n), ve;
      }
      function _n(e) {
        return aa(Il(e, r, Wl), e + "");
      }
      function Jo(e) {
        return qs(e, mt, na);
      }
      function jo(e) {
        return qs(e, Et, Sl);
      }
      var ea = mi ? function(e) {
        return mi.get(e);
      } : wa;
      function Di(e) {
        for (var n = e.name + "", o = mr[n], c = Fe.call(mr, n) ? o.length : 0; c--; ) {
          var d = o[c], p = d.func;
          if (p == null || p == e)
            return d.name;
        }
        return n;
      }
      function br(e) {
        var n = Fe.call(f, "placeholder") ? f : e;
        return n.placeholder;
      }
      function ie() {
        var e = f.iteratee || ga;
        return e = e === ga ? Ks : e, arguments.length ? e(arguments[0], arguments[1]) : e;
      }
      function Ii(e, n) {
        var o = e.__data__;
        return Rh(n) ? o[typeof n == "string" ? "string" : "hash"] : o.map;
      }
      function ta(e) {
        for (var n = mt(e), o = n.length; o--; ) {
          var c = n[o], d = e[c];
          n[o] = [c, d, Al(d)];
        }
        return n;
      }
      function er(e, n) {
        var o = Wd(e, n);
        return Gs(o) ? o : r;
      }
      function Ih(e) {
        var n = Fe.call(e, Qn), o = e[Qn];
        try {
          e[Qn] = r;
          var c = !0;
        } catch {
        }
        var d = li.call(e);
        return c && (n ? e[Qn] = o : delete e[Qn]), d;
      }
      var na = Ao ? function(e) {
        return e == null ? [] : (e = Ue(e), In(Ao(e), function(n) {
          return Es.call(e, n);
        }));
      } : ba, Sl = Ao ? function(e) {
        for (var n = []; e; )
          En(n, na(e)), e = di(e);
        return n;
      } : ba, Ct = St;
      (Do && Ct(new Do(new ArrayBuffer(1))) != lr || Br && Ct(new Br()) != L || Io && Ct(Io.resolve()) != wn || vr && Ct(new vr()) != jt || xr && Ct(new xr()) != Ar) && (Ct = function(e) {
        var n = St(e), o = n == nt ? e.constructor : r, c = o ? tr(o) : "";
        if (c)
          switch (c) {
            case hf:
              return lr;
            case pf:
              return L;
            case vf:
              return wn;
            case mf:
              return jt;
            case gf:
              return Ar;
          }
        return n;
      });
      function Eh(e, n, o) {
        for (var c = -1, d = o.length; ++c < d; ) {
          var p = o[c], m = p.size;
          switch (p.type) {
            case "drop":
              e += m;
              break;
            case "dropRight":
              n -= m;
              break;
            case "take":
              n = kt(n, e + m);
              break;
            case "takeRight":
              e = dt(e, n - m);
              break;
          }
        }
        return { start: e, end: n };
      }
      function Bh(e) {
        var n = e.match(Rc);
        return n ? n[1].split(Fc) : [];
      }
      function Ol(e, n, o) {
        n = Ln(n, e);
        for (var c = -1, d = n.length, p = !1; ++c < d; ) {
          var m = fn(n[c]);
          if (!(p = e != null && o(e, m)))
            break;
          e = e[m];
        }
        return p || ++c != d ? p : (d = e == null ? 0 : e.length, !!d && Ri(d) && Tn(m, d) && (ce(e) || nr(e)));
      }
      function xh(e) {
        var n = e.length, o = new e.constructor(n);
        return n && typeof e[0] == "string" && Fe.call(e, "index") && (o.index = e.index, o.input = e.input), o;
      }
      function Ml(e) {
        return typeof e.constructor == "function" && !Nr(e) ? gr(di(e)) : {};
      }
      function Vh(e, n, o) {
        var c = e.constructor;
        switch (n) {
          case Dr:
            return Qo(e);
          case Ce:
          case _e:
            return new c(+e);
          case lr:
            return yh(e, o);
          case eo:
          case to:
          case no:
          case ro:
          case io:
          case oo:
          case ao:
          case so:
          case lo:
            return cl(e, o);
          case L:
            return new c();
          case G:
          case Mr:
            return new c(e);
          case Or:
            return wh(e);
          case jt:
            return new c();
          case Jr:
            return bh(e);
        }
      }
      function Ph(e, n) {
        var o = n.length;
        if (!o)
          return e;
        var c = o - 1;
        return n[c] = (o > 1 ? "& " : "") + n[c], n = n.join(o > 2 ? ", " : " "), e.replace(Lc, `{
/* [wrapped with ` + n + `] */
`);
      }
      function Lh(e) {
        return ce(e) || nr(e) || !!(Bs && e && e[Bs]);
      }
      function Tn(e, n) {
        var o = typeof e;
        return n = n ?? yt, !!n && (o == "number" || o != "symbol" && Kc.test(e)) && e > -1 && e % 1 == 0 && e < n;
      }
      function Ot(e, n, o) {
        if (!Qe(o))
          return !1;
        var c = typeof n;
        return (c == "number" ? It(o) && Tn(n, o.length) : c == "string" && n in o) ? nn(o[n], e) : !1;
      }
      function ra(e, n) {
        if (ce(e))
          return !1;
        var o = typeof e;
        return o == "number" || o == "symbol" || o == "boolean" || e == null || Rt(e) ? !0 : Bc.test(e) || !Ec.test(e) || n != null && e in Ue(n);
      }
      function Rh(e) {
        var n = typeof e;
        return n == "string" || n == "number" || n == "symbol" || n == "boolean" ? e !== "__proto__" : e === null;
      }
      function ia(e) {
        var n = Di(e), o = f[n];
        if (typeof o != "function" || !(n in $e.prototype))
          return !1;
        if (e === o)
          return !0;
        var c = ea(o);
        return !!c && e === c[0];
      }
      function Fh(e) {
        return !!As && As in e;
      }
      var Wh = ai ? Sn : ka;
      function Nr(e) {
        var n = e && e.constructor, o = typeof n == "function" && n.prototype || pr;
        return e === o;
      }
      function Al(e) {
        return e === e && !Qe(e);
      }
      function Dl(e, n) {
        return function(o) {
          return o == null ? !1 : o[e] === n && (n !== r || e in Ue(o));
        };
      }
      function Hh(e) {
        var n = Pi(e, function(c) {
          return o.size === T && o.clear(), c;
        }), o = n.cache;
        return n;
      }
      function Uh(e, n) {
        var o = e[1], c = n[1], d = o | c, p = d < (M | R | Ae), m = c == Ae && o == U || c == Ae && o == Ze && e[7].length <= n[8] || c == (Ae | Ze) && n[7].length <= n[8] && o == U;
        if (!(p || m))
          return e;
        c & M && (e[2] = n[2], d |= o & M ? 0 : ee);
        var w = n[3];
        if (w) {
          var _ = e[3];
          e[3] = _ ? fl(_, w, n[4]) : w, e[4] = _ ? Bn(e[3], k) : n[4];
        }
        return w = n[5], w && (_ = e[5], e[5] = _ ? hl(_, w, n[6]) : w, e[6] = _ ? Bn(e[5], k) : n[6]), w = n[7], w && (e[7] = w), c & Ae && (e[8] = e[8] == null ? n[8] : kt(e[8], n[8])), e[9] == null && (e[9] = n[9]), e[0] = n[0], e[1] = d, e;
      }
      function Nh(e) {
        var n = [];
        if (e != null)
          for (var o in Ue(e))
            n.push(o);
        return n;
      }
      function zh(e) {
        return li.call(e);
      }
      function Il(e, n, o) {
        return n = dt(n === r ? e.length - 1 : n, 0), function() {
          for (var c = arguments, d = -1, p = dt(c.length - n, 0), m = A(p); ++d < p; )
            m[d] = c[n + d];
          d = -1;
          for (var w = A(n + 1); ++d < n; )
            w[d] = c[d];
          return w[n] = o(m), Vt(e, this, w);
        };
      }
      function El(e, n) {
        return n.length < 2 ? e : jn(e, Qt(n, 0, -1));
      }
      function qh(e, n) {
        for (var o = e.length, c = kt(n.length, o), d = Dt(e); c--; ) {
          var p = n[c];
          e[c] = Tn(p, o) ? d[p] : r;
        }
        return e;
      }
      function oa(e, n) {
        if (!(n === "constructor" && typeof e[n] == "function") && n != "__proto__")
          return e[n];
      }
      var Bl = Vl(nl), zr = af || function(e, n) {
        return wt.setTimeout(e, n);
      }, aa = Vl(ph);
      function xl(e, n, o) {
        var c = n + "";
        return aa(e, Ph(c, Yh(Bh(c), o)));
      }
      function Vl(e) {
        var n = 0, o = 0;
        return function() {
          var c = cf(), d = be - (c - o);
          if (o = c, d > 0) {
            if (++n >= Le)
              return arguments[0];
          } else
            n = 0;
          return e.apply(r, arguments);
        };
      }
      function Ei(e, n) {
        var o = -1, c = e.length, d = c - 1;
        for (n = n === r ? c : n; ++o < n; ) {
          var p = Uo(o, d), m = e[p];
          e[p] = e[o], e[o] = m;
        }
        return e.length = n, e;
      }
      var Pl = Hh(function(e) {
        var n = [];
        return e.charCodeAt(0) === 46 && n.push(""), e.replace(xc, function(o, c, d, p) {
          n.push(d ? p.replace(Uc, "$1") : c || o);
        }), n;
      });
      function fn(e) {
        if (typeof e == "string" || Rt(e))
          return e;
        var n = e + "";
        return n == "0" && 1 / e == -ke ? "-0" : n;
      }
      function tr(e) {
        if (e != null) {
          try {
            return si.call(e);
          } catch {
          }
          try {
            return e + "";
          } catch {
          }
        }
        return "";
      }
      function Yh(e, n) {
        return qt(gn, function(o) {
          var c = "_." + o[0];
          n & o[1] && !ni(e, c) && e.push(c);
        }), e.sort();
      }
      function Ll(e) {
        if (e instanceof $e)
          return e.clone();
        var n = new Gt(e.__wrapped__, e.__chain__);
        return n.__actions__ = Dt(e.__actions__), n.__index__ = e.__index__, n.__values__ = e.__values__, n;
      }
      function Gh(e, n, o) {
        (o ? Ot(e, n, o) : n === r) ? n = 1 : n = dt(pe(n), 0);
        var c = e == null ? 0 : e.length;
        if (!c || n < 1)
          return [];
        for (var d = 0, p = 0, m = A(pi(c / n)); d < c; )
          m[p++] = Qt(e, d, d += n);
        return m;
      }
      function Kh(e) {
        for (var n = -1, o = e == null ? 0 : e.length, c = 0, d = []; ++n < o; ) {
          var p = e[n];
          p && (d[c++] = p);
        }
        return d;
      }
      function Qh() {
        var e = arguments.length;
        if (!e)
          return [];
        for (var n = A(e - 1), o = arguments[0], c = e; c--; )
          n[c - 1] = arguments[c];
        return En(ce(o) ? Dt(o) : [o], bt(n, 1));
      }
      var Xh = me(function(e, n) {
        return rt(e) ? Rr(e, bt(n, 1, rt, !0)) : [];
      }), Zh = me(function(e, n) {
        var o = Xt(n);
        return rt(o) && (o = r), rt(e) ? Rr(e, bt(n, 1, rt, !0), ie(o, 2)) : [];
      }), Jh = me(function(e, n) {
        var o = Xt(n);
        return rt(o) && (o = r), rt(e) ? Rr(e, bt(n, 1, rt, !0), r, o) : [];
      });
      function jh(e, n, o) {
        var c = e == null ? 0 : e.length;
        return c ? (n = o || n === r ? 1 : pe(n), Qt(e, n < 0 ? 0 : n, c)) : [];
      }
      function ep(e, n, o) {
        var c = e == null ? 0 : e.length;
        return c ? (n = o || n === r ? 1 : pe(n), n = c - n, Qt(e, 0, n < 0 ? 0 : n)) : [];
      }
      function tp(e, n) {
        return e && e.length ? _i(e, ie(n, 3), !0, !0) : [];
      }
      function np(e, n) {
        return e && e.length ? _i(e, ie(n, 3), !0) : [];
      }
      function rp(e, n, o, c) {
        var d = e == null ? 0 : e.length;
        return d ? (o && typeof o != "number" && Ot(e, n, o) && (o = 0, c = d), Qf(e, n, o, c)) : [];
      }
      function Rl(e, n, o) {
        var c = e == null ? 0 : e.length;
        if (!c)
          return -1;
        var d = o == null ? 0 : pe(o);
        return d < 0 && (d = dt(c + d, 0)), ri(e, ie(n, 3), d);
      }
      function Fl(e, n, o) {
        var c = e == null ? 0 : e.length;
        if (!c)
          return -1;
        var d = c - 1;
        return o !== r && (d = pe(o), d = o < 0 ? dt(c + d, 0) : kt(d, c - 1)), ri(e, ie(n, 3), d, !0);
      }
      function Wl(e) {
        var n = e == null ? 0 : e.length;
        return n ? bt(e, 1) : [];
      }
      function ip(e) {
        var n = e == null ? 0 : e.length;
        return n ? bt(e, ke) : [];
      }
      function op(e, n) {
        var o = e == null ? 0 : e.length;
        return o ? (n = n === r ? 1 : pe(n), bt(e, n)) : [];
      }
      function ap(e) {
        for (var n = -1, o = e == null ? 0 : e.length, c = {}; ++n < o; ) {
          var d = e[n];
          c[d[0]] = d[1];
        }
        return c;
      }
      function Hl(e) {
        return e && e.length ? e[0] : r;
      }
      function sp(e, n, o) {
        var c = e == null ? 0 : e.length;
        if (!c)
          return -1;
        var d = o == null ? 0 : pe(o);
        return d < 0 && (d = dt(c + d, 0)), cr(e, n, d);
      }
      function lp(e) {
        var n = e == null ? 0 : e.length;
        return n ? Qt(e, 0, -1) : [];
      }
      var up = me(function(e) {
        var n = Ge(e, Go);
        return n.length && n[0] === e[0] ? Lo(n) : [];
      }), cp = me(function(e) {
        var n = Xt(e), o = Ge(e, Go);
        return n === Xt(o) ? n = r : o.pop(), o.length && o[0] === e[0] ? Lo(o, ie(n, 2)) : [];
      }), dp = me(function(e) {
        var n = Xt(e), o = Ge(e, Go);
        return n = typeof n == "function" ? n : r, n && o.pop(), o.length && o[0] === e[0] ? Lo(o, r, n) : [];
      });
      function fp(e, n) {
        return e == null ? "" : lf.call(e, n);
      }
      function Xt(e) {
        var n = e == null ? 0 : e.length;
        return n ? e[n - 1] : r;
      }
      function hp(e, n, o) {
        var c = e == null ? 0 : e.length;
        if (!c)
          return -1;
        var d = c;
        return o !== r && (d = pe(o), d = d < 0 ? dt(c + d, 0) : kt(d, c - 1)), n === n ? qd(e, n, d) : ri(e, ks, d, !0);
      }
      function pp(e, n) {
        return e && e.length ? Js(e, pe(n)) : r;
      }
      var vp = me(Ul);
      function Ul(e, n) {
        return e && e.length && n && n.length ? Ho(e, n) : e;
      }
      function mp(e, n, o) {
        return e && e.length && n && n.length ? Ho(e, n, ie(o, 2)) : e;
      }
      function gp(e, n, o) {
        return e && e.length && n && n.length ? Ho(e, n, r, o) : e;
      }
      var yp = _n(function(e, n) {
        var o = e == null ? 0 : e.length, c = Bo(e, n);
        return tl(e, Ge(n, function(d) {
          return Tn(d, o) ? +d : d;
        }).sort(dl)), c;
      });
      function wp(e, n) {
        var o = [];
        if (!(e && e.length))
          return o;
        var c = -1, d = [], p = e.length;
        for (n = ie(n, 3); ++c < p; ) {
          var m = e[c];
          n(m, c, e) && (o.push(m), d.push(c));
        }
        return tl(e, d), o;
      }
      function sa(e) {
        return e == null ? e : ff.call(e);
      }
      function bp(e, n, o) {
        var c = e == null ? 0 : e.length;
        return c ? (o && typeof o != "number" && Ot(e, n, o) ? (n = 0, o = c) : (n = n == null ? 0 : pe(n), o = o === r ? c : pe(o)), Qt(e, n, o)) : [];
      }
      function kp(e, n) {
        return $i(e, n);
      }
      function Cp(e, n, o) {
        return zo(e, n, ie(o, 2));
      }
      function $p(e, n) {
        var o = e == null ? 0 : e.length;
        if (o) {
          var c = $i(e, n);
          if (c < o && nn(e[c], n))
            return c;
        }
        return -1;
      }
      function _p(e, n) {
        return $i(e, n, !0);
      }
      function Tp(e, n, o) {
        return zo(e, n, ie(o, 2), !0);
      }
      function Sp(e, n) {
        var o = e == null ? 0 : e.length;
        if (o) {
          var c = $i(e, n, !0) - 1;
          if (nn(e[c], n))
            return c;
        }
        return -1;
      }
      function Op(e) {
        return e && e.length ? rl(e) : [];
      }
      function Mp(e, n) {
        return e && e.length ? rl(e, ie(n, 2)) : [];
      }
      function Ap(e) {
        var n = e == null ? 0 : e.length;
        return n ? Qt(e, 1, n) : [];
      }
      function Dp(e, n, o) {
        return e && e.length ? (n = o || n === r ? 1 : pe(n), Qt(e, 0, n < 0 ? 0 : n)) : [];
      }
      function Ip(e, n, o) {
        var c = e == null ? 0 : e.length;
        return c ? (n = o || n === r ? 1 : pe(n), n = c - n, Qt(e, n < 0 ? 0 : n, c)) : [];
      }
      function Ep(e, n) {
        return e && e.length ? _i(e, ie(n, 3), !1, !0) : [];
      }
      function Bp(e, n) {
        return e && e.length ? _i(e, ie(n, 3)) : [];
      }
      var xp = me(function(e) {
        return Pn(bt(e, 1, rt, !0));
      }), Vp = me(function(e) {
        var n = Xt(e);
        return rt(n) && (n = r), Pn(bt(e, 1, rt, !0), ie(n, 2));
      }), Pp = me(function(e) {
        var n = Xt(e);
        return n = typeof n == "function" ? n : r, Pn(bt(e, 1, rt, !0), r, n);
      });
      function Lp(e) {
        return e && e.length ? Pn(e) : [];
      }
      function Rp(e, n) {
        return e && e.length ? Pn(e, ie(n, 2)) : [];
      }
      function Fp(e, n) {
        return n = typeof n == "function" ? n : r, e && e.length ? Pn(e, r, n) : [];
      }
      function la(e) {
        if (!(e && e.length))
          return [];
        var n = 0;
        return e = In(e, function(o) {
          if (rt(o))
            return n = dt(o.length, n), !0;
        }), To(n, function(o) {
          return Ge(e, Co(o));
        });
      }
      function Nl(e, n) {
        if (!(e && e.length))
          return [];
        var o = la(e);
        return n == null ? o : Ge(o, function(c) {
          return Vt(n, r, c);
        });
      }
      var Wp = me(function(e, n) {
        return rt(e) ? Rr(e, n) : [];
      }), Hp = me(function(e) {
        return Yo(In(e, rt));
      }), Up = me(function(e) {
        var n = Xt(e);
        return rt(n) && (n = r), Yo(In(e, rt), ie(n, 2));
      }), Np = me(function(e) {
        var n = Xt(e);
        return n = typeof n == "function" ? n : r, Yo(In(e, rt), r, n);
      }), zp = me(la);
      function qp(e, n) {
        return sl(e || [], n || [], Lr);
      }
      function Yp(e, n) {
        return sl(e || [], n || [], Hr);
      }
      var Gp = me(function(e) {
        var n = e.length, o = n > 1 ? e[n - 1] : r;
        return o = typeof o == "function" ? (e.pop(), o) : r, Nl(e, o);
      });
      function zl(e) {
        var n = f(e);
        return n.__chain__ = !0, n;
      }
      function Kp(e, n) {
        return n(e), e;
      }
      function Bi(e, n) {
        return n(e);
      }
      var Qp = _n(function(e) {
        var n = e.length, o = n ? e[0] : 0, c = this.__wrapped__, d = function(p) {
          return Bo(p, e);
        };
        return n > 1 || this.__actions__.length || !(c instanceof $e) || !Tn(o) ? this.thru(d) : (c = c.slice(o, +o + (n ? 1 : 0)), c.__actions__.push({
          func: Bi,
          args: [d],
          thisArg: r
        }), new Gt(c, this.__chain__).thru(function(p) {
          return n && !p.length && p.push(r), p;
        }));
      });
      function Xp() {
        return zl(this);
      }
      function Zp() {
        return new Gt(this.value(), this.__chain__);
      }
      function Jp() {
        this.__values__ === r && (this.__values__ = iu(this.value()));
        var e = this.__index__ >= this.__values__.length, n = e ? r : this.__values__[this.__index__++];
        return { done: e, value: n };
      }
      function jp() {
        return this;
      }
      function ev(e) {
        for (var n, o = this; o instanceof yi; ) {
          var c = Ll(o);
          c.__index__ = 0, c.__values__ = r, n ? d.__wrapped__ = c : n = c;
          var d = c;
          o = o.__wrapped__;
        }
        return d.__wrapped__ = e, n;
      }
      function tv() {
        var e = this.__wrapped__;
        if (e instanceof $e) {
          var n = e;
          return this.__actions__.length && (n = new $e(this)), n = n.reverse(), n.__actions__.push({
            func: Bi,
            args: [sa],
            thisArg: r
          }), new Gt(n, this.__chain__);
        }
        return this.thru(sa);
      }
      function nv() {
        return al(this.__wrapped__, this.__actions__);
      }
      var rv = Ti(function(e, n, o) {
        Fe.call(e, o) ? ++e[o] : Cn(e, o, 1);
      });
      function iv(e, n, o) {
        var c = ce(e) ? ws : Kf;
        return o && Ot(e, n, o) && (n = r), c(e, ie(n, 3));
      }
      function ov(e, n) {
        var o = ce(e) ? In : Ns;
        return o(e, ie(n, 3));
      }
      var av = gl(Rl), sv = gl(Fl);
      function lv(e, n) {
        return bt(xi(e, n), 1);
      }
      function uv(e, n) {
        return bt(xi(e, n), ke);
      }
      function cv(e, n, o) {
        return o = o === r ? 1 : pe(o), bt(xi(e, n), o);
      }
      function ql(e, n) {
        var o = ce(e) ? qt : Vn;
        return o(e, ie(n, 3));
      }
      function Yl(e, n) {
        var o = ce(e) ? Md : Us;
        return o(e, ie(n, 3));
      }
      var dv = Ti(function(e, n, o) {
        Fe.call(e, o) ? e[o].push(n) : Cn(e, o, [n]);
      });
      function fv(e, n, o, c) {
        e = It(e) ? e : Cr(e), o = o && !c ? pe(o) : 0;
        var d = e.length;
        return o < 0 && (o = dt(d + o, 0)), Fi(e) ? o <= d && e.indexOf(n, o) > -1 : !!d && cr(e, n, o) > -1;
      }
      var hv = me(function(e, n, o) {
        var c = -1, d = typeof n == "function", p = It(e) ? A(e.length) : [];
        return Vn(e, function(m) {
          p[++c] = d ? Vt(n, m, o) : Fr(m, n, o);
        }), p;
      }), pv = Ti(function(e, n, o) {
        Cn(e, o, n);
      });
      function xi(e, n) {
        var o = ce(e) ? Ge : Qs;
        return o(e, ie(n, 3));
      }
      function vv(e, n, o, c) {
        return e == null ? [] : (ce(n) || (n = n == null ? [] : [n]), o = c ? r : o, ce(o) || (o = o == null ? [] : [o]), js(e, n, o));
      }
      var mv = Ti(function(e, n, o) {
        e[o ? 0 : 1].push(n);
      }, function() {
        return [[], []];
      });
      function gv(e, n, o) {
        var c = ce(e) ? bo : $s, d = arguments.length < 3;
        return c(e, ie(n, 4), o, d, Vn);
      }
      function yv(e, n, o) {
        var c = ce(e) ? Ad : $s, d = arguments.length < 3;
        return c(e, ie(n, 4), o, d, Us);
      }
      function wv(e, n) {
        var o = ce(e) ? In : Ns;
        return o(e, Li(ie(n, 3)));
      }
      function bv(e) {
        var n = ce(e) ? Rs : fh;
        return n(e);
      }
      function kv(e, n, o) {
        (o ? Ot(e, n, o) : n === r) ? n = 1 : n = pe(n);
        var c = ce(e) ? Nf : hh;
        return c(e, n);
      }
      function Cv(e) {
        var n = ce(e) ? zf : vh;
        return n(e);
      }
      function $v(e) {
        if (e == null)
          return 0;
        if (It(e))
          return Fi(e) ? fr(e) : e.length;
        var n = Ct(e);
        return n == L || n == jt ? e.size : Fo(e).length;
      }
      function _v(e, n, o) {
        var c = ce(e) ? ko : mh;
        return o && Ot(e, n, o) && (n = r), c(e, ie(n, 3));
      }
      var Tv = me(function(e, n) {
        if (e == null)
          return [];
        var o = n.length;
        return o > 1 && Ot(e, n[0], n[1]) ? n = [] : o > 2 && Ot(n[0], n[1], n[2]) && (n = [n[0]]), js(e, bt(n, 1), []);
      }), Vi = of || function() {
        return wt.Date.now();
      };
      function Sv(e, n) {
        if (typeof n != "function")
          throw new Yt(s);
        return e = pe(e), function() {
          if (--e < 1)
            return n.apply(this, arguments);
        };
      }
      function Gl(e, n, o) {
        return n = o ? r : n, n = e && n == null ? e.length : n, $n(e, Ae, r, r, r, r, n);
      }
      function Kl(e, n) {
        var o;
        if (typeof n != "function")
          throw new Yt(s);
        return e = pe(e), function() {
          return --e > 0 && (o = n.apply(this, arguments)), e <= 1 && (n = r), o;
        };
      }
      var ua = me(function(e, n, o) {
        var c = M;
        if (o.length) {
          var d = Bn(o, br(ua));
          c |= ue;
        }
        return $n(e, c, n, o, d);
      }), Ql = me(function(e, n, o) {
        var c = M | R;
        if (o.length) {
          var d = Bn(o, br(Ql));
          c |= ue;
        }
        return $n(n, c, e, o, d);
      });
      function Xl(e, n, o) {
        n = o ? r : n;
        var c = $n(e, U, r, r, r, r, r, n);
        return c.placeholder = Xl.placeholder, c;
      }
      function Zl(e, n, o) {
        n = o ? r : n;
        var c = $n(e, de, r, r, r, r, r, n);
        return c.placeholder = Zl.placeholder, c;
      }
      function Jl(e, n, o) {
        var c, d, p, m, w, _, B = 0, x = !1, P = !1, N = !0;
        if (typeof e != "function")
          throw new Yt(s);
        n = Zt(n) || 0, Qe(o) && (x = !!o.leading, P = "maxWait" in o, p = P ? dt(Zt(o.maxWait) || 0, n) : p, N = "trailing" in o ? !!o.trailing : N);
        function te(it) {
          var rn = c, Mn = d;
          return c = d = r, B = it, m = e.apply(Mn, rn), m;
        }
        function oe(it) {
          return B = it, w = zr(we, n), x ? te(it) : m;
        }
        function ve(it) {
          var rn = it - _, Mn = it - B, gu = n - rn;
          return P ? kt(gu, p - Mn) : gu;
        }
        function ae(it) {
          var rn = it - _, Mn = it - B;
          return _ === r || rn >= n || rn < 0 || P && Mn >= p;
        }
        function we() {
          var it = Vi();
          if (ae(it))
            return Te(it);
          w = zr(we, ve(it));
        }
        function Te(it) {
          return w = r, N && c ? te(it) : (c = d = r, m);
        }
        function Ft() {
          w !== r && ll(w), B = 0, c = _ = d = w = r;
        }
        function Mt() {
          return w === r ? m : Te(Vi());
        }
        function Wt() {
          var it = Vi(), rn = ae(it);
          if (c = arguments, d = this, _ = it, rn) {
            if (w === r)
              return oe(_);
            if (P)
              return ll(w), w = zr(we, n), te(_);
          }
          return w === r && (w = zr(we, n)), m;
        }
        return Wt.cancel = Ft, Wt.flush = Mt, Wt;
      }
      var Ov = me(function(e, n) {
        return Hs(e, 1, n);
      }), Mv = me(function(e, n, o) {
        return Hs(e, Zt(n) || 0, o);
      });
      function Av(e) {
        return $n(e, pt);
      }
      function Pi(e, n) {
        if (typeof e != "function" || n != null && typeof n != "function")
          throw new Yt(s);
        var o = function() {
          var c = arguments, d = n ? n.apply(this, c) : c[0], p = o.cache;
          if (p.has(d))
            return p.get(d);
          var m = e.apply(this, c);
          return o.cache = p.set(d, m) || p, m;
        };
        return o.cache = new (Pi.Cache || kn)(), o;
      }
      Pi.Cache = kn;
      function Li(e) {
        if (typeof e != "function")
          throw new Yt(s);
        return function() {
          var n = arguments;
          switch (n.length) {
            case 0:
              return !e.call(this);
            case 1:
              return !e.call(this, n[0]);
            case 2:
              return !e.call(this, n[0], n[1]);
            case 3:
              return !e.call(this, n[0], n[1], n[2]);
          }
          return !e.apply(this, n);
        };
      }
      function Dv(e) {
        return Kl(2, e);
      }
      var Iv = gh(function(e, n) {
        n = n.length == 1 && ce(n[0]) ? Ge(n[0], Pt(ie())) : Ge(bt(n, 1), Pt(ie()));
        var o = n.length;
        return me(function(c) {
          for (var d = -1, p = kt(c.length, o); ++d < p; )
            c[d] = n[d].call(this, c[d]);
          return Vt(e, this, c);
        });
      }), ca = me(function(e, n) {
        var o = Bn(n, br(ca));
        return $n(e, ue, r, n, o);
      }), jl = me(function(e, n) {
        var o = Bn(n, br(jl));
        return $n(e, Ie, r, n, o);
      }), Ev = _n(function(e, n) {
        return $n(e, Ze, r, r, r, n);
      });
      function Bv(e, n) {
        if (typeof e != "function")
          throw new Yt(s);
        return n = n === r ? n : pe(n), me(e, n);
      }
      function xv(e, n) {
        if (typeof e != "function")
          throw new Yt(s);
        return n = n == null ? 0 : dt(pe(n), 0), me(function(o) {
          var c = o[n], d = Rn(o, 0, n);
          return c && En(d, c), Vt(e, this, d);
        });
      }
      function Vv(e, n, o) {
        var c = !0, d = !0;
        if (typeof e != "function")
          throw new Yt(s);
        return Qe(o) && (c = "leading" in o ? !!o.leading : c, d = "trailing" in o ? !!o.trailing : d), Jl(e, n, {
          leading: c,
          maxWait: n,
          trailing: d
        });
      }
      function Pv(e) {
        return Gl(e, 1);
      }
      function Lv(e, n) {
        return ca(Ko(n), e);
      }
      function Rv() {
        if (!arguments.length)
          return [];
        var e = arguments[0];
        return ce(e) ? e : [e];
      }
      function Fv(e) {
        return Kt(e, O);
      }
      function Wv(e, n) {
        return n = typeof n == "function" ? n : r, Kt(e, O, n);
      }
      function Hv(e) {
        return Kt(e, S | O);
      }
      function Uv(e, n) {
        return n = typeof n == "function" ? n : r, Kt(e, S | O, n);
      }
      function Nv(e, n) {
        return n == null || Ws(e, n, mt(n));
      }
      function nn(e, n) {
        return e === n || e !== e && n !== n;
      }
      var zv = Ai(Po), qv = Ai(function(e, n) {
        return e >= n;
      }), nr = Ys(/* @__PURE__ */ function() {
        return arguments;
      }()) ? Ys : function(e) {
        return je(e) && Fe.call(e, "callee") && !Es.call(e, "callee");
      }, ce = A.isArray, Yv = hs ? Pt(hs) : eh;
      function It(e) {
        return e != null && Ri(e.length) && !Sn(e);
      }
      function rt(e) {
        return je(e) && It(e);
      }
      function Gv(e) {
        return e === !0 || e === !1 || je(e) && St(e) == Ce;
      }
      var Fn = sf || ka, Kv = ps ? Pt(ps) : th;
      function Qv(e) {
        return je(e) && e.nodeType === 1 && !qr(e);
      }
      function Xv(e) {
        if (e == null)
          return !0;
        if (It(e) && (ce(e) || typeof e == "string" || typeof e.splice == "function" || Fn(e) || kr(e) || nr(e)))
          return !e.length;
        var n = Ct(e);
        if (n == L || n == jt)
          return !e.size;
        if (Nr(e))
          return !Fo(e).length;
        for (var o in e)
          if (Fe.call(e, o))
            return !1;
        return !0;
      }
      function Zv(e, n) {
        return Wr(e, n);
      }
      function Jv(e, n, o) {
        o = typeof o == "function" ? o : r;
        var c = o ? o(e, n) : r;
        return c === r ? Wr(e, n, r, o) : !!c;
      }
      function da(e) {
        if (!je(e))
          return !1;
        var n = St(e);
        return n == Nt || n == vt || typeof e.message == "string" && typeof e.name == "string" && !qr(e);
      }
      function jv(e) {
        return typeof e == "number" && xs(e);
      }
      function Sn(e) {
        if (!Qe(e))
          return !1;
        var n = St(e);
        return n == yn || n == V || n == un || n == Ua;
      }
      function eu(e) {
        return typeof e == "number" && e == pe(e);
      }
      function Ri(e) {
        return typeof e == "number" && e > -1 && e % 1 == 0 && e <= yt;
      }
      function Qe(e) {
        var n = typeof e;
        return e != null && (n == "object" || n == "function");
      }
      function je(e) {
        return e != null && typeof e == "object";
      }
      var tu = vs ? Pt(vs) : rh;
      function em(e, n) {
        return e === n || Ro(e, n, ta(n));
      }
      function tm(e, n, o) {
        return o = typeof o == "function" ? o : r, Ro(e, n, ta(n), o);
      }
      function nm(e) {
        return nu(e) && e != +e;
      }
      function rm(e) {
        if (Wh(e))
          throw new se(u);
        return Gs(e);
      }
      function im(e) {
        return e === null;
      }
      function om(e) {
        return e == null;
      }
      function nu(e) {
        return typeof e == "number" || je(e) && St(e) == G;
      }
      function qr(e) {
        if (!je(e) || St(e) != nt)
          return !1;
        var n = di(e);
        if (n === null)
          return !0;
        var o = Fe.call(n, "constructor") && n.constructor;
        return typeof o == "function" && o instanceof o && si.call(o) == ef;
      }
      var fa = ms ? Pt(ms) : ih;
      function am(e) {
        return eu(e) && e >= -yt && e <= yt;
      }
      var ru = gs ? Pt(gs) : oh;
      function Fi(e) {
        return typeof e == "string" || !ce(e) && je(e) && St(e) == Mr;
      }
      function Rt(e) {
        return typeof e == "symbol" || je(e) && St(e) == Jr;
      }
      var kr = ys ? Pt(ys) : ah;
      function sm(e) {
        return e === r;
      }
      function lm(e) {
        return je(e) && Ct(e) == Ar;
      }
      function um(e) {
        return je(e) && St(e) == _c;
      }
      var cm = Ai(Wo), dm = Ai(function(e, n) {
        return e <= n;
      });
      function iu(e) {
        if (!e)
          return [];
        if (It(e))
          return Fi(e) ? en(e) : Dt(e);
        if (Er && e[Er])
          return Ud(e[Er]());
        var n = Ct(e), o = n == L ? Oo : n == jt ? ii : Cr;
        return o(e);
      }
      function On(e) {
        if (!e)
          return e === 0 ? e : 0;
        if (e = Zt(e), e === ke || e === -ke) {
          var n = e < 0 ? -1 : 1;
          return n * Ht;
        }
        return e === e ? e : 0;
      }
      function pe(e) {
        var n = On(e), o = n % 1;
        return n === n ? o ? n - o : n : 0;
      }
      function ou(e) {
        return e ? Jn(pe(e), 0, ut) : 0;
      }
      function Zt(e) {
        if (typeof e == "number")
          return e;
        if (Rt(e))
          return xt;
        if (Qe(e)) {
          var n = typeof e.valueOf == "function" ? e.valueOf() : e;
          e = Qe(n) ? n + "" : n;
        }
        if (typeof e != "string")
          return e === 0 ? e : +e;
        e = _s(e);
        var o = qc.test(e);
        return o || Gc.test(e) ? Td(e.slice(2), o ? 2 : 8) : zc.test(e) ? xt : +e;
      }
      function au(e) {
        return dn(e, Et(e));
      }
      function fm(e) {
        return e ? Jn(pe(e), -yt, yt) : e === 0 ? e : 0;
      }
      function Re(e) {
        return e == null ? "" : Lt(e);
      }
      var hm = yr(function(e, n) {
        if (Nr(n) || It(n)) {
          dn(n, mt(n), e);
          return;
        }
        for (var o in n)
          Fe.call(n, o) && Lr(e, o, n[o]);
      }), su = yr(function(e, n) {
        dn(n, Et(n), e);
      }), Wi = yr(function(e, n, o, c) {
        dn(n, Et(n), e, c);
      }), pm = yr(function(e, n, o, c) {
        dn(n, mt(n), e, c);
      }), vm = _n(Bo);
      function mm(e, n) {
        var o = gr(e);
        return n == null ? o : Fs(o, n);
      }
      var gm = me(function(e, n) {
        e = Ue(e);
        var o = -1, c = n.length, d = c > 2 ? n[2] : r;
        for (d && Ot(n[0], n[1], d) && (c = 1); ++o < c; )
          for (var p = n[o], m = Et(p), w = -1, _ = m.length; ++w < _; ) {
            var B = m[w], x = e[B];
            (x === r || nn(x, pr[B]) && !Fe.call(e, B)) && (e[B] = p[B]);
          }
        return e;
      }), ym = me(function(e) {
        return e.push(r, _l), Vt(lu, r, e);
      });
      function wm(e, n) {
        return bs(e, ie(n, 3), cn);
      }
      function bm(e, n) {
        return bs(e, ie(n, 3), Vo);
      }
      function km(e, n) {
        return e == null ? e : xo(e, ie(n, 3), Et);
      }
      function Cm(e, n) {
        return e == null ? e : zs(e, ie(n, 3), Et);
      }
      function $m(e, n) {
        return e && cn(e, ie(n, 3));
      }
      function _m(e, n) {
        return e && Vo(e, ie(n, 3));
      }
      function Tm(e) {
        return e == null ? [] : ki(e, mt(e));
      }
      function Sm(e) {
        return e == null ? [] : ki(e, Et(e));
      }
      function ha(e, n, o) {
        var c = e == null ? r : jn(e, n);
        return c === r ? o : c;
      }
      function Om(e, n) {
        return e != null && Ol(e, n, Xf);
      }
      function pa(e, n) {
        return e != null && Ol(e, n, Zf);
      }
      var Mm = wl(function(e, n, o) {
        n != null && typeof n.toString != "function" && (n = li.call(n)), e[n] = o;
      }, ma(Bt)), Am = wl(function(e, n, o) {
        n != null && typeof n.toString != "function" && (n = li.call(n)), Fe.call(e, n) ? e[n].push(o) : e[n] = [o];
      }, ie), Dm = me(Fr);
      function mt(e) {
        return It(e) ? Ls(e) : Fo(e);
      }
      function Et(e) {
        return It(e) ? Ls(e, !0) : sh(e);
      }
      function Im(e, n) {
        var o = {};
        return n = ie(n, 3), cn(e, function(c, d, p) {
          Cn(o, n(c, d, p), c);
        }), o;
      }
      function Em(e, n) {
        var o = {};
        return n = ie(n, 3), cn(e, function(c, d, p) {
          Cn(o, d, n(c, d, p));
        }), o;
      }
      var Bm = yr(function(e, n, o) {
        Ci(e, n, o);
      }), lu = yr(function(e, n, o, c) {
        Ci(e, n, o, c);
      }), xm = _n(function(e, n) {
        var o = {};
        if (e == null)
          return o;
        var c = !1;
        n = Ge(n, function(p) {
          return p = Ln(p, e), c || (c = p.length > 1), p;
        }), dn(e, jo(e), o), c && (o = Kt(o, S | E | O, Mh));
        for (var d = n.length; d--; )
          qo(o, n[d]);
        return o;
      });
      function Vm(e, n) {
        return uu(e, Li(ie(n)));
      }
      var Pm = _n(function(e, n) {
        return e == null ? {} : uh(e, n);
      });
      function uu(e, n) {
        if (e == null)
          return {};
        var o = Ge(jo(e), function(c) {
          return [c];
        });
        return n = ie(n), el(e, o, function(c, d) {
          return n(c, d[0]);
        });
      }
      function Lm(e, n, o) {
        n = Ln(n, e);
        var c = -1, d = n.length;
        for (d || (d = 1, e = r); ++c < d; ) {
          var p = e == null ? r : e[fn(n[c])];
          p === r && (c = d, p = o), e = Sn(p) ? p.call(e) : p;
        }
        return e;
      }
      function Rm(e, n, o) {
        return e == null ? e : Hr(e, n, o);
      }
      function Fm(e, n, o, c) {
        return c = typeof c == "function" ? c : r, e == null ? e : Hr(e, n, o, c);
      }
      var cu = Cl(mt), du = Cl(Et);
      function Wm(e, n, o) {
        var c = ce(e), d = c || Fn(e) || kr(e);
        if (n = ie(n, 4), o == null) {
          var p = e && e.constructor;
          d ? o = c ? new p() : [] : Qe(e) ? o = Sn(p) ? gr(di(e)) : {} : o = {};
        }
        return (d ? qt : cn)(e, function(m, w, _) {
          return n(o, m, w, _);
        }), o;
      }
      function Hm(e, n) {
        return e == null ? !0 : qo(e, n);
      }
      function Um(e, n, o) {
        return e == null ? e : ol(e, n, Ko(o));
      }
      function Nm(e, n, o, c) {
        return c = typeof c == "function" ? c : r, e == null ? e : ol(e, n, Ko(o), c);
      }
      function Cr(e) {
        return e == null ? [] : So(e, mt(e));
      }
      function zm(e) {
        return e == null ? [] : So(e, Et(e));
      }
      function qm(e, n, o) {
        return o === r && (o = n, n = r), o !== r && (o = Zt(o), o = o === o ? o : 0), n !== r && (n = Zt(n), n = n === n ? n : 0), Jn(Zt(e), n, o);
      }
      function Ym(e, n, o) {
        return n = On(n), o === r ? (o = n, n = 0) : o = On(o), e = Zt(e), Jf(e, n, o);
      }
      function Gm(e, n, o) {
        if (o && typeof o != "boolean" && Ot(e, n, o) && (n = o = r), o === r && (typeof n == "boolean" ? (o = n, n = r) : typeof e == "boolean" && (o = e, e = r)), e === r && n === r ? (e = 0, n = 1) : (e = On(e), n === r ? (n = e, e = 0) : n = On(n)), e > n) {
          var c = e;
          e = n, n = c;
        }
        if (o || e % 1 || n % 1) {
          var d = Vs();
          return kt(e + d * (n - e + _d("1e-" + ((d + "").length - 1))), n);
        }
        return Uo(e, n);
      }
      var Km = wr(function(e, n, o) {
        return n = n.toLowerCase(), e + (o ? fu(n) : n);
      });
      function fu(e) {
        return va(Re(e).toLowerCase());
      }
      function hu(e) {
        return e = Re(e), e && e.replace(Qc, Ld).replace(pd, "");
      }
      function Qm(e, n, o) {
        e = Re(e), n = Lt(n);
        var c = e.length;
        o = o === r ? c : Jn(pe(o), 0, c);
        var d = o;
        return o -= n.length, o >= 0 && e.slice(o, d) == n;
      }
      function Xm(e) {
        return e = Re(e), e && Ac.test(e) ? e.replace(za, Rd) : e;
      }
      function Zm(e) {
        return e = Re(e), e && Vc.test(e) ? e.replace(uo, "\\$&") : e;
      }
      var Jm = wr(function(e, n, o) {
        return e + (o ? "-" : "") + n.toLowerCase();
      }), jm = wr(function(e, n, o) {
        return e + (o ? " " : "") + n.toLowerCase();
      }), eg = ml("toLowerCase");
      function tg(e, n, o) {
        e = Re(e), n = pe(n);
        var c = n ? fr(e) : 0;
        if (!n || c >= n)
          return e;
        var d = (n - c) / 2;
        return Mi(vi(d), o) + e + Mi(pi(d), o);
      }
      function ng(e, n, o) {
        e = Re(e), n = pe(n);
        var c = n ? fr(e) : 0;
        return n && c < n ? e + Mi(n - c, o) : e;
      }
      function rg(e, n, o) {
        e = Re(e), n = pe(n);
        var c = n ? fr(e) : 0;
        return n && c < n ? Mi(n - c, o) + e : e;
      }
      function ig(e, n, o) {
        return o || n == null ? n = 0 : n && (n = +n), df(Re(e).replace(co, ""), n || 0);
      }
      function og(e, n, o) {
        return (o ? Ot(e, n, o) : n === r) ? n = 1 : n = pe(n), No(Re(e), n);
      }
      function ag() {
        var e = arguments, n = Re(e[0]);
        return e.length < 3 ? n : n.replace(e[1], e[2]);
      }
      var sg = wr(function(e, n, o) {
        return e + (o ? "_" : "") + n.toLowerCase();
      });
      function lg(e, n, o) {
        return o && typeof o != "number" && Ot(e, n, o) && (n = o = r), o = o === r ? ut : o >>> 0, o ? (e = Re(e), e && (typeof n == "string" || n != null && !fa(n)) && (n = Lt(n), !n && dr(e)) ? Rn(en(e), 0, o) : e.split(n, o)) : [];
      }
      var ug = wr(function(e, n, o) {
        return e + (o ? " " : "") + va(n);
      });
      function cg(e, n, o) {
        return e = Re(e), o = o == null ? 0 : Jn(pe(o), 0, e.length), n = Lt(n), e.slice(o, o + n.length) == n;
      }
      function dg(e, n, o) {
        var c = f.templateSettings;
        o && Ot(e, n, o) && (n = r), e = Re(e), n = Wi({}, n, c, $l);
        var d = Wi({}, n.imports, c.imports, $l), p = mt(d), m = So(d, p), w, _, B = 0, x = n.interpolate || jr, P = "__p += '", N = Mo(
          (n.escape || jr).source + "|" + x.source + "|" + (x === qa ? Nc : jr).source + "|" + (n.evaluate || jr).source + "|$",
          "g"
        ), te = "//# sourceURL=" + (Fe.call(n, "sourceURL") ? (n.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++wd + "]") + `
`;
        e.replace(N, function(ae, we, Te, Ft, Mt, Wt) {
          return Te || (Te = Ft), P += e.slice(B, Wt).replace(Xc, Fd), we && (w = !0, P += `' +
__e(` + we + `) +
'`), Mt && (_ = !0, P += `';
` + Mt + `;
__p += '`), Te && (P += `' +
((__t = (` + Te + `)) == null ? '' : __t) +
'`), B = Wt + ae.length, ae;
        }), P += `';
`;
        var oe = Fe.call(n, "variable") && n.variable;
        if (!oe)
          P = `with (obj) {
` + P + `
}
`;
        else if (Hc.test(oe))
          throw new se(h);
        P = (_ ? P.replace(Tc, "") : P).replace(Sc, "$1").replace(Oc, "$1;"), P = "function(" + (oe || "obj") + `) {
` + (oe ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (w ? ", __e = _.escape" : "") + (_ ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + P + `return __p
}`;
        var ve = vu(function() {
          return Ve(p, te + "return " + P).apply(r, m);
        });
        if (ve.source = P, da(ve))
          throw ve;
        return ve;
      }
      function fg(e) {
        return Re(e).toLowerCase();
      }
      function hg(e) {
        return Re(e).toUpperCase();
      }
      function pg(e, n, o) {
        if (e = Re(e), e && (o || n === r))
          return _s(e);
        if (!e || !(n = Lt(n)))
          return e;
        var c = en(e), d = en(n), p = Ts(c, d), m = Ss(c, d) + 1;
        return Rn(c, p, m).join("");
      }
      function vg(e, n, o) {
        if (e = Re(e), e && (o || n === r))
          return e.slice(0, Ms(e) + 1);
        if (!e || !(n = Lt(n)))
          return e;
        var c = en(e), d = Ss(c, en(n)) + 1;
        return Rn(c, 0, d).join("");
      }
      function mg(e, n, o) {
        if (e = Re(e), e && (o || n === r))
          return e.replace(co, "");
        if (!e || !(n = Lt(n)))
          return e;
        var c = en(e), d = Ts(c, en(n));
        return Rn(c, d).join("");
      }
      function gg(e, n) {
        var o = re, c = xe;
        if (Qe(n)) {
          var d = "separator" in n ? n.separator : d;
          o = "length" in n ? pe(n.length) : o, c = "omission" in n ? Lt(n.omission) : c;
        }
        e = Re(e);
        var p = e.length;
        if (dr(e)) {
          var m = en(e);
          p = m.length;
        }
        if (o >= p)
          return e;
        var w = o - fr(c);
        if (w < 1)
          return c;
        var _ = m ? Rn(m, 0, w).join("") : e.slice(0, w);
        if (d === r)
          return _ + c;
        if (m && (w += _.length - w), fa(d)) {
          if (e.slice(w).search(d)) {
            var B, x = _;
            for (d.global || (d = Mo(d.source, Re(Ya.exec(d)) + "g")), d.lastIndex = 0; B = d.exec(x); )
              var P = B.index;
            _ = _.slice(0, P === r ? w : P);
          }
        } else if (e.indexOf(Lt(d), w) != w) {
          var N = _.lastIndexOf(d);
          N > -1 && (_ = _.slice(0, N));
        }
        return _ + c;
      }
      function yg(e) {
        return e = Re(e), e && Mc.test(e) ? e.replace(Na, Yd) : e;
      }
      var wg = wr(function(e, n, o) {
        return e + (o ? " " : "") + n.toUpperCase();
      }), va = ml("toUpperCase");
      function pu(e, n, o) {
        return e = Re(e), n = o ? r : n, n === r ? Hd(e) ? Qd(e) : Ed(e) : e.match(n) || [];
      }
      var vu = me(function(e, n) {
        try {
          return Vt(e, r, n);
        } catch (o) {
          return da(o) ? o : new se(o);
        }
      }), bg = _n(function(e, n) {
        return qt(n, function(o) {
          o = fn(o), Cn(e, o, ua(e[o], e));
        }), e;
      });
      function kg(e) {
        var n = e == null ? 0 : e.length, o = ie();
        return e = n ? Ge(e, function(c) {
          if (typeof c[1] != "function")
            throw new Yt(s);
          return [o(c[0]), c[1]];
        }) : [], me(function(c) {
          for (var d = -1; ++d < n; ) {
            var p = e[d];
            if (Vt(p[0], this, c))
              return Vt(p[1], this, c);
          }
        });
      }
      function Cg(e) {
        return Gf(Kt(e, S));
      }
      function ma(e) {
        return function() {
          return e;
        };
      }
      function $g(e, n) {
        return e == null || e !== e ? n : e;
      }
      var _g = yl(), Tg = yl(!0);
      function Bt(e) {
        return e;
      }
      function ga(e) {
        return Ks(typeof e == "function" ? e : Kt(e, S));
      }
      function Sg(e) {
        return Xs(Kt(e, S));
      }
      function Og(e, n) {
        return Zs(e, Kt(n, S));
      }
      var Mg = me(function(e, n) {
        return function(o) {
          return Fr(o, e, n);
        };
      }), Ag = me(function(e, n) {
        return function(o) {
          return Fr(e, o, n);
        };
      });
      function ya(e, n, o) {
        var c = mt(n), d = ki(n, c);
        o == null && !(Qe(n) && (d.length || !c.length)) && (o = n, n = e, e = this, d = ki(n, mt(n)));
        var p = !(Qe(o) && "chain" in o) || !!o.chain, m = Sn(e);
        return qt(d, function(w) {
          var _ = n[w];
          e[w] = _, m && (e.prototype[w] = function() {
            var B = this.__chain__;
            if (p || B) {
              var x = e(this.__wrapped__), P = x.__actions__ = Dt(this.__actions__);
              return P.push({ func: _, args: arguments, thisArg: e }), x.__chain__ = B, x;
            }
            return _.apply(e, En([this.value()], arguments));
          });
        }), e;
      }
      function Dg() {
        return wt._ === this && (wt._ = tf), this;
      }
      function wa() {
      }
      function Ig(e) {
        return e = pe(e), me(function(n) {
          return Js(n, e);
        });
      }
      var Eg = Xo(Ge), Bg = Xo(ws), xg = Xo(ko);
      function mu(e) {
        return ra(e) ? Co(fn(e)) : ch(e);
      }
      function Vg(e) {
        return function(n) {
          return e == null ? r : jn(e, n);
        };
      }
      var Pg = bl(), Lg = bl(!0);
      function ba() {
        return [];
      }
      function ka() {
        return !1;
      }
      function Rg() {
        return {};
      }
      function Fg() {
        return "";
      }
      function Wg() {
        return !0;
      }
      function Hg(e, n) {
        if (e = pe(e), e < 1 || e > yt)
          return [];
        var o = ut, c = kt(e, ut);
        n = ie(n), e -= ut;
        for (var d = To(c, n); ++o < e; )
          n(o);
        return d;
      }
      function Ug(e) {
        return ce(e) ? Ge(e, fn) : Rt(e) ? [e] : Dt(Pl(Re(e)));
      }
      function Ng(e) {
        var n = ++jd;
        return Re(e) + n;
      }
      var zg = Oi(function(e, n) {
        return e + n;
      }, 0), qg = Zo("ceil"), Yg = Oi(function(e, n) {
        return e / n;
      }, 1), Gg = Zo("floor");
      function Kg(e) {
        return e && e.length ? bi(e, Bt, Po) : r;
      }
      function Qg(e, n) {
        return e && e.length ? bi(e, ie(n, 2), Po) : r;
      }
      function Xg(e) {
        return Cs(e, Bt);
      }
      function Zg(e, n) {
        return Cs(e, ie(n, 2));
      }
      function Jg(e) {
        return e && e.length ? bi(e, Bt, Wo) : r;
      }
      function jg(e, n) {
        return e && e.length ? bi(e, ie(n, 2), Wo) : r;
      }
      var e0 = Oi(function(e, n) {
        return e * n;
      }, 1), t0 = Zo("round"), n0 = Oi(function(e, n) {
        return e - n;
      }, 0);
      function r0(e) {
        return e && e.length ? _o(e, Bt) : 0;
      }
      function i0(e, n) {
        return e && e.length ? _o(e, ie(n, 2)) : 0;
      }
      return f.after = Sv, f.ary = Gl, f.assign = hm, f.assignIn = su, f.assignInWith = Wi, f.assignWith = pm, f.at = vm, f.before = Kl, f.bind = ua, f.bindAll = bg, f.bindKey = Ql, f.castArray = Rv, f.chain = zl, f.chunk = Gh, f.compact = Kh, f.concat = Qh, f.cond = kg, f.conforms = Cg, f.constant = ma, f.countBy = rv, f.create = mm, f.curry = Xl, f.curryRight = Zl, f.debounce = Jl, f.defaults = gm, f.defaultsDeep = ym, f.defer = Ov, f.delay = Mv, f.difference = Xh, f.differenceBy = Zh, f.differenceWith = Jh, f.drop = jh, f.dropRight = ep, f.dropRightWhile = tp, f.dropWhile = np, f.fill = rp, f.filter = ov, f.flatMap = lv, f.flatMapDeep = uv, f.flatMapDepth = cv, f.flatten = Wl, f.flattenDeep = ip, f.flattenDepth = op, f.flip = Av, f.flow = _g, f.flowRight = Tg, f.fromPairs = ap, f.functions = Tm, f.functionsIn = Sm, f.groupBy = dv, f.initial = lp, f.intersection = up, f.intersectionBy = cp, f.intersectionWith = dp, f.invert = Mm, f.invertBy = Am, f.invokeMap = hv, f.iteratee = ga, f.keyBy = pv, f.keys = mt, f.keysIn = Et, f.map = xi, f.mapKeys = Im, f.mapValues = Em, f.matches = Sg, f.matchesProperty = Og, f.memoize = Pi, f.merge = Bm, f.mergeWith = lu, f.method = Mg, f.methodOf = Ag, f.mixin = ya, f.negate = Li, f.nthArg = Ig, f.omit = xm, f.omitBy = Vm, f.once = Dv, f.orderBy = vv, f.over = Eg, f.overArgs = Iv, f.overEvery = Bg, f.overSome = xg, f.partial = ca, f.partialRight = jl, f.partition = mv, f.pick = Pm, f.pickBy = uu, f.property = mu, f.propertyOf = Vg, f.pull = vp, f.pullAll = Ul, f.pullAllBy = mp, f.pullAllWith = gp, f.pullAt = yp, f.range = Pg, f.rangeRight = Lg, f.rearg = Ev, f.reject = wv, f.remove = wp, f.rest = Bv, f.reverse = sa, f.sampleSize = kv, f.set = Rm, f.setWith = Fm, f.shuffle = Cv, f.slice = bp, f.sortBy = Tv, f.sortedUniq = Op, f.sortedUniqBy = Mp, f.split = lg, f.spread = xv, f.tail = Ap, f.take = Dp, f.takeRight = Ip, f.takeRightWhile = Ep, f.takeWhile = Bp, f.tap = Kp, f.throttle = Vv, f.thru = Bi, f.toArray = iu, f.toPairs = cu, f.toPairsIn = du, f.toPath = Ug, f.toPlainObject = au, f.transform = Wm, f.unary = Pv, f.union = xp, f.unionBy = Vp, f.unionWith = Pp, f.uniq = Lp, f.uniqBy = Rp, f.uniqWith = Fp, f.unset = Hm, f.unzip = la, f.unzipWith = Nl, f.update = Um, f.updateWith = Nm, f.values = Cr, f.valuesIn = zm, f.without = Wp, f.words = pu, f.wrap = Lv, f.xor = Hp, f.xorBy = Up, f.xorWith = Np, f.zip = zp, f.zipObject = qp, f.zipObjectDeep = Yp, f.zipWith = Gp, f.entries = cu, f.entriesIn = du, f.extend = su, f.extendWith = Wi, ya(f, f), f.add = zg, f.attempt = vu, f.camelCase = Km, f.capitalize = fu, f.ceil = qg, f.clamp = qm, f.clone = Fv, f.cloneDeep = Hv, f.cloneDeepWith = Uv, f.cloneWith = Wv, f.conformsTo = Nv, f.deburr = hu, f.defaultTo = $g, f.divide = Yg, f.endsWith = Qm, f.eq = nn, f.escape = Xm, f.escapeRegExp = Zm, f.every = iv, f.find = av, f.findIndex = Rl, f.findKey = wm, f.findLast = sv, f.findLastIndex = Fl, f.findLastKey = bm, f.floor = Gg, f.forEach = ql, f.forEachRight = Yl, f.forIn = km, f.forInRight = Cm, f.forOwn = $m, f.forOwnRight = _m, f.get = ha, f.gt = zv, f.gte = qv, f.has = Om, f.hasIn = pa, f.head = Hl, f.identity = Bt, f.includes = fv, f.indexOf = sp, f.inRange = Ym, f.invoke = Dm, f.isArguments = nr, f.isArray = ce, f.isArrayBuffer = Yv, f.isArrayLike = It, f.isArrayLikeObject = rt, f.isBoolean = Gv, f.isBuffer = Fn, f.isDate = Kv, f.isElement = Qv, f.isEmpty = Xv, f.isEqual = Zv, f.isEqualWith = Jv, f.isError = da, f.isFinite = jv, f.isFunction = Sn, f.isInteger = eu, f.isLength = Ri, f.isMap = tu, f.isMatch = em, f.isMatchWith = tm, f.isNaN = nm, f.isNative = rm, f.isNil = om, f.isNull = im, f.isNumber = nu, f.isObject = Qe, f.isObjectLike = je, f.isPlainObject = qr, f.isRegExp = fa, f.isSafeInteger = am, f.isSet = ru, f.isString = Fi, f.isSymbol = Rt, f.isTypedArray = kr, f.isUndefined = sm, f.isWeakMap = lm, f.isWeakSet = um, f.join = fp, f.kebabCase = Jm, f.last = Xt, f.lastIndexOf = hp, f.lowerCase = jm, f.lowerFirst = eg, f.lt = cm, f.lte = dm, f.max = Kg, f.maxBy = Qg, f.mean = Xg, f.meanBy = Zg, f.min = Jg, f.minBy = jg, f.stubArray = ba, f.stubFalse = ka, f.stubObject = Rg, f.stubString = Fg, f.stubTrue = Wg, f.multiply = e0, f.nth = pp, f.noConflict = Dg, f.noop = wa, f.now = Vi, f.pad = tg, f.padEnd = ng, f.padStart = rg, f.parseInt = ig, f.random = Gm, f.reduce = gv, f.reduceRight = yv, f.repeat = og, f.replace = ag, f.result = Lm, f.round = t0, f.runInContext = $, f.sample = bv, f.size = $v, f.snakeCase = sg, f.some = _v, f.sortedIndex = kp, f.sortedIndexBy = Cp, f.sortedIndexOf = $p, f.sortedLastIndex = _p, f.sortedLastIndexBy = Tp, f.sortedLastIndexOf = Sp, f.startCase = ug, f.startsWith = cg, f.subtract = n0, f.sum = r0, f.sumBy = i0, f.template = dg, f.times = Hg, f.toFinite = On, f.toInteger = pe, f.toLength = ou, f.toLower = fg, f.toNumber = Zt, f.toSafeInteger = fm, f.toString = Re, f.toUpper = hg, f.trim = pg, f.trimEnd = vg, f.trimStart = mg, f.truncate = gg, f.unescape = yg, f.uniqueId = Ng, f.upperCase = wg, f.upperFirst = va, f.each = ql, f.eachRight = Yl, f.first = Hl, ya(f, function() {
        var e = {};
        return cn(f, function(n, o) {
          Fe.call(f.prototype, o) || (e[o] = n);
        }), e;
      }(), { chain: !1 }), f.VERSION = l, qt(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(e) {
        f[e].placeholder = f;
      }), qt(["drop", "take"], function(e, n) {
        $e.prototype[e] = function(o) {
          o = o === r ? 1 : dt(pe(o), 0);
          var c = this.__filtered__ && !n ? new $e(this) : this.clone();
          return c.__filtered__ ? c.__takeCount__ = kt(o, c.__takeCount__) : c.__views__.push({
            size: kt(o, ut),
            type: e + (c.__dir__ < 0 ? "Right" : "")
          }), c;
        }, $e.prototype[e + "Right"] = function(o) {
          return this.reverse()[e](o).reverse();
        };
      }), qt(["filter", "map", "takeWhile"], function(e, n) {
        var o = n + 1, c = o == Tt || o == Je;
        $e.prototype[e] = function(d) {
          var p = this.clone();
          return p.__iteratees__.push({
            iteratee: ie(d, 3),
            type: o
          }), p.__filtered__ = p.__filtered__ || c, p;
        };
      }), qt(["head", "last"], function(e, n) {
        var o = "take" + (n ? "Right" : "");
        $e.prototype[e] = function() {
          return this[o](1).value()[0];
        };
      }), qt(["initial", "tail"], function(e, n) {
        var o = "drop" + (n ? "" : "Right");
        $e.prototype[e] = function() {
          return this.__filtered__ ? new $e(this) : this[o](1);
        };
      }), $e.prototype.compact = function() {
        return this.filter(Bt);
      }, $e.prototype.find = function(e) {
        return this.filter(e).head();
      }, $e.prototype.findLast = function(e) {
        return this.reverse().find(e);
      }, $e.prototype.invokeMap = me(function(e, n) {
        return typeof e == "function" ? new $e(this) : this.map(function(o) {
          return Fr(o, e, n);
        });
      }), $e.prototype.reject = function(e) {
        return this.filter(Li(ie(e)));
      }, $e.prototype.slice = function(e, n) {
        e = pe(e);
        var o = this;
        return o.__filtered__ && (e > 0 || n < 0) ? new $e(o) : (e < 0 ? o = o.takeRight(-e) : e && (o = o.drop(e)), n !== r && (n = pe(n), o = n < 0 ? o.dropRight(-n) : o.take(n - e)), o);
      }, $e.prototype.takeRightWhile = function(e) {
        return this.reverse().takeWhile(e).reverse();
      }, $e.prototype.toArray = function() {
        return this.take(ut);
      }, cn($e.prototype, function(e, n) {
        var o = /^(?:filter|find|map|reject)|While$/.test(n), c = /^(?:head|last)$/.test(n), d = f[c ? "take" + (n == "last" ? "Right" : "") : n], p = c || /^find/.test(n);
        d && (f.prototype[n] = function() {
          var m = this.__wrapped__, w = c ? [1] : arguments, _ = m instanceof $e, B = w[0], x = _ || ce(m), P = function(we) {
            var Te = d.apply(f, En([we], w));
            return c && N ? Te[0] : Te;
          };
          x && o && typeof B == "function" && B.length != 1 && (_ = x = !1);
          var N = this.__chain__, te = !!this.__actions__.length, oe = p && !N, ve = _ && !te;
          if (!p && x) {
            m = ve ? m : new $e(this);
            var ae = e.apply(m, w);
            return ae.__actions__.push({ func: Bi, args: [P], thisArg: r }), new Gt(ae, N);
          }
          return oe && ve ? e.apply(this, w) : (ae = this.thru(P), oe ? c ? ae.value()[0] : ae.value() : ae);
        });
      }), qt(["pop", "push", "shift", "sort", "splice", "unshift"], function(e) {
        var n = oi[e], o = /^(?:push|sort|unshift)$/.test(e) ? "tap" : "thru", c = /^(?:pop|shift)$/.test(e);
        f.prototype[e] = function() {
          var d = arguments;
          if (c && !this.__chain__) {
            var p = this.value();
            return n.apply(ce(p) ? p : [], d);
          }
          return this[o](function(m) {
            return n.apply(ce(m) ? m : [], d);
          });
        };
      }), cn($e.prototype, function(e, n) {
        var o = f[n];
        if (o) {
          var c = o.name + "";
          Fe.call(mr, c) || (mr[c] = []), mr[c].push({ name: n, func: o });
        }
      }), mr[Si(r, R).name] = [{
        name: "wrapper",
        func: r
      }], $e.prototype.clone = yf, $e.prototype.reverse = wf, $e.prototype.value = bf, f.prototype.at = Qp, f.prototype.chain = Xp, f.prototype.commit = Zp, f.prototype.next = Jp, f.prototype.plant = ev, f.prototype.reverse = tv, f.prototype.toJSON = f.prototype.valueOf = f.prototype.value = nv, f.prototype.first = f.prototype.head, Er && (f.prototype[Er] = jp), f;
    }, hr = Xd();
    Kn ? ((Kn.exports = hr)._ = hr, go._ = hr) : wt._ = hr;
  }).call(Kr);
})(Ki, Ki.exports);
var Qi = Ki.exports;
const P1 = X({
  name: "Multiselect",
  components: {
    BsIcon: He,
    Avatar: Zr,
    Spinner: Gn,
    SelectedOptionSingle: ac
  },
  emits: [
    "update:modelValue",
    "search",
    "blur"
  ],
  props: {
    /** used for v-model */
    modelValue: {
      type: [Array, Object, Number, String, null],
      required: !0
    },
    /** if the modelValue is a object, use this to determine the object key for v-for */
    objectKeyProp: {
      type: String,
      default: null
    },
    /** Selectable options */
    options: {
      type: Array,
      required: !0
    },
    /** If false, the avatars will be hidden */
    useAvatar: {
      type: Boolean,
      default: !0
    },
    /** Set this to true if you need to load options with ajax */
    useAjax: {
      type: Boolean,
      default: !1
    },
    /** Input placeholder text */
    placeholder: {
      type: String,
      default: "Kirjoita jotain hakeaksesi..."
    },
    /** Input ID (for focus) */
    id: {
      type: String,
      default: () => mn()
    },
    /** Hide caret (down arrow) */
    hideArrow: {
      type: Boolean,
      default: void 0
    },
    disallowRemove: {
      type: Boolean,
      default: !1
    },
    isInvalid: {
      type: Boolean,
      default: null
    }
  },
  data() {
    return {
      showMenu: !1,
      hoverOption: null,
      search: "",
      // selectedOptions: [] as ISelectOption<any>[]|ISelectOption<any>|null,
      selectedOptions: [],
      //selectedOption: null as string|number|null,
      singleSelectOptionObjCache: null,
      isLoading: !1,
      focusInterval: 0
    };
  },
  watch: {
    modelValue() {
      this.singleSelect ? this.singleSelectOptionObjCache = this.options.filter((t) => t.value == this.modelValue)[0] : this.selectedOptions = this.modelValue;
    },
    selectedOptions() {
      this.$emit("update:modelValue", this.selectedOptions);
    },
    // selectedOption() {
    // 	this.$emit('update:modelValue', this.selectedOption);
    // 	this.singleSelectOptionObjCache = this.options.filter(x => x.value == this.selectedOption)[0];
    // },
    search() {
      this.useAjax && this.search.length > 1 && (this.isLoading = !0, this.$emit("search", this.search));
    },
    options() {
      this.useAjax && (this.isLoading = !1), this.singleSelect && (this.singleSelectOptionObjCache = this.options.filter((t) => t.value == this.modelValue)[0]);
    },
    optionsFiltered() {
      this.hoverFirstOption();
    },
    showMenu() {
      this.showMenu ? this.hoverFirstOption() : (this.search = "", this.$emit("blur"));
    }
  },
  beforeMount() {
    if (this.singleSelect && this.modelValue != null) {
      const t = this.options.filter((i) => i.value == this.modelValue)[0];
      t && (this.singleSelectOptionObjCache = t);
    } else
      this.modelValue != null && (this.selectedOptions = this.modelValue);
    this.focusInterval = window.setInterval(() => {
      if (!this.showMenu)
        return;
      this.checkIfHasFocus() || (this.showMenu = !1);
    }, 32);
  },
  beforeUnmount() {
    window.clearInterval(this.focusInterval);
  },
  computed: {
    texts() {
      return Ra;
    },
    hideArrowInternal() {
      return typeof this.hideArrow > "u" ? !!this.useAjax : this.hideArrow;
    },
    singleModelValue() {
      if (Array.isArray(this.modelValue))
        throw "singleModelValue cannot be called if the modelValue is an array!";
      return this.modelValue;
    },
    singleSelect() {
      return !Array.isArray(this.modelValue);
    },
    optionsFiltered() {
      return this.options.filter((r) => !!(r.text || "").toLowerCase().includes(this.search.toLowerCase()));
    },
    optionsGrouped() {
      return Qi.groupBy(this.optionsFiltered, (i) => i.group);
    }
  },
  methods: {
    emitBlur() {
      this.useAjax && (this.showMenu || this.$emit("blur"));
    },
    checkIfHasFocus() {
      let t = document.activeElement;
      return !t || t && t.tagName.toLowerCase() == "body" || this.showMenu == !1 ? !1 : t.closest(".hako-multiselect") != null;
    },
    clickDropdownIcon() {
      this.showMenu = !this.showMenu, this.showMenu && this.$refs.searchInput.focus();
    },
    /** Triggered by mouse hovering over option */
    onHoverOption(t, i) {
      this.hoverOption = null, i && (this.hoverOption = t.value);
    },
    /** "hover" over the first option */
    hoverFirstOption() {
      this.optionsFiltered.length > 0 && (this.hoverOption = this.optionsFiltered[0].value);
    },
    /** Change "hover" to next or previous option */
    hoverNextOrPrevOption(t) {
      if (!this.showMenu) {
        this.showMenu = !0;
        return;
      }
      if (!this.hoverOption) {
        this.hoverOption = this.optionsFiltered[0].value;
        return;
      }
      if (!this.hoverOption)
        return;
      const i = this.optionsFiltered.map((l) => l.value).indexOf(this.hoverOption), r = this.optionsFiltered[i + t];
      r && (this.hoverOption = r.value);
    },
    selectHoverOption() {
      let t = this.optionsFiltered.filter((i) => i.value == this.hoverOption)[0];
      t && this.selectOption(t);
    },
    selectOption(t, i = !0) {
      if (!t)
        return;
      let r = this.selectedOptions;
      if (Array.isArray(this.selectedOptions) && r.includes(t.value))
        this.selectedOptions = r.filter((l) => l != t.value), this.$emit("update:modelValue", this.selectedOptions);
      else if (this.singleSelect)
        this.$emit("update:modelValue", t.value);
      else {
        const l = this.selectedOptions;
        l.push(t.value), this.selectedOptions = l.splice(0), this.$emit("update:modelValue", this.selectedOptions);
      }
      i && (this.showMenu = !1);
    },
    removeSelectedOptions() {
      this.singleSelect ? this.$emit("update:modelValue", null) : this.$emit("update:modelValue", []);
    },
    getAvatarData(t) {
      return t.avatar ? t.avatar : t.text;
    },
    ariaOptionIsSelected(t) {
      const i = this.selectedOptions;
      return Array.isArray(i) ? i.includes(t) : t == i;
    },
    fakeOptionClasses(t) {
      let i = [];
      return this.hoverOption && this.hoverOption == t.value && i.push("hover"), this.singleSelect && i.push("ps-2"), i;
    },
    optionKey(t) {
      if (this.objectKeyProp != null) {
        let i = t.value[this.objectKeyProp];
        return typeof i > "u" && console.warn("MultiSelect: Given objectKeyProp returns undefined!"), i;
      }
      return t.value;
    }
  }
}), L1 = ["id", "placeholder"], R1 = {
  key: 0,
  class: "selected-option"
}, F1 = {
  key: 0,
  class: "fake-select-menu"
}, W1 = { key: 0 }, H1 = {
  key: 1,
  class: "p-3"
}, U1 = {
  key: 0,
  class: "fake-option heading d-flex align-items-center"
}, N1 = ["aria-label", "aria-selected"], z1 = ["onClick"], q1 = ["value"], Y1 = {
  key: 1,
  class: "avatar-container fixed-width"
}, G1 = ["onMouseenter", "onMouseleave", "onMousedown"];
function K1(t, i, r, l, a, u) {
  const s = ye("selected-option-single"), h = ye("bs-icon"), g = ye("spinner"), T = ye("avatar");
  return v(), b("div", {
    class: z(["hako-multiselect", { "menu-is-open": t.showMenu, "has-arrow": !t.hideArrow }]),
    ref: "root",
    role: "listbox",
    "aria-multiselectable": "true"
  }, [
    Ne(y("input", {
      type: "text",
      "onUpdate:modelValue": i[0] || (i[0] = (k) => t.search = k),
      class: z(["form-control", {
        "no-validation-icon": !t.useAjax,
        "is-valid": t.isInvalid === !1,
        "is-invalid": t.isInvalid === !0
      }]),
      id: t.id,
      ref: "searchInput",
      onFocus: i[1] || (i[1] = (k) => t.showMenu = !0),
      onInput: i[2] || (i[2] = (k) => t.showMenu = !0),
      onKeydown: [
        i[3] || (i[3] = on((k) => {
          t.selectHoverOption(), t.search = "";
        }, ["enter"])),
        i[4] || (i[4] = on((k) => t.hoverNextOrPrevOption(1), ["down"])),
        i[5] || (i[5] = on((k) => t.hoverNextOrPrevOption(-1), ["up"]))
      ],
      placeholder: t.placeholder,
      onBlur: i[6] || (i[6] = (...k) => t.emitBlur && t.emitBlur(...k))
    }, null, 42, L1), [
      [Nn, t.search]
    ]),
    t.singleSelect && t.singleSelectOptionObjCache ? (v(), b("div", R1, [
      H(s, {
        option: t.singleSelectOptionObjCache,
        "use-avatar": t.useAvatar,
        "avatar-size": 1.75,
        class: z(["ms-" + (t.useAvatar ? 0 : 2)]),
        "hide-caret": t.hideArrowInternal,
        "disallow-remove": t.disallowRemove,
        onRemove: t.removeSelectedOptions,
        onClick: ne(t.clickDropdownIcon, ["prevent"])
      }, null, 8, ["option", "use-avatar", "class", "hide-caret", "disallow-remove", "onRemove", "onClick"])
    ])) : W("", !0),
    Ne(y("div", {
      class: "dropdown-icon",
      onMousedown: i[7] || (i[7] = ne((...k) => t.clickDropdownIcon && t.clickDropdownIcon(...k), ["prevent"]))
    }, [
      H(h, { icon: "chevron-down" })
    ], 544), [
      [Dn, !t.hideArrowInternal]
    ]),
    H(ft, { name: "menu" }, {
      default: Z(() => [
        t.showMenu && !(t.useAjax && t.search.length < 2) ? (v(), b("div", F1, [
          t.isLoading ? (v(), b("div", W1, [
            H(g, {
              size: 2,
              style: { margin: "1rem" }
            })
          ])) : t.options.length == 0 ? (v(), b("div", H1, F(t.texts.noResults), 1)) : !t.isLoading && t.options.length > 0 ? (v(!0), b(he, { key: 2 }, Se(Object.keys(t.optionsGrouped), (k) => (v(), b(he, { key: k }, [
            k != "undefined" ? (v(), b("div", U1, [
              y("h3", null, F(k), 1)
            ])) : W("", !0),
            (v(!0), b(he, null, Se(t.optionsGrouped[k], (S) => (v(), b("div", {
              class: z(["fake-option d-flex align-items-center", t.fakeOptionClasses(S)]),
              tabindex: "-1",
              key: t.optionKey(S),
              role: "option",
              "aria-label": S.text,
              "aria-selected": t.ariaOptionIsSelected(S)
            }, [
              t.singleSelect ? W("", !0) : (v(), b("div", {
                key: 0,
                class: "checkbox fixed-width",
                onClick: ne((E) => t.selectOption(S, !1), ["stop", "self"])
              }, [
                Ne(y("input", {
                  type: "checkbox",
                  name: "selected-options",
                  value: S.value,
                  "onUpdate:modelValue": i[8] || (i[8] = (E) => t.selectedOptions = E)
                }, null, 8, q1), [
                  [Xi, t.selectedOptions]
                ])
              ], 8, z1)),
              t.useAvatar ? (v(), b("div", Y1, [
                H(T, {
                  "avatar-data": t.getAvatarData(S),
                  role: S.theme
                }, null, 8, ["avatar-data", "role"])
              ])) : W("", !0),
              y("label", {
                class: "text-container flex-fill",
                onMouseenter: (E) => t.onHoverOption(S, !0),
                onMouseleave: (E) => t.onHoverOption(S, !1),
                onMousedown: (E) => t.selectOption(S)
              }, F(S.text), 41, G1)
            ], 10, N1))), 128))
          ], 64))), 128)) : W("", !0)
        ])) : W("", !0)
      ]),
      _: 1
    }),
    t.showMenu ? (v(), b("div", {
      key: 1,
      class: "hako-multiselect-menu-closer",
      onClick: i[9] || (i[9] = ne((k) => {
        t.showMenu = !1;
      }, ["prevent"]))
    })) : W("", !0)
  ], 2);
}
const Q1 = /* @__PURE__ */ ge(P1, [["render", K1]]), X1 = X({
  emits: [
    "matches"
  ],
  props: {
    content: {
      type: String,
      required: !0
    },
    highlight: {
      type: String,
      required: !0
    }
  },
  computed: {
    contentTextHighlight() {
      const t = this.content.replace(/\n/g, " ").replace(/\t/g, " ").replace(/\s{2,}/g, " "), i = t.length, r = t.toLowerCase(), l = this.highlight.toLowerCase(), a = l.length;
      if (!r.includes(l) || a == 0)
        return t;
      const u = [], s = [], h = [];
      let g = -l.length;
      do
        g = r.indexOf(l, g + l.length), g >= 0 && (u.push(g), s.push(g + l.length));
      while (g >= 0);
      for (let k = 0; k < u.length; k++) {
        const S = u[k];
        let E = s[k - 1];
        E || (E = 0);
        let O = u[k + 1];
        O || (O = i);
        const C = t.substring(E, S), I = t.substring(S, S + a);
        if (h[k] = [], h[k][0] = C, h[k][1] = I, k + 1 == u.length) {
          const M = t.substring(S + a, O);
          h[k][2] = M;
        }
      }
      let T = [];
      return h.forEach((k) => {
        let S = `<span>${k[0]}</span><span class="highlight">${k[1]}</span>`;
        k[2] && (S += `<span>${k[2]}</span>`), T.push(S);
      }), this.$emit("matches", u.length), T.join("");
    }
  }
}), Z1 = ["innerHTML"];
function J1(t, i, r, l, a, u) {
  return v(), b("span", {
    class: "hakosalo-highlight",
    innerHTML: t.contentTextHighlight
  }, null, 8, Z1);
}
const Fa = /* @__PURE__ */ ge(X1, [["render", J1]]), j1 = X({
  props: {
    show: {
      type: Boolean,
      default: !0
    },
    duration: {
      type: Number,
      default: 350
    }
  },
  data() {
    return {
      timeouts: {
        hide: 0,
        show: 0
      },
      innerShow: this.show,
      isCollapsing: !1,
      useContainerHeight: !1,
      containerHeight: 0
    };
  },
  watch: {
    async show() {
      this.timeouts.hide && window.clearTimeout(this.timeouts.hide), this.timeouts.show && window.clearTimeout(this.timeouts.show), await $t(), this.show ? (this.isCollapsing = !0, await $t(), this.containerHeight = this.getContainerScrollHeight(), this.useContainerHeight = !0, this.timeouts.show = window.setTimeout(() => {
        this.useContainerHeight = !1, this.isCollapsing = !1, this.innerShow = !0;
      }, this.duration)) : (this.containerHeight = this.getContainerScrollHeight(), this.useContainerHeight = !0, await $t(), this.isCollapsing = !0, await $t(), window.setTimeout(() => {
        this.useContainerHeight = !1;
      }, 1), this.timeouts.hide = window.setTimeout(() => {
        this.isCollapsing = !1, this.innerShow = !1;
      }, this.duration));
    }
  },
  computed: {
    myClasses() {
      let t = [];
      return this.isCollapsing ? t.push("collapsing") : (t.push("collapse"), this.innerShow && t.push("show")), t;
    },
    myStyle() {
      let t = {};
      return this.isCollapsing && (t.transition = `height ${this.duration}ms ease`), this.useContainerHeight && (t.height = this.containerHeight + "px"), t;
    }
  },
  methods: {
    getContainerScrollHeight() {
      return this.$refs.container.scrollHeight;
    }
  }
});
function eb(t, i, r, l, a, u) {
  return v(), b("div", {
    class: z(["hakosalo-collapse", t.myClasses]),
    ref: "container",
    style: fe(t.myStyle)
  }, [
    J(t.$slots, "default")
  ], 6);
}
const ji = /* @__PURE__ */ ge(j1, [["render", eb]]), tb = X({
  name: "ItemRender",
  emits: [
    "update:selectedOptions",
    "uncollapse"
  ],
  components: {
    HighlightText: Fa,
    BsIcon: He,
    Collapse: ji
  },
  props: {
    selectedOptions: {
      type: Array,
      required: !0
    },
    option: {
      type: Object,
      required: !0
    },
    id: {
      type: String,
      default: () => Date.now().toString(36) + Math.random().toString(36).substr(2)
    },
    level: {
      type: Number,
      required: !0
    },
    search: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      collapseChildren: !1,
      highlightMatchCount: 0,
      searchTimeout: 0
    };
  },
  watch: {
    search() {
      window.clearTimeout(this.searchTimeout), !(this.search.length < 2) && (this.searchTimeout = window.setTimeout(() => {
        this.highlightMatchCount > 0 && (this.collapseChildren = !1, this.$emit("uncollapse"));
      }, 1e3));
    }
  },
  computed: {
    isOptionChecked() {
      return Array.isArray(this.selectedOptions) ? this.selectedOptions.some((t) => t.value == this.option.value) : !1;
    },
    hasChildren() {
      return Array.isArray(this.option.children) ? this.option.children.length > 0 : !1;
    },
    children() {
      return this.option.children || [];
    },
    optionClasses() {
      let t = [];
      return this.hasChildren && t.push("has-children"), t.push("level-" + this.level), t;
    }
  }
}), nb = { class: "d-flex justify-content-between" }, rb = { class: "form-check" }, ib = ["id", "value", "checked"], ob = ["for"], ab = {
  key: 0,
  class: "collapse-container"
};
function sb(t, i, r, l, a, u) {
  const s = ye("highlight-text"), h = ye("bs-icon"), g = ye("item-render"), T = ye("collapse");
  return v(), b(he, null, [
    y("div", {
      class: z(["hakosalo-multilevelselect-option-render", t.optionClasses])
    }, [
      y("div", nb, [
        y("div", null, [
          y("div", rb, [
            y("input", {
              class: "form-check-input",
              type: "checkbox",
              id: t.id,
              value: t.option,
              checked: t.isOptionChecked,
              onChange: i[0] || (i[0] = (k) => t.$emit("update:selectedOptions", t.option))
            }, null, 40, ib),
            y("label", {
              class: "form-check-label",
              for: t.id
            }, [
              H(s, {
                content: t.option.text,
                highlight: t.search,
                onMatches: i[1] || (i[1] = (k) => t.highlightMatchCount = k)
              }, null, 8, ["content", "highlight"])
            ], 8, ob)
          ])
        ]),
        t.hasChildren ? (v(), b("div", ab, [
          y("button", {
            type: "button",
            onClick: i[2] || (i[2] = (k) => t.collapseChildren = !t.collapseChildren)
          }, [
            H(h, {
              icon: t.collapseChildren ? "chevron-up" : "chevron-down"
            }, null, 8, ["icon"])
          ])
        ])) : W("", !0)
      ])
    ], 2),
    t.hasChildren ? (v(), le(T, {
      key: 0,
      show: !t.collapseChildren
    }, {
      default: Z(() => [
        (v(!0), b(he, null, Se(t.children, (k) => (v(), le(g, {
          key: k.value,
          "selected-options": t.selectedOptions,
          level: t.level + 1,
          option: k,
          search: t.search,
          "onUpdate:selectedOptions": (S) => {
            t.$emit("update:selectedOptions", S);
          },
          onUncollapse: i[3] || (i[3] = (S) => {
            t.collapseChildren = !1, t.$emit("uncollapse");
          })
        }, null, 8, ["selected-options", "level", "option", "search", "onUpdate:selectedOptions"]))), 128))
      ]),
      _: 1
    }, 8, ["show"])) : W("", !0)
  ], 64);
}
const lb = /* @__PURE__ */ ge(tb, [["render", sb]]), ub = X({
  name: "HakoInput",
  inheritAttrs: !1,
  props: {
    float: {
      type: Boolean,
      default: !1
    },
    modelValue: {
      type: [String, Number, null],
      required: !1
    },
    id: {
      type: String,
      default: () => (/* @__PURE__ */ new Date()).valueOf().toString() + "-" + Math.random().toString().split(".")[1]
    },
    type: {
      type: String,
      default: "text"
    },
    label: {
      type: String,
      default: ""
    },
    inputClasses: {
      type: Array,
      default: () => ["form-control"]
    },
    /**
    * true = invalid, false = valid, null = neutral
    */
    isInvalid: {
      type: Boolean,
      default: null
    },
    placeholder: {
      type: String,
      default: " "
    },
    suggestions: {
      type: Array,
      default: []
    },
    showSuggestionsWhenEmpty: {
      type: Boolean,
      default: !1
    },
    dontFilterSuggestions: {
      type: Boolean,
      default: !1
    },
    theme: {
      type: String,
      default: "primary"
    },
    sm: {
      type: Boolean,
      default: !1
    },
    lg: {
      type: Boolean,
      default: !1
    },
    /**
    * When debounce-event will be fired (in milliseconds)
    */
    debounceTime: {
      type: Number,
      default: 500
    }
  },
  emits: [
    "update:modelValue",
    "update:is-invalid",
    "debounce"
  ],
  data() {
    return {
      hasFocus: !1,
      refocusImmediately: !1,
      hoveringSuggestion: "",
      debounceTimeout: -1
    };
  },
  watch: {
    modelValue() {
      this.filteredSuggestions.indexOf(this.hoveringSuggestion) < 0 && (this.hoveringSuggestion = "");
    }
  },
  beforeMount() {
    (this.modelValue === void 0 || this.modelValue === null) && this.$emit("update:modelValue", "");
  },
  computed: {
    computedType() {
      return this.type;
    },
    computedInputClasses() {
      const t = [
        ...this.inputClasses
      ];
      return this.isInvalid === !1 ? t.push("is-valid") : this.isInvalid === !0 && t.push("is-invalid"), this.sm ? t.push("form-control-sm") : this.lg && t.push("form-control-lg"), t;
    },
    value: {
      get() {
        return this.modelValue;
      },
      set(t) {
        this.$emit("update:modelValue", t);
      }
    },
    filteredSuggestions() {
      const t = this.suggestions, i = (this.modelValue || "").toString().toLowerCase();
      return i.length == 0 && this.showSuggestionsWhenEmpty ? t : i.length == 0 ? [] : this.dontFilterSuggestions ? t : t.filter((l) => l.toLowerCase().includes(i)).filter((l) => l.toLowerCase() != i);
    }
  },
  methods: {
    selectSuggestion(t) {
      this.value = t, this.refocusImmediately = !0;
    },
    onBlur() {
      var i;
      this.hasFocus = !1;
      const t = ((i = this.modelValue) == null ? void 0 : i.toString()) || "";
      if (this.type == "tel" && t.length > 0) {
        if (t[0] != "+") {
          let r = "+358" + t.substring(1);
          this.$emit("update:modelValue", r);
        }
      } else if (this.type == "url" && t.length > 0 && !/https?:\/\//.test(t)) {
        let r = "https://" + t;
        this.$emit("update:modelValue", r);
      }
      this.refocusImmediately && (this.refocusImmediately = !1, this.$refs.input.focus()), this.$nextTick(() => {
        this.validate();
      });
    },
    validate() {
      var i;
      const t = ((i = this.modelValue) == null ? void 0 : i.toString()) || "";
      this.$emit("update:is-invalid", null), this.type == "tel" && !/^\+\d+$/.test(t) ? this.$emit("update:is-invalid", !0) : this.type == "url" && (/^https?:\/\/[^\/]+\..*\/*.*$/.test(t) || this.$emit("update:is-invalid", !0));
    },
    suggestionClasses(t) {
      const i = [];
      return this.hoveringSuggestion == t && (i.push("hovering"), i.push(`bg-${this.theme}`)), i;
    },
    onInput(t) {
      let i = t.data;
      this.debounceTime != -1 && window.clearTimeout(this.debounceTimeout), this.debounceTimeout = window.setTimeout(() => {
        this.$emit("debounce", i);
      }, this.debounceTime);
    },
    onInputKeyPress(t, i) {
      if (this.filteredSuggestions.length == 0)
        return;
      if (t.preventDefault(), i == "down" && this.hoveringSuggestion == "") {
        this.hoveringSuggestion = this.filteredSuggestions[0];
        return;
      }
      const r = this.filteredSuggestions.indexOf(this.hoveringSuggestion), l = this.filteredSuggestions[r + 1], a = this.filteredSuggestions[r - 1];
      if (i == "down" && typeof l < "u") {
        this.hoveringSuggestion = l;
        return;
      }
      if (i == "up") {
        typeof a > "u" ? this.hoveringSuggestion = "" : this.hoveringSuggestion = a;
        return;
      }
    },
    onInputEnter() {
      this.hoveringSuggestion != "" && this.selectSuggestion(this.hoveringSuggestion);
    }
  }
}), cb = { class: "hakosalo-input-input" }, db = ["type", "id", "aria-label", "placeholder"], fb = {
  key: 1,
  class: "form-floating"
}, hb = ["type", "id", "placeholder"], pb = ["for"], vb = {
  key: 0,
  class: "hakosalo-input-suggestions"
}, mb = ["onMousedown", "onMouseenter"];
function gb(t, i, r, l, a, u) {
  return v(), b("div", {
    class: z(["hakosalo-input", { "hakosalo-input-suggestions-on": t.filteredSuggestions.length > 0 }])
  }, [
    y("div", cb, [
      t.float ? (v(), b("div", fb, [
        Ne(y("input", ht({
          ref: "input",
          type: t.type
        }, t.$attrs, {
          class: t.inputClasses,
          id: t.id,
          "onUpdate:modelValue": i[7] || (i[7] = (s) => t.value = s),
          placeholder: t.placeholder,
          onFocus: i[8] || (i[8] = (s) => t.hasFocus = !0),
          onBlur: i[9] || (i[9] = (...s) => t.onBlur && t.onBlur(...s)),
          onKeydown: [
            i[10] || (i[10] = on((s) => t.onInputKeyPress(s, "down"), ["down"])),
            i[11] || (i[11] = on((s) => t.onInputKeyPress(s, "up"), ["up"])),
            i[12] || (i[12] = on((...s) => t.onInputEnter && t.onInputEnter(...s), ["enter"]))
          ],
          onInput: i[13] || (i[13] = (s) => t.onInput(s))
        }), null, 16, hb), [
          [yu, t.value]
        ]),
        y("label", { for: t.id }, F(t.label), 9, pb)
      ])) : Ne((v(), b("input", ht({
        key: 0,
        ref: "input",
        type: t.computedType,
        id: t.id
      }, t.$attrs, {
        class: t.computedInputClasses,
        "aria-label": t.label,
        placeholder: t.placeholder,
        "onUpdate:modelValue": i[0] || (i[0] = (s) => t.value = s),
        onFocus: i[1] || (i[1] = (s) => t.hasFocus = !0),
        onBlur: i[2] || (i[2] = (...s) => t.onBlur && t.onBlur(...s)),
        onKeydown: [
          i[3] || (i[3] = on((s) => t.onInputKeyPress(s, "down"), ["down"])),
          i[4] || (i[4] = on((s) => t.onInputKeyPress(s, "up"), ["up"])),
          i[5] || (i[5] = on((...s) => t.onInputEnter && t.onInputEnter(...s), ["enter"]))
        ],
        onInput: i[6] || (i[6] = (s) => t.onInput(s))
      }), null, 16, db)), [
        [yu, t.value]
      ])
    ]),
    t.filteredSuggestions.length > 0 && t.hasFocus ? (v(), b("div", vb, [
      (v(!0), b(he, null, Se(t.filteredSuggestions, (s) => (v(), b("div", {
        key: s,
        class: z(["hakosalo-input-suggestion", t.suggestionClasses(s)]),
        onMousedown: (h) => t.selectSuggestion(s),
        onMouseenter: (h) => t.hoveringSuggestion = s,
        onMouseleave: i[14] || (i[14] = (h) => t.hoveringSuggestion = "")
      }, F(s), 43, mb))), 128))
    ])) : W("", !0)
  ], 2);
}
const Sr = /* @__PURE__ */ ge(ub, [["render", gb]]), yb = X({
  components: {
    Button: At,
    Input: Sr,
    ItemRender: lb
  },
  emits: [
    "update:modelValue",
    "update:search",
    "onSave",
    "onCancel",
    "onSaveOrCancel"
  ],
  props: {
    /** used for v-model */
    modelValue: {
      type: Array,
      default: () => []
    },
    search: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ""
    },
    selectChildren: {
      type: Boolean,
      default: !0
    }
  },
  data() {
    return {
      currentSelectedOptions: []
    };
  },
  watch: {
    modelValue() {
      this.checkOptionValues();
    }
  },
  beforeMount() {
    this.checkOptionValues();
  },
  computed: {
    texts() {
      return Ra;
    },
    searchComputed: {
      get() {
        return this.search;
      },
      set(t) {
        this.$emit("update:search", t);
      }
    },
    optionsFiltered() {
      if (this.search.length < 2)
        return this.options;
      let t = [...this.options];
      return t = t.filter((i) => this.checkIfOptionHasText(i, this.search)), t;
    }
  },
  methods: {
    selectAll(t) {
      this.options.forEach((i) => {
        this.setOption(i, t ? "disable" : "enable", !0);
      });
    },
    setOption(t, i = "auto", r = !1) {
      const l = this.selectChildren || r;
      let a = "enable", u = this.currentSelectedOptions.map((s) => s.value).indexOf(t.value);
      u >= 0 && i != "enable" ? (this.currentSelectedOptions.splice(u, 1), a = "disable") : i != "disable" && u < 0 && this.currentSelectedOptions.push(t), l && t.children && t.children.forEach((s) => {
        this.setOption(s, a, l);
      });
    },
    checkOptionValues() {
      const t = [];
      this.options.forEach((i) => {
        this.makeOptionsArray(t, i);
      }), this.currentSelectedOptions = [], this.modelValue.forEach((i) => {
        let r = t.filter((l) => l.value == i)[0];
        r && this.currentSelectedOptions.push(r);
      });
    },
    // Recursive function that pushes option and it's children (and their children) to array 
    makeOptionsArray(t, i) {
      t.push(i), i.children && i.children.forEach((r) => {
        this.makeOptionsArray(t, r);
      });
    },
    onSaveBtnClick() {
      this.$emit("update:modelValue", [...this.currentSelectedOptions.map((t) => t.value)]), this.$emit("onSave"), this.$emit("onSaveOrCancel");
    },
    onCancelBtnClick() {
      this.currentSelectedOptions = this.options.filter((t) => this.modelValue.includes(t.value)), this.$emit("onCancel"), this.$emit("onSaveOrCancel");
    },
    checkIfOptionHasText(t, i) {
      let r = t.text.toLowerCase(), l = i.toLowerCase();
      if (r.includes(l))
        return !0;
      if (Array.isArray(t.children) && t.children.length > 0)
        for (let u = 0; u < t.children.length; u++) {
          const s = t.children[u];
          if (this.checkIfOptionHasText(s, i))
            return !0;
        }
      return !1;
    }
  }
}), wb = { class: "hakosalo-multilevelselect" }, bb = { class: "top-controls mt-1" }, kb = { class: "d-flex justify-content-between" }, Cb = { class: "buttons" }, $b = { class: "mt-3" }, _b = /* @__PURE__ */ y("hr", null, null, -1), Tb = { class: "options-container" }, Sb = { class: "bottom-controls mt-4 mb-1 text-end" }, Ob = { class: "buttons" };
function Mb(t, i, r, l, a, u) {
  const s = ye("Button"), h = ye("Input"), g = ye("item-render");
  return v(), b("div", wb, [
    y("div", bb, [
      y("div", kb, [
        y("h2", null, F(t.title), 1),
        y("div", Cb, [
          H(s, {
            theme: "success",
            class: "me-2",
            onClick: ne(t.onSaveBtnClick, ["prevent"])
          }, {
            default: Z(() => [
              Ke(F(t.texts.save), 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          H(s, {
            theme: "secondary",
            onClick: ne(t.onCancelBtnClick, ["prevent"])
          }, {
            default: Z(() => [
              Ke(F(t.texts.cancel), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      H(h, {
        class: "my-3",
        label: t.texts.search,
        modelValue: t.searchComputed,
        "onUpdate:modelValue": i[0] || (i[0] = (T) => t.searchComputed = T),
        id: "multilevelselect-search"
      }, null, 8, ["label", "modelValue"])
    ]),
    y("div", $b, [
      y("button", {
        type: "button",
        class: "btn btn-sm btn-primary",
        onClick: i[1] || (i[1] = ne((T) => t.selectAll(!1), ["prevent"]))
      }, F(t.texts.selectAll), 1),
      y("button", {
        type: "button",
        class: "btn btn-sm btn-secondary ms-2",
        onClick: i[2] || (i[2] = ne((T) => t.selectAll(!0), ["prevent"]))
      }, F(t.texts.unselectAll), 1)
    ]),
    _b,
    y("div", Tb, [
      (v(!0), b(he, null, Se(t.optionsFiltered, (T) => (v(), le(g, {
        key: T.value,
        level: 0,
        "selected-options": t.currentSelectedOptions,
        "onUpdate:selectedOptions": t.setOption,
        option: T,
        search: t.search
      }, null, 8, ["selected-options", "onUpdate:selectedOptions", "option", "search"]))), 128))
    ]),
    y("div", Sb, [
      y("div", Ob, [
        H(s, {
          theme: "success",
          class: "me-2",
          onClick: ne(t.onSaveBtnClick, ["prevent"])
        }, {
          default: Z(() => [
            Ke(F(t.texts.save), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        H(s, {
          theme: "secondary",
          onClick: ne(t.onCancelBtnClick, ["prevent"])
        }, {
          default: Z(() => [
            Ke(F(t.texts.cancel), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ])
  ]);
}
const Ab = /* @__PURE__ */ ge(yb, [["render", Mb]]), Db = X({
  name: "SelectedOptions",
  emits: [
    "remove"
  ],
  components: {
    Avatar: Zr,
    BsIcon: He,
    SelectedOptionSingle: ac
  },
  props: {
    // modelValue: {
    // 	type: Array as PropType<SelectOption<any>[]>,
    // 	required: true
    // },
    options: {
      type: Array,
      required: !0
    },
    useAvatar: {
      type: Boolean,
      default: !0
    },
    useBadges: {
      type: Boolean,
      default: !1
    }
  },
  computed: {},
  methods: {
    removeOption(t) {
      this.$emit("remove", t);
    },
    getAvatarData(t) {
      return t.avatar ? t.avatar : t.text;
    },
    optionClasses(t) {
      let i = [];
      return this.useAvatar || i.push("no-avatar"), this.useBadges && (t.theme || (t.theme = "secondary"), i.push("bg-" + t.theme + "-light")), i;
    }
  }
}), Ib = { class: "hakosalo-selected-options" };
function Eb(t, i, r, l, a, u) {
  const s = ye("selected-option-single");
  return v(), b("div", Ib, [
    y("div", {
      class: z({ blocks: !t.useBadges, badges: t.useBadges })
    }, [
      (v(!0), b(he, null, Se(t.options, (h) => (v(), le(s, {
        key: h.value,
        option: h,
        "use-avatar": t.useAvatar,
        "use-badges": t.useBadges,
        onRemove: (g) => t.removeOption(h)
      }, null, 8, ["option", "use-avatar", "use-badges", "onRemove"]))), 128))
    ], 2)
  ]);
}
const Bb = /* @__PURE__ */ ge(Db, [["render", Eb]]), xb = { class: "d-flex align-items-center" }, Vb = {
  key: 0,
  class: "checkbox py-1 px-2"
}, Pb = ["checked"], Lb = {
  key: 1,
  class: "pe-2"
}, Rb = {
  key: 2,
  class: "avatar pe-2"
}, Fb = { class: "text" }, Du = /* @__PURE__ */ X({
  __name: "ListOption",
  props: {
    option: {
      type: Object,
      required: !0
    },
    useAvatar: {
      type: Boolean,
      default: !1
    },
    isSelected: {
      type: Boolean,
      required: !0
    },
    customContent: {
      type: Boolean,
      default: !1
    },
    theme: {
      type: String,
      default: ""
    },
    isSingleMode: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["select"],
  setup(t, { emit: i }) {
    const r = i, l = q(null);
    function a(u) {
      u.target != l.value && (u.preventDefault(), r("select"));
    }
    return (u, s) => (v(), b("div", {
      class: "hako-list-option py-2 px-2",
      onClick: a
    }, [
      y("div", xb, [
        t.isSingleMode ? t.isSelected ? (v(), b("div", Lb, [
          H(He, { icon: "check2-square" })
        ])) : W("", !0) : (v(), b("div", Vb, [
          y("input", {
            type: "checkbox",
            ref_key: "checkbox",
            ref: l,
            checked: t.isSelected,
            onKeydown: s[0] || (s[0] = on((h) => u.$emit("select"), ["enter"])),
            onChange: s[1] || (s[1] = (h) => u.$emit("select"))
          }, null, 40, Pb)
        ])),
        t.useAvatar ? (v(), b("div", Rb, [
          H(Zr, {
            "avatar-data": t.option.avatar || t.option.text,
            role: t.option.theme || t.theme
          }, null, 8, ["avatar-data", "role"])
        ])) : W("", !0),
        y("div", Fb, [
          t.customContent ? J(u.$slots, "default", { key: 0 }) : (v(), b(he, { key: 1 }, [
            Ke(F(t.option.text), 1)
          ], 64))
        ])
      ])
    ]));
  }
}), Wb = X({
  components: {
    Spinner: Gn
  },
  props: {
    modelValue: {
      type: Boolean,
      required: !0
    },
    text: {
      type: String,
      default: ""
    }
  }
}), Hb = { class: "hakosalo-block-spinner" }, Ub = { key: 0 };
function Nb(t, i, r, l, a, u) {
  const s = ye("spinner");
  return v(), b("div", Hb, [
    y("div", {
      class: z(["spinner", { "spinner-on": t.modelValue }])
    }, [
      H(s, { center: "" }),
      t.text ? (v(), b("span", Ub, F(t.text), 1)) : W("", !0)
    ], 2),
    y("div", {
      class: z(["bg-effect", { "bg-effect-on": t.modelValue }])
    }, null, 2),
    y("div", {
      class: z([{ "content-blur-on": t.modelValue }, "content-blur"])
    }, [
      J(t.$slots, "default")
    ], 2)
  ]);
}
const Aa = /* @__PURE__ */ ge(Wb, [["render", Nb]]), zb = 2e3, Da = () => {
  const t = document.querySelectorAll(".hakosalo-window, .hakosalo-modal-container");
  let i = zb;
  return t.forEach((r) => {
    let a = parseInt(r.style.zIndex);
    a > i && (i = a);
  }), i + 1;
}, sc = () => {
  let t = document.querySelector("body"), i = document.querySelectorAll(".hakosalo-modal-container");
  function r(l) {
    var s;
    let a = (s = document.defaultView) == null ? void 0 : s.getComputedStyle(l).getPropertyValue("z-index");
    a || (a = "");
    const u = parseInt(a);
    return isNaN(u) ? 0 : u;
  }
  return i.length > 0 && (t = null, i.forEach((l) => {
    if (t == null) {
      t = l;
      return;
    }
    let a = r(t);
    r(l) > a && (t = l);
  })), t == null && (console.warn("Target should never be null here"), t = document.body), t;
}, qb = X({
  name: "HakoWindow",
  // If set to true, messes up the WindowVueManager system... 
  inheritAttrs: !1,
  emits: [
    "close",
    "update:modelValue"
  ],
  components: {
    BsIcon: He
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: "l"
    },
    modelValue: {
      type: Boolean,
      required: !0
    },
    startingPosition: {
      type: Object,
      default: null
    },
    positionUnderElement: {
      type: Object,
      default: null
    },
    disablePadding: {
      type: Boolean,
      default: !1
    },
    stuck: {
      type: Boolean,
      default: !1
    },
    id: {
      type: String,
      default: () => mn()
    }
  },
  data() {
    return {
      zIndex: 0,
      isDrag: !1,
      isDestroyed: !1,
      // can be used to force-unmount window
      previousDragEvent: null,
      position: {
        top: 0,
        left: 0
      }
    };
  },
  watch: {
    modelValue() {
      this.modelValue ? (this.setStartingPosition(), this.putWindowOnTop()) : this.$emit("close"), this.$nextTick(() => {
        this.bodyClassCheck();
      });
    }
  },
  beforeMount() {
  },
  mounted() {
    this.setStartingPosition(), this.$nextTick(() => {
      this.zIndex = Da();
    }), this.bodyClassCheck();
  },
  unmounted() {
    this.bodyClassCheck();
  },
  computed: {
    rootDiv() {
      return this.$refs.window;
    },
    showWindow() {
      return this.modelValue;
    },
    teleportLocation() {
      return sc();
    },
    windowWidth() {
      return [300, 600, 800, 1e3, 1280]["smlxlxxl".indexOf(this.size.toLowerCase())];
    },
    windowInlineStyle() {
      const t = {};
      return t["z-index"] = this.zIndex.toString(), t.top = this.position.top + "px", t.left = this.position.left + "px", t.width = this.windowWidth + "px", t;
    },
    windowContentStyle() {
      let t = {};
      return this.disablePadding && (t.padding = "0px"), t;
    }
  },
  methods: {
    destroy() {
      console.warn("HakoWindow destroyed itself, this should not happen"), this.$emit("close"), this.isDestroyed = !0;
    },
    putWindowOnTop() {
      this.zIndex = Da();
    },
    setStartingPosition() {
      const i = this.$refs.window.closest(".hakosalo-modal-container"), r = this.windowWidth, l = window.innerWidth;
      let a = { top: 0, left: 0 };
      if (this.positionUnderElement) {
        const s = this.positionUnderElement;
        a = { top: 0, left: 0 };
        let h = window.scrollY;
        i != null && (h = i.scrollTop), a.left = s.getBoundingClientRect().left, a.top = s.getBoundingClientRect().top + s.clientHeight + h, this.position = a;
      } else if (this.startingPosition == null) {
        a = {
          top: 20,
          left: 0
        }, a.left = Math.round(l / 2 - r / 2);
        let s = window.scrollY;
        i != null && (s = i.scrollTop), s = parseInt(s.toFixed()), a.top += scrollY;
      } else
        a = { top: this.startingPosition.top, left: this.startingPosition.left };
      r > l && (a.left = 0), a.left + r > l && (a.left = l - r);
      let u = 0;
      for (; u < 1e3; ) {
        const s = document.getElementsByClassName("hakosalo-window-visible");
        let h = !1;
        for (let g = 0; g < s.length; g++) {
          const k = s[g];
          let S = parseInt(k.style.left), E = parseInt(k.style.top);
          if (!(isNaN(S) || isNaN(E)) && a.left == S && a.top == E) {
            a.left += 20, a.top += 20, h = !0;
            break;
          }
        }
        if (!h)
          break;
      }
      this.position = a;
    },
    onDragStart(t) {
      this.isDrag = !0, this.putWindowOnTop(), window.addEventListener("mousemove", this.onDrag), window.addEventListener("mouseup", this.onDragEnd);
    },
    onDrag(t) {
      if (!this.isDrag || this.stuck)
        return;
      if (!this.previousDragEvent) {
        this.previousDragEvent = t;
        return;
      }
      const i = this.$refs.window;
      i == null && this.destroy();
      let r = t.pageY - this.previousDragEvent.pageY, l = t.pageX - this.previousDragEvent.pageX;
      this.position.top = this.position.top + r, this.position.left = this.position.left + l, this.position.top < 0 && (this.position.top = 0), this.position.left < 0 && (this.position.left = 0);
      let a = document.body.clientWidth - i.clientWidth;
      this.position.left > a && (this.position.left = a), this.previousDragEvent = t;
    },
    onDragEnd(t) {
      this.isDrag = !1, this.previousDragEvent = null, window.removeEventListener("mousemove", this.onDrag), window.removeEventListener("mouseup", this.onDragEnd);
    },
    bodyClassCheck() {
      const t = document.querySelectorAll(".hakosalo-window"), r = Array.from(t).some((l) => l.offsetWidth > 0);
      document.body.classList.remove("hakowindow-open"), r && document.body.classList.add("hakowindow-open");
    }
  }
}), Yb = ["id"], Gb = { class: "d-flex justify-content-between align-items-center" }, Kb = { class: "buttons" };
function Qb(t, i, r, l, a, u) {
  const s = ye("bs-icon");
  return v(), le(Yn, { to: t.teleportLocation }, [
    H(ft, null, {
      default: Z(() => [
        t.isDestroyed ? W("", !0) : Ne((v(), b("div", {
          key: 0,
          class: z(["hakosalo-window", { "hakosalo-window-visible": t.showWindow }]),
          ref: "window",
          id: `hw-${t.id}`,
          style: fe(t.windowInlineStyle),
          onMousedown: i[2] || (i[2] = (h) => t.putWindowOnTop()),
          onClose: i[3] || (i[3] = (h) => t.$emit("update:modelValue", !1))
        }, [
          y("header", Gb, [
            y("div", {
              class: "title flex-fill",
              onMousedown: i[0] || (i[0] = ne((...h) => t.onDragStart && t.onDragStart(...h), ["prevent"])),
              style: fe({ cursor: t.stuck ? "auto" : "move" })
            }, [
              y("h1", null, F(t.title), 1)
            ], 36),
            y("div", Kb, [
              y("button", {
                type: "button",
                onClick: i[1] || (i[1] = ne((h) => t.$emit("update:modelValue", !1), ["prevent"]))
              }, [
                H(s, { icon: "x-lg" })
              ])
            ])
          ]),
          y("div", {
            class: "window-content",
            style: fe(t.windowContentStyle)
          }, [
            J(t.$slots, "default")
          ], 4)
        ], 46, Yb)), [
          [Dn, t.showWindow]
        ])
      ]),
      _: 3
    })
  ], 8, ["to"]);
}
const Wa = /* @__PURE__ */ ge(qb, [["render", Qb]]), Xb = { class: "hakolib-ms2-selected-options" }, Zb = { class: "d-flex align-items-center" }, Jb = { class: "hakolib-ms2-selected-option-text" }, jb = { class: "ms-auto" }, ek = ["onClick", "onMouseover"], tk = /* @__PURE__ */ X({
  __name: "SelectedOptions",
  props: {
    options: {
      type: Array,
      default: () => []
    },
    useCustomRendering: {
      type: Boolean,
      default: !1
    },
    optionComparer: {
      type: Function,
      required: !0
    },
    icon: {
      type: String,
      default: null
    }
  },
  emits: ["remove"],
  setup(t, { emit: i }) {
    const r = i, l = q("");
    function a(u) {
      r("remove", u), l.value = "";
    }
    return (u, s) => (v(), b("div", Xb, [
      t.useCustomRendering ? J(u.$slots, "selectedCustomRender", {
        key: 0,
        options: t.options
      }) : (v(!0), b(he, { key: 1 }, Se(t.options, (h) => (v(), b("div", {
        key: t.optionComparer(h.value),
        class: z(["hakolib-ms2-selected-option", { hover: l.value == t.optionComparer(h.value) }])
      }, [
        y("div", Zb, [
          y("div", Jb, [
            t.icon ? (v(), le(He, {
              key: 0,
              icon: t.icon
            }, null, 8, ["icon"])) : W("", !0),
            Ke(" " + F(h.text), 1)
          ]),
          y("div", jb, [
            y("button", {
              type: "button",
              class: "remove-btn",
              onClick: (g) => a(h),
              onMouseover: (g) => l.value = t.optionComparer(h.value),
              onMouseout: s[0] || (s[0] = (g) => l.value = "")
            }, [
              H(He, { icon: "x" })
            ], 40, ek)
          ])
        ])
      ], 2))), 128))
    ]));
  }
}), lc = {
  options: () => [],
  pageSize: 10,
  useAvatar: !1,
  theme: "",
  icon: "person-fill",
  startSearchLimit: 2,
  placeholder: "",
  //configGetText(config.components.inputs.multiselect2.texts?.placeholder),
  inputAttrs: {},
  useWindowMenu: !1,
  hideSelectedOptions: !1,
  isInvalid: null
}, nk = ["id"], rk = ["placeholder"], ik = {
  key: 0,
  class: "p-3"
}, ok = {
  key: 0,
  class: "py-3 px-3"
}, ak = { class: "win-search mb-3 mt-1" }, sk = ["placeholder"], lk = { key: 0 }, uk = { key: 1 }, ck = {
  key: 0,
  class: "mb-3"
}, dk = { class: "mt-2" }, fk = { class: "mt-5 text-end" }, hk = {
  key: 0,
  class: "selected-options mt-2"
};
st.components.inputs.multiselect2 = {
  texts: {
    placeholder: {
      en: "Write a search term",
      fi: "Kirjoita hakusana",
      sv: "Skriv ett sökord"
    },
    isIgnoringSearchBecauseOfLimit: {
      en: "Write a bit more to show results",
      fi: "Kirjoita hieman enemmän, jotta voimme näyttää tuloksia",
      sv: "Skriv lite mer för att visa resultat"
    },
    noResults: {
      en: "No results",
      fi: "Ei tuloksia",
      sv: "Inga resultat"
    },
    windowTitle: {
      fi: "Vaihtoehtojen poiminta",
      en: "Select options",
      sv: "Välj alternativ"
    },
    selectAll: {
      fi: "Valitse kaikki (näkyvät)",
      en: "Select all (visible)",
      sv: "Välj alla (synliga)"
    },
    deselectAll: {
      fi: "Poista kaikki (näkyvät) valinnat",
      en: "Deselect all (visible)",
      sv: "Avmarkera alla (synliga)"
    },
    loadMoreOptions: {
      fi: "Lataa lisää vaihtoehtoja",
      en: "Load more options",
      sv: "Ladda fler alternativ"
    },
    done: {
      fi: "Valmis",
      en: "Done",
      sv: "Klar"
    }
  }
};
const pk = {
  ...lc,
  isSingleMode: !1,
  singleRemovable: !0
}, vk = X({}), uc = /* @__PURE__ */ X({
  ...vk,
  __name: "Multiselect2",
  props: /* @__PURE__ */ xu({
    modelValue: {},
    isSingleMode: { type: Boolean },
    singleRemovable: { type: Boolean },
    options: {},
    optionGenerator: { type: Function },
    optionComparer: { type: Function },
    optionLoader: { type: Function },
    optionFilter: { type: Function },
    pageSize: {},
    useAvatar: { type: Boolean },
    avatarData: { type: Function },
    theme: {},
    icon: {},
    startSearchLimit: {},
    placeholder: {},
    id: {},
    inputAttrs: {},
    useWindowMenu: { type: Boolean },
    windowTitle: {},
    hideSelectedOptions: { type: Boolean },
    isInvalid: { type: [Boolean, null] }
  }, pk),
  emits: ["update:modelValue", "blur", "change"],
  setup(t, { emit: i }) {
    const r = t, l = Vu(), a = j(() => l.default ? !0 : r.useWindowMenu), u = j(() => st.components.inputs.multiselect2.texts), s = (V) => gt(u.value[V]), h = i, g = q(""), T = q([]), k = q([]);
    vn(async () => {
      g.value = "ms2-" + mn(), r.id && (g.value = r.id), sn();
    });
    const S = q(0), E = q(null);
    zn(() => {
      var V;
      window.addEventListener("click", _e), S.value = window.setInterval(() => {
        Nt() || (Ce.value = !1);
      }, 100), (V = E.value) == null || V.addEventListener("scroll", O);
    }), qn(() => {
      var V;
      window.removeEventListener("click", _e), window.clearInterval(S.value), (V = E.value) == null || V.removeEventListener("scroll", O);
    });
    function O() {
      if (!re.value) {
        xt.value = !0;
        return;
      }
      const V = E.value;
      if (!V)
        return;
      const L = V.scrollHeight, G = V.scrollTop, tt = V.clientHeight;
      L - G == tt && !xt.value && Ae.value.length >= r.pageSize && (Ht.value++, un(ke.value));
    }
    const C = q(!1);
    an(C, (V) => {
      if (V == !1) {
        const L = ke.value.trim();
        ke.value = "", L != ke.value && sn(), h("blur");
      }
    });
    const I = q(!1), M = q(null), R = q(null), ee = q({ top: 0, left: 0 });
    function U() {
      if (!M.value)
        return { top: 0, left: 0 };
      let V = 0;
      R.value && (V = R.value.windowWidth);
      const L = M.value.getBoundingClientRect();
      let G = window.scrollY;
      const tt = M.value.closest(".hakosalo-modal-container");
      tt && (G = tt.scrollTop);
      let nt = L.top + G, wn = L.left + L.width + 5;
      return M.value.clientWidth > 600 && (nt = L.top + G + L.height + 5, wn = L.right - V), {
        top: Math.round(nt),
        left: Math.round(wn)
      };
    }
    zn(() => {
      U();
    }), an(C, (V) => {
      V && (ee.value = U());
    });
    function de() {
      a.value ? C.value = !C.value : Ce.value = !Ce.value;
    }
    const ue = j(() => {
      let V = [], L = r.options;
      return re.value ? L = T.value : ke.value.length > 0 && (L = k.value), ke.value.length > 0 && !a.value ? V = [...L, ...V] : V = [...V, ...L], Qi.uniqBy(
        V,
        r.optionComparer
      );
    }), Ie = j(() => r.options.map((V) => pt(V))), Ae = j(() => {
      let V = ue.value;
      return typeof r.optionFilter == "function" && (V = V.filter(r.optionFilter)), V.map((L) => pt(L));
    }), Ze = j(() => r.modelValue.map((L) => pt(L)));
    function pt(V) {
      const L = r.optionGenerator(V);
      if (typeof L.value > "u" && (L.value = V), r.useAvatar && !L.avatar) {
        let G = L.text;
        typeof r.avatarData == "function" && (G = r.avatarData(V) || ""), L.avatar = G;
      }
      return L;
    }
    const re = j(() => typeof r.optionLoader == "function");
    async function xe(V = !1) {
      for (const L of Ae.value) {
        const G = Le(L);
        V && G ? await be(L) : !V && !G && await be(L);
      }
    }
    function Le(V) {
      const L = r.modelValue, G = r.optionComparer(V.value);
      for (const tt of L) {
        const nt = r.optionComparer(tt);
        if (G == nt)
          return !0;
      }
      return !1;
    }
    async function be(V) {
      vt.value = !0, await $t();
      const L = Tt(), G = r.modelValue;
      let tt = [...G];
      r.isSingleMode && (tt = [], Ce.value = !1, C.value = !1, ke.value = "");
      const nt = G.filter((wn) => r.optionComparer(wn) == r.optionComparer(V.value))[0];
      return !nt || r.isSingleMode ? tt.push(V.value) : tt = tt.filter((wn) => wn != nt), h("update:modelValue", tt), h("change"), await $t(), L == null || L.focus(), await $t(), vt.value = !1, Promise.resolve();
    }
    function Tt() {
      const V = document.activeElement;
      if (!V)
        return null;
      const L = V.closest(".hako-list-option");
      if (!L)
        return null;
      let G = L.nextElementSibling;
      return G || (G = L.previousElementSibling), G ? G.querySelector("input") : null;
    }
    const De = q(!1), Je = q(!1), ke = q(""), yt = q(0), Ht = q(1), xt = q(!1);
    function ut(V) {
      Ht.value == 1 ? (De.value = V, Je.value = !1) : Je.value = V;
    }
    const Ut = q(!1);
    async function sn() {
      a.value ? Jt() : ln();
    }
    const gn = q(0);
    async function Jt() {
      ln(), window.clearTimeout(gn.value), gn.value = window.setTimeout(async () => {
        ke.value.length > 0 && (C.value = !0);
      }, 1e3);
      const V = Nt();
      ke.value.length == 0 && V && (C.value = !1);
    }
    async function ln() {
      const V = ke.value.toLowerCase();
      if (Ht.value = 1, xt.value = !1, Ut.value = !1, re.value) {
        if (V.length > 0 && V.length <= r.startSearchLimit) {
          Ut.value = !0, T.value = [];
          return;
        }
        ut(!0), window.clearTimeout(yt.value), yt.value = window.setTimeout(async () => {
          await un(V);
        }, 333);
      } else {
        const L = Ie.value.filter((G) => G.text.toLowerCase().includes(V)).map((G) => G.value);
        k.value = L;
      }
    }
    async function un(V) {
      var tt;
      ut(!0);
      const L = yt.value, G = await r.optionLoader(V, Ht.value);
      if (L != yt.value) {
        ut(!1);
        return;
      }
      if (Ht.value == 1 && V.length > r.startSearchLimit && (T.value = []), G.length > 0)
        if (Ht.value > 1) {
          let nt = (tt = E.value) == null ? void 0 : tt.scrollTop;
          T.value = [...T.value, ...G], await $t(), E.value && nt && (E.value.scrollTop = nt);
        } else
          T.value = G;
      else
        xt.value = !0;
      ut(!1);
    }
    const Ce = q(!1);
    function _e(V) {
      V.target.closest(".hakolib-multiselect2") != null || (Ce.value = !1);
    }
    an(Ce, (V) => {
      if (!a.value)
        if (Ce.value) {
          const L = document.querySelector(`#${g.value} .listmenu`);
          $t(() => {
            L.scrollTop = 0;
          });
        } else {
          const L = ke.value;
          ke.value = "", L != ke.value && sn(), h("blur");
        }
    });
    const vt = q(!1);
    function Nt() {
      if (vt.value)
        return !0;
      if (Ce.value == !1)
        return !1;
      const V = document.activeElement;
      return V ? V.closest("#" + g.value) != null : !1;
    }
    function yn() {
      r.isSingleMode && (I.value = !0, $t(() => {
        M.value.querySelector("input").focus();
      }));
    }
    return (V, L) => (v(), b("div", {
      class: "hakolib-multiselect2",
      id: g.value
    }, [
      y("div", {
        class: "input-container",
        ref_key: "inputContainer",
        ref: M
      }, [
        J(V.$slots, "default", {
          openMenu: de,
          searchInput: ke.value
        }, () => [
          V.isSingleMode && Ze.value.length > 0 && !I.value ? (v(), b(he, { key: 0 }, [
            y("div", {
              class: "single-selected",
              onClick: ne(yn, ["prevent", "stop"])
            }, [
              y("span", null, F(Ze.value[0].text), 1)
            ]),
            V.singleRemovable ? (v(), b("button", {
              key: 0,
              type: "button",
              class: "single-remove-button",
              onClick: L[0] || (L[0] = ne((G) => V.$emit("update:modelValue", []), ["prevent"])),
              tabindex: "-1"
            }, [
              H(He, { icon: "x-circle-fill" })
            ])) : W("", !0)
          ], 64)) : W("", !0),
          Ne(y("input", ht({
            "onUpdate:modelValue": L[1] || (L[1] = (G) => ke.value = G),
            type: "text",
            class: ["form-control", {
              "is-valid": V.isInvalid === !1,
              "is-invalid": V.isInvalid === !0
            }],
            onInput: L[2] || (L[2] = async () => await sn()),
            onFocus: L[3] || (L[3] = (G) => Ce.value = !0),
            onBlur: L[4] || (L[4] = (G) => {
              I.value = !1, V.$emit("blur");
            }),
            placeholder: V.placeholder
          }, V.inputAttrs), null, 16, rk), [
            [Nn, ke.value]
          ]),
          y("button", {
            type: "button",
            class: "chevron-button",
            onClick: ne(de, ["prevent"]),
            tabindex: "-1"
          }, [
            H(He, {
              icon: !a.value && Ce.value || a.value && C.value ? "chevron-up" : "chevron-down"
            }, null, 8, ["icon"])
          ])
        ]),
        a.value ? (v(), le(Wa, {
          key: 1,
          ref_key: "hakowindow",
          ref: R,
          modelValue: C.value,
          "onUpdate:modelValue": L[12] || (L[12] = (G) => C.value = G),
          title: V.windowTitle == null ? s("windowTitle") : V.windowTitle,
          size: "m",
          startingPosition: ee.value
        }, {
          default: Z(() => [
            y("div", ak, [
              Ne(y("input", ht({
                "onUpdate:modelValue": L[6] || (L[6] = (G) => ke.value = G),
                type: "text",
                class: "form-control",
                onInput: L[7] || (L[7] = async () => await sn()),
                placeholder: V.placeholder
              }, V.inputAttrs), null, 16, sk), [
                [Nn, ke.value]
              ])
            ]),
            Ut.value ? (v(), b("div", lk, F(s("isIgnoringSearchBecauseOfLimit")), 1)) : !De.value && Ae.value.length == 0 ? (v(), b("p", uk, F(s("noResults")), 1)) : W("", !0),
            H(Aa, {
              style: { "min-height": "100px" },
              modelValue: De.value || Je.value
            }, {
              default: Z(() => [
                !V.isSingleMode && Ae.value.length > 0 ? (v(), b("div", ck, [
                  y("a", {
                    href: "#",
                    class: "pe-5",
                    onClick: L[8] || (L[8] = ne((G) => xe(), ["prevent"]))
                  }, F(s("selectAll")), 1),
                  y("a", {
                    href: "#",
                    onClick: L[9] || (L[9] = ne((G) => xe(!0), ["prevent"]))
                  }, F(s("deselectAll")), 1)
                ])) : W("", !0),
                (v(!0), b(he, null, Se(Ae.value, (G) => (v(), le(Du, {
                  key: V.optionComparer(G.value),
                  "use-avatar": V.useAvatar,
                  theme: V.theme,
                  option: G,
                  "is-selected": Le(G),
                  "custom-content": !!V.$slots.option,
                  onSelect: (tt) => be(G)
                }, {
                  default: Z(() => [
                    J(V.$slots, "option", { option: G })
                  ]),
                  _: 2
                }, 1032, ["use-avatar", "theme", "option", "is-selected", "custom-content", "onSelect"]))), 128)),
                y("div", dk, [
                  !xt.value && re.value && Ae.value.length >= V.pageSize ? (v(), b("a", {
                    key: 0,
                    href: "#",
                    onClick: L[10] || (L[10] = ne(() => {
                      Ht.value += 1, un(ke.value);
                    }, ["prevent"]))
                  }, F(s("loadMoreOptions")), 1)) : W("", !0)
                ])
              ]),
              _: 3
            }, 8, ["modelValue"]),
            y("div", fk, [
              H(At, {
                onClick: L[11] || (L[11] = (G) => C.value = !1)
              }, {
                default: Z(() => [
                  Ke(F(s("done")), 1)
                ]),
                _: 1
              })
            ])
          ]),
          _: 3
        }, 8, ["modelValue", "title", "startingPosition"])) : (v(), le(ft, {
          key: 0,
          name: "menu"
        }, {
          default: Z(() => [
            Ne(y("div", {
              class: "listmenu",
              ref_key: "listmenu",
              ref: E,
              tabindex: "-1"
            }, [
              H(Aa, {
                style: { "min-height": "60px" },
                modelValue: De.value,
                "onUpdate:modelValue": L[5] || (L[5] = (G) => De.value = G)
              }, {
                default: Z(() => [
                  Ut.value ? (v(), b("div", ik, F(s("isIgnoringSearchBecauseOfLimit")), 1)) : (v(), b(he, { key: 1 }, [
                    !De.value && Ae.value.length == 0 ? (v(), b("div", ok, F(s("noResults")), 1)) : W("", !0),
                    (v(!0), b(he, null, Se(Ae.value, (G) => (v(), le(Du, {
                      key: V.optionComparer(G.value),
                      "use-avatar": V.useAvatar,
                      theme: V.theme,
                      option: G,
                      "is-selected": Le(G),
                      "custom-content": !!V.$slots.option,
                      isSingleMode: V.isSingleMode,
                      onSelect: (tt) => be(G)
                    }, {
                      default: Z(() => [
                        J(V.$slots, "option", { option: G })
                      ]),
                      _: 2
                    }, 1032, ["use-avatar", "theme", "option", "is-selected", "custom-content", "isSingleMode", "onSelect"]))), 128)),
                    !xt.value && re.value && Ae.value.length >= V.pageSize ? (v(), b("div", {
                      key: 1,
                      class: z(["text-center bottom-loader", { "is-visible": Je.value }])
                    }, [
                      H(Gn, {
                        class: "p-2",
                        size: 2,
                        theme: "light"
                      })
                    ], 2)) : W("", !0)
                  ], 64))
                ]),
                _: 3
              }, 8, ["modelValue"])
            ], 512), [
              [Dn, Ce.value]
            ])
          ]),
          _: 3
        }))
      ], 512),
      !V.isSingleMode && !V.hideSelectedOptions ? (v(), b("div", hk, [
        H(tk, {
          options: Ze.value,
          "use-custom-rendering": !!V.$slots.selectedCustomRender,
          "option-comparer": V.optionComparer,
          icon: V.icon,
          onRemove: be
        }, {
          selectedCustomRender: Z(({ options: G }) => [
            J(V.$slots, "selectedCustomRender", {
              options: G,
              remove: (tt) => be(tt)
            })
          ]),
          _: 3
        }, 8, ["options", "use-custom-rendering", "option-comparer", "icon"])
      ])) : W("", !0)
    ], 8, nk));
  }
}), mk = {
  ...lc,
  emptyValue: null,
  isRemovable: !0
}, gk = X({}), yk = /* @__PURE__ */ X({
  ...gk,
  __name: "SingleSelect2",
  props: /* @__PURE__ */ xu({
    modelValue: {},
    isRemovable: { type: Boolean },
    emptyValue: {},
    options: {},
    optionGenerator: { type: Function },
    optionComparer: { type: Function },
    optionLoader: { type: Function },
    optionFilter: { type: Function },
    pageSize: {},
    useAvatar: { type: Boolean },
    avatarData: { type: Function },
    theme: {},
    icon: {},
    startSearchLimit: {},
    placeholder: {},
    id: {},
    inputAttrs: {},
    useWindowMenu: { type: Boolean },
    windowTitle: {},
    hideSelectedOptions: { type: Boolean },
    isInvalid: { type: [Boolean, null] }
  }, mk),
  emits: ["update:modelValue", "blur", "change"],
  setup(t, { emit: i }) {
    const r = i, l = t, a = q([]);
    return an(a, (u) => {
      let s = u[0];
      s || (s = l.emptyValue), r("update:modelValue", s);
    }), an(() => l.modelValue, (u) => {
      u !== a.value[0] && (u ? a.value = [u] : a.value = []);
    }, { immediate: !0 }), (u, s) => (v(), le(uc, ht(l, {
      modelValue: a.value,
      "onUpdate:modelValue": s[0] || (s[0] = (h) => a.value = h),
      isSingleMode: !0,
      "single-removable": u.isRemovable,
      onBlur: s[1] || (s[1] = (h) => u.$emit("blur")),
      onChange: s[2] || (s[2] = (h) => u.$emit("change"))
    }), Pu({ _: 2 }, [
      u.$slots.default ? {
        name: "default",
        fn: Z(({ openMenu: h, searchInput: g }) => [
          J(u.$slots, "default", {
            openMenu: h,
            searchInput: g
          })
        ]),
        key: "0"
      } : void 0,
      u.$slots.option ? {
        name: "option",
        fn: Z(({ option: h }) => [
          J(u.$slots, "option", { option: h })
        ]),
        key: "1"
      } : void 0
    ]), 1040, ["modelValue", "single-removable"]));
  }
}), Hn = (t) => typeof t.key < "u" ? t.key.toString() : JSON.stringify(t.obj), wk = { key: 0 }, bk = { class: "checkbox flex-grow-1" }, kk = { class: "d-flex align-items-baseline" }, Ck = ["checked", "value", "disabled"], $k = {
  key: 0,
  class: "child-count"
}, _k = /* @__PURE__ */ X({
  __name: "RecursiveSelectOption",
  props: {
    selectedItemKeys: {
      type: Array,
      required: !0
    },
    selectedItems: {
      type: Array,
      required: !0
    },
    item: {
      type: Object,
      required: !0
    },
    level: {
      type: Number,
      required: !0
    },
    search: {
      type: String,
      required: !0
    },
    openAllTimestamp: {
      type: Number,
      required: !0
    },
    disabled: {
      type: [Boolean, String],
      default: !1
    }
  },
  emits: ["itemchange"],
  setup(t, { emit: i }) {
    const r = t, l = i;
    vn(() => {
      r.level > 1 && (a.value = !1), k.value && (a.value = !1);
    });
    const a = q(!0);
    an(() => r.openAllTimestamp, () => {
      a.value = !1;
    });
    const u = j(() => r.disabled === !0 || r.disabled === "recursive"), s = j(() => {
      const M = ["level-" + r.level];
      return r.item.children.length > 0 && M.push("has-children"), u.value && M.push("disabled"), M;
    }), h = j(() => {
      if (!r.search)
        return !0;
      let M = g(r.item);
      return M && (a.value = !1), M;
    }), g = (M) => {
      const R = M.text.toLowerCase().trim(), ee = r.search.toLowerCase().trim();
      if (R.includes(ee))
        return !0;
      for (const U of M.children)
        if (g(U))
          return !0;
      return !1;
    }, T = j(() => r.selectedItemKeys.includes(Hn(r.item))), k = j(() => T.value ? !0 : S(r.item)), S = (M) => {
      for (const R of M.children)
        if (r.selectedItemKeys.includes(Hn(R)) || S(R))
          return !0;
      return !1;
    }, E = j(() => O(r.item)), O = (M) => {
      let R = M.children.length;
      for (const ee of M.children) {
        let U = O(ee);
        R += U;
      }
      return R;
    }, C = async (M) => {
      if (u.value)
        return;
      const R = M.currentTarget;
      await I(r.item, R.checked);
    }, I = async (M, R) => {
      l("itemchange", M, R), await $t(), R && (a.value = !1);
      for (const ee of M.children)
        I(ee, R), await $t();
    };
    return (M, R) => {
      const ee = ye("RecursiveSelectOption", !0);
      return v(), b("div", null, [
        t.level == 1 ? (v(), b("hr", wk)) : W("", !0),
        Ne(y("div", {
          class: z(["recursive-select-option", s.value])
        }, [
          y("div", {
            class: z({ "d-flex": t.level == 1 })
          }, [
            y("div", bk, [
              y("label", kk, [
                y("input", {
                  ref: "checkbox",
                  type: "checkbox",
                  checked: T.value,
                  value: t.item.value,
                  disabled: u.value,
                  onChange: R[0] || (R[0] = (U) => C(U))
                }, null, 40, Ck),
                H(Fa, {
                  content: t.item.text,
                  highlight: t.search || ""
                }, null, 8, ["content", "highlight"]),
                t.level == 1 ? (v(), b("div", $k, [
                  y("span", null, F(E.value), 1)
                ])) : W("", !0)
              ])
            ]),
            t.level == 1 ? (v(), b("div", {
              key: 0,
              class: z(["hide-children-btn", { "hidden-mode": a.value }]),
              onClick: R[1] || (R[1] = (U) => a.value = !a.value)
            }, [
              H(He, { icon: "chevron-up" })
            ], 2)) : W("", !0)
          ], 2)
        ], 2), [
          [Dn, h.value]
        ]),
        H(ji, {
          show: !a.value
        }, {
          default: Z(() => [
            (v(!0), b(he, null, Se(t.item.children, (U) => (v(), le(ee, {
              key: Lu(Hn)(U),
              item: U,
              level: t.level + 1,
              "selected-items": t.selectedItems,
              "selected-item-keys": t.selectedItemKeys,
              search: t.search,
              onItemchange: R[2] || (R[2] = (de, ue) => M.$emit("itemchange", de, ue)),
              "open-all-timestamp": t.openAllTimestamp,
              disabled: t.disabled == "recursive" || U.disabled === !0 || U.disabled == "recursive" ? t.disabled : !1
            }, null, 8, ["item", "level", "selected-items", "selected-item-keys", "search", "open-all-timestamp", "disabled"]))), 128))
          ]),
          _: 1
        }, 8, ["show"])
      ]);
    };
  }
}), Tk = { class: "hakosalo-multilevel-select" }, Sk = { class: "header row align-items-center" }, Ok = { class: "col-sm-5" }, Mk = { class: "col-sm-7 buttons text-end" }, Ak = {
  key: 0,
  class: "icon search-icon"
}, Dk = { class: "toolbar row" }, Ik = { class: "col" }, Ek = { key: 0 }, Bk = { key: 1 }, xk = { class: "col text-end" }, Vk = { class: "options-container" }, Pk = /* @__PURE__ */ y("hr", null, null, -1), Lk = { class: "buttons text-end mt-4" }, Rk = /* @__PURE__ */ X({
  __name: "MultiLevelSelect2",
  props: {
    modelValue: {
      type: Array,
      required: !0
    },
    items: {
      type: Array,
      required: !0
    },
    title: {
      type: String,
      default: ""
    }
  },
  emits: [
    "update:modelValue",
    "save",
    "cancel"
  ],
  setup(t, { emit: i }) {
    st.components.content.multiLevelSelect = {
      texts: {
        save: {
          fi: "Tallenna",
          en: "Save",
          sv: "Spara"
        },
        cancel: {
          fi: "Peruuta",
          en: "Cancel",
          sv: "Annullera"
        },
        selectAll: {
          fi: "Valitse kaikki",
          en: "Select all",
          sv: "Välj alla"
        },
        unselectAll: {
          fi: "Poista valinnat",
          en: "Unselect all",
          sv: "Avmarkera alla"
        },
        openAll: {
          fi: "Avaa kaikki",
          en: "Open all",
          sv: "Öppna alla"
        }
      }
    };
    const r = j(() => st.components.content.multiLevelSelect.texts), l = j(() => {
      var U;
      return gt((U = r.value) == null ? void 0 : U.save);
    }), a = j(() => {
      var U;
      return gt((U = r.value) == null ? void 0 : U.cancel);
    }), u = j(() => {
      var U;
      return gt((U = r.value) == null ? void 0 : U.selectAll);
    }), s = j(() => {
      var U;
      return gt((U = r.value) == null ? void 0 : U.unselectAll);
    }), h = j(() => {
      var U;
      return gt((U = r.value) == null ? void 0 : U.openAll);
    }), g = t, T = i, k = q([]), S = q(""), E = q(0);
    vn(() => {
      k.value = [...g.modelValue.map((U) => Hn(U))];
    });
    const O = j(() => g.items.filter((U) => k.value.includes(Hn(U)))), C = (U, de) => {
      const ue = Hn(U);
      k.value = k.value.filter((Ie) => Ie != ue), de && k.value.push(ue);
    }, I = () => {
      let U = [];
      function de(ue) {
        const Ie = Hn(ue);
        k.value.includes(Ie) && U.push(ue), ue.children.forEach((Ae) => de(Ae));
      }
      g.items.forEach((ue) => de(ue)), T("update:modelValue", U), T("save");
    }, M = j(() => k.value.length == 0 ? "none" : k.value.length == g.items.length ? "all" : "some"), R = (U) => {
      const de = Hn(U);
      k.value.push(de), U.children.forEach((ue) => {
        R(ue);
      });
    }, ee = () => {
      M.value == "none" ? g.items.forEach((U) => R(U)) : k.value = [];
    };
    return (U, de) => (v(), b("div", Tk, [
      y("div", Sk, [
        y("h5", Ok, F(t.title), 1),
        y("div", Mk, [
          H(At, {
            theme: "primary",
            class: "me-2",
            onClick: ne(I, ["prevent"])
          }, {
            default: Z(() => [
              Ke(F(l.value), 1)
            ]),
            _: 1
          }),
          H(At, {
            theme: "secondary",
            onClick: de[0] || (de[0] = ne((ue) => U.$emit("cancel"), ["prevent"]))
          }, {
            default: Z(() => [
              Ke(F(a.value), 1)
            ]),
            _: 1
          })
        ])
      ]),
      y("div", {
        class: z(["search-container", { "is-searching": !!S.value }])
      }, [
        H(Sr, {
          modelValue: S.value,
          "onUpdate:modelValue": de[1] || (de[1] = (ue) => S.value = ue)
        }, null, 8, ["modelValue"]),
        H(ft, null, {
          default: Z(() => [
            S.value ? W("", !0) : (v(), b("div", Ak, [
              H(He, { icon: "search" })
            ]))
          ]),
          _: 1
        }),
        S.value ? (v(), b("div", {
          key: 0,
          class: "icon del-icon",
          onClick: de[2] || (de[2] = (ue) => S.value = "")
        }, [
          H(He, { icon: "x" })
        ])) : W("", !0)
      ], 2),
      y("div", Dk, [
        y("div", Ik, [
          y("a", {
            href: "#",
            onClick: ne(ee, ["prevent"])
          }, [
            M.value == "none" ? (v(), b("span", Ek, F(u.value), 1)) : (v(), b("span", Bk, F(s.value), 1))
          ])
        ]),
        y("div", xk, [
          y("a", {
            href: "#",
            onClick: de[3] || (de[3] = ne(() => E.value = (/* @__PURE__ */ new Date()).valueOf(), ["prevent"]))
          }, F(h.value), 1)
        ])
      ]),
      y("div", Vk, [
        (v(!0), b(he, null, Se(t.items, (ue) => (v(), le(_k, {
          item: ue,
          level: 1,
          "selected-item-keys": k.value,
          "selected-items": O.value,
          search: S.value,
          "open-all-timestamp": E.value,
          disabled: ue.disabled,
          onItemchange: C
        }, null, 8, ["item", "selected-item-keys", "selected-items", "search", "open-all-timestamp", "disabled"]))), 256))
      ]),
      Pk,
      y("div", Lk, [
        H(At, {
          theme: "primary",
          class: "me-2",
          onClick: ne(I, ["prevent"])
        }, {
          default: Z(() => [
            Ke(F(l.value), 1)
          ]),
          _: 1
        }),
        H(At, {
          theme: "secondary",
          onClick: de[4] || (de[4] = ne((ue) => U.$emit("cancel"), ["prevent"]))
        }, {
          default: Z(() => [
            Ke(F(a.value), 1)
          ]),
          _: 1
        })
      ])
    ]));
  }
}), Fk = ["rows"], Wk = {
  key: 0,
  class: "leftside-bg"
}, Hk = {
  key: 1,
  class: "max-length-indicator"
}, Uk = { class: "spent" }, Nk = /* @__PURE__ */ y("span", { class: "separator" }, " / ", -1), zk = { class: "max" }, qk = ["rows"], Yk = /* @__PURE__ */ X({
  inheritAttrs: !1,
  __name: "TextArea",
  props: {
    modelValue: {
      type: String,
      required: !0
    },
    /**
    * Set this to true to prevent textarea from growing automatically in size
    * based on content.
    */
    noAutogrow: {
      type: Boolean,
      default: !1
    },
    /**
    * true = invalid, false = valid, null = neutral
    */
    isInvalid: {
      type: Boolean,
      default: null
    },
    /**
    * Allows to set a maximum number of characters
    */
    maxLength: {
      type: Number,
      default: null
    },
    /**
    * Initial/Minimum set of rows
    */
    rows: {
      type: Number,
      default: 3
    },
    /**
    * This is basically CSS Resize style for textarea
    */
    resize: {
      type: String,
      default: "none"
    }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: i }) {
    const r = t, l = i;
    zn(() => {
      E("");
    });
    const a = q(""), u = j({
      get() {
        return r.modelValue || "";
      },
      set(O) {
        if (r.maxLength != null && typeof r.maxLength < "u" && O.length > r.maxLength) {
          O = a.value;
          const C = k.value, I = C.selectionStart;
          C.value = O, C.selectionStart = I - 1, C.selectionEnd = I - 1;
        }
        a.value = O, l("update:modelValue", O);
      }
    }), s = j(() => {
      const O = [];
      return r.maxLength && O.push("max-len-mode"), O;
    }), h = j(() => {
      const O = [];
      return r.isInvalid === !1 ? O.push("is-valid") : r.isInvalid === !0 && O.push("is-invalid"), O;
    }), g = (O) => {
      let C = O.key;
      C == "Enter" ? C = `
` : C.length != 1 && (C = ""), E(C);
    }, T = () => {
      E("");
    }, k = q(null), S = q(null), E = (O) => {
      if (r.noAutogrow)
        return;
      const C = k.value, I = S.value;
      if (C == null || I == null)
        return;
      I.value = C.value + O, C.scrollTop = 0;
      const M = C.getBoundingClientRect();
      I.style.width = M.width + "px", C.style.minHeight = I.scrollHeight + 5 + "px";
    };
    return (O, C) => (v(), b("div", {
      class: z(["hakosalo-text-area", s.value])
    }, [
      Ne(y("textarea", ht({
        "onUpdate:modelValue": C[0] || (C[0] = (I) => u.value = I),
        onKeydown: g,
        onKeyup: T,
        ref_key: "textarea",
        ref: k,
        class: ["form-control visible-textarea", h.value],
        style: { resize: t.resize },
        rows: t.rows
      }, O.$attrs), null, 16, Fk), [
        [Nn, u.value]
      ]),
      t.maxLength ? (v(), b("div", Wk)) : W("", !0),
      t.maxLength ? (v(), b("div", Hk, [
        y("span", Uk, F(u.value.length), 1),
        Nk,
        y("span", zk, F(t.maxLength), 1)
      ])) : W("", !0),
      Ne(y("textarea", {
        "onUpdate:modelValue": C[1] || (C[1] = (I) => u.value = I),
        tabindex: "-1",
        ref_key: "textareaClone",
        ref: S,
        class: "form-control autogrow-help",
        rows: t.rows
      }, null, 8, qk), [
        [Nn, u.value]
      ])
    ], 2));
  }
}), Iu = [
  {
    c: "+93",
    e: "🇦🇫"
  },
  {
    c: "+355",
    e: "🇦🇱"
  },
  {
    c: "+213",
    e: "🇩🇿"
  },
  {
    c: "+1684",
    e: "🇦🇸"
  },
  {
    c: "+376",
    e: "🇦🇩"
  },
  {
    c: "+244",
    e: "🇦🇴"
  },
  {
    c: "+1264",
    e: "🇦🇮"
  },
  {
    c: "+672",
    e: "🇦🇶"
  },
  {
    c: "+1268",
    e: "🇦🇬"
  },
  {
    c: "+54",
    e: "🇦🇷"
  },
  {
    c: "+374",
    e: "🇦🇲"
  },
  {
    c: "+297",
    e: "🇦🇼"
  },
  {
    c: "+61",
    e: "🇦🇺"
  },
  {
    c: "+43",
    e: "🇦🇹"
  },
  {
    c: "+994",
    e: "🇦🇿"
  },
  {
    c: "+1242",
    e: "🇧🇸"
  },
  {
    c: "+973",
    e: "🇧🇭"
  },
  {
    c: "+880",
    e: "🇧🇩"
  },
  {
    c: "+1246",
    e: "🇧🇧"
  },
  {
    c: "+375",
    e: "🇧🇾"
  },
  {
    c: "+32",
    e: "🇧🇪"
  },
  {
    c: "+501",
    e: "🇧🇿"
  },
  {
    c: "+229",
    e: "🇧🇯"
  },
  {
    c: "+1441",
    e: "🇧🇲"
  },
  {
    c: "+975",
    e: "🇧🇹"
  },
  {
    c: "+591",
    e: "🇧🇴"
  },
  {
    c: "+387",
    e: "🇧🇦"
  },
  {
    c: "+267",
    e: "🇧🇼"
  },
  {
    c: "+55",
    e: "🇧🇷"
  },
  {
    c: "+246",
    e: "🇮🇴"
  },
  {
    c: "+673",
    e: "🇧🇳"
  },
  {
    c: "+359",
    e: "🇧🇬"
  },
  {
    c: "+226",
    e: "🇧🇫"
  },
  {
    c: "+257",
    e: "🇧🇮"
  },
  {
    c: "+855",
    e: "🇰🇭"
  },
  {
    c: "+237",
    e: "🇨🇲"
  },
  {
    c: "+238",
    e: "🇨🇻"
  },
  {
    c: "+345",
    e: "🇰🇾"
  },
  {
    c: "+236",
    e: "🇨🇫"
  },
  {
    c: "+235",
    e: "🇹🇩"
  },
  {
    c: "+56",
    e: "🇨🇱"
  },
  {
    c: "+86",
    e: "🇨🇳"
  },
  {
    c: "+57",
    e: "🇨🇴"
  },
  {
    c: "+269",
    e: "🇰🇲"
  },
  {
    c: "+242",
    e: "🇨🇬"
  },
  {
    c: "+243",
    e: "🇨🇩"
  },
  {
    c: "+682",
    e: "🇨🇰"
  },
  {
    c: "+506",
    e: "🇨🇷"
  },
  {
    c: "+225",
    e: "🇨🇮"
  },
  {
    c: "+385",
    e: "🇭🇷"
  },
  {
    c: "+53",
    e: "🇨🇺"
  },
  {
    c: "+357",
    e: "🇨🇾"
  },
  {
    c: "+420",
    e: "🇨🇿"
  },
  {
    c: "+45",
    e: "🇩🇰"
  },
  {
    c: "+253",
    e: "🇩🇯"
  },
  {
    c: "+1767",
    e: "🇩🇲"
  },
  {
    c: "+1849",
    e: "🇩🇴"
  },
  {
    c: "+593",
    e: "🇪🇨"
  },
  {
    c: "+20",
    e: "🇪🇬"
  },
  {
    c: "+503",
    e: "🇸🇻"
  },
  {
    c: "+240",
    e: "🇬🇶"
  },
  {
    c: "+291",
    e: "🇪🇷"
  },
  {
    c: "+372",
    e: "🇪🇪"
  },
  {
    c: "+251",
    e: "🇪🇹"
  },
  {
    c: "+500",
    e: "🇫🇰"
  },
  {
    c: "+298",
    e: "🇫🇴"
  },
  {
    c: "+679",
    e: "🇫🇯"
  },
  {
    c: "+358",
    e: "🇫🇮"
  },
  {
    c: "+33",
    e: "🇫🇷"
  },
  {
    c: "+594",
    e: "🇬🇫"
  },
  {
    c: "+689",
    e: "🇵🇫"
  },
  {
    c: "+241",
    e: "🇬🇦"
  },
  {
    c: "+220",
    e: "🇬🇲"
  },
  {
    c: "+995",
    e: "🇬🇪"
  },
  {
    c: "+49",
    e: "🇩🇪"
  },
  {
    c: "+233",
    e: "🇬🇭"
  },
  {
    c: "+350",
    e: "🇬🇮"
  },
  {
    c: "+30",
    e: "🇬🇷"
  },
  {
    c: "+299",
    e: "🇬🇱"
  },
  {
    c: "+1473",
    e: "🇬🇩"
  },
  {
    c: "+590",
    e: "🇬🇵"
  },
  {
    c: "+1671",
    e: "🇬🇺"
  },
  {
    c: "+502",
    e: "🇬🇹"
  },
  {
    c: "+224",
    e: "🇬🇳"
  },
  {
    c: "+245",
    e: "🇬🇼"
  },
  {
    c: "+595",
    e: "🇬🇾"
  },
  {
    c: "+509",
    e: "🇭🇹"
  },
  {
    c: "+379",
    e: "🇻🇦"
  },
  {
    c: "+504",
    e: "🇭🇳"
  },
  {
    c: "+852",
    e: "🇭🇰"
  },
  {
    c: "+36",
    e: "🇭🇺"
  },
  {
    c: "+354",
    e: "🇮🇸"
  },
  {
    c: "+91",
    e: "🇮🇳"
  },
  {
    c: "+62",
    e: "🇮🇩"
  },
  {
    c: "+98",
    e: "🇮🇷"
  },
  {
    c: "+964",
    e: "🇮🇷"
  },
  {
    c: "+353",
    e: "🇮🇪"
  },
  {
    c: "+972",
    e: "🇮🇱"
  },
  {
    c: "+39",
    e: "🇮🇹"
  },
  {
    c: "+1876",
    e: "🇯🇲"
  },
  {
    c: "+81",
    e: "🇯🇵"
  },
  {
    c: "+962",
    e: "🇯🇴"
  },
  {
    c: "+77",
    e: "🇰🇿"
  },
  {
    c: "+254",
    e: "🇰🇪"
  },
  {
    c: "+686",
    e: "🇰🇮"
  },
  {
    c: "+850",
    e: "🇰🇵"
  },
  {
    c: "+82",
    e: "🇰🇷"
  },
  {
    c: "+965",
    e: "🇰🇼"
  },
  {
    c: "+996",
    e: "🇰🇬"
  },
  {
    c: "+856",
    e: "🇱🇦"
  },
  {
    c: "+371",
    e: "🇱🇻"
  },
  {
    c: "+961",
    e: "🇱🇧"
  },
  {
    c: "+266",
    e: "🇱🇸"
  },
  {
    c: "+231",
    e: "🇱🇷"
  },
  {
    c: "+218",
    e: "🇱🇾"
  },
  {
    c: "+423",
    e: "🇱🇮"
  },
  {
    c: "+370",
    e: "🇱🇹"
  },
  {
    c: "+352",
    e: "🇱🇺"
  },
  {
    c: "+853",
    e: "🇲🇴"
  },
  {
    c: "+389",
    e: "🇲🇰"
  },
  {
    c: "+261",
    e: "🇲🇬"
  },
  {
    c: "+265",
    e: "🇲🇼"
  },
  {
    c: "+60",
    e: "🇲🇾"
  },
  {
    c: "+960",
    e: "🇲🇻"
  },
  {
    c: "+223",
    e: "🇲🇱"
  },
  {
    c: "+356",
    e: "🇲🇹"
  },
  {
    c: "+692",
    e: "🇲🇭"
  },
  {
    c: "+596",
    e: "🇲🇶"
  },
  {
    c: "+222",
    e: "🇲🇷"
  },
  {
    c: "+230",
    e: "🇲🇺"
  },
  {
    c: "+262",
    e: "🇾🇹"
  },
  {
    c: "+52",
    e: "🇲🇽"
  },
  {
    c: "+691",
    e: "🇫🇲"
  },
  {
    c: "+373",
    e: "🇲🇩"
  },
  {
    c: "+377",
    e: "🇲🇨"
  },
  {
    c: "+976",
    e: "🇲🇳"
  },
  {
    c: "+382",
    e: "🇲🇪"
  },
  {
    c: "+1664",
    e: "🇲🇸"
  },
  {
    c: "+212",
    e: "🇲🇦"
  },
  {
    c: "+258",
    e: "🇲🇿"
  },
  {
    c: "+95",
    e: "🇲🇲"
  },
  {
    c: "+264",
    e: "🇳🇦"
  },
  {
    c: "+674",
    e: "🇳🇷"
  },
  {
    c: "+977",
    e: "🇳🇵"
  },
  {
    c: "+31",
    e: "🇳🇱"
  },
  {
    c: "+599",
    e: "🇧🇶"
  },
  {
    c: "+687",
    e: "🇳🇨"
  },
  {
    c: "+64",
    e: "🇳🇿"
  },
  {
    c: "+505",
    e: "🇳🇮"
  },
  {
    c: "+227",
    e: "🇳🇪"
  },
  {
    c: "+234",
    e: "🇳🇬"
  },
  {
    c: "+683",
    e: "🇳🇺"
  },
  {
    c: "+1670",
    e: "🇲🇵"
  },
  {
    c: "+47",
    e: "🇳🇴"
  },
  {
    c: "+968",
    e: "🇴🇲"
  },
  {
    c: "+92",
    e: "🇵🇰"
  },
  {
    c: "+680",
    e: "🇵🇼"
  },
  {
    c: "+970",
    e: "🇵🇸"
  },
  {
    c: "+507",
    e: "🇵🇦"
  },
  {
    c: "+675",
    e: "🇵🇬"
  },
  {
    c: "+51",
    e: "🇵🇪"
  },
  {
    c: "+63",
    e: "🇵🇭"
  },
  {
    c: "+872",
    e: "🇵🇳"
  },
  {
    c: "+48",
    e: "🇵🇱"
  },
  {
    c: "+351",
    e: "🇵🇹"
  },
  {
    c: "+1939",
    e: "🇵🇷"
  },
  {
    c: "+974",
    e: "🇶🇦"
  },
  {
    c: "+40",
    e: "🇷🇴"
  },
  {
    c: "+7",
    e: "🇷🇺"
  },
  {
    c: "+250",
    e: "🇷🇼"
  },
  {
    c: "+290",
    e: "🇸🇭"
  },
  {
    c: "+1869",
    e: "🇰🇳"
  },
  {
    c: "+1758",
    e: "🇱🇨"
  },
  {
    c: "+508",
    e: "🇵🇲"
  },
  {
    c: "+1784",
    e: "🇻🇨"
  },
  {
    c: "+685",
    e: "🇼🇸"
  },
  {
    c: "+378",
    e: "🇸🇲"
  },
  {
    c: "+239",
    e: "🇸🇹"
  },
  {
    c: "+966",
    e: "🇸🇦"
  },
  {
    c: "+221",
    e: "🇸🇳"
  },
  {
    c: "+381",
    e: "🇷🇸"
  },
  {
    c: "+248",
    e: "🇸🇨"
  },
  {
    c: "+232",
    e: "🇸🇱"
  },
  {
    c: "+65",
    e: "🇸🇬"
  },
  {
    c: "+421",
    e: "🇸🇰"
  },
  {
    c: "+386",
    e: "🇸🇮"
  },
  {
    c: "+677",
    e: "🇸🇧"
  },
  {
    c: "+252",
    e: "🇸🇴"
  },
  {
    c: "+27",
    e: "🇿🇦"
  },
  {
    c: "+211",
    e: "🇸🇸"
  },
  {
    c: "+34",
    e: "🇪🇸"
  },
  {
    c: "+94",
    e: "🇱🇰"
  },
  {
    c: "+249",
    e: "🇸🇩"
  },
  {
    c: "+597",
    e: "🇸🇷"
  },
  {
    c: "+268",
    e: "🇸🇿"
  },
  {
    c: "+46",
    e: "🇸🇪"
  },
  {
    c: "+41",
    e: "🇨🇭"
  },
  {
    c: "+963",
    e: "🇸🇾"
  },
  {
    c: "+886",
    e: "🇹🇼"
  },
  {
    c: "+992",
    e: "🇹🇯"
  },
  {
    c: "+255",
    e: "🇹🇿"
  },
  {
    c: "+66",
    e: "🇹🇭"
  },
  {
    c: "+670",
    e: "🇹🇱"
  },
  {
    c: "+228",
    e: "🇹🇬"
  },
  {
    c: "+690",
    e: "🇹🇰"
  },
  {
    c: "+676",
    e: "🇹🇴"
  },
  {
    c: "+1868",
    e: "🇹🇹"
  },
  {
    c: "+216",
    e: "🇹🇳"
  },
  {
    c: "+90",
    e: "🇹🇷"
  },
  {
    c: "+993",
    e: "🇹🇲"
  },
  {
    c: "+1649",
    e: "🇹🇨"
  },
  {
    c: "+688",
    e: "🇹🇻"
  },
  {
    c: "+256",
    e: "🇺🇬"
  },
  {
    c: "+380",
    e: "🇺🇦"
  },
  {
    c: "+971",
    e: "🇦🇪"
  },
  {
    c: "+44",
    e: "🇬🇧"
  },
  {
    c: "+1",
    e: "🇺🇸"
  },
  {
    c: "+598",
    e: "🇺🇾"
  },
  {
    c: "+998",
    e: "🇺🇿"
  },
  {
    c: "+678",
    e: "🇻🇺"
  },
  {
    c: "+58",
    e: "🇻🇪"
  },
  {
    c: "+84",
    e: "🇻🇳"
  },
  {
    c: "+1284",
    e: "🇻🇬"
  },
  {
    c: "+1340",
    e: "🇻🇮"
  },
  {
    c: "+681",
    e: "🇼🇫"
  },
  {
    c: "+967",
    e: "🇾🇪"
  },
  {
    c: "+260",
    e: "🇿🇲"
  },
  {
    c: "+263",
    e: "🇿🇼"
  }
], Gk = { class: "hako-tele-input" }, Kk = { class: "d-flex" }, Qk = { class: "code-input" }, Xk = ["value"], Zk = { class: "number-input flex-fill" }, Jk = /* @__PURE__ */ X({
  inheritAttrs: !1,
  __name: "TeleInput",
  props: {
    modelValue: {
      type: String,
      required: !0
    },
    isInvalid: {
      type: Boolean,
      default: null
    }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: i }) {
    const r = t, l = i, a = q(""), u = q(""), s = q(!1);
    an(() => r.modelValue, () => {
      if (r.modelValue === null || typeof r.modelValue > "u") {
        l("update:modelValue", "");
        return;
      }
      g(r.modelValue), s.value || T();
    }), vn(() => {
      if (r.modelValue === null || typeof r.modelValue > "u") {
        l("update:modelValue", "");
        return;
      }
      g(r.modelValue);
    }), an([a, u], () => {
      let E = a.value + u.value;
      u.value == "" && (E = ""), l("update:modelValue", E);
    });
    const h = (E) => {
      const O = Qi.orderBy(Iu, (I) => I.c.length, "desc").map((I) => I.c);
      let C = "";
      for (const I of O) {
        const M = I.length;
        if ((E == null ? void 0 : E.substring(0, M)) == I) {
          C = I;
          break;
        }
      }
      return C;
    }, g = (E) => {
      let O = h(E);
      O == "" && (O = "+358"), a.value = O, u.value = E.replace(O, "");
    }, T = (E = !0) => {
      s.value = !1;
      const O = u.value;
      if (O[0] == "+" && E) {
        const C = h(O);
        C != "" && (a.value = C, u.value = O.replace(C, ""));
      } else
        O[0] == "0" && (u.value = O.substring(1));
      u.value = u.value.trim();
    }, k = j(() => Qi.sortBy(Iu, (E) => parseInt(E.c.replace("+", "")))), S = j(() => {
      const E = [];
      return r.isInvalid === !1 ? E.push("is-valid") : r.isInvalid === !0 && E.push("is-invalid"), E;
    });
    return (E, O) => (v(), b("div", Gk, [
      y("div", Kk, [
        y("div", Qk, [
          Ne(y("select", {
            class: z(["form-select", S.value]),
            "onUpdate:modelValue": O[0] || (O[0] = (C) => a.value = C)
          }, [
            (v(!0), b(he, null, Se(k.value, (C) => (v(), b("option", {
              key: C.c,
              value: C.c
            }, F(C.e) + " " + F(C.c), 9, Xk))), 128))
          ], 2), [
            [Ru, a.value]
          ])
        ]),
        y("div", Zk, [
          H(Sr, ht(E.$attrs, {
            "is-invalid": t.isInvalid,
            modelValue: u.value,
            "onUpdate:modelValue": O[1] || (O[1] = (C) => u.value = C),
            onBlur: T,
            onFocus: O[2] || (O[2] = (C) => s.value = !0)
          }), null, 16, ["is-invalid", "modelValue"])
        ])
      ])
    ]));
  }
}), jk = async () => new Promise((t, i) => {
  window.setTimeout(() => {
    t();
  }, 4e3);
}), Ia = [
  {
    command: "klo",
    create: async (t) => {
      const i = /* @__PURE__ */ new Date(), r = i.getHours() < 10 ? "0" + i.getHours() : i.getHours().toString(), l = i.getMinutes() < 10 ? "0" + i.getMinutes() : i.getMinutes().toString();
      return `${r}:${l}`;
    }
  },
  {
    command: "pvm",
    create: async () => {
      const t = /* @__PURE__ */ new Date();
      return `${t.getDate()}.${t.getMonth() + 1}.${t.getFullYear()}`;
    }
  },
  {
    command: "ytunnus:$1",
    variableName: "Yrityksen nimi",
    create: async (t, i) => (i.toLowerCase().trim() == "hakosalo oy" && (await jk(), i = "3007168-6"), i)
  }
], N_ = (t) => Ia.push(t);
var cc = { exports: {} };
(function(t) {
  (function() {
    var i = [
      "direction",
      // RTL support
      "boxSizing",
      "width",
      // on Chrome and IE, exclude the scrollbar, so the mirror div wraps exactly as the textarea does
      "height",
      "overflowX",
      "overflowY",
      // copy the scrollbar for IE
      "borderTopWidth",
      "borderRightWidth",
      "borderBottomWidth",
      "borderLeftWidth",
      "borderStyle",
      "paddingTop",
      "paddingRight",
      "paddingBottom",
      "paddingLeft",
      // https://developer.mozilla.org/en-US/docs/Web/CSS/font
      "fontStyle",
      "fontVariant",
      "fontWeight",
      "fontStretch",
      "fontSize",
      "fontSizeAdjust",
      "lineHeight",
      "fontFamily",
      "textAlign",
      "textTransform",
      "textIndent",
      "textDecoration",
      // might not make a difference, but better be safe
      "letterSpacing",
      "wordSpacing",
      "tabSize",
      "MozTabSize"
    ], r = typeof window < "u", l = r && window.mozInnerScreenX != null;
    function a(u, s, h) {
      if (!r)
        throw new Error("textarea-caret-position#getCaretCoordinates should only be called in a browser");
      var g = h && h.debug || !1;
      if (g) {
        var T = document.querySelector("#input-textarea-caret-position-mirror-div");
        T && T.parentNode.removeChild(T);
      }
      var k = document.createElement("div");
      k.id = "input-textarea-caret-position-mirror-div", document.body.appendChild(k);
      var S = k.style, E = window.getComputedStyle ? window.getComputedStyle(u) : u.currentStyle, O = u.nodeName === "INPUT";
      S.whiteSpace = "pre-wrap", O || (S.wordWrap = "break-word"), S.position = "absolute", g || (S.visibility = "hidden"), i.forEach(function(M) {
        O && M === "lineHeight" ? S.lineHeight = E.height : S[M] = E[M];
      }), l ? u.scrollHeight > parseInt(E.height) && (S.overflowY = "scroll") : S.overflow = "hidden", k.textContent = u.value.substring(0, s), O && (k.textContent = k.textContent.replace(/\s/g, " "));
      var C = document.createElement("span");
      C.textContent = u.value.substring(s) || ".", k.appendChild(C);
      var I = {
        top: C.offsetTop + parseInt(E.borderTopWidth),
        left: C.offsetLeft + parseInt(E.borderLeftWidth),
        height: parseInt(E.lineHeight)
      };
      return g ? C.style.backgroundColor = "#aaa" : document.body.removeChild(k), I;
    }
    t.exports = a;
  })();
})(cc);
var eC = cc.exports;
const Sa = /* @__PURE__ */ V1(eC), tC = X({
  components: {
    Spinner: Gn
  },
  props: {
    modelValue: {
      type: String,
      required: !0
    }
  },
  setup(t, i) {
    const r = q(null), l = q(null);
    zn(() => {
      l.value = r.value.querySelector("textarea,input[type='text']"), l.value.addEventListener("blur", T), l.value.addEventListener("focus", T), l.value.addEventListener("keydown", T);
    }), qn(() => {
      var O, C, I;
      (O = l.value) == null || O.removeEventListener("blur", T), (C = l.value) == null || C.removeEventListener("focus", T), (I = l.value) == null || I.removeEventListener("keydown", T);
    });
    const a = q({ top: 0, left: 0, height: 0 }), u = q(!1), s = q(""), h = q([]), g = async () => {
      const O = l.value;
      if (O == null) {
        console.warn("RunMacro: HTML Element is null");
        return;
      }
      a.value = Sa(O, O.selectionEnd);
      for (const C of Ia) {
        let I = `\\[\\=${C.command}\\]`;
        I = I.replace("$1", "(.+)");
        const M = new RegExp(I);
        if (M.test(t.modelValue)) {
          const R = M.exec(t.modelValue);
          if (R) {
            let ee = R[1];
            if (typeof ee > "u" && (ee = ""), h.value.some((Ie) => Ie.matchName == R[0]))
              return;
            h.value.push({
              matchName: R[0],
              start: Sa(
                O,
                t.modelValue.indexOf(R[0])
              ),
              end: Sa(
                O,
                t.modelValue.indexOf(R[0]) + R[0].length
              )
            });
            const U = await C.create(R[0], ee), de = O.selectionStart, ue = t.modelValue.replace(R[0], U);
            i.emit("update:modelValue", ue), h.value = h.value.filter((Ie) => Ie.matchName != R[0]), $t(() => {
              O.selectionStart = de - R[0].length + U.length, O.selectionEnd = O.selectionStart;
            });
            break;
          }
        }
      }
    }, T = () => {
      const O = l.value;
      if (O == null) {
        console.warn("CheckIntellisense: HtmlElement is null");
        return;
      }
      const C = O == document.activeElement;
      if (u.value = !1, !C)
        return;
      const I = t.modelValue.lastIndexOf("]"), M = t.modelValue.substring(I, O.selectionStart);
      t.modelValue.substring(O.selectionStart), M.includes("[=") && (u.value = !0, s.value = M.split("[=")[1]);
    };
    an(() => t.modelValue, () => {
      T(), g();
    });
    const k = j(() => ({
      top: a.value.top + a.value.height + "px",
      left: a.value.left + "px"
    })), S = (O) => {
      const C = {
        top: "0",
        left: "0",
        width: "0",
        height: "0"
      };
      return C.top = O.start.top + "px", C.left = O.start.left + "px", C.width = O.end.left - O.start.left + "px", C.height = O.start.height + "px", C;
    }, E = j(() => {
      let O = s.value.toLowerCase();
      O = O.split(":", 1)[0];
      const C = Ia.filter((I) => {
        let M = O + ".*";
        return M = M, new RegExp(M).test(I.command);
      });
      return C.forEach((I) => {
        I.uiCommand = I.command, I.variableName && (I.uiCommand = I.command.replace("$1", I.variableName));
      }), C;
    });
    return {
      root: r,
      caretPositionStyle: k,
      showIntellisense: u,
      filteredMacroDefinitions: E,
      processingMacros: h,
      processingMacroStyle: S
    };
  }
  // data() { return {
  // 	myElement: null as HTMLTextAreaElement|HTMLInputElement|null
  // }},
  // mounted() {
  // 	const slot = this.$slots.default as any;
  // 	this.myElement = slot()[0];
  // 	const modelValue = ref<string>(this.modelValue);
  // 	TextMacroer.make(this.modelValue)
  // }
}), nC = {
  class: "hakosalo-text-macro-container",
  ref: "root"
};
function rC(t, i, r, l, a, u) {
  const s = ye("Spinner");
  return v(), b("div", nC, [
    J(t.$slots, "default"),
    t.showIntellisense && t.filteredMacroDefinitions.length > 0 ? (v(), b("div", {
      key: 0,
      class: "intellisense",
      style: fe(t.caretPositionStyle)
    }, [
      (v(!0), b(he, null, Se(t.filteredMacroDefinitions, (h) => (v(), b("div", {
        key: h.command,
        class: "intellisense-option"
      }, [
        y("code", null, F(h.uiCommand), 1)
      ]))), 128))
    ], 4)) : W("", !0),
    (v(!0), b(he, null, Se(t.processingMacros, (h) => (v(), b("div", {
      class: "processing-macro",
      style: fe(t.processingMacroStyle(h)),
      key: h.matchName
    }, [
      H(s, {
        size: 1,
        theme: "light",
        center: ""
      })
    ], 4))), 128))
  ], 512);
}
const iC = /* @__PURE__ */ ge(tC, [["render", rC]]), oC = X({
  props: {
    theme: {
      type: String,
      default: "primary"
    },
    modelValue: {
      type: Boolean,
      required: !0
    },
    text: {
      type: String,
      required: !0
    }
  },
  computed: {
    myStyling() {
      const t = {};
      return this.modelValue && (t["border-color"] = l0[this.theme].color), t;
    }
  },
  methods: {
    onClick() {
      this.$emit("selected"), this.$emit("update:modelValue", !this.modelValue);
    }
  }
}), aC = { class: "d-flex align-items-center" }, sC = { class: "flex-fill" };
function lC(t, i, r, l, a, u) {
  return v(), b("div", {
    class: "hakosalo-fancy-toggle",
    style: fe(t.myStyling),
    onClick: i[0] || (i[0] = ne((...s) => t.onClick && t.onClick(...s), ["prevent"]))
  }, [
    y("div", aC, [
      y("span", sC, F(t.text), 1)
    ])
  ], 4);
}
const dc = /* @__PURE__ */ ge(oC, [["render", lC]]), uC = X({
  components: {
    FancyToggle: dc
  },
  props: {
    theme: {
      type: String,
      default: "primary"
    },
    options: {
      type: Array,
      required: !0
    },
    modelValue: {
      required: !0
    },
    allowDeselect: {
      type: Boolean,
      default: !1
    }
  },
  methods: {
    selectedOption(t) {
      this.modelValue == t.value && this.allowDeselect ? this.$emit("update:modelValue", null) : this.$emit("update:modelValue", t.value);
    }
  }
}), cC = { class: "hakosalo-fancy-radio" }, dC = { class: "row row-cols-sm-auto align-items-stretch" };
function fC(t, i, r, l, a, u) {
  const s = ye("FancyToggle");
  return v(), b("div", cC, [
    y("div", dC, [
      (v(!0), b(he, null, Se(t.options, (h) => (v(), b("div", {
        class: "col-sm",
        key: h.value + h.text
      }, [
        H(s, {
          theme: t.theme,
          "model-value": t.modelValue == h.value,
          text: h.text,
          onSelected: (g) => t.selectedOption(h)
        }, null, 8, ["theme", "model-value", "text", "onSelected"])
      ]))), 128))
    ])
  ]);
}
const hC = /* @__PURE__ */ ge(uC, [["render", fC]]), fc = {
  modelValue: {
    type: [String, Number, Boolean, Object],
    required: !1
  },
  value: {
    type: [String, Number, Boolean, Object],
    default: !0
  },
  for: {
    type: String,
    default: null
  },
  inline: {
    type: Boolean,
    default: !1
  },
  useCheckmark: {
    type: Boolean,
    default: !1
  },
  disabled: {
    type: Boolean,
    default: !1
  }
}, hc = ["update:modelValue"];
function pc(t, i, r) {
  const l = q("");
  vn(() => {
    l.value = (t == "radio" ? "radio" : "chkbox") + "_" + mn();
  });
  const a = j(() => i.for != null ? i.for : l.value), u = j({
    get() {
      return i.modelValue;
    },
    set(h) {
      r.emit("update:modelValue", h);
    }
  }), s = j(() => {
    const h = ["form-check"];
    return i.inline && h.push("form-check-inline"), i.useCheckmark && h.push("ps-0"), h;
  });
  return {
    generatedFor: l,
    onBeforeMount: vn,
    myFor: a,
    myValue: u,
    rootClasses: s
  };
}
const pC = /* @__PURE__ */ X({
  __name: "CheckMark",
  props: {
    modelValue: {
      type: Boolean,
      default: !0
    },
    /** Checkmark size, by default 1 (em). 1 em should be equivalent to
    * normal text size inside the container.
    */
    size: {
      type: Number,
      default: 1
    },
    /** Size Unit, by default 'em', could be eg. "px".
    	* Note: Percentage (%) does not work well.
    	* */
    sizeUnit: {
      type: String,
      default: "em"
    },
    /** Fits inside the container while keeping 1:1 aspect ratio.
    * Uses javascript to calculate the width and height.
    */
    fitToContainer: {
      type: Boolean,
      default: !1
    },
    readonly: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: i }) {
    const r = i, l = t, a = q(null), u = () => {
      var I;
      const C = (I = h.value) == null ? void 0 : I.parentElement;
      l.fitToContainer && C && !a.value && (a.value = new ResizeObserver((M) => {
        S();
      }), a.value.observe(C));
    }, s = () => {
      a.value && a.value.disconnect();
    };
    zn(() => {
      u(), S();
    }), qn(() => {
      s();
    }), an(() => l.fitToContainer, () => {
      l.fitToContainer ? u() : s();
    });
    const h = q(null), g = j(() => {
      const C = [];
      return l.modelValue && C.push("active"), C;
    }), T = q(0), k = j(() => {
      const C = {};
      return C.width = l.size + l.sizeUnit, C.height = l.size + l.sizeUnit, l.fitToContainer && (C.width = T.value + "px", C.height = T.value + "px"), l.readonly || (C.cursor = "pointer"), C;
    }), S = () => {
      var I;
      const C = (I = h.value) == null ? void 0 : I.parentElement;
      if (C) {
        const M = C.clientHeight, R = C.clientWidth;
        let ee = M > R ? R : M;
        T.value = ee;
      }
    }, E = j(() => {
      const C = {};
      return C["font-size"] = (l.size * 0.75).toString().replace(",", ".") + l.sizeUnit, l.fitToContainer && (C["font-size"] = Math.round(T.value * 0.75) + "px"), C;
    }), O = () => {
      l.readonly || r("update:modelValue", !l.modelValue);
    };
    return (C, I) => (v(), b("div", {
      class: z(["hako-checkmark", g.value]),
      ref_key: "rootElem",
      ref: h,
      style: fe(k.value),
      onClick: ne(O, ["prevent"])
    }, [
      H(ft, null, {
        default: Z(() => [
          t.modelValue ? (v(), b("i", {
            key: 0,
            style: fe(E.value),
            class: "bi bi-check-lg"
          }, null, 4)) : W("", !0)
        ]),
        _: 1
      })
    ], 6));
  }
}), vC = X({
  components: { Checkmark: pC },
  props: { ...fc },
  emits: [...hc],
  inheritAttrs: !1,
  setup(t, i) {
    const {
      myFor: r,
      myValue: l,
      rootClasses: a
    } = pc("checkbox", t, i), u = j({
      get() {
        return Array.isArray(l.value) ? l.value.includes(t.value) : !!l.value;
      },
      set(s) {
        let h = t.modelValue;
        Array.isArray(h) ? h.includes(t.value) ? h = h.filter((g) => g != t.value) : h.push(t.value) : h = !h, i.emit("update:modelValue", h);
      }
    });
    return {
      myFor: r,
      myValue: l,
      rootClasses: a,
      isCheckmarkChecked: u
    };
  }
}), mC = ["value", "id", "disabled"], gC = ["for"];
function yC(t, i, r, l, a, u) {
  const s = ye("Checkmark");
  return v(), b("div", {
    class: z(t.rootClasses)
  }, [
    t.useCheckmark ? (v(), le(s, ht({
      key: 1,
      class: "me-2",
      readonly: t.disabled,
      modelValue: t.isCheckmarkChecked,
      "onUpdate:modelValue": i[1] || (i[1] = (h) => t.isCheckmarkChecked = h)
    }, t.$attrs), null, 16, ["readonly", "modelValue"])) : Ne((v(), b("input", ht({
      key: 0,
      class: "form-check-input",
      type: "checkbox",
      value: t.value,
      id: t.myFor,
      disabled: t.disabled,
      "onUpdate:modelValue": i[0] || (i[0] = (h) => t.myValue = h)
    }, t.$attrs), null, 16, mC)), [
      [Xi, t.myValue]
    ]),
    y("label", {
      class: "form-check-label",
      for: t.myFor
    }, [
      J(t.$slots, "default")
    ], 8, gC)
  ], 2);
}
const vc = /* @__PURE__ */ ge(vC, [["render", yC]]), wC = X({
  props: { ...fc },
  emits: [...hc],
  inheritAttrs: !1,
  setup(t, i) {
    const {
      myFor: r,
      myValue: l,
      rootClasses: a
    } = pc("radio", t, i);
    return {
      myFor: r,
      myValue: l,
      rootClasses: a
    };
  }
}), bC = ["value", "id", "disabled"], kC = ["for"];
function CC(t, i, r, l, a, u) {
  return v(), b("div", {
    class: z(t.rootClasses)
  }, [
    Ne(y("input", ht({
      class: "form-check-input",
      type: "radio",
      value: t.value,
      id: t.myFor,
      disabled: t.disabled,
      "onUpdate:modelValue": i[0] || (i[0] = (s) => t.myValue = s)
    }, t.$attrs), null, 16, bC), [
      [Fu, t.myValue]
    ]),
    y("label", {
      class: "form-check-label",
      for: t.myFor
    }, [
      J(t.$slots, "default")
    ], 8, kC)
  ], 2);
}
const $C = /* @__PURE__ */ ge(wC, [["render", CC]]);
function mc(t, i = 2) {
  if (!+t)
    return "0 Bytes";
  if (t < 1024)
    return "~1 KiB";
  const r = 1024, l = i < 0 ? 0 : i, a = ["Bytes", "KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"], u = Math.floor(Math.log(t) / Math.log(r));
  return `${parseFloat((t / Math.pow(r, u)).toFixed(l))} ${a[u]}`;
}
const _C = {
  key: 0,
  class: "row"
}, TC = { class: "col-1 checkbox-col" }, SC = {
  key: 0,
  class: "col-4 name-col"
}, OC = { class: "col filesize-col text-end" }, MC = {
  key: 1,
  class: "mobile-container"
}, AC = { class: "checkbox" }, DC = { class: "fw-bold filename" }, IC = { class: "filename-value" }, EC = /* @__PURE__ */ y("div", { class: "fw-bold" }, "Nimi:", -1), BC = /* @__PURE__ */ X({
  __name: "FilePickerItem",
  props: {
    pickerFile: {
      type: Object,
      required: !0
    },
    showNameInput: {
      type: Boolean,
      default: !0
    },
    isMobile: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["is-checked", "set-name"],
  setup(t, { emit: i }) {
    const r = i, l = t, a = j(() => mc(l.pickerFile.file.size, 1)), u = j({
      get() {
        return l.pickerFile.isChecked;
      },
      set() {
        r("is-checked", !l.pickerFile.isChecked);
      }
    }), s = j({
      get() {
        return l.pickerFile.name;
      },
      set(h) {
        r("set-name", h);
      }
    });
    return (h, g) => (v(), b("div", {
      class: z(["hakosalo-filepicker-item", { "is-mobile": t.isMobile, "is-unchecked": !u.value }])
    }, [
      t.isMobile ? (v(), b("div", MC, [
        y("div", AC, [
          H(vc, {
            modelValue: u.value,
            "onUpdate:modelValue": g[2] || (g[2] = (T) => u.value = T)
          }, null, 8, ["modelValue"])
        ]),
        y("div", null, [
          y("div", DC, "Tiedosto (" + F(a.value) + "):", 1),
          y("div", IC, F(t.pickerFile.file.name), 1)
        ]),
        y("div", null, [
          EC,
          y("div", null, [
            H(Sr, {
              sm: "",
              modelValue: s.value,
              "onUpdate:modelValue": g[3] || (g[3] = (T) => s.value = T),
              disabled: !u.value
            }, null, 8, ["modelValue", "disabled"])
          ])
        ])
      ])) : (v(), b("div", _C, [
        y("div", TC, [
          Ne(y("input", {
            type: "checkbox",
            "onUpdate:modelValue": g[0] || (g[0] = (T) => u.value = T)
          }, null, 512), [
            [Xi, u.value]
          ])
        ]),
        y("div", {
          class: z(["col-4 filename-col", { unchecked: !u.value }])
        }, [
          y("span", null, F(t.pickerFile.file.name), 1)
        ], 2),
        t.showNameInput ? (v(), b("div", SC, [
          H(Sr, {
            sm: "",
            modelValue: s.value,
            "onUpdate:modelValue": g[1] || (g[1] = (T) => s.value = T),
            disabled: !u.value
          }, null, 8, ["modelValue", "disabled"])
        ])) : W("", !0),
        y("div", OC, [
          y("span", null, F(a.value), 1)
        ])
      ]))
    ], 2));
  }
}), xC = q(0), VC = () => --xC.value;
var Qr = /* @__PURE__ */ ((t) => (t.IdenticalFile = "IdenticalFile", t.NoExtension = "NoExtension", t.NotAllowedExtension = "NotAllowedExtension", t.ExceedsMaxFileSize = "ExceesMaxFileSize", t))(Qr || {});
const PC = { class: "help" }, LC = {
  key: 0,
  class: "row filelist-heading-row"
}, RC = /* @__PURE__ */ y("div", { class: "col-1" }, [
  /* @__PURE__ */ y("span")
], -1), FC = { class: "col-4" }, WC = {
  key: 0,
  class: "col-4"
}, HC = { class: "col text-end" }, UC = {
  key: 1,
  class: "file-list-placeholder d-flex align-items-center justify-content-center"
}, NC = /* @__PURE__ */ X({
  __name: "FilePicker",
  props: {
    modelValue: {
      type: Array,
      required: !0
    },
    showNameInput: {
      type: Boolean,
      default: !0
    },
    allowedFileExtensions: {
      type: Array,
      default: null
    },
    maxFileSize: {
      type: Number,
      default: () => 5 * 1024 * 1024
    },
    noDragAndDrop: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue", "file-add-fail"],
  setup(t, { emit: i }) {
    st.components.inputs.filePicker = {
      texts: {
        addFile: {
          fi: "Lisää tiedosto",
          sv: "Lägg till fil",
          en: "Add file"
        },
        originalFilename: {
          fi: "Alkuperäinen tiedostonimi",
          en: "Original filename",
          sv: "Originalt filnamn"
        },
        name: {
          fi: "Nimi",
          sv: "Namn",
          en: "Name"
        },
        filesize: {
          fi: "Tiedostokoko",
          sv: "Filstorlek",
          en: "File size"
        },
        dropFileHeader: {
          fi: "Pudota tiedosto(t) tähän!",
          en: "Drop file(s) here!",
          sv: "Släpp fil(er) här"
        },
        dropFileText: {
          fi: 'Käytä "Lisää tiedosto"-painiketta tai raahaa tiedostoja tälle alueelle',
          en: 'Use the "Add file" button or drag files to this area',
          sv: 'Använd knappen "Lägg till fil" eller dra filer till det här området'
        },
        maxFileSizeText: {
          fi: "Yksittäisen tiedoston suurin sallittu koko on",
          en: "Maximum file size for one file is",
          sv: "Maximal filstorlek för en fil är"
        }
      }
    };
    const r = j(() => {
      var re;
      return gt((re = st.components.inputs.filePicker.texts) == null ? void 0 : re.addFile);
    }), l = j(() => {
      var re;
      return gt((re = st.components.inputs.filePicker.texts) == null ? void 0 : re.originalFilename);
    }), a = j(() => {
      var re;
      return gt((re = st.components.inputs.filePicker.texts) == null ? void 0 : re.name);
    }), u = j(() => {
      var re;
      return gt((re = st.components.inputs.filePicker.texts) == null ? void 0 : re.filesize);
    }), s = j(() => {
      var re;
      return gt((re = st.components.inputs.filePicker.texts) == null ? void 0 : re.dropFileHeader);
    }), h = j(() => {
      var re;
      return gt((re = st.components.inputs.filePicker.texts) == null ? void 0 : re.dropFileText);
    }), g = j(() => {
      var re;
      return gt((re = st.components.inputs.filePicker.texts) == null ? void 0 : re.maxFileSizeText);
    }), T = i, k = t, S = q(window.innerWidth);
    vn(() => {
      window.addEventListener("resize", E);
    }), qn(() => {
      window.removeEventListener("resize", E);
    });
    function E() {
      S.value = window.innerWidth;
    }
    const O = j(() => S.value <= 512), C = q(!1), I = (re) => {
      re.preventDefault(), C.value = !1;
    }, M = (re) => {
      C.value = !0;
    }, R = (re) => {
      C.value = !1;
    };
    vn(() => {
      window.addEventListener("dragstart", M), window.addEventListener("dragend", R), window.addEventListener("dragleave", R), window.addEventListener("dragover", M), window.addEventListener("drop", I);
    }), qn(() => {
      window.removeEventListener("dragstart", M), window.removeEventListener("dragend", R), window.removeEventListener("dragleave", R), window.removeEventListener("dragover", M), window.removeEventListener("drop", I);
    });
    const ee = q(!1), U = q(null), de = (re) => {
      if (!U.value.files)
        return;
      const xe = U.value.files[0];
      Ae(xe);
    }, ue = (re) => {
      var Le;
      ee.value = !1;
      const xe = [];
      (Le = re.dataTransfer) != null && Le.files && [...re.dataTransfer.files].forEach((be) => {
        xe.push(be);
      }), xe && Ze(xe);
    }, Ie = (re) => {
      const xe = re.lastIndexOf(".");
      return re.substring(0, xe);
    }, Ae = (re) => {
      Ze([re]);
    }, Ze = (re) => {
      const xe = re.map((be) => {
        const Tt = {};
        return Tt.id = VC(), Tt.isChecked = !0, Tt.file = be, Tt.name = Ie(be.name), Tt;
      });
      let Le = [...k.modelValue];
      xe.forEach((be) => {
        if (Le.some((De) => De.file.name == be.file.name && De.file.size == be.file.size && De.file.lastModified == be.file.lastModified)) {
          T("file-add-fail", Qr.IdenticalFile, be);
          return;
        }
        if (!be.file.name.includes(".")) {
          T("file-add-fail", Qr.NoExtension, be);
          return;
        }
        if (k.allowedFileExtensions != null) {
          const De = be.file.name.split(".");
          De.length == 0 && console.warn("File does not have extension: " + be.file.name);
          const Je = De[De.length - 1].toLowerCase();
          if (!k.allowedFileExtensions.map((yt) => yt.toLowerCase()).includes(Je)) {
            T("file-add-fail", Qr.NotAllowedExtension, be);
            return;
          }
        }
        if (be.file.size > k.maxFileSize) {
          T("file-add-fail", Qr.ExceedsMaxFileSize, be);
          return;
        }
        Le.push(be);
      }), T("update:modelValue", Le);
    }, pt = () => {
      U.value.click();
    };
    return (re, xe) => (v(), b("div", {
      class: z(["hakosalo-file-picker", { "is-mobile": O.value }])
    }, [
      y("div", {
        class: z(["toolbar align-items-center", { "d-flex": !O.value }])
      }, [
        H(At, {
          theme: "primary",
          "is-block": O.value,
          onClick: pt
        }, {
          default: Z(() => [
            H(He, { icon: "file-earmark-arrow-down-fill" }),
            Ke(" " + F(r.value), 1)
          ]),
          _: 1
        }, 8, ["is-block"]),
        y("div", PC, [
          y("div", null, F(g.value) + ": " + F(Lu(mc)(t.maxFileSize)), 1)
        ])
      ], 2),
      y("div", {
        class: z(["file-list", { "is-drag": ee.value, "mt-0": t.noDragAndDrop, "border-0": t.noDragAndDrop }]),
        onDrop: xe[0] || (xe[0] = ne((Le) => ue(Le), ["prevent"])),
        onDragover: xe[1] || (xe[1] = ne((Le) => ee.value = !0, ["prevent"])),
        onDragenter: xe[2] || (xe[2] = ne((Le) => ee.value = !0, ["prevent"])),
        onDragleave: xe[3] || (xe[3] = ne((Le) => ee.value = !1, ["prevent"]))
      }, [
        !O.value && t.modelValue && t.modelValue.length > 0 ? (v(), b("div", LC, [
          RC,
          y("div", FC, [
            y("span", null, F(l.value), 1)
          ]),
          t.showNameInput ? (v(), b("div", WC, [
            y("span", null, F(a.value), 1)
          ])) : W("", !0),
          y("div", HC, [
            y("span", null, F(u.value), 1)
          ])
        ])) : !O.value && !t.noDragAndDrop ? (v(), b("div", UC, [
          y("div", null, [
            y("h1", null, F(s.value), 1),
            y("p", null, F(h.value), 1)
          ])
        ])) : W("", !0),
        (v(!0), b(he, null, Se(t.modelValue, (Le) => (v(), le(BC, {
          "is-mobile": O.value,
          key: Le.file.name.toString() + Le.file.size.toString(),
          "picker-file": Le,
          "show-name-input": t.showNameInput,
          onIsChecked: (be) => Le.isChecked = be,
          onSetName: (be) => Le.name = be
        }, null, 8, ["is-mobile", "picker-file", "show-name-input", "onIsChecked", "onSetName"]))), 128))
      ], 34),
      y("input", {
        ref_key: "fileInput",
        ref: U,
        type: "file",
        hidden: "",
        onChange: xe[4] || (xe[4] = (Le) => de())
      }, null, 544)
    ], 2));
  }
}), Ha = {
  /**
  * Modal title. If you need special formatting, use slot '#title' and 
  * leave this empty.
  */
  title: {
    type: String,
    default: ""
  },
  /**
  * Modal size in BS fashion: "xs"|"sm"|"md"|"lg"|"xl"|"xxl"|"full".
  * Full doesn't have a max-width.
  */
  size: {
    type: String,
    default: "xl"
  },
  /**
  * When true, allow the user to close the modal by clicking outside.
  */
  closeFromShadow: {
    type: Boolean,
    default: !1
  },
  /**
  * When true, no [close] button is generated for the modal.
  */
  noCloseButton: {
    type: Boolean,
    default: !1
  },
  /**
  * When false, render a [action] button. Change action-button text 
  * with 'action-text' prop.
  */
  noActionButton: {
    type: Boolean,
    default: !0
  },
  /**
  * [action] button text.
  */
  actionText: {
    type: String,
    default: ""
  },
  /**
   * Disable [action] button.
   */
  actionButtonIsDisabled: {
    type: Boolean,
    default: !1
  },
  /**
   * Set [action] button to loading state (HakoButton)
   */
  actionButtonIsLoading: {
    type: Boolean,
    default: !1
  },
  /**
  * When true, shows [X] button on top-right corner.
  */
  showX: {
    type: Boolean,
    default: !1
  },
  /**
  * When true, no header is rendered (title, top buttons, X-button etc).
  */
  noHeader: {
    type: Boolean,
    default: !1
  },
  /**
  * When true, no footer is rendered (bottom buttons).
  */
  noFooter: {
    type: Boolean,
    default: !1
  }
}, zC = {
  ...Ha,
  /**
  * Whether modal is open or not.
  */
  modelValue: {
    type: Boolean,
    required: !0
  },
  slotIsModalContent: {
    type: Boolean,
    default: !1
  }
}, qC = { class: "hakosalo-modal-box" }, YC = { class: "d-md-flex gap-2 justify-content-start align-items-center top-bar" }, GC = { class: "d-flex align-items-center" }, KC = { key: 0 }, QC = { class: "flex-fill d-flex" }, XC = {
  key: 0,
  class: "d-flex justify-content-end w-100 gap-2"
}, ZC = {
  key: 0,
  ref: "mobileBtnContainer",
  class: "top-bar mt-4 d-flex justify-content-start"
}, JC = { class: "btns-on-grid" }, jC = { class: "modal-main" }, e$ = { key: 1 }, gc = /* @__PURE__ */ X({
  __name: "HakoModalContent",
  props: {
    ...Ha
  },
  emits: ["close", "onAction"],
  setup(t, { emit: i }) {
    const r = i, l = t, a = q(!1);
    function u() {
      let k = window.innerWidth;
      a.value = !1, k < 720 && (a.value = !0);
    }
    vn(() => {
      u(), window.addEventListener("resize", u);
    }), qn(() => {
      window.removeEventListener("resize", u);
    });
    const s = j(() => st.components.modalsAndWindows.hakoModal.texts), h = j(() => l.actionText != "" ? l.actionText : gt(s.value.actionDefault)), g = j(() => gt(s.value.cancel));
    function T() {
      r("close");
    }
    return (k, S) => (v(), b("div", qC, [
      k.noHeader ? W("", !0) : (v(), b("header", {
        key: 0,
        class: z({ "show-x": k.showX })
      }, [
        y("div", YC, [
          y("div", GC, [
            y("h1", null, [
              Ke(F(k.title) + " ", 1),
              k.title ? W("", !0) : (v(), b("span", KC, " ")),
              J(k.$slots, "title")
            ]),
            J(k.$slots, "after-title")
          ]),
          y("div", QC, [
            a.value ? W("", !0) : (v(), b("div", XC, [
              J(k.$slots, "header-buttons"),
              J(k.$slots, "modal-buttons"),
              k.noActionButton ? W("", !0) : (v(), le(At, {
                key: 0,
                theme: "primary",
                onClick: S[0] || (S[0] = ne((E) => k.$emit("onAction"), ["prevent"])),
                "is-loading": k.actionButtonIsLoading,
                disabled: k.actionButtonIsDisabled
              }, {
                default: Z(() => [
                  Ke(F(h.value), 1)
                ]),
                _: 1
              }, 8, ["is-loading", "disabled"])),
              k.noCloseButton ? W("", !0) : (v(), le(At, {
                key: 1,
                theme: "secondary",
                onClick: ne(T, ["prevent"])
              }, {
                default: Z(() => [
                  Ke(F(g.value), 1)
                ]),
                _: 1
              }))
            ]))
          ])
        ]),
        a.value ? (v(), b("div", ZC, [
          y("div", JC, [
            J(k.$slots, "header-buttons"),
            J(k.$slots, "modal-buttons"),
            k.noActionButton ? W("", !0) : (v(), le(At, {
              key: 0,
              theme: "primary",
              onClick: S[1] || (S[1] = ne((E) => k.$emit("onAction"), ["prevent"])),
              "is-loading": k.actionButtonIsLoading,
              disabled: k.actionButtonIsDisabled
            }, {
              default: Z(() => [
                Ke(F(h.value), 1)
              ]),
              _: 1
            }, 8, ["is-loading", "disabled"])),
            k.noCloseButton ? W("", !0) : (v(), le(At, {
              key: 1,
              theme: "secondary",
              onClick: ne(T, ["prevent"])
            }, {
              default: Z(() => [
                Ke(F(g.value), 1)
              ]),
              _: 1
            }))
          ])
        ], 512)) : W("", !0),
        k.showX ? (v(), b("button", {
          key: 1,
          type: "button",
          class: "close-btn",
          onClick: ne(T, ["prevent"])
        }, [
          H(He, { icon: "x-lg" })
        ])) : W("", !0),
        J(k.$slots, "header")
      ], 2)),
      y("div", jC, [
        J(k.$slots, "default")
      ]),
      k.noFooter ? W("", !0) : (v(), b("footer", e$, [
        J(k.$slots, "footer"),
        y("div", {
          class: z(["bottom-bar w-100", {
            "btns-on-grid": a.value,
            "d-flex": !a.value,
            "justify-content-end": !a.value
          }]),
          ref: "mobileBtnContainerBottom"
        }, [
          J(k.$slots, "footer-buttons"),
          J(k.$slots, "modal-buttons"),
          k.noActionButton ? W("", !0) : (v(), le(At, {
            key: 0,
            theme: "primary",
            onClick: S[2] || (S[2] = ne((E) => k.$emit("onAction"), ["prevent"])),
            "is-loading": k.actionButtonIsLoading,
            disabled: k.actionButtonIsDisabled
          }, {
            default: Z(() => [
              Ke(F(h.value), 1)
            ]),
            _: 1
          }, 8, ["is-loading", "disabled"])),
          k.noCloseButton ? W("", !0) : (v(), le(At, {
            key: 1,
            theme: "secondary",
            onClick: ne(T, ["prevent"])
          }, {
            default: Z(() => [
              Ke(F(g.value), 1)
            ]),
            _: 1
          }))
        ], 2),
        J(k.$slots, "footer-lower")
      ]))
    ]));
  }
});
st.components.modalsAndWindows.hakoModal = {
  texts: {
    actionDefault: {
      fi: "Tallenna",
      en: "Save",
      sv: "Spara"
    },
    cancel: {
      fi: "Peruuta",
      en: "Cancel",
      sv: "Avbryt"
    }
  }
};
const t$ = X({
  components: {
    BsIcon: He,
    HakoModalContent: gc
  },
  inheritAttrs: !1,
  props: {
    ...zC,
    modelValue: {
      type: Boolean,
      required: !0
    }
  },
  data() {
    return {
      isMobile: !1,
      myModelValue: !1,
      zIndex: 2e3
    };
  },
  watch: {
    modelValue() {
      this.myModelValue = this.modelValue, this.modelValue ? this.$nextTick(() => {
        this.zIndex = Da();
      }) : this.$emit("close"), this.checkIfModalsAreOpen();
    }
  },
  beforeMount() {
    this.checkIfMobile(), window.addEventListener("resize", this.checkIfMobile);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkIfMobile);
  },
  unmounted() {
    this.$emit("update:modelValue", !1), this.myModelValue = !1, this.checkIfModalsAreOpen();
  },
  computed: {
    // remove
    texts() {
      return st.components.modalsAndWindows.hakoModal.texts;
    },
    computedActionText() {
      return this.actionText != "" ? this.actionText : gt(this.texts.actionDefault);
    },
    computedCancelText() {
      return gt(this.texts.cancel);
    },
    modalClasses() {
      let t = [];
      return t.push(`size-${this.size}`), t;
    }
  },
  methods: {
    checkIfMobile() {
      let t = window.innerWidth;
      this.isMobile = !1, t < 720 && (this.isMobile = !0);
    },
    closeModal() {
      this.$emit("update:modelValue", !1);
    },
    onClickModalContainer(t) {
      const i = this.$refs.modalcontainer, r = t.target, l = "no-close-effect";
      r == i && (this.closeFromShadow ? this.closeModal() : (i.classList.add(l), window.setTimeout(() => {
        i.classList.remove(l);
      }, 220)));
    },
    checkIfModalsAreOpen() {
      const t = document.getElementsByClassName("hakosalo-modal").length;
      document.body.classList.remove("hakosalo-modal-open"), (t > 1 || this.myModelValue) && document.body.classList.add("hakosalo-modal-open");
    }
  }
}), n$ = /* @__PURE__ */ y("div", { class: "spacer" }, null, -1);
function r$(t, i, r, l, a, u) {
  const s = ye("HakoModalContent");
  return v(), b("div", null, [
    (v(), le(Yn, { to: "body" }, [
      H(ft, null, {
        default: Z(() => [
          t.myModelValue ? (v(), b("div", {
            key: 0,
            class: "hakosalo-modal-container",
            ref: "modalcontainer",
            style: fe({ "z-index": t.zIndex + 1 }),
            onClick: i[1] || (i[1] = (...h) => t.onClickModalContainer && t.onClickModalContainer(...h)),
            onClose: i[2] || (i[2] = (h) => t.$emit("update:modelValue", !1))
          }, [
            H(ft, null, {
              default: Z(() => [
                y("div", ht({
                  class: ["hakosalo-modal", t.modalClasses],
                  ref: "modal"
                }, t.$attrs), [
                  t.slotIsModalContent ? J(t.$slots, "default", { key: 0 }) : (v(), le(s, ht({ key: 1 }, t.$props, {
                    onClose: t.closeModal,
                    onOnAction: i[0] || (i[0] = (h) => t.$emit("onAction"))
                  }), {
                    title: Z(() => [
                      J(t.$slots, "title")
                    ]),
                    "after-title": Z(() => [
                      J(t.$slots, "after-title")
                    ]),
                    "header-buttons": Z(() => [
                      J(t.$slots, "header-buttons")
                    ]),
                    "modal-buttons": Z(() => [
                      J(t.$slots, "modal-buttons")
                    ]),
                    header: Z(() => [
                      J(t.$slots, "header")
                    ]),
                    footer: Z(() => [
                      J(t.$slots, "footer")
                    ]),
                    "footer-buttons": Z(() => [
                      J(t.$slots, "footer-buttons")
                    ]),
                    "footer-lower": Z(() => [
                      J(t.$slots, "footer-lower")
                    ]),
                    default: Z(() => [
                      J(t.$slots, "default")
                    ]),
                    _: 3
                  }, 16, ["onClose"])),
                  n$
                ], 16)
              ]),
              _: 3
            })
          ], 36)) : W("", !0)
        ]),
        _: 3
      }),
      H(ft, null, {
        default: Z(() => [
          t.modelValue ? (v(), b("div", {
            key: 0,
            class: "hakosalo-modal-shadow",
            ref: "shadow",
            style: fe({ "z-index": t.zIndex })
          }, null, 4)) : W("", !0)
        ]),
        _: 1
      })
    ]))
  ]);
}
const yc = /* @__PURE__ */ ge(t$, [["render", r$]]), Ea = {
  modals: q([]),
  create: function(t) {
    t.id || (t.id = mn()), t.componentEmits || (t.componentEmits = {}), t.componentOptions || (t.componentOptions = {});
    const i = t;
    i.isOpen = Ba({ value: !1 }), i.componentRef = Wu(i.component), this.modals.value.push(i), $t(() => {
      i.isOpen.value = !0;
    });
  },
  remove: function(t) {
    const i = this.modals.value.filter((r) => r.id === t)[0];
    i || console.warn("Cant find modal with ID: " + t), i.isOpen.value = !1, window.setTimeout(() => {
      this.modals.value = this.modals.value.filter((r) => r.id !== t);
    }, 333);
  }
}, i$ = /* @__PURE__ */ X({
  __name: "ModalVueManager",
  setup(t) {
    const i = j(() => Ea.modals.value), r = (s) => {
      const h = s.slotIsModalContent;
      return typeof h < "u" ? h : !0;
    }, l = (s) => ({
      ...a(s),
      ...s.componentOptions
    }), a = (s) => {
      const h = Object.keys(Ha), g = Object.keys(s);
      let T = {};
      return g.forEach((k) => {
        if (h.includes(k)) {
          const S = s[k];
          T[k] = S;
        }
      }), T;
    }, u = (s) => {
      Ea.remove(s.id);
    };
    return (s, h) => (v(!0), b(he, null, Se(i.value, (g, T) => (v(), le(yc, ht({
      key: g.id
    }, g, {
      modelValue: g.isOpen.value,
      "onUpdate:modelValue": (k) => g.isOpen.value = k,
      onClose: (k) => u(g),
      "data-modalid": g.id,
      slotIsModalContent: r(g)
    }), {
      default: Z(() => [
        (v(), le(Zi(g.componentRef), ht(l(g), Hu(g.componentEmits), {
          onClose: (k) => u(g)
        }), null, 16, ["onClose"]))
      ]),
      _: 2
    }, 1040, ["modelValue", "onUpdate:modelValue", "onClose", "data-modalid", "slotIsModalContent"]))), 128));
  }
}), Xr = {
  windows: q([]),
  //winState: ref({}) as Ref<{ [key:string]: boolean }>,
  create(t) {
    t.id || (t.id = mn()), t.componentEmits || (t.componentEmits = {}), t.componentOptions || (t.componentOptions = {});
    const i = t;
    i.isOpen = Ba({ value: !1 }), i.componentRef = Wu(i.component), this.windows.value.push(i), $t(() => {
      i.isOpen.value = !0;
    });
  },
  removeWindow(t) {
    const i = this.windows.value.filter((r) => r.id == t)[0];
    if (!i) {
      console.warn("Window does not exist with ID: " + t);
      return;
    }
    i.isOpen.value = !1, window.setTimeout(() => {
      this.windows.value = this.windows.value.filter((r) => r.id != t);
    }, 333);
  }
}, o$ = X({
  name: "HakoWindowVueManager",
  data() {
    return {
      intValId: -1
    };
  },
  components: {
    HakoWindow: Wa
  },
  computed: {
    windows() {
      return Xr.windows.value;
    }
  },
  mounted() {
    this.intValId = window.setInterval(() => {
      this.checkForOrphans();
    }, 5e3);
  },
  beforeUnmount() {
    window.clearInterval(this.intValId);
  },
  methods: {
    closeWindow(t) {
      Xr.removeWindow(t.id || "");
    },
    checkForOrphans() {
      const t = Xr.windows.value;
      for (const i of t)
        document.querySelector("#hw-" + i.id) || Xr.removeWindow(i.id || "");
    }
  }
});
function a$(t, i, r, l, a, u) {
  const s = ye("hako-window");
  return v(!0), b(he, null, Se(t.windows, (h) => (v(), le(s, ht({
    key: h.id
  }, h, {
    modelValue: h.isOpen.value,
    "onUpdate:modelValue": (g) => h.isOpen.value = g,
    onClose: (g) => t.closeWindow(h),
    "data-windowid": h.id
  }), {
    default: Z(() => [
      (v(), le(Zi(h.componentRef), ht(h.componentOptions, Hu(h.componentEmits), {
        onClose: (g) => t.closeWindow(h)
      }), null, 16, ["onClose"]))
    ]),
    _: 2
  }, 1040, ["modelValue", "onUpdate:modelValue", "onClose", "data-windowid"]))), 128);
}
const s$ = /* @__PURE__ */ ge(o$, [["render", a$]]), l$ = X({
  components: {
    Spinner: Gn
  },
  props: {
    modelValue: {
      type: Boolean,
      required: !0
    }
  },
  watch: {
    modelValue() {
      this.checkBlurEffect();
    }
  },
  mounted() {
    this.checkBlurEffect();
  },
  beforeUnmount() {
    document.body.classList.remove("hakopanel-open");
  },
  methods: {
    checkBlurEffect() {
      this.modelValue ? document.body.classList.add("hakopanel-open") : document.body.classList.remove("hakopanel-open");
    }
  }
}), u$ = {
  key: 0,
  class: "hakosalo-fullscreen-spinner"
}, c$ = { class: "centering d-flex justify-content-center align-items-center" }, d$ = { class: "inner d-flex align-items-center" }, f$ = { class: "content" };
function h$(t, i, r, l, a, u) {
  const s = ye("spinner");
  return v(), le(Yn, { to: "body" }, [
    H(ft, null, {
      default: Z(() => [
        t.modelValue ? (v(), b("div", u$, [
          y("div", c$, [
            H(ft, null, {
              default: Z(() => [
                y("div", d$, [
                  H(s, { class: "me-4" }),
                  y("div", f$, [
                    J(t.$slots, "default", {}, () => [
                      Ke(" Loading... ")
                    ])
                  ])
                ])
              ]),
              _: 3
            })
          ])
        ])) : W("", !0)
      ]),
      _: 3
    })
  ]);
}
const p$ = /* @__PURE__ */ ge(l$, [["render", h$]]), v$ = X({
  props: {
    modelValue: {
      type: Number,
      required: !0
    },
    theme: {
      type: String,
      default: "primary"
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    unit: {
      type: String,
      default: "%"
    },
    ariaLabel: {
      type: String,
      default: "Edistyminen / Progress"
    },
    striped: {
      type: Boolean,
      default: !0
    },
    animated: {
      type: Boolean,
      default: !0
    },
    xl: {
      type: Boolean,
      default: !1
    },
    hideLabel: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    widthStyle() {
      let t = {};
      return t.width = this.progressPercentage + "%", t;
    },
    progressBarClasses() {
      const t = [];
      return t.push("bg-" + this.theme), this.striped && (t.push("progress-bar-striped"), this.animated && t.push("progress-bar-animated")), t;
    },
    rootClasses() {
      const t = [];
      return this.xl && t.push("size-xl"), t;
    },
    progressPercentage() {
      return this.modelValue == 0 ? 0 : (this.modelValue - this.min) / this.max * 100;
    }
  }
}), m$ = {
  class: "progress",
  style: { height: "100%" }
}, g$ = ["aria-label", "aria-valuenow", "aria-valuemin", "aria-valuemax"];
function y$(t, i, r, l, a, u) {
  return v(), b("div", {
    class: z(["hakosalo-progressbar", t.rootClasses])
  }, [
    y("div", m$, [
      y("div", {
        class: z(["progress-bar", t.progressBarClasses]),
        style: fe(t.widthStyle),
        role: "progressbar",
        "aria-label": t.ariaLabel,
        "aria-valuenow": t.modelValue,
        "aria-valuemin": t.min,
        "aria-valuemax": t.max
      }, [
        t.hideLabel ? W("", !0) : J(t.$slots, "default", { key: 0 }, () => [
          y("span", null, F(t.modelValue) + F(t.unit), 1)
        ])
      ], 14, g$)
    ])
  ], 2);
}
const w$ = /* @__PURE__ */ ge(v$, [["render", y$]]), b$ = ["aria-expanded"], wc = /* @__PURE__ */ X({
  __name: "Dropdown",
  props: {
    /**
     * Default dropdown button text.
     */
    title: {
      type: String,
      default: ""
    },
    /**
     * Theme name.
     */
    theme: {
      type: String,
      default: "primary"
    },
    /**
     * When user clicks an item in the dropdown, if the target is or has a descendant
     * from these css selectors, the menu will be closed.
     */
    closeDropdownSelectors: {
      type: Array,
      default: () => ["a"]
    },
    /**
     * Open dropdown menu on the right side
     */
    menuOnRight: {
      type: Boolean,
      default: !1
    },
    /**
     * Dropdown menu will be minimum 100% width of the container.
     */
    menuFullWidth: {
      type: Boolean,
      default: !1
    },
    /**
     * If true, the '.hakosalo-dropdown-block' root container will be inline-block.
     */
    inline: {
      type: Boolean,
      default: !1
    },
    /**
     * If true, the '.hakosalo-dropdown' container will be inline-block.
     */
    innerInline: {
      type: Boolean,
      default: !0
    },
    teleportElement: {
      type: [Object, String],
      default: null
    }
  },
  setup(t) {
    const i = Vu(), r = t, l = q(document.body), a = q(null), u = q(null), s = q(!1), h = q({}), g = q(null);
    an(s, () => {
      $t(() => {
        O();
      });
    }), vn(() => {
    }), zn(() => {
      if (r.teleportElement)
        if (typeof r.teleportElement == "string") {
          const C = document.querySelector(r.teleportElement);
          C ? l.value = C : console.warn("Dropdown: Teleport element is missing: " + r.teleportElement);
        } else
          r.teleportElement && (l.value = r.teleportElement);
      else
        l.value = sc();
      window.addEventListener("mousedown", k), window.addEventListener("mouseup", S), window.addEventListener("resize", O), a.value && (g.value = new ResizeObserver(() => {
        O();
      }), g.value.observe(a.value));
    }), qn(() => {
      window.removeEventListener("mousedown", k), window.removeEventListener("mouseup", S), window.removeEventListener("resize", O), g.value && g.value.disconnect();
    });
    const T = j(() => !!i.customButton), k = (C) => {
      let I = C.target;
      if (I && a.value && u.value) {
        let M = E(I, a.value), R = E(I, u.value);
        !M && !R && (s.value = !1);
      }
    }, S = (C) => {
      let I = C.target;
      if (I && !(a.value && u.value && !E(I, u.value))) {
        for (const M of r.closeDropdownSelectors)
          if (I.closest(M)) {
            s.value = !1;
            break;
          }
      }
    }, E = (C, I) => {
      let M = C.parentElement, R = !1;
      for (; M; ) {
        if (M == I) {
          R = !0;
          break;
        }
        M = M.parentElement;
      }
      return R;
    }, O = () => {
      const C = {};
      if (a.value && u.value) {
        const I = {
          left: 0,
          right: 0,
          top: 0
        };
        let M = a.value.getBoundingClientRect(), R = u.value.getBoundingClientRect(), ee = window.scrollY;
        const U = a.value.closest(".hakosalo-modal-container");
        U != null && (ee = U.scrollTop), I.top = M.top + a.value.clientHeight + ee, I.left = M.left, I.right = M.right - R.width, C.top = Math.ceil(I.top) + "px", r.menuFullWidth ? (C.left = Math.ceil(I.left) + "px", C.width = Math.ceil(M.width) + "px") : r.menuOnRight ? C.left = Math.ceil(I.right) + "px" : C.left = Math.ceil(I.left) + "px", parseInt(C.left.replace("px", "")) < 1 && (C.left = "0px");
      }
      h.value = C;
    };
    return (C, I) => (v(), b("div", {
      class: z(["hakosalo-dropdown-block", { "d-inline-block": t.inline }])
    }, [
      y("div", {
        class: z(["hakosalo-dropdown", {
          show: s.value,
          "d-inline-block": t.innerInline,
          "on-right": t.menuOnRight,
          "full-width": t.menuFullWidth
        }]),
        ref_key: "root",
        ref: a
      }, [
        T.value ? (v(), b("div", {
          key: 0,
          onClick: I[0] || (I[0] = ne((M) => s.value = !s.value, ["prevent"]))
        }, [
          J(C.$slots, "customButton")
        ])) : (v(), b("button", {
          key: 1,
          type: "button",
          class: z(["btn dropdown-toggle", ["btn-" + t.theme]]),
          "aria-expanded": s.value,
          onClick: I[1] || (I[1] = ne((M) => s.value = !s.value, ["prevent"]))
        }, F(t.title), 11, b$)),
        (v(), le(Yn, { to: l.value }, [
          H(ft, null, {
            default: Z(() => [
              Ne(y("ul", {
                class: "hako-dropdown-menu",
                ref_key: "dropdownMenu",
                ref: u,
                style: fe(h.value)
              }, [
                J(C.$slots, "default")
              ], 4), [
                [Dn, s.value]
              ])
            ]),
            _: 3
          })
        ], 8, ["to"]))
      ], 2)
    ], 2));
  }
}), k$ = X({
  components: {
    Dropdown: wc,
    BsIcon: He
  },
  props: {
    label: {
      type: String,
      default: "Header"
    },
    theme: {
      type: String,
      default: "company"
    },
    backgroundColor: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      openMenu: !1
    };
  },
  computed: {
    computedBgColor() {
      if (this.backgroundColor)
        return this.backgroundColor;
      let t = or[this.theme] || ar[this.theme];
      return t ? t.color : "gray";
    },
    hasDropDown() {
      return !!this.$slots.menu;
    }
  }
}), C$ = { class: "d-flex align-items-center" }, $$ = { class: "flex-fill" }, _$ = { class: "right-side flex-fill" }, T$ = { class: "d-flex justify-content-end align-items-center" }, S$ = {
  key: 0,
  type: "button",
  class: "dropdown-btn"
}, O$ = /* @__PURE__ */ y("div", { class: "grow-div" }, null, -1);
function M$(t, i, r, l, a, u) {
  const s = ye("bs-icon"), h = ye("dropdown");
  return v(), b("div", {
    class: "hakosalo-header-block",
    style: fe({ backgroundColor: t.computedBgColor })
  }, [
    y("div", C$, [
      y("h1", $$, [
        Ke(F(t.label) + " ", 1),
        J(t.$slots, "infoball")
      ]),
      y("div", _$, [
        y("div", T$, [
          J(t.$slots, "default"),
          H(h, {
            modelValue: t.openMenu,
            "onUpdate:modelValue": i[0] || (i[0] = (g) => t.openMenu = g),
            "menu-on-right": ""
          }, {
            customButton: Z(() => [
              t.hasDropDown ? (v(), b("button", S$, [
                H(s, { icon: "list" })
              ])) : W("", !0)
            ]),
            default: Z(() => [
              J(t.$slots, "menu")
            ]),
            _: 3
          }, 8, ["modelValue"]),
          O$
        ])
      ])
    ])
  ], 4);
}
const bc = /* @__PURE__ */ ge(k$, [["render", M$]]), Hi = q({}), A$ = X({
  components: {
    HeaderBlock: bc,
    BsIcon: He,
    Collapse: ji
  },
  props: {
    theme: {
      type: String,
      default: "company"
    },
    themeLeftBar: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: "Header"
    },
    collapsed: {
      type: Boolean,
      default: !1
    },
    collapsable: {
      type: Boolean,
      default: !0
    },
    noHeader: {
      type: Boolean,
      default: !1
    },
    noBorder: {
      type: Boolean,
      default: !1
    },
    noPadding: {
      type: Boolean,
      default: !1
    },
    /** Removes gap between header and contentblock. 
     * No effect is 'noHeader' is enabled */
    noGap: {
      type: Boolean,
      default: !1
    },
    /**
     * If true, the header is integrated to the content block. Note that
     * background is forced to white. NoGap has no effect when this is enabled.
     */
    integratedHeader: {
      type: Boolean,
      default: !1
    },
    backgroundColor: {
      type: String,
      default: "white"
    },
    headerBackgroundColor: {
      type: String,
      default: null
    },
    /** bootstrap padding as array [x, y], results to: px-x, py-y */
    padding: {
      type: Array,
      default: [3, 3]
    },
    group: {
      type: String,
      required: !1
    }
  },
  data() {
    return {
      isActive: !0
    };
  },
  watch: {
    myGroupValue() {
      this.isActive = !1;
    }
  },
  beforeMount() {
    this.collapsed && (this.isActive = !1);
  },
  computed: {
    collapseOrExpandIcon() {
      return this.isActive ? "chevron-up" : "chevron-down";
    },
    myGroupValue() {
      return this.group ? Hi.value[this.group] : 0;
    },
    contentBlockClasses() {
      let t = [];
      return this.noPadding ? t.push("p-0") : (t.push("px-" + this.padding[0]), t.push("py-" + this.padding[1])), this.themeLeftBar && t.push("has-theme-bar"), this.noGapValue && !this.noHeader && t.push("no-gap"), this.noHeader && t.push("no-header"), t;
    },
    themeLeftBarBgColor() {
      let t = or[this.themeLeftBar] || ar[this.themeLeftBar];
      return t ? t.color : "gray";
    },
    noGapValue() {
      return this.noGap || this.integratedHeader;
    }
  },
  methods: {
    async setIsActiveFromHeader(t) {
      const i = t.target, r = i.nodeName, l = i.className, a = [
        "hakosalo-header-block",
        "d-flex"
      ];
      (r == "H1" || a.some((u) => l.includes(u))) && await this.setIsActive();
    },
    async setIsActive() {
      this.collapsable && (this.group && this.isActive == !1 && (Hi.value[this.group] || (Hi.value[this.group] = 0), Hi.value[this.group] += 1), await this.$nextTick(), this.isActive = !this.isActive);
    }
  }
});
function D$(t, i, r, l, a, u) {
  const s = ye("bs-icon"), h = ye("header-block"), g = ye("collapse");
  return v(), b("div", {
    class: z(["hakosalo-content-block-container", {
      "no-header": t.noHeader,
      "no-border": t.noBorder,
      collapsable: t.collapsable,
      collapsed: !t.isActive,
      "has-theme-bar": !!t.themeLeftBar,
      "integrated-header": t.integratedHeader
    }])
  }, [
    t.noHeader ? W("", !0) : (v(), le(h, {
      key: 0,
      label: t.label,
      theme: t.theme,
      "background-color": t.headerBackgroundColor,
      onClick: t.setIsActiveFromHeader
    }, Pu({
      infoball: Z(() => [
        J(t.$slots, "infoball")
      ]),
      default: Z(() => [
        J(t.$slots, "header"),
        t.collapsable ? (v(), b("button", {
          key: 0,
          type: "button",
          class: z(["expand-collapse-btn", { collapsed: !t.isActive }]),
          onClick: i[0] || (i[0] = ne((...T) => t.setIsActive && t.setIsActive(...T), ["prevent"]))
        }, [
          H(s, { icon: "chevron-up" })
        ], 2)) : W("", !0),
        t.integratedHeader && t.themeLeftBar ? (v(), b("div", {
          key: 1,
          class: "theme-left-bar",
          style: fe({ backgroundColor: t.themeLeftBarBgColor })
        }, null, 4)) : W("", !0)
      ]),
      _: 2
    }, [
      t.$slots.menu ? {
        name: "menu",
        fn: Z(() => [
          J(t.$slots, "menu")
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["label", "theme", "background-color", "onClick"])),
    J(t.$slots, "gap"),
    H(g, { show: t.isActive }, {
      default: Z(() => [
        y("div", {
          class: z(["content-block", t.contentBlockClasses]),
          style: fe({ backgroundColor: t.backgroundColor })
        }, [
          t.themeLeftBar ? (v(), b("div", {
            key: 0,
            class: "theme-left-bar",
            style: fe({ backgroundColor: t.themeLeftBarBgColor })
          }, null, 4)) : W("", !0),
          J(t.$slots, "default")
        ], 6)
      ]),
      _: 3
    }, 8, ["show"])
  ], 2);
}
const I$ = /* @__PURE__ */ ge(A$, [["render", D$]]), E$ = X({
  emits: [
    "update:modelValue"
  ],
  props: {
    modelValue: {
      type: Boolean,
      required: !0
    },
    width: {
      type: Number,
      default: 350
    },
    isRightSide: {
      type: Boolean,
      default: !1
    }
  },
  watch: {
    modelValue() {
      this.modelValue ? (document.body.classList.add("hakopanel-open"), this.$nextTick(() => {
        this.$refs.panelContent.scrollTo(0, 0);
      })) : document.body.classList.remove("hakopanel-open");
    }
  },
  computed: {
    rootElementStyling() {
      return {
        width: this.width + "px"
      };
    },
    rootElementClasses() {
      let t = [];
      return this.modelValue && t.push("is-open"), this.isRightSide ? t.push("panel-on-right") : t.push("panel-on-left"), t;
    }
  }
}), B$ = {
  class: "panel-content",
  ref: "panelContent"
};
function x$(t, i, r, l, a, u) {
  return v(), le(Yn, { to: "body" }, [
    H(ft, null, {
      default: Z(() => [
        Ne(y("div", {
          class: z(["hakosalo-sidepanel", t.rootElementClasses]),
          style: fe(t.rootElementStyling)
        }, [
          y("div", B$, [
            J(t.$slots, "default")
          ], 512)
        ], 6), [
          [Dn, t.modelValue]
        ])
      ]),
      _: 3
    }),
    H(ft, null, {
      default: Z(() => [
        t.modelValue ? (v(), b("div", {
          key: 0,
          class: "hakosalo-sidepanel-bg",
          onClick: i[0] || (i[0] = (s) => t.$emit("update:modelValue", !1))
        })) : W("", !0)
      ]),
      _: 1
    })
  ]);
}
const V$ = /* @__PURE__ */ ge(E$, [["render", x$]]), P$ = function() {
  let t = !1;
  return function(i) {
    (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(i) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(i.substr(0, 4))) && (t = !0);
  }(navigator.userAgent || navigator.vendor || window.opera), t;
}, L$ = X({
  components: {
    BsIcon: He
  },
  props: {
    modelValue: {
      type: Boolean,
      required: !0
    },
    showCloseArrow: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      isMobile: !1,
      isMounted: !1
    };
  },
  watch: {
    modelValue() {
      this.onPanelCloseOrOpen();
    },
    isMobile() {
      this.onPanelCloseOrOpen();
    }
  },
  beforeMount() {
    this.onPanelCloseOrOpen(), this.checkMobile(), window.addEventListener("resize", this.checkMobile);
  },
  mounted() {
    this.isMounted = !0;
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkMobile);
    const t = document.querySelector("body");
    if (t == null)
      return;
    t.classList.forEach((r) => {
      r.toLowerCase().includes("hako-sticky-panel") && t.classList.remove(r);
    });
  },
  computed: {
    stickySidepanelClasses() {
      let t = [];
      return this.modelValue ? t.push("panel-open") : t.push("panel-closed"), this.isMobile && t.push("is-mobile"), t;
    }
  },
  methods: {
    checkMobile() {
      let t = !1;
      (window.innerWidth < 1400 || P$()) && (t = !0), this.isMobile = t;
    },
    onPanelCloseOrOpen() {
      const t = document.querySelector("body");
      t != null && (this.isMounted && t.classList.add("hako-sticky-panel-mounted"), t.classList.remove("hako-sticky-panel-mobile"), this.modelValue ? (t.classList.add("hako-sticky-panel-open"), this.isMobile && t.classList.add("hako-sticky-panel-mobile")) : (t.classList.add("hako-sticky-panel-closing"), t.classList.remove("hako-sticky-panel-open"), window.setTimeout(() => {
        t.classList.remove("hako-sticky-panel-closing");
      }, 350)));
    }
  }
}), R$ = { class: "main-content" };
function F$(t, i, r, l, a, u) {
  const s = ye("bs-icon");
  return v(), le(Yn, { to: "body" }, [
    H(ft, null, {
      default: Z(() => [
        Ne(y("div", {
          class: z(["hakosalo-sticky-sidepanel", t.stickySidepanelClasses])
        }, [
          t.showCloseArrow && !t.isMobile ? (v(), b("button", {
            key: 0,
            type: "button",
            class: "close-btn",
            onClick: i[0] || (i[0] = ne((h) => t.$emit("update:modelValue", !1), ["prevent"]))
          }, [
            H(s, {
              icon: "arrow-left-short",
              size: 200
            })
          ])) : W("", !0),
          y("div", R$, [
            J(t.$slots, "default")
          ])
        ], 2), [
          [Dn, t.modelValue]
        ])
      ]),
      _: 3
    }),
    t.isMobile && t.modelValue ? (v(), b("div", {
      key: 0,
      class: "hakosalo-sticky-sidepanel-mobile-bg",
      onClick: i[1] || (i[1] = ne((h) => t.$emit("update:modelValue", !1), ["prevent"]))
    })) : W("", !0)
  ]);
}
const W$ = /* @__PURE__ */ ge(L$, [["render", F$]]), H$ = X({
  components: {
    BsIcon: He
  },
  emits: [
    "update:modelValue"
  ],
  props: {
    modelValue: {
      type: [String, null]
    },
    tabs: {
      type: Array,
      required: !0
    },
    theme: {
      type: String,
      default: "dark"
    }
  },
  data() {
    return {
      useMobileView: !1,
      rulerPosition: {
        x: 0
      }
    };
  },
  mounted() {
    this.checkIfNeedToUseMobileView(), window.addEventListener("resize", this.checkIfNeedToUseMobileView);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkIfNeedToUseMobileView);
  },
  methods: {
    tabClasses(t, i) {
      let r = [];
      return this.modelValue == t.id && r.push("active"), r.push("tab-" + i), r;
    },
    tabStyling(t) {
      let i = or[this.theme] || ar[this.theme], r = {
        // "border-color": theme.color
      };
      return this.modelValue == t.id && (r.color = i.color), r;
    },
    checkIfNeedToUseMobileView() {
      this.useMobileView = !1, this.$nextTick(() => {
        const t = this.$refs.tabRow;
        t && t.scrollWidth > t.clientWidth && (this.useMobileView = !0);
      });
    },
    onSelectChange(t) {
      let i = t.target;
      i && this.$emit("update:modelValue", i.value);
    }
  }
}), U$ = {
  key: 0,
  class: "tab-row",
  ref: "tabRow"
}, N$ = ["value"], z$ = {
  key: 1,
  class: "tab-row d-flex align-items-end",
  ref: "tabRow"
}, q$ = ["onClick"];
function Y$(t, i, r, l, a, u) {
  const s = ye("BsIcon");
  return v(), b("div", {
    class: z(["hakosalo-tabs", { mobileview: t.useMobileView }])
  }, [
    t.useMobileView ? (v(), b("div", U$, [
      H(s, { icon: "segmented-nav" }),
      y("select", {
        class: "form-select",
        onChange: i[0] || (i[0] = (h) => t.onSelectChange(h))
      }, [
        (v(!0), b(he, null, Se(t.tabs, (h) => (v(), b("option", {
          key: h.id,
          value: h.id
        }, F(h.name), 9, N$))), 128))
      ], 32)
    ], 512)) : (v(), b("div", z$, [
      (v(!0), b(he, null, Se(t.tabs, (h, g) => (v(), b("div", {
        class: z(["tab", t.tabClasses(h, g)]),
        key: h.id,
        ref_for: !0,
        ref: "tab-" + g,
        style: fe(t.tabStyling(h)),
        onClick: (T) => t.$emit("update:modelValue", h.id)
      }, [
        y("span", null, F(h.name), 1)
      ], 14, q$))), 128))
    ], 512))
  ], 2);
}
const G$ = /* @__PURE__ */ ge(H$, [["render", Y$]]), K$ = X({
  props: {
    modelValue: {
      type: String,
      required: !0
    },
    tabs: {
      type: Array,
      required: !0
    },
    theme: {
      type: String,
      default: "primary"
    }
  },
  methods: {
    tabClasses(t) {
      let i = [];
      return t.id == this.modelValue && (i.push("active"), i.push("bg-" + this.theme)), i;
    }
  }
}), Q$ = { class: "hakosalo-vertical-tabs" }, X$ = {
  class: "nav flex-column nav-pills",
  id: "v-pills-tab",
  role: "tablist",
  "aria-orientation": "vertical"
}, Z$ = ["aria-selected", "onClick"];
function J$(t, i, r, l, a, u) {
  return v(), b("div", Q$, [
    y("div", X$, [
      (v(!0), b(he, null, Se(t.tabs, (s) => (v(), b("button", {
        key: s.id,
        type: "button",
        class: z(["nav-link pe-3", t.tabClasses(s)]),
        role: "tab",
        "aria-selected": s.id == t.modelValue,
        onClick: ne((h) => t.$emit("update:modelValue", s.id), ["prevent"])
      }, F(s.name), 11, Z$))), 128))
    ])
  ]);
}
const j$ = /* @__PURE__ */ ge(K$, [["render", J$]]), e_ = X({});
function t_(t, i, r, l, a, u) {
  return v(), b("li", null, [
    y("a", {
      href: "#",
      class: "dropdown-item",
      onClick: i[0] || (i[0] = ne((s) => t.$emit("click"), ["prevent", "stop"]))
    }, [
      J(t.$slots, "default")
    ])
  ]);
}
const n_ = /* @__PURE__ */ ge(e_, [["render", t_]]), Ui = 2, Eu = 10, Un = {
  notifications: q([]),
  get defaultNotificationSettings() {
    return {
      timeInSeconds: Ui
    };
  },
  /**
   * Create a notification
   * @param notification Notification Settings Object (interface INotification)
   * @returns The final INotification object.
   */
  create(t) {
    return t.id || (t.id = mn()), Object.keys(this.defaultNotificationSettings).forEach((i) => {
      typeof t[i] > "u" && (t[i] = this.defaultNotificationSettings[i]);
    }), this.notifications.value.push(t), t;
  },
  /**
   * Create a notification quickly
   * @param theme Notification theme
   * @param title Notification title
   * @param message Notification message
   * @param timeout Notification timeout, default 5
   * @returns The final INotification object.
   */
  quick(t, i, r, l = Ui) {
    return Un.create({
      theme: t,
      title: i,
      content: r,
      timeInSeconds: l
    });
  },
  /**
   * Create a normal notification quickly
   * @param theme Notification theme
   * @param title Notification title
   * @param message Notification message
   * @param timeout Notification timeout, default 5
   * @returns The final INotification object.
   */
  quickNormal(t, i, r = Ui) {
    return Un.quick("primary", t, i, r);
  },
  /**
   * Create a success notification quickly
   * @param theme Notification theme
   * @param title Notification title
   * @param message Notification message
   * @param timeout Notification timeout, default 5
   * @returns The final INotification object.
   */
  quickSuccess(t, i, r = Ui) {
    return Un.quick("success", t, i, r);
  },
  /**
   * Create a failure notification quickly
   * @param theme Notification theme
   * @param title Notification title
   * @param message Notification message
   * @param timeout Notification timeout, default 5
   * @returns The final INotification object.
   */
  quickDanger(t, i, r = Eu) {
    return Un.quick("danger", t, i, r);
  },
  /**
   * Create a warning notification quickly
   * @param theme Notification theme
   * @param title Notification title
   * @param message Notification message
   * @param timeout Notification timeout, default 5
   * @returns The final INotification object.
   */
  quickWarning(t, i, r = Eu) {
    return Un.quick("warning", t, i, r);
  },
  /**
   * Remove a notification 
   * @param id Notification ID
   */
  remove(t) {
    typeof t > "u" || (this.notifications.value = this.notifications.value.filter((i) => i.id != t));
  }
}, r_ = X({
  components: {
    BsIcon: He
  },
  props: {
    configuration: {
      type: Object,
      required: !0
    },
    queueNumber: {
      type: Number,
      required: !0
    }
  },
  data() {
    return {
      visible: !0,
      mountedTime: /* @__PURE__ */ new Date(),
      mountedTimeIntval: 0,
      timerBarWidth: 100
    };
  },
  mounted() {
    this.mountedTime = /* @__PURE__ */ new Date(), this.configuration.timeInSeconds !== 0 && window.setTimeout(() => {
      this.closeNotification();
    }, this.timeInSeconds * 1e3);
  },
  beforeUnmount() {
    window.clearInterval(this.mountedTimeIntval);
  },
  methods: {
    closeNotification() {
      this.visible = !1, window.setTimeout(() => {
        Un.remove(this.configuration.id);
      }, 2e3);
    }
  },
  computed: {
    timeInSeconds() {
      return this.configuration.timeInSeconds || 0;
    },
    theme() {
      return this.configuration.theme || "secondary";
    },
    timerBarFillStyle() {
      return {
        width: this.timerBarWidth + "%",
        animationDuration: `${this.timeInSeconds}s`
      };
    },
    configurationContentNewlined() {
      return this.configuration.content ? this.configuration.content.split(`
`).map((t) => t.length == 0 ? "" : t) : "";
    }
  }
}), i_ = {
  key: 0,
  class: "title"
}, o_ = {
  key: 1,
  class: "timer-bar"
}, a_ = { class: "notification-content" }, s_ = {
  key: 0,
  class: "text-content"
}, l_ = ["innerHTML"], u_ = {
  key: 1,
  class: "text-content"
};
function c_(t, i, r, l, a, u) {
  const s = ye("bs-icon");
  return v(), le(ft, { appear: "" }, {
    default: Z(() => [
      t.visible ? (v(), b("div", {
        key: 0,
        class: z(["hakosalo-notification", [`text-bg-${t.theme}-lighter`]])
      }, [
        t.configuration.title ? (v(), b("div", i_, [
          y("span", null, F(t.configuration.title), 1),
          y("button", {
            type: "button",
            class: z(["close-notification-btn", [`text-${t.theme}-dark`]]),
            onClick: i[0] || (i[0] = ne((...h) => t.closeNotification && t.closeNotification(...h), ["prevent"]))
          }, [
            H(s, { icon: "x" })
          ], 2)
        ])) : W("", !0),
        t.configuration.enableTimer && t.timeInSeconds > 0 ? (v(), b("div", o_, [
          y("div", {
            class: z(["fill", [`text-bg-${t.theme}`]]),
            style: fe(t.timerBarFillStyle)
          }, null, 6)
        ])) : W("", !0),
        y("div", a_, [
          t.configuration.content ? (v(), b("div", s_, [
            t.configuration.useHtmlContent ? (v(), b("span", {
              key: 0,
              innerHTML: t.configuration.content
            }, null, 8, l_)) : (v(), b("span", u_, [
              (v(!0), b(he, null, Se(t.configurationContentNewlined, (h, g) => (v(), b("p", { key: g }, F(h), 1))), 128))
            ]))
          ])) : W("", !0),
          t.configuration.contentComponent ? (v(), le(Zi(t.configuration.contentComponent), { key: 1 })) : W("", !0)
        ])
      ], 2)) : W("", !0)
    ]),
    _: 1
  });
}
const kc = /* @__PURE__ */ ge(r_, [["render", c_]]), d_ = X({
  components: {
    Notification: kc
  },
  data() {
    return {
      allowExistence: !0
    };
  },
  beforeMount() {
    document.querySelector("#hakosalo-notification-vue-manager") && (this.allowExistence = !1);
  },
  computed: {
    notifications() {
      return Un.notifications.value;
    }
  }
}), f_ = {
  key: 0,
  id: "hakosalo-notification-vue-manager"
};
function h_(t, i, r, l, a, u) {
  const s = ye("notification");
  return v(), le(Yn, { to: "body" }, [
    t.allowExistence ? (v(), b("div", f_, [
      (v(!0), b(he, null, Se(t.notifications, (h, g) => (v(), le(s, {
        key: h.id,
        configuration: h,
        "queue-number": g
      }, null, 8, ["configuration", "queue-number"]))), 128))
    ])) : W("", !0)
  ]);
}
const p_ = /* @__PURE__ */ ge(d_, [["render", h_]]), v_ = X({
  props: {
    config: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      prompt: "",
      promptArr: []
    };
  },
  mounted() {
    const t = this.$refs.promptInput;
    t && t.focus();
  },
  computed: {
    theme() {
      return this.config.theme || "primary";
    },
    promptOptions() {
      return this.config.promptOptions || [];
    },
    emitData() {
      return {
        prompt: this.prompt,
        promptArr: this.config.promptType != "checkbox" ? null : this.promptArr
      };
    }
  },
  methods: {
    makeRadioId(t) {
      return `halert-option-${this.config.id}-${t.value}`;
    }
  }
}), m_ = { class: "hakosalo-halert" }, g_ = {
  key: 0,
  class: "title"
}, y_ = { class: "content" }, w_ = { key: 0 }, b_ = { key: 1 }, k_ = {
  key: 1,
  class: "controls mb-4"
}, C_ = ["value"], $_ = ["id", "value"], __ = ["for"], T_ = ["id", "value"], S_ = ["for"], O_ = { class: "buttons" };
function M_(t, i, r, l, a, u) {
  return v(), b("div", m_, [
    t.config.title ? (v(), b("div", g_, [
      y("h4", null, F(t.config.title), 1)
    ])) : W("", !0),
    y("div", y_, [
      t.config.text ? (v(), b("p", w_, F(t.config.text), 1)) : W("", !0),
      t.config.contentComponent ? (v(), b("div", b_, [
        (v(), le(Zi(t.config.contentComponent)))
      ])) : W("", !0)
    ]),
    t.config.type == "prompt" ? (v(), b("div", k_, [
      t.config.promptType == "text" ? Ne((v(), b("input", {
        key: 0,
        type: "text",
        class: "form-control",
        "onUpdate:modelValue": i[0] || (i[0] = (s) => t.prompt = s),
        ref: "promptInput",
        onKeydown: i[1] || (i[1] = on((s) => t.$emit("ok", t.emitData), ["enter"]))
      }, null, 544)), [
        [Nn, t.prompt]
      ]) : t.config.promptType == "select" ? Ne((v(), b("select", {
        key: 1,
        class: "form-select",
        "onUpdate:modelValue": i[2] || (i[2] = (s) => t.prompt = s)
      }, [
        (v(!0), b(he, null, Se(t.promptOptions, (s) => (v(), b("option", {
          key: s.value,
          value: s.value
        }, F(s.text), 9, C_))), 128))
      ], 512)), [
        [Ru, t.prompt]
      ]) : t.config.promptType == "radio" ? (v(!0), b(he, { key: 2 }, Se(t.promptOptions, (s) => (v(), b("div", {
        class: "form-check",
        key: s.value
      }, [
        Ne(y("input", {
          type: "radio",
          id: t.makeRadioId(s),
          name: "halert-radio-group",
          class: "form-check-input",
          value: s.value,
          "onUpdate:modelValue": i[3] || (i[3] = (h) => t.prompt = h)
        }, null, 8, $_), [
          [Fu, t.prompt]
        ]),
        y("label", {
          class: "form-check-label",
          for: t.makeRadioId(s)
        }, F(s.text), 9, __)
      ]))), 128)) : t.config.promptType == "checkbox" ? (v(!0), b(he, { key: 3 }, Se(t.promptOptions, (s) => (v(), b("div", {
        class: "form-check",
        key: s.value
      }, [
        Ne(y("input", {
          type: "checkbox",
          id: t.makeRadioId(s),
          class: "form-check-input",
          value: s.value,
          "onUpdate:modelValue": i[4] || (i[4] = (h) => t.promptArr = h)
        }, null, 8, T_), [
          [Xi, t.promptArr]
        ]),
        y("label", {
          class: "form-check-label",
          for: t.makeRadioId(s)
        }, F(s.text), 9, S_)
      ]))), 128)) : W("", !0)
    ])) : W("", !0),
    y("div", O_, [
      t.config.type == "alert" || t.config.type == "prompt" ? (v(), b(he, { key: 0 }, [
        y("button", {
          type: "button",
          class: z(["btn", [`btn-${t.theme}`]]),
          onClick: i[5] || (i[5] = ne((s) => t.$emit("ok", t.emitData), ["prevent"]))
        }, F(t.config.textOk), 3),
        t.config.showCancelBtn ? (v(), b("button", {
          key: 0,
          type: "button",
          class: "btn btn-secondary ms-4",
          onClick: i[6] || (i[6] = ne((s) => t.$emit("cancel"), ["prevent"]))
        }, F(t.config.textCancel), 1)) : W("", !0)
      ], 64)) : t.config.type == "confirm" ? (v(), b(he, { key: 1 }, [
        y("button", {
          type: "button",
          class: z(["btn", [`btn-${t.theme}`]]),
          onClick: i[7] || (i[7] = ne((s) => t.$emit("ok"), ["prevent"]))
        }, F(t.config.textOk), 3),
        y("button", {
          type: "button",
          class: "btn btn-secondary ms-4",
          onClick: i[8] || (i[8] = ne((s) => t.$emit("cancel"), ["prevent"]))
        }, F(t.config.textCancel), 1)
      ], 64)) : W("", !0)
    ])
  ]);
}
const Cc = /* @__PURE__ */ ge(v_, [["render", M_]]), _r = {
  alerts: q([]),
  defaultAlertOptions() {
    const t = {};
    return t.id = mn(), t.title = "", t.text = "", t.type = "alert", t.theme = "primary", t.promptType = "text", t.promptOptions = [], t.showCancelBtn = !0, t.textOk = "OK", t.textCancel = Ra.cancel, t.contentComponent = null, t;
  },
  /**
  * Merges settings if setting is undefined.
  * @param config1 Original settings
  * @param config2 Copy defined values from this object
  * @returns config1
  */
  mergeAlertOptions(t, i) {
    const r = _r.defaultAlertOptions();
    return Object.keys(r).forEach((l) => {
      typeof i[l] < "u" && (t[l] = i[l]);
    }), t;
  }
}, Ni = {
  custom(t) {
    return new Promise((r, l) => {
      let a = _r.defaultAlertOptions();
      _r.mergeAlertOptions(a, t), a.resolve = r, a.reject = l, _r.alerts.value.push(a);
    });
  },
  alert(t, i, r = "primary") {
    return Ni.custom({
      type: "alert",
      showCancelBtn: !1,
      title: t,
      text: i,
      theme: r
    });
  },
  confirm(t, i, r = "primary") {
    return Ni.custom({
      type: "confirm",
      title: t,
      text: i,
      theme: r
    });
  },
  prompt(t, i, r = "primary", l = "text", a = []) {
    return Ni.custom({
      type: "prompt",
      showCancelBtn: !0,
      promptType: l,
      promptOptions: a,
      title: t,
      text: i,
      theme: r
    });
  }
}, A_ = X({
  components: {
    Alert: Cc
  },
  data() {
    return {};
  },
  computed: {
    alerts() {
      return _r.alerts.value;
    },
    firstAlert() {
      return this.alerts[0];
    }
  },
  methods: {
    closeAlert() {
      _r.alerts.value.splice(0, 1);
    },
    okEvent(t) {
      this.firstAlert.resolve(t), this.closeAlert();
    },
    cancelEvent() {
      this.firstAlert.reject(), this.closeAlert();
    }
  }
}), D_ = { id: "halert-vue-manager" }, I_ = {
  key: 0,
  class: "halert-container"
};
function E_(t, i, r, l, a, u) {
  const s = ye("alert");
  return v(), le(Yn, { to: "body" }, [
    y("div", D_, [
      H(ft, null, {
        default: Z(() => [
          t.firstAlert ? (v(), b("div", I_, [
            H(s, {
              config: t.firstAlert,
              onOk: t.okEvent,
              onCancel: t.cancelEvent
            }, null, 8, ["config", "onOk", "onCancel"])
          ])) : W("", !0)
        ]),
        _: 1
      })
    ])
  ]);
}
const B_ = /* @__PURE__ */ ge(A_, [["render", E_]]), x_ = { class: "hakosalo-top-scroll" }, V_ = /* @__PURE__ */ X({
  __name: "TopScroll",
  setup(t) {
    const i = q(null), r = q(!1), l = q(null), a = q(null), u = q(null), s = () => u.value.firstElementChild, h = () => {
      const S = s();
      return u.value ? S.clientWidth > u.value.clientWidth : !1;
    }, g = () => {
      if (!u.value || !a.value)
        return;
      r.value = h();
      const S = s();
      S && (a.value.style.width = Math.floor(S.clientWidth - 0.5) + "px");
    }, T = () => {
      r.value = h();
    };
    zn(() => {
      i.value = new ResizeObserver(g);
      const S = s();
      i.value.observe(S), window.addEventListener("resize", T), g();
    }), qn(() => {
      var S;
      window.removeEventListener("resize", T), (S = i.value) == null || S.disconnect();
    });
    const k = (S) => {
      const E = S.target == u.value ? u.value : l.value, O = E == u.value ? l.value : u.value;
      !O || !E || (O.scrollLeft = E.scrollLeft);
    };
    return (S, E) => (v(), b("div", x_, [
      Ne(y("div", {
        class: "top-scroll",
        ref_key: "topScroll",
        ref: l,
        onScrollPassive: E[0] || (E[0] = (O) => k(O))
      }, [
        y("div", {
          class: "top-scroll-stretcher",
          ref_key: "topScrollStretcher",
          ref: a
        }, null, 512)
      ], 544), [
        [Dn, r.value]
      ]),
      y("div", {
        class: "content-container",
        ref_key: "contentContainer",
        ref: u,
        onScrollPassive: E[1] || (E[1] = (O) => k(O))
      }, [
        J(S.$slots, "default")
      ], 544)
    ]));
  }
}), P_ = /* @__PURE__ */ X({
  __name: "Badge",
  props: {
    theme: {
      type: String,
      default: "primary"
    },
    bgColor: {
      type: String,
      default: null
    },
    blackFont: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    const i = t, r = j(() => {
      const a = [];
      return i.bgColor || a.push(`text-bg-${i.theme}`), i.blackFont ? a.push("text-black") : a.push("text-white"), a;
    }), l = j(() => {
      const a = {};
      return i.bgColor && (a["background-color"] = i.bgColor), a;
    });
    return (a, u) => (v(), b("div", {
      class: z(["hako-badge badge", r.value]),
      style: fe(l.value)
    }, [
      J(a.$slots, "default")
    ], 6));
  }
}), Bu = 300, L_ = /* @__PURE__ */ X({
  __name: "BadgeAdvanced",
  props: {
    theme: {
      type: String,
      default: ""
    },
    showX: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["remove"],
  setup(t, { emit: i }) {
    const r = i, l = t, a = j(() => {
      let k = or[l.theme] || ar[l.theme];
      return k ? k.color : "white";
    }), u = j(() => {
      const k = {
        transition: `all ${Bu}ms ease-out`
      };
      return g.value > 0 && (k.width = `${g.value}px`), h.value && (k.width = "0px"), k;
    }), s = q(null), h = q(!1), g = q(0);
    async function T() {
      g.value = s.value.offsetWidth, window.setTimeout(() => {
        h.value = !0, window.setTimeout(() => {
          r("remove");
        }, Bu);
      }, 10);
    }
    return (k, S) => (v(), b("div", {
      ref_key: "rootElement",
      ref: s,
      class: z(["hakolib-hako-badge-advanced", { "is-removing": h.value }]),
      style: fe(u.value)
    }, [
      t.theme ? (v(), b("div", {
        key: 0,
        class: "theme-left-bar",
        style: fe({ backgroundColor: a.value })
      }, null, 4)) : W("", !0),
      J(k.$slots, "default"),
      t.showX ? (v(), b("div", {
        key: 1,
        class: "hako-badge-x",
        onClick: T
      }, [
        H(He, { icon: "x-lg" })
      ])) : W("", !0)
    ], 6));
  }
}), R_ = ["onMouseenter", "onClick"], F_ = ["onMouseenter", "onClick"], W_ = ["onMouseenter", "onClick"], H_ = /* @__PURE__ */ X({
  __name: "Pearls",
  props: {
    pearls: {
      type: Array,
      required: !0
    },
    isClickable: {
      type: Boolean,
      default: !1
    },
    restrictWidth: {
      type: Boolean,
      default: !0
    },
    mobileWidth: {
      type: Number,
      default: 512
    },
    forceMobile: {
      type: Boolean,
      default: !1
    },
    alignGrid: {
      type: String,
      default: "left"
    }
  },
  setup(t) {
    var O;
    const i = t, r = q(null), l = q((O = r.value) == null ? void 0 : O.clientWidth), a = j(() => i.forceMobile ? !0 : (l.value || 0) < i.mobileWidth), u = q(null);
    zn(() => {
      u.value = new ResizeObserver((C) => {
        for (let I of C)
          l.value = I.contentRect.width;
      }), r.value && u.value.observe(r.value);
    }), o0(() => {
      u && r.value && (u.value.unobserve(r.value), u.value.disconnect());
    });
    const s = q(null), h = j(() => {
      const C = {};
      return C["text-align"] = i.alignGrid, C;
    }), g = j(() => {
      const C = i.pearls, I = {
        "grid-template-columns": `repeat(${C.length}, 1fr)`,
        "grid-template-rows": "repeat(3, auto)",
        "grid-template-areas": `'title${C.map((R, ee) => ee).join(" title")}' 
			'ball${C.map((R, ee) => ee).join(" ball")}' 
			'footer${C.map((R, ee) => ee).join(" footer")}'`
      };
      let M = "";
      return C.forEach((R, ee) => {
        M += `'title${ee} ball${ee} footer${ee}' `;
      }), a.value && (I["grid-template-areas"] = M, I["grid-template-columns"] = "repeat(3, auto)", I["grid-template-rows"] = `repeat(${C.length}, auto)`), I;
    }), T = j(() => {
      const C = i.pearls, I = {};
      if (i.restrictWidth) {
        const M = C.length * 200;
        I["max-width"] = `${M}px`;
      }
      return I;
    });
    function k(C) {
      return C.iconOverride ? C.iconOverride : C.status == "success" ? "check-lg" : C.status == "fail" ? "x-lg" : "question-lg";
    }
    function S(C) {
      i.isClickable && (s.value = C);
    }
    function E(C) {
      if (!i.isClickable || s.value == null)
        return !1;
      let I = !0;
      return Object.keys(C).forEach((M) => {
        I && C[M] != s.value[M] && (I = !1);
      }), I;
    }
    return (C, I) => (v(), b("div", {
      ref_key: "rootEl",
      ref: r,
      class: z(["hako-string-of-pearls", { "is-mobile": a.value }]),
      style: fe(h.value)
    }, [
      y("div", {
        class: "grid-wrapper",
        style: fe(T.value)
      }, [
        y("div", {
          class: "grid text-center",
          style: fe(g.value)
        }, [
          (v(!0), b(he, null, Se(t.pearls, (M, R) => (v(), b("div", {
            key: M.id + M.title,
            class: "col-title",
            style: fe({ "grid-area": `title${R}` })
          }, [
            y("div", {
              class: z(["max-constraint", { hover: E(M) }]),
              onMouseenter: (ee) => S(M),
              onMouseleave: I[0] || (I[0] = (ee) => S(null)),
              onClick: (ee) => C.$emit("pearl-click", M, R)
            }, [
              J(C.$slots, "title", { pearl: M }, () => [
                Ke(F(M.title), 1)
              ])
            ], 42, R_)
          ], 4))), 128)),
          (v(!0), b(he, null, Se(t.pearls, (M, R) => (v(), b("div", {
            key: M.id + M.title + "ball",
            class: z(["col-ball", {
              "col-ball-last": R === t.pearls.length - 1,
              "break-line": M.breakLine
            }]),
            style: fe({ "grid-area": `ball${R}` })
          }, [
            y("div", {
              class: z(["max-constraint", { hover: E(M) }]),
              onMouseenter: (ee) => S(M),
              onMouseleave: I[1] || (I[1] = (ee) => S(null)),
              onClick: (ee) => C.$emit("pearl-click", M, R)
            }, [
              J(C.$slots, "ball", { pearl: M }, () => [
                y("div", {
                  class: "ball",
                  style: fe({ backgroundColor: M.color || "gray" })
                }, [
                  y("div", null, [
                    M.status || M.iconOverride ? (v(), le(He, {
                      key: 0,
                      icon: k(M)
                    }, null, 8, ["icon"])) : W("", !0)
                  ])
                ], 4)
              ])
            ], 42, F_)
          ], 6))), 128)),
          (v(!0), b(he, null, Se(t.pearls, (M, R) => (v(), b("div", {
            key: M.id + M.title + "footer",
            class: z(["col-footer", { hover: E(M) }]),
            style: fe({ "grid-area": `footer${R}` })
          }, [
            y("div", {
              class: z(["max-constraint", { hover: E(M) }]),
              onMouseenter: (ee) => S(M),
              onMouseleave: I[2] || (I[2] = (ee) => S(null)),
              onClick: (ee) => C.$emit("pearl-click", M, R)
            }, [
              J(C.$slots, "footer", { pearl: M }, () => [
                Ke(F(M.footer), 1)
              ])
            ], 42, W_)
          ], 6))), 128))
        ], 4)
      ], 4)
    ], 6));
  }
}), z_ = [
  "#4090C7",
  "#6BC1E6",
  "#43B4AB",
  "#56A681",
  "#60B88A",
  "#80CB8A",
  "#B6D786",
  "#E5E87F",
  "#C6BF60",
  "#F6CB86",
  "#DDA059",
  "#F18760",
  "#ED6E74",
  "#F0A0A2",
  "#DB5485",
  "#B7498A",
  "#B66CB1",
  "#8D67AB",
  "#59538C",
  "#6366AB"
], q_ = {
  install(t) {
    t.component("HakoBlockSpinner", Aa), t.component("HakoBsIcon", He), t.component("HakoRoundAvatar", Zr), t.component("HakoButton", At), t.component("HakoBsIconButton", w0), t.component("HakoButtonIconOnly", Ji), t.component("HakoButtonIconOnlyAdd", k0), t.component("HakoButtonIconOnlyRemove", C0), t.component("HakoButtonIconOnlyEdit", $0), t.component("HakoCollapse", ji), t.component("HakoContentBlock", I$), t.component("HakoDatePicker", l1), t.component("HakoDropdown", wc), t.component("HakoDropdownItem", n_), t.component("HakoFullscreenSpinner", p$), t.component("HakoHeaderBlock", bc), t.component("HakoHighlightText", Fa), t.component("HakoInput", Sr), t.component("HakoTextArea", Yk), t.component("HakoTeleInput", Jk), t.component("HakoLabelControl", M1), t.component("HakoMiniCalendar", oc), t.component("HakoMultiLevelSelectOld", Ab), t.component("HakoMultiLevelSelect", Rk), t.component("HakoMultiselect", Q1), t.component("HakoMultiselect2", uc), t.component("HakoSingleSelect2", yk), t.component("HakoSelectedOptions", Bb), t.component("HakoSidePanel", V$), t.component("HakoSpinner", Gn), t.component("HakoProgressBar", w$), t.component("HakoStickySidePanel", W$), t.component("HakoSwitch", C1), t.component("HakoTabs", G$), t.component("HakoVerticalTabs", j$), t.component("HakoTimePicker", v1), t.component("HakoModal", yc), t.component("HakoModalContent", gc), t.component("HakoModalVueManager", i$), t.component("HakoWindow", Wa), t.component("HakoWindowVueManager", s$), t.component("HakoNotificationVueManager", p_), t.component("HakoNotification", kc), t.component("HakoAlert", Cc), t.component("HakoAlertVueManager", B_), t.component("HakoTextMacro", iC), t.component("HakoFancyRadio", hC), t.component("HakoFancyToggle", dc), t.component("HakoTopScroll", V_), t.component("HakoBadge", P_), t.component("HakoBadgeAdvanced", L_), t.component("HakoPearls", H_), t.component("HakoCheckbox", vc), t.component("HakoRadio", $C), t.component("HakoFilePicker", NC), t.config.globalProperties.$notifications = Un, t.config.globalProperties.$alert = Ni, t.config.globalProperties.$hakowindow = Xr, t.config.globalProperties.$hakomodal = Ea;
  }
};
export {
  Cc as Alert,
  Ni as AlertManager,
  B_ as AlertVueManager,
  P_ as Badge,
  L_ as BadgeAdvanced,
  Aa as BlockSpinner,
  He as BsIcon,
  w0 as BsIconButton,
  At as Button,
  Ji as ButtonIconOnly,
  k0 as ButtonIconOnlyAdd,
  $0 as ButtonIconOnlyEdit,
  C0 as ButtonIconOnlyRemove,
  vc as Checkbox,
  ji as Collapse,
  I$ as ContentBlock,
  l1 as DatePicker,
  wc as Dropdown,
  n_ as DropdownItem,
  hC as FancyRadio,
  dc as FancyToggle,
  Qr as FileDenyReason,
  NC as FilePicker,
  p$ as FullscreenSpinner,
  Sr as HakoInput,
  yc as HakoModal,
  gc as HakoModalContent,
  Ea as HakoModalManager,
  i$ as HakoModalVueManager,
  Wa as HakoWindow,
  Xr as HakoWindowManager,
  s$ as HakoWindowVueManager,
  bc as HeaderBlock,
  Fa as HighlightText,
  M1 as LabelControl,
  oc as MiniCalendar,
  Ab as MultiLevelSelect,
  Rk as MultiLevelSelect2,
  Q1 as Multiselect,
  uc as Multiselect2,
  kc as Notification,
  Un as NotificationManager,
  p_ as NotificationVueManager,
  H_ as Pearls,
  w$ as ProgressBar,
  $C as Radio,
  Zr as RoundAvatar,
  Bb as SelectedOptions,
  V$ as SidePanel,
  yk as SingleSelect2,
  Gn as Spinner,
  W$ as StickySidePanel,
  C1 as Switch,
  G$ as Tabs,
  Jk as TeleInput,
  Yk as TextArea,
  iC as TextMacro,
  v1 as TimePicker,
  V_ as TopScroll,
  j$ as VerticalTabs,
  N_ as addMacroDefinition,
  z_ as chartColors,
  st as config,
  gt as getText,
  q_ as hakoLibVuePlugin,
  xa as hakoThemeList,
  or as hakoThemes,
  Uu as hakoThemesEnum,
  Ia as macroDefinitions
};
